(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.it.es === region.jN.es)
	{
		return 'on line ' + region.it.es;
	}
	return 'on lines ' + region.it.es + ' through ' + region.jN.es;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList === 'function' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nM,
		impl.pd,
		impl.oT,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		kS: func(record.kS),
		l7: record.l7,
		lh: record.lh
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.kS;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.l7;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.lh) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nM,
		impl.pd,
		impl.oT,
		function(sendToApp, initialModel) {
			var view = impl.gP;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.nM,
		impl.pd,
		impl.oT,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.il && impl.il(sendToApp)
			var view = impl.gP;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.al);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.mp) && (_VirtualDom_doc.title = title = doc.mp);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.of;
	var onUrlRequest = impl.og;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		il: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.lr === next.lr
							&& curr.kf === next.kf
							&& curr.lf.a === next.lf.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		nM: function(flags)
		{
			return A3(impl.nM, flags, _Browser_getUrl(), key);
		},
		gP: impl.gP,
		pd: impl.pd,
		oT: impl.oT
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { nF: 'hidden', m5: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { nF: 'mozHidden', m5: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { nF: 'msHidden', m5: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { nF: 'webkitHidden', m5: 'webkitvisibilitychange' }
		: { nF: 'hidden', m5: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		lO: _Browser_getScene(),
		mJ: {
			bl: _Browser_window.pageXOffset,
			bo: _Browser_window.pageYOffset,
			mO: _Browser_doc.documentElement.clientWidth,
			o: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		mO: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		o: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			lO: {
				mO: node.scrollWidth,
				o: node.scrollHeight
			},
			mJ: {
				bl: node.scrollLeft,
				bo: node.scrollTop,
				mO: node.clientWidth,
				o: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			lO: _Browser_getScene(),
			mJ: {
				bl: x,
				bo: y,
				mO: _Browser_doc.documentElement.clientWidth,
				o: _Browser_doc.documentElement.clientHeight
			},
			nk: {
				bl: x + rect.left,
				bo: y + rect.top,
				mO: rect.width,
				o: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.ao.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.ao.b, xhr)); });
		$elm$core$Maybe$isJust(request.az) && _Http_track(router, xhr, request.az.a);

		try {
			xhr.open(request.as, request.aA, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.aA));
		}

		_Http_configureRequest(xhr, request);

		request.al.a && xhr.setRequestHeader('Content-Type', request.al.a);
		xhr.send(request.al.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ar; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.ax.a || 0;
	xhr.responseType = request.ao.d;
	xhr.withCredentials = request.mW;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		aA: xhr.responseURL,
		oO: xhr.status,
		oP: xhr.statusText,
		ar: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			oG: event.loaded,
			l_: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			or: event.loaded,
			l_: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.n1) { flags += 'm'; }
	if (options.m3) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = '';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.jA))
		{
			lang = options.jA.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.nC.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.oW,
		breaks: gfm && gfm.m0,
		sanitize: options.oy,
		smartypants: options.oL
	};
}
var $author$project$Main$LinkClicked = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$UrlChange = function (a) {
	return {$: 0, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.u) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.x),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.x);
		} else {
			var treeLen = builder.u * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.y) : builder.y;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.u);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.x) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.x);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{y: nodeList, u: (len / $elm$core$Array$branchFactor) | 0, x: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {j8: fragment, kf: host, om: path, lf: port_, lr: protocol, lz: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Main$AdjustTimeZone = function (a) {
	return {$: 7, a: a};
};
var $author$project$Main$HandleTranslationsResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Main$Mdc = function (a) {
	return {$: 9, a: a};
};
var $author$project$Main$NotReady = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Utils$PersistantState$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Data$Role$Role = function (root) {
	return {lK: root};
};
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$Data$Role$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'root',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Data$Role$Role));
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Utils$PersistantState$stateDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'role',
		$author$project$Api$Data$Role$decoder,
		$elm$json$Json$Decode$succeed($author$project$Utils$PersistantState$State)));
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Utils$PersistantState$decode = function (value) {
	return $elm$core$Result$toMaybe(
		A2(
			$elm$core$Result$andThen,
			function (str) {
				return A2($elm$json$Json$Decode$decodeString, $author$project$Utils$PersistantState$stateDecoder, str);
			},
			A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, value)));
};
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Decoders$decodeTranslations = $elm$json$Json$Decode$dict($elm$json$Json$Decode$string);
var $author$project$Material$defaultModel = {jg: $elm$core$Dict$empty, jn: $elm$core$Dict$empty, jo: $elm$core$Dict$empty, jD: $elm$core$Dict$empty, hd: $elm$core$Dict$empty, jV: $elm$core$Dict$empty, kh: $elm$core$Dict$empty, kH: $elm$core$Dict$empty, K: $elm$core$Dict$empty, lA: $elm$core$Dict$empty, bd: $elm$core$Dict$empty, lU: $elm$core$Dict$empty, l$: $elm$core$Dict$empty, eV: $elm$core$Dict$empty, me: $elm$core$Dict$empty, mg: $elm$core$Dict$empty, mn: $elm$core$Dict$empty, iE: $elm$core$Dict$empty, mu: $elm$core$Dict$empty};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.oO));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {lD: reqs, md: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.az;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.lD));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.md)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					mW: r.mW,
					al: r.al,
					ao: A2(_Http_mapExpect, func, r.ao),
					ar: r.ar,
					as: r.as,
					ax: r.ax,
					az: r.az,
					aA: r.aA
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{mW: false, al: r.al, ao: r.ao, ar: r.ar, as: r.as, ax: r.ax, az: r.az, aA: r.aA}));
};
var $elm$http$Http$get = function (r) {
	return $elm$http$Http$request(
		{al: $elm$http$Http$emptyBody, ao: r.ao, ar: _List_Nil, as: 'GET', ax: $elm$core$Maybe$Nothing, az: $elm$core$Maybe$Nothing, aA: r.aA});
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $author$project$Material$init = function (_v0) {
	return $elm$core$Platform$Cmd$none;
};
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Main$init = F3(
	function (flags, url, navKey) {
		return _Utils_Tuple2(
			{
				D: A3(
					$author$project$Main$NotReady,
					$elm$core$Maybe$Just(
						$elm$time$Time$millisToPosix(flags.jx)),
					$elm$core$Maybe$Just($elm$time$Time$utc),
					$author$project$Utils$PersistantState$decode(flags.iu)),
				kP: $author$project$Material$defaultModel,
				f1: navKey,
				aA: url
			},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$elm$http$Http$get(
						{
							ao: A2(
								$elm$http$Http$expectJson,
								A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Main$HandleTranslationsResponse),
								$author$project$Decoders$decodeTranslations),
							aA: '/translations/de.json'
						}),
						A2($elm$core$Task$perform, $author$project$Main$AdjustTimeZone, $elm$time$Time$here),
						$author$project$Material$init($author$project$Main$Mdc)
					])));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Main$PersistanceUpdate = function (a) {
	return {$: 8, a: a};
};
var $author$project$Main$SpinnerMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Main$TimeChange = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$UploadProgressMsg = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {lq: processes, mh: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.lq;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.mh);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $author$project$Utils$PersistantState$onStoreChange = _Platform_incomingPort('onStoreChange', $elm$json$Json$Decode$value);
var $author$project$Utils$PersistantState$storageToState = function (toMsg) {
	return $author$project$Utils$PersistantState$onStoreChange(
		function (value) {
			return toMsg(
				$author$project$Utils$PersistantState$decode(value));
		});
};
var $damienklinnert$elm_spinner$Spinner$AnimationFrame = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {hZ: oldTime, gl: request, md: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.gl;
		var oldTime = _v0.hZ;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.md;
		var oldTime = _v0.hZ;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $damienklinnert$elm_spinner$Spinner$subscription = $elm$browser$Browser$Events$onAnimationFrame($damienklinnert$elm_spinner$Spinner$AnimationFrame);
var $author$project$Internal$Msg$DrawerMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Internal$Component$subs = F5(
	function (ctor, get, subscriptions, lift, model) {
		return $elm$core$Platform$Sub$batch(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (idx, state, ss) {
						return A2(
							$elm$core$List$cons,
							A2(
								$elm$core$Platform$Sub$map,
								A2(
									$elm$core$Basics$composeL,
									lift,
									ctor(idx)),
								subscriptions(state)),
							ss);
					}),
				_List_Nil,
				get(model)));
	});
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Internal$Drawer$Implementation$subscriptions = function (model) {
	return $elm$core$Platform$Sub$none;
};
var $author$project$Internal$Drawer$Implementation$subs = A3(
	$author$project$Internal$Component$subs,
	$author$project$Internal$Msg$DrawerMsg,
	function ($) {
		return $.hd;
	},
	$author$project$Internal$Drawer$Implementation$subscriptions);
var $author$project$Internal$Msg$MenuMsg = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Internal$Menu$Model$DocumentClick = {$: 7};
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {lc: pids, md: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {hg: event, kv: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.lc,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.kv;
		var event = _v0.hg;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.md);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Internal$Menu$Implementation$subscriptions = function (model) {
	return (model.B && (!_Utils_eq(model.cR, $elm$core$Maybe$Nothing))) ? $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($author$project$Internal$Menu$Model$DocumentClick)) : $elm$core$Platform$Sub$none;
};
var $author$project$Internal$Menu$Implementation$subs = A3(
	$author$project$Internal$Component$subs,
	$author$project$Internal$Msg$MenuMsg,
	function ($) {
		return $.K;
	},
	$author$project$Internal$Menu$Implementation$subscriptions);
var $author$project$Material$subscriptions = F2(
	function (lift, model) {
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2($author$project$Internal$Drawer$Implementation$subs, lift, model.kP),
					A2($author$project$Internal$Menu$Implementation$subs, lift, model.kP)
				]));
	});
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				A2($elm$time$Time$every, 1000, $author$project$Main$TimeChange),
				A2($elm$core$Platform$Sub$map, $author$project$Main$SpinnerMsg, $damienklinnert$elm_spinner$Spinner$subscription),
				$author$project$Utils$PersistantState$storageToState($author$project$Main$PersistanceUpdate),
				A2($elm$http$Http$track, 'file_upload', $author$project$Main$UploadProgressMsg),
				A2($author$project$Material$subscriptions, $author$project$Main$Mdc, model)
			]));
};
var $author$project$Routing$Router$PersistanceUpdate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Routing$Router$SpinnerMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Routing$Router$UploadProgressMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Routing$Router$UrlChange = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.lr;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.j8,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.lz,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.lf,
					_Utils_ap(http, url.kf)),
				url.om)));
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Internal$Dispatch$forward = function (msgs) {
	return $elm$core$Platform$Cmd$batch(
		A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Task$perform($elm$core$Basics$identity),
				$elm$core$Task$succeed),
			msgs));
};
var $author$project$Internal$Msg$ButtonMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Idle = {$: 0};
var $author$project$Internal$Ripple$Model$defaultModel = {cu: 0, ak: $author$project$Internal$Ripple$Model$Idle, g0: $elm$core$Maybe$Nothing, fE: false};
var $author$project$Internal$Button$Model$defaultModel = {bd: $author$project$Internal$Ripple$Model$defaultModel};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Internal$Component$indexed = F3(
	function (get_model, set_model, model0) {
		var set_ = F3(
			function (idx, store, model) {
				return A2(
					set_model,
					A3(
						$elm$core$Dict$insert,
						idx,
						model,
						get_model(store)),
					store);
			});
		var get_ = F2(
			function (idx, store) {
				return A2(
					$elm$core$Maybe$withDefault,
					model0,
					A2(
						$elm$core$Dict$get,
						idx,
						get_model(store)));
			});
		return {j9: get_, oH: set_};
	});
var $author$project$Internal$Button$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.jg;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{jg: x});
		}),
	$author$project$Internal$Button$Model$defaultModel);
var $author$project$Internal$Component$react = F8(
	function (get, set, ctor, update, lift, msg, idx, store) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$map(
				A2(set, idx, store)),
			A3(
				update,
				A2(
					$elm$core$Basics$composeL,
					lift,
					ctor(idx)),
				msg,
				A2(get, idx, store)));
	});
var $author$project$Internal$Button$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Internal$Helpers$delayedCmd = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Internal$Ripple$Model$Activate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Ripple$Model$Activated = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Ripple$Model$ActivationEnded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Ripple$Model$Deactivated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Ripple$Model$DeactivationEnded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Ripple$Model$Reactivate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$normalizedEventCoords = F3(
	function (event, pageOffset, clientRect) {
		var _v0 = pageOffset;
		var x = _v0.bl;
		var y = _v0.bo;
		var documentX = x + clientRect.bl;
		var documentY = x + clientRect.bo;
		var _v1 = event.ol;
		var pageX = _v1.k7;
		var pageY = _v1.k8;
		return {bl: pageX - documentX, bo: pageY - documentY};
	});
var $author$project$Internal$Ripple$Implementation$fgTranslationCoords = F2(
	function (isUnbounded, _v0) {
		var frame = _v0.a2;
		var activationEvent = _v0.cr;
		var windowPageOffset = _v0.mP;
		var wasActivatedByPointer = _v0.mK;
		var maxDimension = A2($elm$core$Basics$max, frame.mO, frame.o);
		var initialSize = maxDimension * 0.6;
		var startPoint = function () {
			var _v1 = A3($author$project$Internal$Ripple$Implementation$normalizedEventCoords, activationEvent, windowPageOffset, frame);
			var x = _v1.bl;
			var y = _v1.bo;
			return {bl: x - (initialSize / 2), bo: y - (initialSize / 2)};
		}();
		var endPoint = {bl: (frame.mO - initialSize) / 2, bo: (frame.o - initialSize) / 2};
		return {jP: endPoint, l4: startPoint};
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Internal$Ripple$Implementation$animateActivation = F4(
	function (isUnbounded, frame, windowPageOffset, activationEvent) {
		var wasActivatedByPointer = true;
		var _v0 = A2(
			$author$project$Internal$Ripple$Implementation$fgTranslationCoords,
			isUnbounded,
			{cr: activationEvent, a2: frame, mK: wasActivatedByPointer, mP: windowPageOffset});
		var startPoint = _v0.l4;
		var endPoint = _v0.jP;
		var translateEnd = isUnbounded ? '' : ($elm$core$String$fromFloat(endPoint.bl) + ('px, ' + ($elm$core$String$fromFloat(endPoint.bo) + 'px')));
		var translateStart = isUnbounded ? '' : ($elm$core$String$fromFloat(startPoint.bl) + ('px, ' + ($elm$core$String$fromFloat(startPoint.bo) + 'px')));
		return {bg: translateEnd, bh: translateStart};
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$Internal$Ripple$Model$numbers = {nd: 225, nx: 150, nN: 0.6, ok: 10, mi: 300};
var $elm$core$Basics$pow = _Basics_pow;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $author$project$Internal$Ripple$Implementation$layoutInternal = F2(
	function (isUnbounded, frame) {
		var maxDim = A2($elm$core$Basics$max, frame.mO, frame.o);
		var initialSize = $elm$core$Basics$floor(maxDim * $author$project$Internal$Ripple$Model$numbers.nN);
		var hypotenuse = $elm$core$Basics$sqrt(
			A2($elm$core$Basics$pow, frame.mO, 2) + A2($elm$core$Basics$pow, frame.o, 2));
		var boundedRadius = hypotenuse + $author$project$Internal$Ripple$Model$numbers.ok;
		var maxRadius = isUnbounded ? maxDim : boundedRadius;
		var fgScale = maxRadius / initialSize;
		return {aL: fgScale, aQ: initialSize};
	});
var $author$project$Internal$Ripple$Implementation$update = F2(
	function (msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.ak);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fE: true}),
						$elm$core$Platform$Cmd$none);
				case 1:
					var _v2 = _v0.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fE: false}),
						$elm$core$Platform$Cmd$none);
				case 8:
					var _v3 = _v0.a;
					var isUnbounded = _v3.a;
					var clientRect = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g0: $elm$core$Maybe$Just(clientRect)
							}),
						$elm$core$Platform$Cmd$none);
				case 2:
					if (!_v0.b.$) {
						var _v4 = _v0.a;
						var domId = _v4.a;
						var activateData = _v4.b;
						var _v5 = _v0.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Activate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					} else {
						var _v6 = _v0.a;
						var domId = _v6.a;
						var activateData = _v6.b;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Internal$Ripple$Model$Reactivate(activateData),
								$elm$browser$Browser$Dom$getElement(domId)));
					}
				case 4:
					var _v7 = _v0.a;
					var activateData = _v7.a;
					var element = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ak: $author$project$Internal$Ripple$Model$Idle}),
						A2(
							$elm$core$Task$perform,
							function (_v8) {
								return A2($author$project$Internal$Ripple$Model$Activate, activateData, element);
							},
							$elm$core$Task$succeed(0)));
				case 3:
					if (_v0.a.b.$ === 1) {
						var _v9 = _v0.a;
						var activateData = _v9.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var _v10 = _v0.a;
						var activateData = _v10.a;
						var element = _v10.b.a.nk;
						var viewport = _v10.b.a.mJ;
						var newAnimationCounter = model.cu + 1;
						var _v11 = A4($author$project$Internal$Ripple$Implementation$animateActivation, activateData.en, element, viewport, activateData.hg);
						var translateStart = _v11.bh;
						var translateEnd = _v11.bg;
						var _v12 = A2($author$project$Internal$Ripple$Implementation$layoutInternal, activateData.en, element);
						var fgScale = _v12.aL;
						var initialSize = _v12.aQ;
						var activatedData = {
							cr: $elm$core$Maybe$Just(activateData.hg),
							gT: false,
							fr: false,
							aL: fgScale,
							a2: {o: element.o, H: element.bl, r: element.bo, mO: element.mO},
							aQ: initialSize,
							bg: translateEnd,
							bh: translateStart,
							iN: activateData.iN
						};
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cu: newAnimationCounter,
									ak: $author$project$Internal$Ripple$Model$Activated(activatedData)
								}),
							A2(
								$elm$core$Task$perform,
								function (_v13) {
									return $author$project$Internal$Ripple$Model$ActivationEnded(newAnimationCounter);
								},
								$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.nd)));
					}
				case 5:
					if (_v0.b.$ === 1) {
						var animationCount = _v0.a.a;
						var activatedData = _v0.b.a;
						if (_Utils_eq(animationCount, model.cu)) {
							if (activatedData.fr) {
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											ak: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
										}),
									A2(
										$elm$core$Task$perform,
										function (_v14) {
											return $author$project$Internal$Ripple$Model$DeactivationEnded(model.cu);
										},
										$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.mi)));
							} else {
								var newActivatedData = _Utils_update(
									activatedData,
									{gT: true});
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											ak: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
										}),
									$elm$core$Platform$Cmd$none);
							}
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$11;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var _v15 = _v0.a;
						var activatedData = _v0.b.a;
						if (activatedData.gT) {
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ak: $author$project$Internal$Ripple$Model$Deactivated(activatedData)
									}),
								A2(
									$elm$core$Task$perform,
									function (_v16) {
										return $author$project$Internal$Ripple$Model$DeactivationEnded(model.cu);
									},
									$elm$core$Process$sleep($author$project$Internal$Ripple$Model$numbers.mi)));
						} else {
							var newActivatedData = _Utils_update(
								activatedData,
								{cr: $elm$core$Maybe$Nothing, fr: true});
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										ak: $author$project$Internal$Ripple$Model$Activated(newActivatedData)
									}),
								$elm$core$Platform$Cmd$none);
						}
					} else {
						break _v0$11;
					}
				default:
					if (_v0.b.$ === 2) {
						var animationCount = _v0.a.a;
						return _Utils_eq(animationCount, model.cu) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{ak: $author$project$Internal$Ripple$Model$Idle}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						break _v0$11;
					}
			}
		}
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $author$project$Internal$Button$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{bd: rippleState})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Button$Model$RippleMsg),
					rippleCmd));
		} else {
			var doRipple = msg.a;
			var msg_ = msg.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2(
					$author$project$Internal$Helpers$delayedCmd,
					doRipple ? 150 : 0,
					msg_));
		}
	});
var $author$project$Internal$Button$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Button$Implementation$getSet.j9, $author$project$Internal$Button$Implementation$getSet.oH, $author$project$Internal$Msg$ButtonMsg, $author$project$Internal$Button$Implementation$update);
var $author$project$Internal$Msg$CheckboxMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Internal$Checkbox$Model$defaultModel = {ff: $elm$core$Maybe$Nothing, nQ: false, fS: $elm$core$Maybe$Nothing};
var $author$project$Internal$Checkbox$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.jn;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{jn: x});
		}),
	$author$project$Internal$Checkbox$Model$defaultModel);
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Internal$Checkbox$Model$CheckedIndeterminate = 3;
var $author$project$Internal$Checkbox$Model$CheckedUnchecked = 2;
var $author$project$Internal$Checkbox$Model$IndeterminateChecked = 4;
var $author$project$Internal$Checkbox$Model$IndeterminateUnchecked = 5;
var $author$project$Internal$Checkbox$Model$UncheckedChecked = 0;
var $author$project$Internal$Checkbox$Model$UncheckedIndeterminate = 1;
var $author$project$Internal$Checkbox$Implementation$animationState = F2(
	function (oldState, state) {
		var _v0 = _Utils_Tuple2(oldState, state);
		_v0$6:
		while (true) {
			if (_v0.a.$ === 1) {
				if (!_v0.b.$) {
					if (!_v0.b.a) {
						var _v5 = _v0.a;
						var _v6 = _v0.b.a;
						return $elm$core$Maybe$Just(4);
					} else {
						var _v7 = _v0.a;
						var _v8 = _v0.b.a;
						return $elm$core$Maybe$Just(5);
					}
				} else {
					break _v0$6;
				}
			} else {
				if (_v0.a.a === 1) {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a.a;
						var _v2 = _v0.b;
						return $elm$core$Maybe$Just(1);
					} else {
						if (!_v0.b.a) {
							var _v9 = _v0.a.a;
							var _v10 = _v0.b.a;
							return $elm$core$Maybe$Just(0);
						} else {
							break _v0$6;
						}
					}
				} else {
					if (_v0.b.$ === 1) {
						var _v3 = _v0.a.a;
						var _v4 = _v0.b;
						return $elm$core$Maybe$Just(3);
					} else {
						if (_v0.b.a === 1) {
							var _v11 = _v0.a.a;
							var _v12 = _v0.b.a;
							return $elm$core$Maybe$Just(2);
						} else {
							break _v0$6;
						}
					}
				}
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Internal$Checkbox$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 2:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{nQ: focus})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var lastKnownState = msg.a;
				var state = msg.b;
				var animation = A2(
					$elm$core$Maybe$andThen,
					function (lastKnownState_) {
						return A2($author$project$Internal$Checkbox$Implementation$animationState, lastKnownState_, state);
					},
					lastKnownState);
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								ff: animation,
								fS: $elm$core$Maybe$Just(state)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{ff: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Checkbox$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Checkbox$Implementation$getSet.j9, $author$project$Internal$Checkbox$Implementation$getSet.oH, $author$project$Internal$Msg$CheckboxMsg, $author$project$Internal$Checkbox$Implementation$update);
var $author$project$Internal$Msg$ChipMsg = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Internal$Chip$Model$defaultModel = {bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Chip$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.jo;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{jo: x});
		}),
	$author$project$Internal$Chip$Model$defaultModel);
var $author$project$Internal$Chip$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Chip$Implementation$update = F3(
	function (lift, msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
			var ripple = _v1.a;
			var cmd = _v1.b;
			return _Utils_Tuple2(
				$elm$core$Maybe$Just(
					_Utils_update(
						model,
						{bd: ripple})),
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeL, lift, $author$project$Internal$Chip$Model$RippleMsg),
					cmd));
		} else {
			var msg_ = msg.a;
			return _Utils_Tuple2(
				$elm$core$Maybe$Nothing,
				A2($author$project$Internal$Helpers$delayedCmd, 150, msg_));
		}
	});
var $author$project$Internal$Chip$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Chip$Implementation$getSet.j9, $author$project$Internal$Chip$Implementation$getSet.oH, $author$project$Internal$Msg$ChipMsg, $author$project$Internal$Chip$Implementation$update);
var $author$project$Internal$Msg$DialogMsg = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Internal$Dialog$Model$defaultModel = {dK: false, B: false};
var $author$project$Internal$Dialog$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.jD;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{jD: x});
		}),
	$author$project$Internal$Dialog$Model$defaultModel);
var $author$project$Internal$Dialog$Implementation$update = F3(
	function (_v0, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return (!_Utils_eq(isOpen, model.B)) ? _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{dK: true, B: isOpen})),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{dK: false})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Dialog$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Dialog$Implementation$getSet.j9, $author$project$Internal$Dialog$Implementation$getSet.oH, $author$project$Internal$Msg$DialogMsg, $author$project$Internal$Dialog$Implementation$update);
var $author$project$Internal$Drawer$Model$defaultModel = {dK: false, fm: false, B: false};
var $author$project$Internal$Drawer$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.hd;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{hd: x});
		}),
	$author$project$Internal$Drawer$Model$defaultModel);
var $elm$core$Basics$not = _Basics_not;
var $author$project$Internal$Drawer$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 1:
				var isOpen = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{dK: true, fm: !isOpen, B: true})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								dK: false,
								fm: false,
								B: model.fm ? false : model.B
							})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Drawer$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Drawer$Implementation$getSet.j9, $author$project$Internal$Drawer$Implementation$getSet.oH, $author$project$Internal$Msg$DrawerMsg, $author$project$Internal$Drawer$Implementation$update);
var $author$project$Internal$Msg$FabMsg = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $author$project$Internal$Component$generalise = F4(
	function (update, lift, msg, model) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(lift),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A2(update, msg, model)));
	});
var $author$project$Internal$Fab$Model$defaultModel = {bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Fab$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.jV;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{jV: x});
		}),
	$author$project$Internal$Fab$Model$defaultModel);
var $author$project$Internal$Fab$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Fab$Implementation$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var msg_ = msg.a;
			var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
			var rippleState = _v1.a;
			var rippleCmd = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{bd: rippleState}),
				A2($elm$core$Platform$Cmd$map, $author$project$Internal$Fab$Model$RippleMsg, rippleCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Fab$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Fab$Implementation$getSet.j9,
	$author$project$Internal$Fab$Implementation$getSet.oH,
	$author$project$Internal$Msg$FabMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Fab$Implementation$update));
var $author$project$Internal$Msg$IconButtonMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Internal$IconButton$Model$defaultModel = {w: false, bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$IconButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.kh;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{kh: x});
		}),
	$author$project$Internal$IconButton$Model$defaultModel);
var $author$project$Internal$IconButton$Model$RippleMsg = $elm$core$Basics$identity;
var $author$project$Internal$IconButton$Implementation$update = F2(
	function (msg, model) {
		var msg_ = msg;
		var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
		var ripple = _v1.a;
		var effects = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bd: ripple}),
			A2($elm$core$Platform$Cmd$map, $elm$core$Basics$identity, effects));
	});
var $author$project$Internal$IconButton$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$IconButton$Implementation$getSet.j9,
	$author$project$Internal$IconButton$Implementation$getSet.oH,
	$author$project$Internal$Msg$IconButtonMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$IconButton$Implementation$update));
var $author$project$Internal$Msg$ListMsg = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Internal$List$Model$defaultModel = {fE: $elm$core$Maybe$Nothing, eL: $elm$core$Dict$empty};
var $author$project$Internal$List$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.kH;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{kH: x});
		}),
	$author$project$Internal$List$Model$defaultModel);
var $author$project$Internal$List$Model$NoOp = {$: 0};
var $author$project$Internal$List$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Internal$List$Implementation$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$List$Implementation$update = F3(
	function (lift, msg, model) {
		var isRtl = false;
		switch (msg.$) {
			case 1:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.eL)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								eL: A3($elm$core$Dict$insert, index, ripple, model.eL)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$List$Model$RippleMsg(index)),
						effects));
			case 3:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: $elm$core$Maybe$Nothing})),
					$elm$core$Platform$Cmd$none);
			case 2:
				var index = msg.a;
				var id = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: $elm$core$Maybe$Nothing})),
					A2(
						$elm$core$Task$attempt,
						function (_v2) {
							return lift($author$project$Internal$List$Model$NoOp);
						},
						$elm$browser$Browser$Dom$focus(id)));
			case 4:
				var index = msg.a;
				var m = msg.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: $elm$core$Maybe$Nothing})),
					$author$project$Internal$List$Implementation$send(
						m(index)));
			default:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$List$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$List$Implementation$getSet.j9, $author$project$Internal$List$Implementation$getSet.oH, $author$project$Internal$Msg$ListMsg, $author$project$Internal$List$Implementation$update);
var $author$project$Internal$Menu$Model$defaultModel = {dK: false, a1: $elm$core$Maybe$Nothing, cR: $elm$core$Maybe$Nothing, cY: $elm$core$Maybe$Nothing, fQ: false, B: false, au: $elm$core$Maybe$Nothing};
var $author$project$Internal$Menu$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.K;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{K: x});
		}),
	$author$project$Internal$Menu$Model$defaultModel);
var $author$project$Internal$Menu$Model$AnimationEnd = {$: 2};
var $author$project$Internal$Menu$Model$Close = {$: 4};
var $author$project$Internal$Menu$Model$Open = {$: 3};
var $author$project$Internal$Helpers$cmd = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $author$project$Internal$Menu$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					var $temp$lift = lift,
						$temp$msg = model.B ? $author$project$Internal$Menu$Model$Close : $author$project$Internal$Menu$Model$Open,
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 3:
					var doQuickOpen = A2($elm$core$Maybe$withDefault, false, model.au);
					return (!model.B) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{dK: true, cR: $elm$core$Maybe$Nothing, B: true})),
						(!doQuickOpen) ? A2(
							$author$project$Internal$Helpers$delayedCmd,
							120,
							lift($author$project$Internal$Menu$Model$AnimationEnd)) : $author$project$Internal$Helpers$cmd(
							lift($author$project$Internal$Menu$Model$AnimationEnd))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 4:
					var doQuickOpen = A2($elm$core$Maybe$withDefault, false, model.au);
					return model.B ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{dK: true, a1: $elm$core$Maybe$Nothing, B: false, au: $elm$core$Maybe$Nothing})),
						(!doQuickOpen) ? A2(
							$author$project$Internal$Helpers$delayedCmd,
							70,
							lift($author$project$Internal$Menu$Model$AnimationEnd)) : $author$project$Internal$Helpers$cmd(
							lift($author$project$Internal$Menu$Model$AnimationEnd))) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2(
							$author$project$Internal$Helpers$delayedCmd,
							50,
							lift($author$project$Internal$Menu$Model$Close)));
				case 1:
					var config = msg.a;
					var geometry = msg.b;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									a1: config.cY,
									cR: $elm$core$Maybe$Just(geometry),
									au: $elm$core$Maybe$Just(config.au)
								})),
						$elm$core$Platform$Cmd$none);
				case 2:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{dK: false})),
						$elm$core$Platform$Cmd$none);
				case 7:
					var $temp$lift = lift,
						$temp$msg = $author$project$Internal$Menu$Model$Close,
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 8:
					var numItems = msg.a;
					var shiftKey = msg.b.gw;
					var altKey = msg.b.fe;
					var ctrlKey = msg.b.fq;
					var metaKey = msg.b.f_;
					var key = msg.c;
					var keyCode = msg.d;
					var lastItemIndex = numItems - 1;
					var isTab = (key === 'Tab') || (keyCode === 9);
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					var keyDownWithinMenu = isEnter || isSpace;
					var isArrowUp = (key === 'ArrowUp') || (keyCode === 38);
					var isArrowDown = (key === 'ArrowDown') || (keyCode === 40);
					var focusedItemIndex = A2($elm$core$Maybe$withDefault, 0, model.a1);
					return A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$map(
							function (updatedModel) {
								return _Utils_update(
									updatedModel,
									{fQ: keyDownWithinMenu});
							}),
						(altKey || (ctrlKey || metaKey)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : (isArrowUp ? _Utils_Tuple2(
							$elm$core$Maybe$Just(
								(!focusedItemIndex) ? _Utils_update(
									model,
									{
										a1: $elm$core$Maybe$Just(lastItemIndex)
									}) : _Utils_update(
									model,
									{
										a1: $elm$core$Maybe$Just(focusedItemIndex - 1)
									})),
							$elm$core$Platform$Cmd$none) : (isArrowDown ? _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_eq(focusedItemIndex, lastItemIndex) ? _Utils_update(
									model,
									{
										a1: $elm$core$Maybe$Just(0)
									}) : _Utils_update(
									model,
									{
										a1: $elm$core$Maybe$Just(focusedItemIndex + 1)
									})),
							$elm$core$Platform$Cmd$none) : ((isSpace || isEnter) ? _Utils_Tuple2(
							$elm$core$Maybe$Just(model),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none)))));
				case 9:
					var shiftKey = msg.a.gw;
					var altKey = msg.a.fe;
					var ctrlKey = msg.a.fq;
					var metaKey = msg.a.f_;
					var key = msg.b;
					var keyCode = msg.c;
					var isSpace = (key === 'Space') || (keyCode === 32);
					var isEscape = (key === 'Escape') || (keyCode === 27);
					var isEnter = (key === 'Enter') || (keyCode === 13);
					return A2(
						$elm$core$Tuple$mapFirst,
						$elm$core$Maybe$map(
							function (updatedModel) {
								return ((isEnter || isSpace) && updatedModel.fQ) ? _Utils_update(
									updatedModel,
									{fQ: false}) : updatedModel;
							}),
						(altKey || (ctrlKey || metaKey)) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none) : ((isEscape || ((isSpace || isEnter) && model.fQ)) ? A3($author$project$Internal$Menu$Implementation$update, lift, $author$project$Internal$Menu$Model$Close, model) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none)));
				default:
					var focusedItemAtIndex = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									a1: $elm$core$Maybe$Just(focusedItemAtIndex)
								})),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Internal$Menu$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Menu$Implementation$getSet.j9, $author$project$Internal$Menu$Implementation$getSet.oH, $author$project$Internal$Msg$MenuMsg, $author$project$Internal$Menu$Implementation$update);
var $author$project$Internal$Msg$RadioButtonMsg = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Internal$RadioButton$Model$defaultModel = {nQ: false, bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$RadioButton$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.lA;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{lA: x});
		}),
	$author$project$Internal$RadioButton$Model$defaultModel);
var $author$project$Internal$RadioButton$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$RadioButton$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bd: ripple})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$RadioButton$Model$RippleMsg),
						effects));
			case 1:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			default:
				var focus = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{nQ: focus})),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$RadioButton$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$RadioButton$Implementation$getSet.j9, $author$project$Internal$RadioButton$Implementation$getSet.oH, $author$project$Internal$Msg$RadioButtonMsg, $author$project$Internal$RadioButton$Implementation$update);
var $author$project$Internal$Msg$RippleMsg = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Internal$Ripple$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.bd;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{bd: x});
		}),
	$author$project$Internal$Ripple$Model$defaultModel);
var $author$project$Internal$Ripple$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Ripple$Implementation$getSet.j9,
	$author$project$Internal$Ripple$Implementation$getSet.oH,
	$author$project$Internal$Msg$RippleMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Ripple$Implementation$update));
var $author$project$Internal$Msg$SelectMsg = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Internal$Select$Model$defaultModel = {fE: false, kr: false, bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Select$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.lU;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{lU: x});
		}),
	$author$project$Internal$Select$Model$defaultModel);
var $author$project$Internal$Select$Model$RippleMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Internal$Select$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var changedValue = msg.a;
				var dirty = changedValue !== '';
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{kr: dirty})),
					$elm$core$Platform$Cmd$none);
			case 0:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: false})),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: true})),
					$elm$core$Platform$Cmd$none);
			default:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{bd: ripple})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, lift, $author$project$Internal$Select$Model$RippleMsg),
						effects));
		}
	});
var $author$project$Internal$Select$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Select$Implementation$getSet.j9, $author$project$Internal$Select$Implementation$getSet.oH, $author$project$Internal$Msg$SelectMsg, $author$project$Internal$Select$Implementation$update);
var $author$project$Internal$Msg$SliderMsg = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Internal$Slider$Model$defaultModel = {aE: false, dI: $elm$core$Maybe$Nothing, fC: false, cR: $elm$core$Maybe$Nothing, eh: false, gg: false};
var $author$project$Internal$Slider$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.l$;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{l$: x});
		}),
	$author$project$Internal$Slider$Model$defaultModel);
var $author$project$Internal$Slider$Model$ActualUp = {$: 11};
var $author$project$Internal$Slider$Model$Init = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Slider$Model$defaultGeometry = {
	a$: false,
	kK: 100,
	kT: 0,
	eJ: {H: 0, mO: 0},
	l6: $elm$core$Maybe$Nothing
};
var $author$project$Internal$Slider$Implementation$valueFromPageX = F2(
	function (geometry, pageX) {
		var xPos = pageX - geometry.eJ.H;
		var isRtl = false;
		var pctComplete = isRtl ? (1 - (xPos / geometry.eJ.mO)) : (xPos / geometry.eJ.mO);
		return geometry.kT + (pctComplete * (geometry.kK - geometry.kT));
	});
var $author$project$Internal$Slider$Implementation$update = F3(
	function (lift, msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 0:
					return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 5:
					return (!model.gg) ? _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{fC: true})),
						$elm$core$Platform$Cmd$none) : _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
				case 6:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{fC: false, gg: false})),
						$elm$core$Platform$Cmd$none);
				case 8:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{eh: false})),
						$elm$core$Platform$Cmd$none);
				case 3:
					var pageX = msg.b.k7;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.cR);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									aE: true,
									dI: $elm$core$Maybe$Just(activeValue),
									eh: true,
									gg: true
								})),
						$elm$core$Platform$Cmd$none);
				case 7:
					var pageX = msg.b.k7;
					var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.cR);
					var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									aE: true,
									dI: $elm$core$Maybe$Just(activeValue),
									eh: false,
									gg: true
								})),
						$elm$core$Platform$Cmd$none);
				case 9:
					var pageX = msg.a.k7;
					if (model.aE) {
						var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$Slider$Model$defaultGeometry, model.cR);
						var activeValue = A2($author$project$Internal$Slider$Implementation$valueFromPageX, geometry, pageX);
						return _Utils_Tuple2(
							$elm$core$Maybe$Just(
								_Utils_update(
									model,
									{
										dI: $elm$core$Maybe$Just(activeValue),
										eh: false
									})),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
					}
				case 1:
					var geometry = msg.a;
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									cR: $elm$core$Maybe$Just(geometry)
								})),
						$elm$core$Platform$Cmd$none);
				case 2:
					var geometry = msg.a;
					var $temp$lift = lift,
						$temp$msg = $author$project$Internal$Slider$Model$Init(geometry),
						$temp$model = model;
					lift = $temp$lift;
					msg = $temp$msg;
					model = $temp$model;
					continue update;
				case 4:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{fC: true})),
						$elm$core$Platform$Cmd$none);
				case 10:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(model),
						A2(
							$elm$core$Task$perform,
							lift,
							$elm$core$Task$succeed($author$project$Internal$Slider$Model$ActualUp)));
				default:
					return _Utils_Tuple2(
						$elm$core$Maybe$Just(
							_Utils_update(
								model,
								{aE: false, dI: $elm$core$Maybe$Nothing})),
						$elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Internal$Slider$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$Slider$Implementation$getSet.j9, $author$project$Internal$Slider$Implementation$getSet.oH, $author$project$Internal$Msg$SliderMsg, $author$project$Internal$Slider$Implementation$update);
var $author$project$Internal$Msg$SnackbarMsg = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Internal$Snackbar$Model$Inert = {$: 0};
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $author$project$Internal$Snackbar$Model$defaultModel = {B: false, gk: _List_Nil, dq: -1, gx: $author$project$Internal$Snackbar$Model$Inert};
var $author$project$Internal$Snackbar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.eV;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{eV: x});
		}),
	$author$project$Internal$Snackbar$Model$defaultModel);
var $author$project$Internal$Snackbar$Model$Clicked = 1;
var $author$project$Internal$Snackbar$Model$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Internal$Snackbar$Model$Fading = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Snackbar$Model$Timeout = 0;
var $author$project$Internal$Snackbar$Implementation$next = function (model) {
	return $elm$core$Platform$Cmd$map(
		$author$project$Internal$Snackbar$Model$Move(model.dq));
};
var $author$project$Internal$Snackbar$Model$Active = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Snackbar$Implementation$tryDequeue = function (model) {
	var _v0 = _Utils_Tuple2(model.gx, model.gk);
	if ((!_v0.a.$) && _v0.b.b) {
		var _v1 = _v0.a;
		var _v2 = _v0.b;
		var c = _v2.a;
		var cs = _v2.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					B: false,
					gk: cs,
					dq: model.dq + 1,
					gx: $author$project$Internal$Snackbar$Model$Active(c)
				}),
			A2(
				$elm$core$Platform$Cmd$map,
				$author$project$Internal$Snackbar$Model$Move(model.dq + 1),
				A2($author$project$Internal$Helpers$delayedCmd, c.ax, 0)));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Internal$Snackbar$Implementation$move = F2(
	function (transition, model) {
		var _v0 = _Utils_Tuple2(model.gx, transition);
		if (_v0.b === 1) {
			if (_v0.a.$ === 1) {
				var contents = _v0.a.a;
				var _v3 = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gx: $author$project$Internal$Snackbar$Model$Fading(contents)
						}),
					A2(
						$author$project$Internal$Snackbar$Implementation$next,
						model,
						A2($author$project$Internal$Helpers$delayedCmd, contents.fw, 0)));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			switch (_v0.a.$) {
				case 0:
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Internal$Snackbar$Implementation$tryDequeue(model);
				case 1:
					var contents = _v0.a.a;
					var _v4 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gx: $author$project$Internal$Snackbar$Model$Fading(contents)
							}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							A2($author$project$Internal$Helpers$delayedCmd, contents.fw, 0)));
				default:
					var contents = _v0.a.a;
					var _v5 = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{gx: $author$project$Internal$Snackbar$Model$Inert}),
						A2(
							$author$project$Internal$Snackbar$Implementation$next,
							model,
							$author$project$Internal$Helpers$cmd(0)));
			}
		}
	});
var $author$project$Internal$Snackbar$Implementation$update = F3(
	function (fwd, msg, model) {
		switch (msg.$) {
			case 0:
				var seq = msg.a;
				var transition = msg.b;
				return _Utils_eq(seq, model.dq) ? A2(
					$elm$core$Tuple$mapSecond,
					$elm$core$Platform$Cmd$map(fwd),
					A2($author$project$Internal$Snackbar$Implementation$move, transition, model)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var dismissOnAction = msg.a;
				var actionOnDismiss = msg.b;
				var fwdEffect = function () {
					if (!actionOnDismiss.$) {
						var msg_ = actionOnDismiss.a;
						return $author$project$Internal$Helpers$cmd(msg_);
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				return A2(
					$elm$core$Tuple$mapSecond,
					function (cmd) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, fwdEffect]));
					},
					dismissOnAction ? A3(
						$author$project$Internal$Snackbar$Implementation$update,
						fwd,
						A2($author$project$Internal$Snackbar$Model$Move, model.dq, 1),
						model) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: true}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Snackbar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Snackbar$Implementation$getSet.j9,
	$author$project$Internal$Snackbar$Implementation$getSet.oH,
	$author$project$Internal$Msg$SnackbarMsg,
	F3(
		function (fwd, msg, model) {
			return A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$Just,
				A3($author$project$Internal$Snackbar$Implementation$update, fwd, msg, model));
		}));
var $author$project$Internal$Msg$SwitchMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Internal$Switch$Model$defaultModel = {nQ: false, bd: $author$project$Internal$Ripple$Model$defaultModel};
var $author$project$Internal$Switch$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.me;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{me: x});
		}),
	$author$project$Internal$Switch$Model$defaultModel);
var $author$project$Internal$Switch$Model$RippleMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Switch$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var msg_ = msg.a;
				var _v1 = A2($author$project$Internal$Ripple$Implementation$update, msg_, model.bd);
				var rippleState = _v1.a;
				var rippleCmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bd: rippleState}),
					A2($elm$core$Platform$Cmd$map, $author$project$Internal$Switch$Model$RippleMsg, rippleCmd));
			case 1:
				var focus = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{nQ: focus}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Switch$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Switch$Implementation$getSet.j9,
	$author$project$Internal$Switch$Implementation$getSet.oH,
	$author$project$Internal$Msg$SwitchMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Switch$Implementation$update));
var $author$project$Internal$Msg$TabBarMsg = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Internal$TabBar$Model$defaultModel = {J: 0, cR: $elm$core$Maybe$Nothing, eL: $elm$core$Dict$empty, mz: 0};
var $author$project$Internal$TabBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.mg;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{mg: x});
		}),
	$author$project$Internal$TabBar$Model$defaultModel);
var $author$project$Internal$TabBar$Model$NoOp = {$: 0};
var $author$project$Internal$TabBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Internal$TabBar$Implementation$calculateScrollIncrement = F5(
	function (geometry, index, nextIndex, scrollPosition, barWidth) {
		var maybe_next_tab = $elm$core$List$head(
			A2($elm$core$List$drop, nextIndex, geometry.eZ));
		var extraScrollAmount = 20;
		if (!maybe_next_tab.$) {
			var next_tab = maybe_next_tab.a;
			var relativeContentRight = next_tab.g5 - scrollPosition;
			var relativeContentLeft = (next_tab.g4 - scrollPosition) - barWidth;
			var rightIncrement = relativeContentLeft + extraScrollAmount;
			var leftIncrement = relativeContentRight - extraScrollAmount;
			return (_Utils_cmp(nextIndex, index) < 0) ? A2($elm$core$Basics$min, leftIncrement, 0) : A2($elm$core$Basics$max, rightIncrement, 0);
		} else {
			return 0;
		}
	});
var $author$project$Internal$TabBar$Model$defaultGeometry = {
	lP: {ag: 0},
	mf: {ag: 0},
	eZ: _List_Nil
};
var $author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge = F4(
	function (index, tab_, scrollPosition, barWidth) {
		var rootRight = tab_.ce + tab_.ag;
		var rootLeft = tab_.ce;
		var relativeRootRight = (rootRight - scrollPosition) - barWidth;
		var relativeRootLeft = rootLeft - scrollPosition;
		var relativeRootDelta = relativeRootLeft + relativeRootRight;
		var rightEdgeIsCloser = (relativeRootRight > 0) || (relativeRootDelta > 0);
		var leftEdgeIsCloser = (relativeRootLeft < 0) || (relativeRootDelta < 0);
		return leftEdgeIsCloser ? (index - 1) : (rightEdgeIsCloser ? (index + 1) : (-1));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Internal$TabBar$Implementation$update = F3(
	function (lift, msg, model) {
		var isRtl = false;
		switch (msg.$) {
			case 2:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.eL)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								eL: A3($elm$core$Dict$insert, index, ripple, model.eL)
							})),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							lift,
							$author$project$Internal$TabBar$Model$RippleMsg(index)),
						effects));
			case 1:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 0:
				return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
			case 3:
				var geometry = msg.a;
				return _Utils_Tuple2(
					function () {
						var tabBarWidth = geometry.mf.ag;
						var scrollAreaWidth = geometry.lP.ag;
						var isOverflowing = _Utils_cmp(tabBarWidth, scrollAreaWidth) > 0;
						var translateOffset = (!isOverflowing) ? 0 : model.mz;
						return $elm$core$Maybe$Just(
							_Utils_update(
								model,
								{
									cR: $elm$core$Maybe$Just(geometry),
									mz: translateOffset
								}));
					}(),
					$elm$core$Platform$Cmd$none);
			default:
				var domId = msg.a;
				var tab_index = msg.b;
				var scrollPosition = msg.c;
				var geometry = A2($elm$core$Maybe$withDefault, $author$project$Internal$TabBar$Model$defaultGeometry, model.cR);
				var tabAtIndex = function (i) {
					return A2(
						$elm$core$Maybe$withDefault,
						{g4: 0, g5: 0, ce: 0, ag: 0},
						$elm$core$List$head(
							A2($elm$core$List$drop, i, geometry.eZ)));
				};
				var tab_ = tabAtIndex(tab_index);
				var barWidth = geometry.mf.ag;
				var next_tab_index = A4($author$project$Internal$TabBar$Implementation$findAdjacentTabIndexClosestToEdge, tab_index, tab_, scrollPosition, barWidth);
				var scrollIncrement = A5($author$project$Internal$TabBar$Implementation$calculateScrollIncrement, geometry, tab_index, next_tab_index, scrollPosition, barWidth);
				var newScrollPosition = (!tab_index) ? 0 : (_Utils_eq(
					tab_index,
					$elm$core$List$length(geometry.eZ) - 1) ? geometry.lP.ag : (scrollPosition + scrollIncrement));
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{J: tab_index})),
					A2(
						$elm$core$Task$perform,
						lift,
						A2(
							$elm$core$Task$onError,
							function (_v3) {
								return $elm$core$Task$succeed($author$project$Internal$TabBar$Model$NoOp);
							},
							A2(
								$elm$core$Task$map,
								function (_v2) {
									return $author$project$Internal$TabBar$Model$NoOp;
								},
								A3($elm$browser$Browser$Dom$setViewportOf, domId + '__scroll-area', newScrollPosition, 0)))));
		}
	});
var $author$project$Internal$TabBar$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TabBar$Implementation$getSet.j9, $author$project$Internal$TabBar$Implementation$getSet.oH, $author$project$Internal$Msg$TabBarMsg, $author$project$Internal$TabBar$Implementation$update);
var $author$project$Internal$Msg$TextFieldMsg = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Internal$TextField$Model$defaultModel = {fE: false, cR: $elm$core$Maybe$Nothing, kr: false, fa: $elm$core$Maybe$Nothing};
var $author$project$Internal$TextField$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.mn;
	},
	F2(
		function (x, c) {
			return _Utils_update(
				c,
				{mn: x});
		}),
	$author$project$Internal$TextField$Model$defaultModel);
var $author$project$Internal$TextField$Implementation$update = F3(
	function (lift, msg, model) {
		switch (msg.$) {
			case 2:
				var str = msg.a;
				var dirty = str !== '';
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								kr: dirty,
								fa: $elm$core$Maybe$Just(str)
							})),
					$elm$core$Platform$Cmd$none);
			case 0:
				var geometry = function () {
					var _v1 = model.fa;
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						return model.cR;
					}
				}();
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{fE: false, cR: geometry})),
					$elm$core$Platform$Cmd$none);
			case 1:
				var geometry = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						_Utils_update(
							model,
							{
								fE: true,
								cR: $elm$core$Maybe$Just(geometry)
							})),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(model),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TextField$Implementation$react = A4($author$project$Internal$Component$react, $author$project$Internal$TextField$Implementation$getSet.j9, $author$project$Internal$TextField$Implementation$getSet.oH, $author$project$Internal$Msg$TextFieldMsg, $author$project$Internal$TextField$Implementation$update);
var $author$project$Internal$Msg$ToolbarMsg = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Internal$Toolbar$Model$defaultModel = {dR: $elm$core$Maybe$Nothing, jr: $elm$core$Maybe$Nothing, cR: $elm$core$Maybe$Nothing, lR: 0};
var $author$project$Internal$Toolbar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.iE;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{iE: x});
		}),
	$author$project$Internal$Toolbar$Model$defaultModel);
var $author$project$Internal$Toolbar$Model$defaultCalculations = {fB: 0, j2: 0, hN: 0, kN: 0, oE: 0, lQ: 0, mq: 0, ms: 0, gE: 0};
var $author$project$Internal$Toolbar$Implementation$initKeyRatio = F2(
	function (config, geometry) {
		var toolbarRowHeight = geometry.hk;
		var toolbarRatio = (!toolbarRowHeight) ? 0 : (geometry.kb / toolbarRowHeight);
		var firstRowMaxRatio = (!toolbarRowHeight) ? 0 : (geometry.ka / toolbarRowHeight);
		var flexibleExpansionRatio_ = firstRowMaxRatio - 1;
		var maxTranslateYRatio = config.d7 ? (toolbarRatio - firstRowMaxRatio) : 0;
		var scrollThresholdRatio = config.d7 ? (toolbarRatio - 1) : (firstRowMaxRatio - 1);
		return _Utils_update(
			$author$project$Internal$Toolbar$Model$defaultCalculations,
			{j2: flexibleExpansionRatio_, kN: maxTranslateYRatio, lQ: scrollThresholdRatio, ms: toolbarRatio});
	});
var $author$project$Internal$Toolbar$Implementation$setKeyHeights = F2(
	function (geometry, calculations) {
		var toolbarRowHeight = geometry.hk;
		var toolbarHeight = calculations.ms * toolbarRowHeight;
		var scrollThreshold = calculations.lQ * toolbarRowHeight;
		var maxTranslateYDistance = calculations.kN * toolbarRowHeight;
		var flexibleExpansionHeight = calculations.j2 * toolbarRowHeight;
		return _Utils_update(
			calculations,
			{fB: flexibleExpansionHeight, hN: maxTranslateYDistance, oE: scrollThreshold, mq: toolbarHeight, gE: toolbarRowHeight});
	});
var $author$project$Internal$Toolbar$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var config = msg.a;
				var geometry = msg.b;
				var calculations = A2(
					$author$project$Internal$Toolbar$Implementation$setKeyHeights,
					geometry,
					A2($author$project$Internal$Toolbar$Implementation$initKeyRatio, config, geometry));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dR: $elm$core$Maybe$Just(calculations),
							jr: $elm$core$Maybe$Just(config),
							cR: $elm$core$Maybe$Just(geometry)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var config = msg.a;
				var geometry = msg.b;
				var calculations = A2(
					$elm$core$Maybe$map,
					$author$project$Internal$Toolbar$Implementation$setKeyHeights(geometry),
					model.dR);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dR: calculations,
							jr: $elm$core$Maybe$Just(config),
							cR: $elm$core$Maybe$Just(geometry)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var config = msg.a;
				var scrollTop = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jr: $elm$core$Maybe$Just(config),
							lR: scrollTop
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$Toolbar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$Toolbar$Implementation$getSet.j9,
	$author$project$Internal$Toolbar$Implementation$getSet.oH,
	$author$project$Internal$Msg$ToolbarMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$Toolbar$Implementation$update));
var $author$project$Internal$Msg$TopAppBarMsg = F2(
	function (a, b) {
		return {$: 19, a: a, b: b};
	});
var $author$project$Internal$TopAppBar$Model$defaultModel = {aZ: 0, ks: true, ep: $elm$core$Maybe$Nothing, eL: $elm$core$Dict$empty, l9: $elm$core$Maybe$Nothing, ay: $elm$core$Maybe$Nothing, gQ: true};
var $author$project$Internal$TopAppBar$Implementation$getSet = A3(
	$author$project$Internal$Component$indexed,
	function ($) {
		return $.mu;
	},
	F2(
		function (x, y) {
			return _Utils_update(
				y,
				{mu: x});
		}),
	$author$project$Internal$TopAppBar$Model$defaultModel);
var $author$project$Internal$TopAppBar$Model$RippleMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$Internal$TopAppBar$Implementation$checkForUpdate = function (model) {
	return A2(
		$elm$core$Maybe$map,
		function (topAppBarHeight) {
			var offscreenBoundaryTop = -topAppBarHeight;
			var hasAnyPixelsOnscreen = _Utils_cmp(model.aZ, offscreenBoundaryTop) > 0;
			var hasAnyPixelsOffscreen = model.aZ < 0;
			var partiallyShowing = hasAnyPixelsOffscreen && hasAnyPixelsOnscreen;
			return partiallyShowing ? _Utils_Tuple2(
				_Utils_update(
					model,
					{gQ: false}),
				true) : ((!model.gQ) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{gQ: true}),
				true) : ((!_Utils_eq(model.ks, hasAnyPixelsOnscreen)) ? _Utils_Tuple2(
				_Utils_update(
					model,
					{ks: hasAnyPixelsOnscreen}),
				true) : _Utils_Tuple2(model, false)));
		},
		model.ay);
};
var $author$project$Internal$TopAppBar$Implementation$moveTopAppBar = function (model) {
	return A2(
		$elm$core$Maybe$andThen,
		function (_v0) {
			var updatedModel = _v0.a;
			var partiallyShowing = _v0.b;
			return partiallyShowing ? A2(
				$elm$core$Maybe$map,
				function (topAppBarHeight) {
					var styleTop = function () {
						var maxTopAppBarHeight = 128;
						return (_Utils_cmp(
							$elm$core$Basics$abs(updatedModel.aZ),
							topAppBarHeight) > 0) ? (-maxTopAppBarHeight) : updatedModel.aZ;
					}();
					return _Utils_update(
						updatedModel,
						{
							l9: $elm$core$Maybe$Just(styleTop)
						});
				},
				updatedModel.ay) : $elm$core$Maybe$Just(updatedModel);
		},
		$author$project$Internal$TopAppBar$Implementation$checkForUpdate(model));
};
var $author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler = F2(
	function (scrollPosition, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Internal$TopAppBar$Implementation$moveTopAppBar,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var topAppBarHeight = _v0.a;
						var lastScrollPosition = _v0.b;
						var isCurrentlyBeingResized = false;
						var currentScrollPosition = A2($elm$core$Basics$max, scrollPosition, 0);
						var diff = currentScrollPosition - lastScrollPosition;
						var currentAppBarOffsetTop = model.aZ - diff;
						var updatedAppBarOffsetTop = (!isCurrentlyBeingResized) ? ((currentAppBarOffsetTop > 0) ? 0 : ((_Utils_cmp(
							$elm$core$Basics$abs(currentAppBarOffsetTop),
							topAppBarHeight) > 0) ? (-topAppBarHeight) : currentAppBarOffsetTop)) : model.aZ;
						var updatedModel = _Utils_update(
							model,
							{
								aZ: updatedAppBarOffsetTop,
								ep: $elm$core$Maybe$Just(currentScrollPosition)
							});
						return A2(
							$elm$core$Maybe$withDefault,
							updatedModel,
							$author$project$Internal$TopAppBar$Implementation$moveTopAppBar(updatedModel));
					},
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (topAppBarHeight, lastScrollPosition) {
								return _Utils_Tuple2(topAppBarHeight, lastScrollPosition);
							}),
						model.ay,
						model.ep))));
	});
var $author$project$Internal$TopAppBar$Implementation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				var msg_ = msg.b;
				var _v1 = A2(
					$author$project$Internal$Ripple$Implementation$update,
					msg_,
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Ripple$Model$defaultModel,
						A2($elm$core$Dict$get, index, model.eL)));
				var ripple = _v1.a;
				var effects = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eL: A3($elm$core$Dict$insert, index, ripple, model.eL)
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						$author$project$Internal$TopAppBar$Model$RippleMsg(index),
						effects));
			case 1:
				var scrollPosition = msg.a.$7;
				var topAppBarHeight = msg.a.ay;
				return _Utils_Tuple2(
					A2(
						$author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler,
						scrollPosition,
						_Utils_update(
							model,
							{
								ep: $elm$core$Maybe$Just(scrollPosition),
								ay: $elm$core$Maybe$Just(topAppBarHeight)
							})),
					$elm$core$Platform$Cmd$none);
			case 3:
				var scrollPosition = msg.a.$7;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, model),
					$elm$core$Platform$Cmd$none);
			default:
				var scrollPosition = msg.a.$7;
				var topAppBarHeight = msg.a.ay;
				var currentHeight = topAppBarHeight;
				var currentAppBarOffsetTop = model.aZ - (topAppBarHeight - currentHeight);
				var updatedModel = (!_Utils_eq(
					$elm$core$Maybe$Just(topAppBarHeight),
					model.ay)) ? _Utils_update(
					model,
					{
						aZ: currentAppBarOffsetTop,
						ay: $elm$core$Maybe$Just(currentHeight),
						gQ: false
					}) : model;
				return _Utils_Tuple2(
					A2($author$project$Internal$TopAppBar$Implementation$topAppBarScrollHandler, scrollPosition, updatedModel),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Internal$TopAppBar$Implementation$react = A4(
	$author$project$Internal$Component$react,
	$author$project$Internal$TopAppBar$Implementation$getSet.j9,
	$author$project$Internal$TopAppBar$Implementation$getSet.oH,
	$author$project$Internal$Msg$TopAppBarMsg,
	$author$project$Internal$Component$generalise($author$project$Internal$TopAppBar$Implementation$update));
var $author$project$Material$update_ = F3(
	function (lift, msg, store) {
		switch (msg.$) {
			case 0:
				var msgs = msg.a;
				return _Utils_Tuple2(
					$elm$core$Maybe$Nothing,
					$author$project$Internal$Dispatch$forward(msgs));
			case 1:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Button$Implementation$react, lift, msg_, idx, store);
			case 2:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Checkbox$Implementation$react, lift, msg_, idx, store);
			case 3:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Chip$Implementation$react, lift, msg_, idx, store);
			case 4:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Dialog$Implementation$react, lift, msg_, idx, store);
			case 5:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Drawer$Implementation$react, lift, msg_, idx, store);
			case 6:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Fab$Implementation$react, lift, msg_, idx, store);
			case 7:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$IconButton$Implementation$react, lift, msg_, idx, store);
			case 8:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$List$Implementation$react, lift, msg_, idx, store);
			case 9:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Menu$Implementation$react, lift, msg_, idx, store);
			case 10:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$RadioButton$Implementation$react, lift, msg_, idx, store);
			case 11:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Ripple$Implementation$react, lift, msg_, idx, store);
			case 12:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Select$Implementation$react, lift, msg_, idx, store);
			case 13:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Slider$Implementation$react, lift, msg_, idx, store);
			case 14:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Snackbar$Implementation$react, lift, msg_, idx, store);
			case 15:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Switch$Implementation$react, lift, msg_, idx, store);
			case 16:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TabBar$Implementation$react, lift, msg_, idx, store);
			case 17:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TextField$Implementation$react, lift, msg_, idx, store);
			case 18:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$Toolbar$Implementation$react, lift, msg_, idx, store);
			default:
				var idx = msg.a;
				var msg_ = msg.b;
				return A4($author$project$Internal$TopAppBar$Implementation$react, lift, msg_, idx, store);
		}
	});
var $author$project$Material$update = F3(
	function (lift, msg, container) {
		return A2(
			$elm$core$Tuple$mapFirst,
			$elm$core$Maybe$withDefault(container),
			A2(
				$elm$core$Tuple$mapFirst,
				$elm$core$Maybe$map(
					function (mdc) {
						return _Utils_update(
							container,
							{kP: mdc});
					}),
				A3(
					$author$project$Material$update_,
					lift,
					msg,
					function ($) {
						return $.kP;
					}(container))));
	});
var $author$project$Main$Ready = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Main$RouterMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Routing$Router$AdminModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Routing$Router$AdminMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Routing$Router$CourseDetailModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Routing$Router$CourseDetailMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Routing$Router$CourseEditorModel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Routing$Router$CourseEditorMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Routing$Router$CoursesModel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Routing$Router$CoursesMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Routing$Router$DashboardModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Routing$Router$DashboardMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Routing$Router$GroupEditorModel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Routing$Router$GroupEditorMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Routing$Router$LoginModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Routing$Router$LoginMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Routing$Router$LoginResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Routing$Helpers$LoginRoute = {$: 0};
var $author$project$Routing$Router$Logout = {$: 9};
var $author$project$Routing$Router$LogoutCompleted = function (a) {
	return {$: 10, a: a};
};
var $author$project$Routing$Router$MailConfirmationModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Routing$Router$MailConfirmationMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Routing$Router$MailEditorModel = function (a) {
	return {$: 16, a: a};
};
var $author$project$Routing$Router$MailEditorMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Routing$Router$MaterialEditorModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Routing$Router$MaterialEditorMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$SharedState$NoUpdate = {$: 0};
var $author$project$Routing$Router$PasswordResetModel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Routing$Router$PasswordResetMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Routing$Router$ProfileEditorModel = function (a) {
	return {$: 12, a: a};
};
var $author$project$Routing$Router$ProfileEditorMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Routing$Router$RegistrationModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routing$Router$RegistrationMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Routing$Router$RequestPasswordResetModel = function (a) {
	return {$: 14, a: a};
};
var $author$project$Routing$Router$RequestPasswordResetMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Routing$Router$SheetDetailModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Routing$Router$SheetDetailMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Routing$Router$SheetEditorModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Routing$Router$SheetEditorMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$Login$SpinnerMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$SpinnerMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Routing$Router$SubmissionGradingEditorModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Routing$Router$SubmissionGradingEditorMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Routing$Router$TermsMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Routing$Router$TermsOfUseModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Routing$Router$ToastyMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedState$UpdateLanguage = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$SheetDetail$UploadProgressMsg = function (a) {
	return {$: 2, a: a};
};
var $pablen$toasty$Toasty$Config = $elm$core$Basics$identity;
var $pablen$toasty$Toasty$config = {g2: _List_Nil, ha: 5000, hB: _List_Nil, iG: _List_Nil, iH: _List_Nil, iI: 0};
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $justgage$tachyons_elm$Tachyons$classes = function (stringList) {
	return $elm$html$Html$Attributes$class(
		A2($elm$core$String$join, ' ', stringList));
};
var $justgage$tachyons_elm$Tachyons$Classes$fixed = 'fixed';
var $justgage$tachyons_elm$Tachyons$Classes$list = 'list';
var $justgage$tachyons_elm$Tachyons$Classes$ma0 = 'ma0';
var $justgage$tachyons_elm$Tachyons$Classes$measure = 'measure';
var $justgage$tachyons_elm$Tachyons$Classes$mt4 = 'mt4';
var $justgage$tachyons_elm$Tachyons$Classes$pa0 = 'pa0';
var $justgage$tachyons_elm$Tachyons$Classes$right_0 = 'right-0';
var $justgage$tachyons_elm$Tachyons$Classes$top_0 = 'top-0';
var $justgage$tachyons_elm$Tachyons$Classes$w_100 = 'w-100';
var $author$project$Components$Toasty$containerAttrs = _List_fromArray(
	[
		$justgage$tachyons_elm$Tachyons$classes(
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$fixed, $justgage$tachyons_elm$Tachyons$Classes$top_0, $justgage$tachyons_elm$Tachyons$Classes$right_0, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$measure, $justgage$tachyons_elm$Tachyons$Classes$list, $justgage$tachyons_elm$Tachyons$Classes$pa0, $justgage$tachyons_elm$Tachyons$Classes$ma0, $justgage$tachyons_elm$Tachyons$Classes$mt4]))
	]);
var $pablen$toasty$Toasty$containerAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{g2: attrs});
	});
var $pablen$toasty$Toasty$delay = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{ha: time});
	});
var $justgage$tachyons_elm$Tachyons$Classes$mb0 = 'mb0';
var $justgage$tachyons_elm$Tachyons$Classes$mh4 = 'mh4';
var $justgage$tachyons_elm$Tachyons$Classes$ml3 = 'ml3';
var $justgage$tachyons_elm$Tachyons$Classes$mr3 = 'mr3';
var $justgage$tachyons_elm$Tachyons$Classes$mt3 = 'mt3';
var $author$project$Components$Toasty$itemAttrs = _List_fromArray(
	[
		$justgage$tachyons_elm$Tachyons$classes(
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mr3, $justgage$tachyons_elm$Tachyons$Classes$mb0, $justgage$tachyons_elm$Tachyons$Classes$ml3, $justgage$tachyons_elm$Tachyons$Classes$mh4]))
	]);
var $pablen$toasty$Toasty$itemAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{hB: attrs});
	});
var $author$project$Components$Toasty$transitionInAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated bounceInRight')
	]);
var $pablen$toasty$Toasty$transitionInAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{iG: attrs});
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Components$Toasty$transitionOutAttrs = _List_fromArray(
	[
		$elm$html$Html$Attributes$class('animated fadeOutRightBig'),
		A2($elm$html$Html$Attributes$style, 'max-height', '0'),
		A2($elm$html$Html$Attributes$style, 'margin-top', '0')
	]);
var $pablen$toasty$Toasty$transitionOutAttrs = F2(
	function (attrs, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{iH: attrs});
	});
var $pablen$toasty$Toasty$transitionOutDuration = F2(
	function (time, _v0) {
		var cfg = _v0;
		return _Utils_update(
			cfg,
			{iI: time});
	});
var $author$project$Components$Toasty$config = A2(
	$pablen$toasty$Toasty$delay,
	5000,
	A2(
		$pablen$toasty$Toasty$itemAttrs,
		$author$project$Components$Toasty$itemAttrs,
		A2(
			$pablen$toasty$Toasty$containerAttrs,
			$author$project$Components$Toasty$containerAttrs,
			A2(
				$pablen$toasty$Toasty$transitionInAttrs,
				$author$project$Components$Toasty$transitionInAttrs,
				A2(
					$pablen$toasty$Toasty$transitionOutAttrs,
					$author$project$Components$Toasty$transitionOutAttrs,
					A2($pablen$toasty$Toasty$transitionOutDuration, 700, $pablen$toasty$Toasty$config))))));
var $author$project$Utils$Utils$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $author$project$Routing$Router$HandleTranslationsResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Routing$Router$getTranslations = function (language) {
	var url = function () {
		if (!language) {
			return '/translations/en.json';
		} else {
			return '/translations/de.json';
		}
	}();
	return $elm$http$Http$get(
		{
			ao: A2(
				$elm$http$Http$expectJson,
				A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, $author$project$Routing$Router$HandleTranslationsResponse),
				$author$project$Decoders$decodeTranslations),
			aA: url
		});
};
var $elm$core$Maybe$destruct = F3(
	function (_default, func, maybe) {
		if (!maybe.$) {
			var a = maybe.a;
			return func(a);
		} else {
			return _default;
		}
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Utils$PersistantState$storeCache = _Platform_outgoingPort(
	'storeCache',
	function ($) {
		return A3($elm$core$Maybe$destruct, $elm$json$Json$Encode$null, $elm$core$Basics$identity, $);
	});
var $author$project$Utils$PersistantState$logout = $author$project$Utils$PersistantState$storeCache($elm$core$Maybe$Nothing);
var $author$project$Routing$Router$modelToLoginRequest = F2(
	function (sharedState, model) {
		var _v0 = sharedState.pg;
		if (!_v0.$) {
			var mail = _v0.a;
			return $elm$core$Maybe$Just(
				{
					jM: $elm$core$Maybe$Just(mail),
					le: $elm$core$Maybe$Just(model.le)
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Routing$Router$Password = 0;
var $rtfeldman$elm_validate$Validate$Validator = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$all = function (validators) {
	var newGetErrors = function (subject) {
		var accumulateErrors = F2(
			function (_v0, totalErrors) {
				var getErrors = _v0;
				return _Utils_ap(
					totalErrors,
					getErrors(subject));
			});
		return A3($elm$core$List$foldl, accumulateErrors, _List_Nil, validators);
	};
	return newGetErrors;
};
var $rtfeldman$elm_validate$Validate$ifTrue = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_fromArray(
				[error]) : _List_Nil;
		};
		return getErrors;
	});
var $rtfeldman$elm_validate$Validate$isWhitespaceChar = function (_char) {
	return (_char === ' ') || ((_char === '\n') || ((_char === '\t') || (_char === '\u000D')));
};
var $rtfeldman$elm_validate$Validate$isBlank = function (str) {
	isBlank:
	while (true) {
		var _v0 = $elm$core$String$uncons(str);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var _char = _v1.a;
			var rest = _v1.b;
			if ($rtfeldman$elm_validate$Validate$isWhitespaceChar(_char)) {
				var $temp$str = rest;
				str = $temp$str;
				continue isBlank;
			} else {
				return false;
			}
		} else {
			return true;
		}
	}
};
var $rtfeldman$elm_validate$Validate$ifBlank = F2(
	function (subjectToString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return $rtfeldman$elm_validate$Validate$isBlank(
					subjectToString(subject));
			},
			error);
	});
var $author$project$Routing$Router$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.le;
			},
			_Utils_Tuple2(0, 'Bitte gib dein Passwort ein.'))
		]));
var $author$project$Routing$Router$NotFound = {$: 18};
var $author$project$Pages$Admin$init = _Utils_Tuple2(
	{jK: 0},
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$CourseDetail$CourseResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CourseDetail$CourseRoleResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CourseDetail$ExamEnrollmentResponse = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$CourseDetail$ExamsResponse = function (a) {
	return {$: 25, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $author$project$Pages$CourseDetail$MaterialRequestResponse = function (a) {
	return {$: 15, a: a};
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Pages$CourseDetail$PointOverviewResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$CourseDetail$SheetRequestResponse = function (a) {
	return {$: 14, a: a};
};
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Api$Endpoint$url = F2(
	function (paths, queryParams) {
		return A2(
			$elm$url$Url$Builder$absolute,
			A2(
				$elm$core$List$cons,
				'api',
				A2($elm$core$List$cons, 'v1', paths)),
			queryParams);
	});
var $author$project$Api$Endpoint$accountEnrollment = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['account', 'enrollments']),
	_List_Nil);
var $author$project$Api$Data$AccountEnrollment$AccountEnrollment = F3(
	function (id, course_id, role) {
		return {jv: course_id, ki: id, lJ: role};
	});
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Api$Data$CourseRole$Admin = 2;
var $author$project$Api$Data$CourseRole$Student = 0;
var $author$project$Api$Data$CourseRole$Tutor = 1;
var $author$project$Api$Data$CourseRole$intToRole = function (_int) {
	switch (_int) {
		case 2:
			return $elm$core$Maybe$Just(2);
		case 1:
			return $elm$core$Maybe$Just(1);
		case 0:
			return $elm$core$Maybe$Just(0);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Api$Data$CourseRole$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (_int) {
		var _v0 = $author$project$Api$Data$CourseRole$intToRole(_int);
		if (!_v0.$) {
			var role = _v0.a;
			return $elm$json$Json$Decode$succeed(role);
		} else {
			return $elm$json$Json$Decode$fail('Not recognized role');
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$Api$Data$AccountEnrollment$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role',
	$author$project$Api$Data$CourseRole$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'course_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Data$AccountEnrollment$AccountEnrollment))));
var $author$project$Api$Helper$get = F3(
	function (url, msg, decoder) {
		return $elm$http$Http$request(
			{
				al: $elm$http$Http$emptyBody,
				ao: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
					decoder),
				ar: _List_Nil,
				as: 'GET',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Api$Endpoint$unwrap = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Api$Request$Account$accountEnrollmentGet = function (msg) {
	return A3(
		$author$project$Api$Helper$get,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$accountEnrollment),
		msg,
		$elm$json$Json$Decode$list($author$project$Api$Data$AccountEnrollment$decoder));
};
var $author$project$Api$Endpoint$course = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id)
			]),
		_List_Nil);
};
var $author$project$Api$Data$Course$Course = F6(
	function (id, name, description, begins_at, ends_at, required_percentage) {
		return {i8: begins_at, jC: description, jQ: ends_at, ki: id, kY: name, lE: required_percentage};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {jq: col, m8: contextStack, lo: problem, lL: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.lL, s.jq, x, s.g));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.a),
			s.b) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.a);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.b, offset) < 0,
					0,
					{jq: col, g: s0.g, k: s0.k, b: offset, lL: row, a: s0.a});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.b, s.lL, s.jq, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.b, s1.b, s0.a),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	return A2(
		$elm$parser$Parser$andThen,
		function (str) {
			if (_Utils_eq(
				$elm$core$String$length(str),
				quantity)) {
				var _v0 = $elm$core$String$toInt(str);
				if (!_v0.$) {
					var intVal = _v0.a;
					return $elm$parser$Parser$succeed(intVal);
				} else {
					return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
				}
			} else {
				return $elm$parser$Parser$problem(
					'Expected ' + ($elm$core$String$fromInt(quantity) + (' digits, but got ' + $elm$core$String$fromInt(
						$elm$core$String$length(str)))));
			}
		},
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.b, s.lL, s.jq, s.a);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{jq: newCol, g: s.g, k: s.k, b: newOffset, lL: newRow, a: s.a});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4),
					$elm$parser$Parser$symbol('-'))),
			A2(
				$elm$parser$Parser$ignorer,
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
				$elm$parser$Parser$symbol('-'))),
		$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts = F3(
	function (multiplier, hours, minutes) {
		return multiplier * ((hours * 60) + minutes);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									A2(
										$elm$parser$Parser$ignorer,
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$symbol(':'))),
								A2(
									$elm$parser$Parser$ignorer,
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
									$elm$parser$Parser$symbol(':'))),
							$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$map,
								function (_v0) {
									return 0;
								},
								$elm$parser$Parser$symbol('Z')),
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$keeper,
										$elm$parser$Parser$succeed($rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetMinutesFromParts),
										$elm$parser$Parser$oneOf(
											_List_fromArray(
												[
													A2(
													$elm$parser$Parser$map,
													function (_v1) {
														return 1;
													},
													$elm$parser$Parser$symbol('+')),
													A2(
													$elm$parser$Parser$map,
													function (_v2) {
														return -1;
													},
													$elm$parser$Parser$symbol('-'))
												]))),
									A2(
										$elm$parser$Parser$ignorer,
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$symbol(':'))),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2))
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {jq: col, lo: problem, lL: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.lL, p.jq, p.lo);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{jq: 1, g: _List_Nil, k: 1, b: 0, lL: 1, a: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$elm$parser$Parser$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Data$Course$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'required_percentage',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ends_at',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'begins_at',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Api$Data$Course$Course)))))));
var $author$project$Api$Request$Courses$courseGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$course(id)),
			msg,
			$author$project$Api$Data$Course$decoder);
	});
var $author$project$Api$Endpoint$courseMaterials = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'materials'
			]),
		_List_Nil);
};
var $author$project$Api$Data$Material$Material = F7(
	function (id, file_url, name, material_type, published_at, lecture_at, required_role) {
		return {jZ: file_url, ki: id, kC: lecture_at, kJ: material_type, kY: name, ly: published_at, lF: required_role};
	});
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Data$Material$Slide = 1;
var $author$project$Api$Data$Material$Supplementary = 0;
var $author$project$Api$Data$Material$typeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		if (!v) {
			return $elm$json$Json$Decode$succeed(1);
		} else {
			return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$Api$Data$Material$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'required_role',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'lecture_at',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'publish_at',
			$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'kind',
				$author$project$Api$Data$Material$typeDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'file_url',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						$elm$core$Maybe$Nothing,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Api$Data$Material$Material))))))));
var $author$project$Api$Request$Courses$courseMaterialsGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseMaterials(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Material$decoder));
	});
var $author$project$Api$Endpoint$coursePoints = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'points'
			]),
		_List_Nil);
};
var $author$project$Api$Data$PointOverview$PointOverview = F5(
	function (acquired_points, achievable_points, max_points, sheet_id, task_id) {
		return {iW: achievable_points, iX: acquired_points, kO: max_points, lZ: sheet_id, ml: task_id};
	});
var $author$project$Api$Data$PointOverview$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'task_id',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sheet_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'max_points',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'achievable_points',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'acquired_points',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Data$PointOverview$PointOverview))))));
var $author$project$Api$Request$Courses$coursePointsGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$coursePoints(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$PointOverview$decoder));
	});
var $author$project$Api$Endpoint$courseSheets = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'sheets'
			]),
		_List_Nil);
};
var $author$project$Api$Data$Sheet$Sheet = F4(
	function (id, name, publish_at, due_at) {
		return {jJ: due_at, ki: id, kY: name, lx: publish_at};
	});
var $author$project$Api$Data$Sheet$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'due_at',
	$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'publish_at',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Data$Sheet$Sheet)))));
var $author$project$Api$Request$Courses$courseSheetsGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseSheets(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Sheet$decoder));
	});
var $author$project$Api$Data$Exam$ExamEnrollment = F5(
	function (status, mark, user_id, course_id, exam_id) {
		return {jv: course_id, jS: exam_id, kI: mark, l5: status, mG: user_id};
	});
var $author$project$Api$Data$Exam$enrollmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'exam_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'course_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user_id',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'mark',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'status',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Data$Exam$ExamEnrollment))))));
var $author$project$Api$Data$Exam$enrollmentsDecoder = $elm$json$Json$Decode$list($author$project$Api$Data$Exam$enrollmentDecoder);
var $author$project$Api$Endpoint$examEnrollments = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['account', 'exams', 'enrollments']),
	_List_Nil);
var $author$project$Api$Request$Exam$examEnrollmentsStudentGet = function (msg) {
	return A3(
		$author$project$Api$Helper$get,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$examEnrollments),
		msg,
		$author$project$Api$Data$Exam$enrollmentsDecoder);
};
var $author$project$Api$Endpoint$courseExams = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'exams'
			]),
		_List_Nil);
};
var $author$project$Api$Data$Exam$Exam = F5(
	function (id, name, description, exam_time, course_id) {
		return {jv: course_id, jC: description, jT: exam_time, ki: id, kY: name};
	});
var $author$project$Api$Data$Exam$examDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'course_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'exam_time',
		$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Data$Exam$Exam))))));
var $author$project$Api$Data$Exam$examsDecoder = $elm$json$Json$Decode$list($author$project$Api$Data$Exam$examDecoder);
var $author$project$Api$Request$Exam$examsGet = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseExams(courseId)),
			msg,
			$author$project$Api$Data$Exam$examsDecoder);
	});
var $author$project$Pages$CourseDetail$initNewExam = A5(
	$author$project$Api$Data$Exam$Exam,
	42,
	'Neue Prüfung',
	'Beschreibung',
	$elm$time$Time$millisToPosix(0),
	0);
var $author$project$Pages$CourseDetail$init = function (id) {
	return _Utils_Tuple2(
		{ju: id, cB: $krisajenkins$remotedata$RemoteData$Loading, Y: $elm$core$Maybe$Nothing, fp: $krisajenkins$remotedata$RemoteData$Loading, jR: $krisajenkins$remotedata$RemoteData$NotAsked, cM: $krisajenkins$remotedata$RemoteData$NotAsked, ab: $elm$core$Dict$empty, F: $elm$core$Dict$empty, a0: $elm$core$Dict$empty, ac: $elm$core$Dict$empty, G: $elm$core$Dict$empty, t: $elm$core$Dict$empty, aO: $elm$core$Maybe$Nothing, ef: $krisajenkins$remotedata$RemoteData$NotAsked, aP: $krisajenkins$remotedata$RemoteData$NotAsked, fY: $krisajenkins$remotedata$RemoteData$Loading, k$: $author$project$Pages$CourseDetail$initNewExam, k0: false, ba: $krisajenkins$remotedata$RemoteData$NotAsked, gd: $krisajenkins$remotedata$RemoteData$NotAsked, eE: $krisajenkins$remotedata$RemoteData$Loading, eO: '', ii: '', eP: $krisajenkins$remotedata$RemoteData$NotAsked, lT: $krisajenkins$remotedata$RemoteData$NotAsked, gv: $krisajenkins$remotedata$RemoteData$Loading, gy: $elm$core$Dict$empty, e0: $krisajenkins$remotedata$RemoteData$NotAsked, dz: $krisajenkins$remotedata$RemoteData$NotAsked},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$CourseDetail$CourseRoleResponse),
					A2($author$project$Api$Request$Courses$courseGet, id, $author$project$Pages$CourseDetail$CourseResponse),
					A2($author$project$Api$Request$Courses$courseSheetsGet, id, $author$project$Pages$CourseDetail$SheetRequestResponse),
					A2($author$project$Api$Request$Courses$courseMaterialsGet, id, $author$project$Pages$CourseDetail$MaterialRequestResponse),
					A2($author$project$Api$Request$Courses$coursePointsGet, id, $author$project$Pages$CourseDetail$PointOverviewResponse),
					A2($author$project$Api$Request$Exam$examsGet, id, $author$project$Pages$CourseDetail$ExamsResponse),
					$author$project$Api$Request$Exam$examEnrollmentsStudentGet($author$project$Pages$CourseDetail$ExamEnrollmentResponse)
				])));
};
var $author$project$Pages$Courses$AccountEnrollmentsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Courses$CoursesResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Endpoint$courses = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['courses']),
	_List_Nil);
var $author$project$Api$Request$Courses$coursesGet = function (msg) {
	return A3(
		$author$project$Api$Helper$get,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$courses),
		msg,
		$elm$json$Json$Decode$list($author$project$Api$Data$Course$decoder));
};
var $pablen$toasty$Toasty$Stack = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $pablen$toasty$Toasty$initialState = A2(
	$pablen$toasty$Toasty$Stack,
	_List_Nil,
	$elm$random$Random$initialSeed(0));
var $author$project$Pages$Courses$init = _Utils_Tuple2(
	{cq: $krisajenkins$remotedata$RemoteData$Loading, cB: $krisajenkins$remotedata$RemoteData$Loading, cC: $elm$core$Maybe$Nothing, cD: $elm$core$Maybe$Nothing, b1: false, b2: false, du: false, iC: $pablen$toasty$Toasty$initialState},
	$elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$Courses$AccountEnrollmentsResponse),
				$author$project$Api$Request$Courses$coursesGet($author$project$Pages$Courses$CoursesResponse)
			])));
var $author$project$Routing$Helpers$CoursesRoute = {$: 3};
var $author$project$Pages$Dashboard$GetAccountEnrollments = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Dashboard$GetCourses = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Dashboard$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Utils$Utils$perform = A2(
	$elm$core$Basics$composeL,
	$elm$core$Task$perform($elm$core$Basics$identity),
	$elm$core$Task$succeed);
var $author$project$Pages$Dashboard$init = function (sharedState) {
	var startRequests = $elm$core$Platform$Cmd$batch(
		_List_fromArray(
			[
				$author$project$Api$Request$Courses$coursesGet($author$project$Pages$Dashboard$GetCourses),
				$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$Dashboard$GetAccountEnrollments)
			]));
	return _Utils_Tuple2(
		{aN: $elm$core$Dict$empty, cS: $krisajenkins$remotedata$RemoteData$Loading, cU: $krisajenkins$remotedata$RemoteData$Loading, bO: $elm$core$Dict$empty, e$: $elm$core$Dict$empty},
		function () {
			var _v0 = _Utils_Tuple2(sharedState.pg, sharedState.lJ);
			if ((!_v0.a.$) && (!_v0.b.$)) {
				var role = _v0.b.a;
				return role.lK ? $author$project$Utils$Utils$perform(
					$author$project$Pages$Dashboard$NavigateTo($author$project$Routing$Helpers$CoursesRoute)) : startRequests;
			} else {
				return startRequests;
			}
		}());
};
var $damienklinnert$elm_spinner$Spinner$Model = $elm$core$Basics$identity;
var $damienklinnert$elm_spinner$Spinner$init = $elm$time$Time$millisToPosix(0);
var $author$project$Pages$Login$init = _Utils_Tuple2(
	{jM: '', hf: _List_Nil, eu: $krisajenkins$remotedata$RemoteData$NotAsked, le: '', eW: $damienklinnert$elm_spinner$Spinner$init},
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$MailConfirmation$ConfirmationResponse = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$confirmEmail = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['auth', 'confirm_email']),
	_List_Nil);
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Data$MailConfirmation$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.jM)),
				_Utils_Tuple2(
				'confirmation_token',
				$elm$json$Json$Encode$string(model.js))
			]));
};
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Api$Helper$postExpectNothing = F3(
	function (url, body, msg) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg)),
				ar: _List_Nil,
				as: 'POST',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Request$Auth$confirmMailPost = F2(
	function (confirmation, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$confirmEmail),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$MailConfirmation$encoder(confirmation)),
			msg);
	});
var $author$project$Pages$MailConfirmation$init = F2(
	function (email, token) {
		var confirmation = {js: token, jM: email};
		return _Utils_Tuple2(
			{fo: $krisajenkins$remotedata$RemoteData$Loading},
			A2($author$project$Api$Request$Auth$confirmMailPost, confirmation, $elm$core$Basics$identity));
	});
var $author$project$Pages$PasswordReset$init = F2(
	function (email, token) {
		return _Utils_Tuple2(
			{jM: email, hf: _List_Nil, lb: '', dg: '', iC: $pablen$toasty$Toasty$initialState, iD: token},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Pages$ProfileEditor$UserGetResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Data$User$User = function (id) {
	return function (firstname) {
		return function (lastname) {
			return function (avatarUrl) {
				return function (email) {
					return function (studentNumber) {
						return function (semester) {
							return function (subject) {
								return function (language) {
									return function (root) {
										return {i3: avatarUrl, jM: email, j_: firstname, ki: id, kA: language, kB: lastname, lK: root, lW: semester, oR: studentNumber, mb: subject};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Data$User$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'root',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$bool),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'language',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'subject',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'semester',
				$elm$json$Json$Decode$int,
				0,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'student_number',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'email',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'avatar_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							$elm$core$Maybe$Nothing,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'last_name',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'first_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$int,
										$elm$json$Json$Decode$succeed($author$project$Api$Data$User$User)))))))))));
var $author$project$Api$Endpoint$me = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['me']),
	_List_Nil);
var $author$project$Api$Request$Me$meGet = function (msg) {
	return A3(
		$author$project$Api$Helper$get,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$me),
		msg,
		$author$project$Api$Data$User$decoder);
};
var $author$project$Pages$ProfileEditor$init = _Utils_Tuple2(
	{gR: false, bq: _List_Nil, dL: $elm$core$Maybe$Nothing, cv: false, jM: '', j_: '', bB: false, kB: '', k3: '', lb: '', dg: '', dj: '', lW: '', oR: '', mb: '', iC: $pablen$toasty$Toasty$initialState, mE: $krisajenkins$remotedata$RemoteData$Loading, bi: _List_Nil},
	$author$project$Api$Request$Me$meGet($author$project$Pages$ProfileEditor$UserGetResponse));
var $author$project$Pages$Registration$init = _Utils_Tuple2(
	{cG: 'Bachelor of Science', jM: '', hf: _List_Nil, hi: '', c$: false, hD: '', ex: false, lb: '', dg: '', ch: $krisajenkins$remotedata$RemoteData$NotAsked, lW: '', oR: '', mb: 'Informatik', iC: $pablen$toasty$Toasty$initialState},
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$RequestPasswordReset$init = _Utils_Tuple2(
	{jM: '', hf: _List_Nil, iC: $pablen$toasty$Toasty$initialState},
	$elm$core$Platform$Cmd$none);
var $author$project$Pages$SheetDetail$GetCourseResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$SheetDetail$GetEnrollmentResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$SheetDetail$GetOwnGroupsResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$SheetDetail$GetSheetDetailResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$SheetDetail$GetTaskFetchResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$courseGroupsOwn = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'groups',
				'own'
			]),
		_List_Nil);
};
var $author$project$Api$Data$Group$Group = F4(
	function (id, description, tutor, courseId) {
		return {ju: courseId, jC: description, ki: id, mB: tutor};
	});
var $author$project$Api$Data$Group$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'course_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'tutor',
		$author$project$Api$Data$User$decoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'description',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Data$Group$Group)))));
var $author$project$Api$Request$Courses$courseOwnGroupGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseGroupsOwn(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Group$decoder));
	});
var $author$project$Api$Endpoint$sheet = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'sheets',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Sheet$sheetGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheet, courseId, id)),
			msg,
			$author$project$Api$Data$Sheet$decoder);
	});
var $author$project$Api$Data$Task$Task = F7(
	function (id, name, max_points, public_tests_url, public_docker_image, private_tests_url, private_docker_image) {
		return {ki: id, kO: max_points, kY: name, lj: private_docker_image, ln: private_tests_url, ls: public_docker_image, lw: public_tests_url};
	});
var $author$project$Api$Data$Task$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'private_docker_image',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'private_tests_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'public_docker_image',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'public_tests_url',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				$elm$core$Maybe$Nothing,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'max_points',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$Api$Data$Task$Task))))))));
var $author$project$Api$Endpoint$sheetTasks = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'sheets',
					$elm$core$String$fromInt(id),
					'tasks'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Sheet$sheetTasksGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheetTasks, courseId, id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Task$decoder));
	});
var $author$project$Pages$SheetDetail$init = F2(
	function (course_id, id) {
		return _Utils_Tuple2(
			{jv: course_id, ki: id, gc: $krisajenkins$remotedata$RemoteData$Loading, eE: $krisajenkins$remotedata$RemoteData$NotAsked, gn: $elm$core$Maybe$Nothing, lJ: $elm$core$Maybe$Nothing, eS: $krisajenkins$remotedata$RemoteData$Loading, e$: $elm$core$Dict$empty, gA: $krisajenkins$remotedata$RemoteData$Loading},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Request$Sheet$sheetTasksGet, course_id, id, $author$project$Pages$SheetDetail$GetTaskFetchResponse),
						A3($author$project$Api$Request$Sheet$sheetGet, course_id, id, $author$project$Pages$SheetDetail$GetSheetDetailResponse),
						$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$SheetDetail$GetEnrollmentResponse),
						A2($author$project$Api$Request$Courses$courseGet, course_id, $author$project$Pages$SheetDetail$GetCourseResponse),
						A2($author$project$Api$Request$Courses$courseOwnGroupGet, course_id, $author$project$Pages$SheetDetail$GetOwnGroupsResponse)
					])));
	});
var $author$project$Pages$SubmissionGradingEditor$GetGrades = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$GetGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$GetTask = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$courseGrades = F2(
	function (courseId, params) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'grades'
				]),
			params);
	});
var $author$project$Api$Data$Grade$Grade = function (id) {
	return function (updated_at) {
		return function (public_execution_state) {
			return function (private_execution_state) {
				return function (public_test_log) {
					return function (private_test_log) {
						return function (public_test_status) {
							return function (private_test_status) {
								return function (acquired_points) {
									return function (feedback) {
										return function (tutor_id) {
											return function (submission_id) {
												return function (users) {
													return function (file_url) {
														return function (plagiat) {
															return {iX: acquired_points, jX: feedback, jZ: file_url, ki: id, ld: plagiat, lk: private_execution_state, ll: private_test_log, lm: private_test_status, lt: public_execution_state, lu: public_test_log, lv: public_test_status, mc: submission_id, mC: tutor_id, mD: updated_at, mH: users};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Data$Grade$Finished = 2;
var $author$project$Api$Data$Grade$Pending = 0;
var $author$project$Api$Data$Grade$Running = 1;
var $author$project$Api$Data$Grade$executionStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		switch (v) {
			case 0:
				return $elm$json$Json$Decode$succeed(0);
			case 1:
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$Api$Data$Grade$Failed = 1;
var $author$project$Api$Data$Grade$Ok = 0;
var $author$project$Api$Data$Grade$testStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (v) {
		if (!v) {
			return $elm$json$Json$Decode$succeed(0);
		} else {
			return $elm$json$Json$Decode$succeed(1);
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$Api$Data$Grade$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'plagiat',
	$elm$json$Json$Decode$bool,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'file_url',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'users',
			$elm$json$Json$Decode$list($author$project$Api$Data$User$decoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'submission_id',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'tutor_id',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'feedback',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'acquired_points',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'private_test_status',
								$author$project$Api$Data$Grade$testStatusDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'public_test_status',
									$author$project$Api$Data$Grade$testStatusDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'private_test_log',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'public_test_log',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'private_execution_state',
												$author$project$Api$Data$Grade$executionStateDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'public_execution_state',
													$author$project$Api$Data$Grade$executionStateDecoder,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'updated_at',
														$rtfeldman$elm_iso8601_date_strings$Iso8601$decoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$Api$Data$Grade$Grade))))))))))))))));
var $author$project$Api$Request$Courses$courseGradesGet = F3(
	function (courseId, params, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseGrades, courseId, params)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Grade$decoder));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $author$project$Api$Request$Courses$courseGradesGetPerTaskAndGroup = F4(
	function (courseId, taskId, groupId, msg) {
		var params = _List_fromArray(
			[
				A2($elm$url$Url$Builder$int, 'task_id', taskId),
				A2($elm$url$Url$Builder$int, 'group_id', groupId)
			]);
		return A3($author$project$Api$Request$Courses$courseGradesGet, courseId, params, msg);
	});
var $author$project$Api$Endpoint$courseGroups = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'groups'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Courses$courseGroupsGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseGroups(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Group$decoder));
	});
var $author$project$Api$Endpoint$task = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$task, courseId, id)),
			msg,
			$author$project$Api$Data$Task$decoder);
	});
var $author$project$Pages$SubmissionGradingEditor$init = F3(
	function (courseId, taskId, groupId) {
		return _Utils_Tuple2(
			{ju: courseId, bw: $elm$core$Dict$empty, ec: $elm$core$Dict$empty, fF: $krisajenkins$remotedata$RemoteData$Loading, fG: $krisajenkins$remotedata$RemoteData$Loading, fH: $krisajenkins$remotedata$RemoteData$Loading, ed: $elm$core$Dict$empty, b6: $elm$core$Dict$empty, ee: true, ke: groupId, eW: $damienklinnert$elm_spinner$Spinner$init, ix: taskId},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Api$Request$Courses$courseGradesGetPerTaskAndGroup, courseId, taskId, groupId, $author$project$Pages$SubmissionGradingEditor$GetGrades),
						A3($author$project$Api$Request$Task$taskGet, courseId, taskId, $author$project$Pages$SubmissionGradingEditor$GetTask),
						A2($author$project$Api$Request$Courses$courseGroupsGet, courseId, $author$project$Pages$SubmissionGradingEditor$GetGroups)
					])));
	});
var $author$project$Pages$Terms$TermsOfUseResponse = $elm$core$Basics$identity;
var $author$project$Api$Request$Terms$Terms = function (terms) {
	return {oY: terms};
};
var $author$project$Api$Request$Terms$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'text',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Api$Request$Terms$Terms));
var $author$project$Api$Endpoint$terms = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['privacy_statement']),
	_List_Nil);
var $author$project$Api$Request$Terms$termsOfUseGet = function (msg) {
	return A3(
		$author$project$Api$Helper$get,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$terms),
		msg,
		$author$project$Api$Request$Terms$decoder);
};
var $author$project$Pages$Terms$init = _Utils_Tuple2(
	{oY: ''},
	$author$project$Api$Request$Terms$termsOfUseGet($elm$core$Basics$identity));
var $author$project$Pages$CourseEditor$BeginDatePicker = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$CourseEditor$EndDatePicker = function (a) {
	return {$: 6, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.it, posixMinutes) < 0) {
					return posixMinutes + era.b;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		jy: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		kV: month,
		mR: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jy;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).kV;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).mR;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		fE: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		bA: false,
		aR: $elm$core$Maybe$Nothing,
		B: false,
		cl: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$Pages$CourseEditor$initModel = function () {
	var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
	var endDatePicker = _v0.a;
	var endDatePickerFx = _v0.b;
	var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
	var beginDatePicker = _v1.a;
	var beginDatePickerFx = _v1.b;
	return _Utils_Tuple2(
		{aH: $elm$core$Maybe$Nothing, dO: beginDatePicker, bX: '', cE: true, jC: '', an: $elm$core$Maybe$Nothing, d4: endDatePicker, hf: _List_Nil, cT: $krisajenkins$remotedata$RemoteData$NotAsked, ki: 0, lE: $elm$core$Maybe$Nothing, iC: $pablen$toasty$Toasty$initialState},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseEditor$BeginDatePicker, beginDatePickerFx),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseEditor$EndDatePicker, endDatePickerFx)
				])));
}();
var $author$project$Pages$CourseEditor$initCreate = function () {
	var _v0 = $author$project$Pages$CourseEditor$initModel;
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(model, cmd);
}();
var $author$project$Pages$GroupEditor$initModel = {ju: 0, bY: false, jC: '', hf: _List_Nil, ke: 0, cc: $elm$core$Maybe$Nothing, eN: '', gs: '', dp: $krisajenkins$remotedata$RemoteData$NotAsked};
var $author$project$Pages$GroupEditor$initCreate = function (courseId) {
	return _Utils_Tuple2(
		_Utils_update(
			$author$project$Pages$GroupEditor$initModel,
			{ju: courseId, bY: true}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$Pages$MaterialEditor$GetRealOffset = {$: 5};
var $stephenreddek$elm_time_picker$TimePicker$TimePicker = $elm$core$Basics$identity;
var $stephenreddek$elm_time_picker$TimePicker$init = function (initialValue) {
	return {aR: $elm$core$Maybe$Nothing, B: false, fa: initialValue};
};
var $CurrySoftware$elm_datepicker$DatePicker$initFromDate = function (date) {
	return {
		fE: $elm$core$Maybe$Just(date),
		bA: false,
		aR: $elm$core$Maybe$Nothing,
		B: false,
		cl: date
	};
};
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $author$project$Utils$DateAndTimeUtils$pickerTimeFromPosix = F2(
	function (zone, posix) {
		var second = A2($elm$time$Time$toSecond, zone, posix);
		var minute = A2($elm$time$Time$toMinute, zone, posix);
		var hour = A2($elm$time$Time$toHour, zone, posix);
		return {ho: hour, hS: minute, gu: second};
	});
var $author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex = 14;
var $author$project$Pages$MaterialEditor$initModel = function (sharedState) {
	var publishedDatePicker = $CurrySoftware$elm_datepicker$DatePicker$initFromDate(
		A2(
			$justinmimbs$date$Date$fromPosix,
			A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				sharedState.jx)));
	var pickerTime = A2(
		$author$project$Utils$DateAndTimeUtils$pickerTimeFromPosix,
		A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
		A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			sharedState.jx));
	var pickerDate = A2(
		$justinmimbs$date$Date$fromPosix,
		A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
		A2(
			$elm$core$Maybe$withDefault,
			$elm$time$Time$millisToPosix(0),
			sharedState.jx));
	var lectureDatePicker = $CurrySoftware$elm_datepicker$DatePicker$initFromDate(
		A2(
			$justinmimbs$date$Date$fromPosix,
			A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				sharedState.jx)));
	var currentTime = A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		sharedState.jx);
	return _Utils_Tuple2(
		{
			jv: 0,
			bZ: true,
			d_: false,
			hf: _List_Nil,
			d6: $elm$core$Maybe$Nothing,
			fx: false,
			bB: false,
			ki: 0,
			a4: $elm$core$Maybe$Just(pickerDate),
			bE: $elm$core$Maybe$Just(pickerTime),
			eq: lectureDatePicker,
			bF: $elm$core$Maybe$Just(currentTime),
			c1: $stephenreddek$elm_time_picker$TimePicker$init(
				$elm$core$Maybe$Just(pickerTime)),
			c6: $krisajenkins$remotedata$RemoteData$NotAsked,
			bH: 1,
			kY: '',
			bb: $elm$core$Maybe$Just(pickerDate),
			bL: $elm$core$Maybe$Just(pickerTime),
			eI: publishedDatePicker,
			bM: $elm$core$Maybe$Just(currentTime),
			dk: $stephenreddek$elm_time_picker$TimePicker$init(
				$elm$core$Maybe$Just(pickerTime)),
			bc: 0,
			iC: $pablen$toasty$Toasty$initialState,
			aB: $author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex
		},
		$author$project$Utils$Utils$perform($author$project$Pages$MaterialEditor$GetRealOffset));
};
var $author$project$Pages$MaterialEditor$initCreate = F2(
	function (courseId, sharedModel) {
		var _v0 = $author$project$Pages$MaterialEditor$initModel(sharedModel);
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{jv: courseId}),
			cmd);
	});
var $author$project$Pages$SheetEditor$DeadlineDatePickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$SheetEditor$GetRealOffset = {$: 5};
var $author$project$Pages$SheetEditor$PublishedDatePickerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$SheetEditor$initModel = function () {
	var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
	var publishedDatePicker = _v0.a;
	var publishedDatePickerFx = _v0.b;
	var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
	var deadlineDatePicker = _v1.a;
	var deadlineDatePickerFx = _v1.b;
	return _Utils_Tuple2(
		{
			jv: 0,
			b_: true,
			a_: $elm$core$Maybe$Nothing,
			bt: $elm$core$Maybe$Nothing,
			dX: deadlineDatePicker,
			Z: $elm$core$Maybe$Nothing,
			cF: $stephenreddek$elm_time_picker$TimePicker$init($elm$core$Maybe$Nothing),
			d$: false,
			hf: _List_Nil,
			d6: $elm$core$Maybe$Nothing,
			fx: false,
			bB: false,
			ki: 0,
			kY: '',
			bb: $elm$core$Maybe$Nothing,
			bL: $elm$core$Maybe$Nothing,
			eI: publishedDatePicker,
			bM: $elm$core$Maybe$Nothing,
			dk: $stephenreddek$elm_time_picker$TimePicker$init($elm$core$Maybe$Nothing),
			dr: $krisajenkins$remotedata$RemoteData$NotAsked,
			iC: $pablen$toasty$Toasty$initialState,
			aB: $author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex
		},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetEditor$PublishedDatePickerMsg, publishedDatePickerFx),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetEditor$DeadlineDatePickerMsg, deadlineDatePickerFx),
					$author$project$Utils$Utils$perform($author$project$Pages$SheetEditor$GetRealOffset)
				])));
}();
var $author$project$Pages$SheetEditor$initCreate = function (courseId) {
	var _v0 = $author$project$Pages$SheetEditor$initModel;
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{jv: courseId}),
		cmd);
};
var $author$project$Pages$CourseEditor$CourseGetResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CourseEditor$initEdit = function (id) {
	var _v0 = $author$project$Pages$CourseEditor$initModel;
	var model = _v0.a;
	var cmd = _v0.b;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{cE: false, cT: $krisajenkins$remotedata$RemoteData$Loading, ki: id}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					A2($author$project$Api$Request$Courses$courseGet, id, $author$project$Pages$CourseEditor$CourseGetResponse)
				])));
};
var $author$project$Pages$MaterialEditor$MaterialGetResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Endpoint$material = F2(
	function (courseId, materialId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'materials',
					$elm$core$String$fromInt(materialId)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Material$materialGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$material, courseId, id)),
			msg,
			$author$project$Api$Data$Material$decoder);
	});
var $author$project$Pages$MaterialEditor$initEdit = F3(
	function (courseId, id, sharedState) {
		var _v0 = $author$project$Pages$MaterialEditor$initModel(sharedState);
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{jv: courseId, bZ: false}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A3($author$project$Api$Request$Material$materialGet, courseId, id, $author$project$Pages$MaterialEditor$MaterialGetResponse)
					])));
	});
var $author$project$Pages$SheetEditor$SheetGetResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$SheetEditor$initEdit = F2(
	function (courseId, id) {
		var _v0 = $author$project$Pages$SheetEditor$initModel;
		var model = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{jv: courseId, b_: false}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						cmd,
						A3($author$project$Api$Request$Sheet$sheetGet, courseId, id, $author$project$Pages$SheetEditor$SheetGetResponse)
					])));
	});
var $author$project$Pages$GroupEditor$GetGroupResponse = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Endpoint$group = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'groups',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Groups$groupsGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$group, courseId, id)),
			msg,
			$author$project$Api$Data$Group$decoder);
	});
var $author$project$Pages$GroupEditor$initEditFromId = F2(
	function (courseId, groupId) {
		return _Utils_Tuple2(
			$author$project$Pages$GroupEditor$initModel,
			A3($author$project$Api$Request$Groups$groupsGet, courseId, groupId, $author$project$Pages$GroupEditor$GetGroupResponse));
	});
var $author$project$Pages$MailEditor$Course = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$MailEditor$CourseResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$MailEditor$initModelFromMode = function (mode) {
	return {c0: false, kS: '', db: mode, mb: '', iC: $pablen$toasty$Toasty$initialState};
};
var $author$project$Pages$MailEditor$initForCourse = function (courseId) {
	return _Utils_Tuple2(
		$author$project$Pages$MailEditor$initModelFromMode(
			A2($author$project$Pages$MailEditor$Course, courseId, $krisajenkins$remotedata$RemoteData$Loading)),
		A2($author$project$Api$Request$Courses$courseGet, courseId, $author$project$Pages$MailEditor$CourseResponse));
};
var $author$project$Pages$MailEditor$Group = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Pages$MailEditor$GroupResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$MailEditor$initForGroup = F2(
	function (courseId, groupId) {
		return _Utils_Tuple2(
			$author$project$Pages$MailEditor$initModelFromMode(
				A3($author$project$Pages$MailEditor$Group, courseId, groupId, $krisajenkins$remotedata$RemoteData$Loading)),
			A3($author$project$Api$Request$Groups$groupsGet, courseId, groupId, $author$project$Pages$MailEditor$GroupResponse));
	});
var $author$project$Pages$MailEditor$User = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$MailEditor$UserResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$user = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'users',
				$elm$core$String$fromInt(id)
			]),
		_List_Nil);
};
var $author$project$Api$Request$User$userGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$user(id)),
			msg,
			$author$project$Api$Data$User$decoder);
	});
var $author$project$Pages$MailEditor$initForUser = function (userId) {
	return _Utils_Tuple2(
		$author$project$Pages$MailEditor$initModelFromMode(
			$author$project$Pages$MailEditor$User(
				$elm$core$Dict$fromList(
					_List_fromArray(
						[
							_Utils_Tuple2(userId, $krisajenkins$remotedata$RemoteData$Loading)
						])))),
		A2($author$project$Api$Request$User$userGet, userId, $author$project$Pages$MailEditor$UserResponse));
};
var $author$project$Routing$Router$initWith = F5(
	function (toModel, toMsg, model, sharedStateUpdate, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					b0: toModel(subModel)
				}),
			A2($elm$core$Platform$Cmd$map, toMsg, subCmd),
			sharedStateUpdate);
	});
var $author$project$Routing$Router$navigateTo = F3(
	function (route, sharedState, model) {
		switch (route.$) {
			case 0:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$LoginModel, $author$project$Routing$Router$LoginMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$Login$init);
			case 1:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$RegistrationModel, $author$project$Routing$Router$RegistrationMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$Registration$init);
			case 2:
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$DashboardModel,
					$author$project$Routing$Router$DashboardMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$Dashboard$init(sharedState));
			case 3:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$CoursesModel, $author$project$Routing$Router$CoursesMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$Courses$init);
			case 4:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$CourseEditorModel, $author$project$Routing$Router$CourseEditorMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$CourseEditor$initCreate);
			case 5:
				var id = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$CourseEditorModel,
					$author$project$Routing$Router$CourseEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$CourseEditor$initEdit(id));
			case 6:
				var id = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$CourseDetailModel,
					$author$project$Routing$Router$CourseDetailMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$CourseDetail$init(id));
			case 7:
				var courseId = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$SheetEditorModel,
					$author$project$Routing$Router$SheetEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$SheetEditor$initCreate(courseId));
			case 8:
				var courseId = route.a;
				var id = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$SheetEditorModel,
					$author$project$Routing$Router$SheetEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$SheetEditor$initEdit, courseId, id));
			case 10:
				var courseId = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MaterialEditorModel,
					$author$project$Routing$Router$MaterialEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$MaterialEditor$initCreate, courseId, sharedState));
			case 11:
				var courseId = route.a;
				var id = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MaterialEditorModel,
					$author$project$Routing$Router$MaterialEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A3($author$project$Pages$MaterialEditor$initEdit, courseId, id, sharedState));
			case 12:
				var courseId = route.a;
				var id = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$SheetDetailModel,
					$author$project$Routing$Router$SheetDetailMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$SheetDetail$init, courseId, id));
			case 13:
				var courseId = route.a;
				var taskId = route.b;
				var groupId = route.c;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$SubmissionGradingEditorModel,
					$author$project$Routing$Router$SubmissionGradingEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A3($author$project$Pages$SubmissionGradingEditor$init, courseId, taskId, groupId));
			case 14:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$AdminModel, $author$project$Routing$Router$AdminMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$Admin$init);
			case 9:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$TermsOfUseModel, $author$project$Routing$Router$TermsMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$Terms$init);
			case 15:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$ProfileEditorModel, $author$project$Routing$Router$ProfileEditorMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$ProfileEditor$init);
			case 16:
				var mail = route.a;
				var token = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MailConfirmationModel,
					$author$project$Routing$Router$MailConfirmationMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$MailConfirmation$init, mail, token));
			case 17:
				return A5($author$project$Routing$Router$initWith, $author$project$Routing$Router$RequestPasswordResetModel, $author$project$Routing$Router$RequestPasswordResetMsg, model, $author$project$SharedState$NoUpdate, $author$project$Pages$RequestPasswordReset$init);
			case 18:
				var mail = route.a;
				var token = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$PasswordResetModel,
					$author$project$Routing$Router$PasswordResetMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$PasswordReset$init, mail, token));
			case 21:
				var userId = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MailEditorModel,
					$author$project$Routing$Router$MailEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$MailEditor$initForUser(userId));
			case 22:
				var courseId = route.a;
				var groupId = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MailEditorModel,
					$author$project$Routing$Router$MailEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$MailEditor$initForGroup, courseId, groupId));
			case 23:
				var courseId = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$MailEditorModel,
					$author$project$Routing$Router$MailEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$MailEditor$initForCourse(courseId));
			case 20:
				var courseId = route.a;
				var groupId = route.b;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$GroupEditorModel,
					$author$project$Routing$Router$GroupEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					A2($author$project$Pages$GroupEditor$initEditFromId, courseId, groupId));
			case 19:
				var courseId = route.a;
				return A5(
					$author$project$Routing$Router$initWith,
					$author$project$Routing$Router$GroupEditorModel,
					$author$project$Routing$Router$GroupEditorMsg,
					model,
					$author$project$SharedState$NoUpdate,
					$author$project$Pages$GroupEditor$initCreate(courseId));
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{b0: $author$project$Routing$Router$NotFound}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Routing$Helpers$NotFoundRoute = {$: 24};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {b5: frag, cf: params, bR: unvisited, fa: value, co: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.bR;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.fa);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.fa);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.om),
					$elm$url$Url$Parser$prepareQuery(url.lz),
					url.j8,
					$elm$core$Basics$identity)));
	});
var $author$project$Routing$Helpers$AdminRoute = {$: 14};
var $author$project$Routing$Helpers$CourseDetailRoute = function (a) {
	return {$: 6, a: a};
};
var $author$project$Routing$Helpers$CreateCourseRoute = {$: 4};
var $author$project$Routing$Helpers$CreateGroupRoute = function (a) {
	return {$: 19, a: a};
};
var $author$project$Routing$Helpers$CreateMaterialRoute = function (a) {
	return {$: 10, a: a};
};
var $author$project$Routing$Helpers$CreateSheetRoute = function (a) {
	return {$: 7, a: a};
};
var $author$project$Routing$Helpers$DashboardRoute = {$: 2};
var $author$project$Routing$Helpers$EditCourseRoute = function (a) {
	return {$: 5, a: a};
};
var $author$project$Routing$Helpers$EditGroupRoute = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Routing$Helpers$EditMaterialRoute = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Routing$Helpers$EditSheetRoute = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Routing$Helpers$MailConfirmationRoute = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Routing$Helpers$MailToCourseRoute = function (a) {
	return {$: 23, a: a};
};
var $author$project$Routing$Helpers$MailToGroupRoute = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Routing$Helpers$MailToUsersRoute = function (a) {
	return {$: 21, a: a};
};
var $author$project$Routing$Helpers$PasswordResetRoute = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Routing$Helpers$ProfileEditorRoute = {$: 15};
var $author$project$Routing$Helpers$RegistrationRoute = {$: 1};
var $author$project$Routing$Helpers$RequestPasswordResetRoute = {$: 17};
var $author$project$Routing$Helpers$SheetDetailRoute = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Routing$Helpers$SubmissionGradingRoute = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Routing$Helpers$TermsOfUseRoute = {$: 9};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.co;
			var unvisited = _v0.bR;
			var params = _v0.cf;
			var frag = _v0.b5;
			var value = _v0.fa;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.co;
		var unvisited = _v0.bR;
		var params = _v0.cf;
		var frag = _v0.b5;
		var value = _v0.fa;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.co;
			var unvisited = _v1.bR;
			var params = _v1.cf;
			var frag = _v1.b5;
			var value = _v1.fa;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.co;
		var unvisited = _v0.bR;
		var params = _v0.cf;
		var frag = _v0.b5;
		var value = _v0.fa;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Routing$Helpers$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Routing$Helpers$LoginRoute, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$RegistrationRoute,
			$elm$url$Url$Parser$s('registration')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$DashboardRoute,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CoursesRoute,
			$elm$url$Url$Parser$s('courses')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CourseDetailRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CreateCourseRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				$elm$url$Url$Parser$s('create'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$EditCourseRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s('edit')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$SheetDetailRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sheet'),
						$elm$url$Url$Parser$int)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CreateSheetRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sheet'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$EditSheetRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('sheet'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							$elm$url$Url$Parser$s('edit')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CreateMaterialRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('material'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$EditMaterialRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('material'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							$elm$url$Url$Parser$s('edit')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$SubmissionGradingRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('task'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$s('grade'),
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('group'),
									$elm$url$Url$Parser$int))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$ProfileEditorRoute,
			$elm$url$Url$Parser$s('profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$AdminRoute,
			$elm$url$Url$Parser$s('admin')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$MailConfirmationRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('confirmation'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$RequestPasswordResetRoute,
			$elm$url$Url$Parser$s('request_reset')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$PasswordResetRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('password_reset'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$CreateGroupRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('group'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$TermsOfUseRoute,
			$elm$url$Url$Parser$s('terms')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$EditGroupRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('course'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('group'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$int,
							$elm$url$Url$Parser$s('edit')))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$MailToUsersRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('email'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('user'),
					$elm$url$Url$Parser$int))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$MailToGroupRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('email'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('course'),
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$int,
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$s('group'),
							$elm$url$Url$Parser$int))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Routing$Helpers$MailToCourseRoute,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('email'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s('course'),
					$elm$url$Url$Parser$int)))
		]));
var $author$project$Routing$Helpers$parseUrl = function (url) {
	var _v0 = url.j8;
	if (_v0.$ === 1) {
		return $author$project$Routing$Helpers$LoginRoute;
	} else {
		var fragment = _v0.a;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Routing$Helpers$NotFoundRoute,
			A2(
				$elm$url$Url$Parser$parse,
				$author$project$Routing$Helpers$routeParser,
				_Utils_update(
					url,
					{j8: $elm$core$Maybe$Nothing, om: fragment})));
	}
};
var $author$project$Routing$Helpers$reverseRoute = function (route) {
	var pieces = function () {
		switch (route.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					['registration']);
			case 2:
				return _List_fromArray(
					['dashboard']);
			case 3:
				return _List_fromArray(
					['courses']);
			case 4:
				return _List_fromArray(
					['course', 'create']);
			case 5:
				var id = route.a;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(id),
						'edit'
					]);
			case 6:
				var id = route.a;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(id)
					]);
			case 7:
				var courseId = route.a;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'sheet',
						'create'
					]);
			case 8:
				var courseId = route.a;
				var id = route.b;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'sheet',
						$elm$core$String$fromInt(id),
						'edit'
					]);
			case 10:
				var courseId = route.a;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'material',
						'create'
					]);
			case 11:
				var courseId = route.a;
				var id = route.b;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'material',
						$elm$core$String$fromInt(id),
						'edit'
					]);
			case 12:
				var courseId = route.a;
				var id = route.b;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'sheet',
						$elm$core$String$fromInt(id)
					]);
			case 13:
				var courseId = route.a;
				var taskId = route.b;
				var groupId = route.c;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'task',
						$elm$core$String$fromInt(taskId),
						'grade',
						'group',
						$elm$core$String$fromInt(groupId)
					]);
			case 14:
				return _List_fromArray(
					['admin']);
			case 9:
				return _List_fromArray(
					['terms']);
			case 15:
				return _List_fromArray(
					['profile']);
			case 16:
				var mail = route.a;
				var token = route.b;
				return _List_fromArray(
					['confirmation', mail, token]);
			case 17:
				return _List_fromArray(
					['request_reset']);
			case 18:
				var mail = route.a;
				var token = route.b;
				return _List_fromArray(
					['password_reset', mail, token]);
			case 19:
				var courseId = route.a;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'group',
						'create'
					]);
			case 20:
				var courseId = route.a;
				var groupId = route.b;
				return _List_fromArray(
					[
						'course',
						$elm$core$String$fromInt(courseId),
						'group',
						$elm$core$String$fromInt(groupId),
						'edit'
					]);
			case 21:
				var userId = route.a;
				return _List_fromArray(
					[
						'email',
						'user',
						$elm$core$String$fromInt(userId)
					]);
			case 22:
				var courseId = route.a;
				var groupId = route.b;
				return _List_fromArray(
					[
						'email',
						'course',
						$elm$core$String$fromInt(courseId),
						'group',
						$elm$core$String$fromInt(groupId)
					]);
			case 23:
				var courseId = route.a;
				return _List_fromArray(
					[
						'email',
						'course',
						$elm$core$String$fromInt(courseId)
					]);
			default:
				return _List_Nil;
		}
	}();
	return '#/' + A2($elm$core$String$join, '/', pieces);
};
var $author$project$Api$Helper$deleteExpectNothing = F2(
	function (url, msg) {
		return $elm$http$Http$request(
			{
				al: $elm$http$Http$emptyBody,
				ao: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg)),
				ar: _List_Nil,
				as: 'DELETE',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Endpoint$sessions = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['auth', 'sessions']),
	_List_Nil);
var $author$project$Api$Request$Auth$sessionDelete = function (msg) {
	return A2(
		$author$project$Api$Helper$deleteExpectNothing,
		$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$sessions),
		msg);
};
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Api$Data$Account$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.jM)),
				_Utils_Tuple2(
				'plain_password',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.le))
			]));
};
var $author$project$Api$Helper$post = F4(
	function (url, body, msg, decoder) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
					decoder),
				ar: _List_Nil,
				as: 'POST',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Request$Auth$sessionPost = F2(
	function (account, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$sessions),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Account$encoder(account)),
			msg,
			$author$project$Api$Data$Role$decoder);
	});
var $author$project$Routing$Router$setField = F3(
	function (model, field, value) {
		return _Utils_update(
			model,
			{le: value});
	});
var $author$project$SharedState$UpdateRoleAndMail = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Utils$PersistantState$stateMsgToSharedStateUpdate = function (maybeState) {
	if (!maybeState.$) {
		var _v1 = maybeState.a;
		var role = _v1.a;
		var mail = _v1.b;
		return A2($author$project$SharedState$UpdateRoleAndMail, role, mail);
	} else {
		return $author$project$SharedState$NoUpdate;
	}
};
var $author$project$Utils$Utils$tupleExtend = F2(
	function (_v0, c) {
		var a = _v0.a;
		var b = _v0.b;
		return _Utils_Tuple3(a, b, c);
	});
var $author$project$Pages$Admin$update = F3(
	function (sharedState, msg, model) {
		var route = msg;
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
	});
var $author$project$Pages$CourseDetail$BiddingModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CourseDetail$BiddingMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CourseDetail$DetailModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CourseDetail$DetailMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$CourseDetail$EnrollmentChangedResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Toasty$Error = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamCreateResponse = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$CourseDetail$ExamDeleteResponse = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamUpdateResponse = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$GroupAdminModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CourseDetail$GroupAdminMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CourseDetail$GroupMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$CourseDetail$SearchUserForEnrollment = {$: 17};
var $author$project$Pages$CourseDetail$SearchUserForEnrollmentResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedState$ShowToast = function (a) {
	return {$: 6, a: a};
};
var $author$project$Components$Toasty$Success = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$TeamGetResponse = function (a) {
	return {$: 38, a: a};
};
var $author$project$Pages$CourseDetail$TeamJoinResponse = function (a) {
	return {$: 44, a: a};
};
var $author$project$Pages$CourseDetail$TeamLeaveResponse = function (a) {
	return {$: 47, a: a};
};
var $author$project$Pages$CourseDetail$TeamUserConfirmed = function (a) {
	return {$: 41, a: a};
};
var $author$project$Pages$CourseDetail$TeamsIncompleteGet = function (a) {
	return {$: 39, a: a};
};
var $author$project$Pages$CourseDetail$ToggleExamEnrollmentResponse = F2(
	function (a, b) {
		return {$: 26, a: a, b: b};
	});
var $author$project$Api$Endpoint$courseEnrollment = F2(
	function (id, params) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(id),
					'enrollments'
				]),
			params);
	});
var $author$project$Api$Data$UserEnrollment$UserEnrollment = F2(
	function (role, user) {
		return {lJ: role, mE: user};
	});
var $author$project$Api$Data$UserEnrollment$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$author$project$Api$Data$User$decoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'role',
		$author$project$Api$Data$CourseRole$decoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Data$UserEnrollment$UserEnrollment)));
var $author$project$Api$Request$Courses$coursesEnrollmentGet = F3(
	function (courseId, params, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseEnrollment, courseId, params)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$UserEnrollment$decoder));
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Api$Request$Courses$coursesEnrollmentGetByEmail = F3(
	function (courseId, emailToSearch, msg) {
		var params = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'email', emailToSearch)
			]);
		return A3($author$project$Api$Request$Courses$coursesEnrollmentGet, courseId, params, msg);
	});
var $author$project$Api$Endpoint$courseEnrollmentUserDetail = F2(
	function (courseId, userId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'enrollments',
					$elm$core$String$fromInt(userId)
				]),
			_List_Nil);
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$Api$Data$CourseRole$roleToInt = function (role) {
	switch (role) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $author$project$Api$Data$CourseRole$encoder = function (courseRole) {
	return $elm$json$Json$Encode$int(
		$author$project$Api$Data$CourseRole$roleToInt(courseRole));
};
var $author$project$Api$Helper$putExpectNothing = F3(
	function (url, body, msg) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg)),
				ar: _List_Nil,
				as: 'PUT',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Request$Courses$coursesEnrollmentsUserPut = F4(
	function (courseId, userId, newRole, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseEnrollmentUserDetail, courseId, userId)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'role',
							$author$project$Api$Data$CourseRole$encoder(newRole))
						]))),
			msg);
	});
var $elm$time$Time$Sun = 6;
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {jy: d, kV: m, mR: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		h$: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		mR: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.mR, 0, date.h$);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.jy;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.kV;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.h$;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		mM: 1 + (((rd - week1Day1) / 7) | 0),
		mN: wy,
		pp: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.mM;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.mN;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.f0(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.hT(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.f0(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.g9(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.cp(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.cp(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.cp(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.iO(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cp(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.cp(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.b, s.a);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jq: 1, g: s.g, k: s.k, b: s.b + 1, lL: s.lL + 1, a: s.a}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jq: s.jq + 1, g: s.g, k: s.k, b: newOffset, lL: s.lL, a: s.a}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.b, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	g9: $justinmimbs$date$Date$withOrdinalSuffix,
	hT: $justinmimbs$date$Date$monthToName,
	f0: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	iO: $justinmimbs$date$Date$weekdayToName,
	cp: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.lo;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	g$: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	fj: $CurrySoftware$elm_datepicker$DatePicker$off,
	cz: 'elm-datepicker--',
	g3: _List_Nil,
	g8: $justinmimbs$date$Date$format('yyyy/MM/dd'),
	nc: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	fy: 6,
	nO: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	hx: _List_Nil,
	hy: $elm$core$Maybe$Nothing,
	hz: $elm$core$Maybe$Nothing,
	fP: $elm$core$Basics$always(false),
	n0: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	id: $justinmimbs$date$Date$fromIsoString,
	eD: 'Please pick a date...',
	iT: $elm$core$String$fromInt
};
var $justgage$tachyons_elm$Tachyons$Classes$b__dark_gray = 'b--dark-gray';
var $justgage$tachyons_elm$Tachyons$Classes$bb = 'bb';
var $justgage$tachyons_elm$Tachyons$Classes$bl_0 = 'bl-0';
var $justgage$tachyons_elm$Tachyons$Classes$black_80 = 'black-80';
var $justgage$tachyons_elm$Tachyons$Classes$br_0 = 'br-0';
var $justgage$tachyons_elm$Tachyons$Classes$bt_0 = 'bt-0';
var $justgage$tachyons_elm$Tachyons$Classes$bw1 = 'bw1';
var $justgage$tachyons_elm$Tachyons$Classes$f5 = 'f5';
var $justgage$tachyons_elm$Tachyons$Classes$input_reset = 'input-reset';
var $justgage$tachyons_elm$Tachyons$Classes$ph0 = 'ph0';
var $justgage$tachyons_elm$Tachyons$Classes$pv3 = 'pv3';
var $author$project$Utils$Styles$lineInputStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw1, $justgage$tachyons_elm$Tachyons$Classes$bt_0, $justgage$tachyons_elm$Tachyons$Classes$bl_0, $justgage$tachyons_elm$Tachyons$Classes$br_0, $justgage$tachyons_elm$Tachyons$Classes$ph0, $justgage$tachyons_elm$Tachyons$Classes$pv3, $justgage$tachyons_elm$Tachyons$Classes$input_reset, $justgage$tachyons_elm$Tachyons$Classes$b__dark_gray, 'hover-b--dark-red', $justgage$tachyons_elm$Tachyons$Classes$black_80, $justgage$tachyons_elm$Tachyons$Classes$f5]));
var $justgage$tachyons_elm$Tachyons$Classes$mb3 = 'mb3';
var $author$project$I18n$get = F2(
	function (dict, key) {
		return A2(
			$elm$core$Maybe$withDefault,
			key,
			A2($elm$core$Dict$get, key, dict));
	});
var $author$project$Utils$DateFormatter$monthFormatter = F2(
	function (sharedState, month) {
		var t = $author$project$I18n$get(sharedState.pa);
		switch (month) {
			case 0:
				return t('month-jan');
			case 1:
				return t('month-feb');
			case 2:
				return t('month-mar');
			case 3:
				return t('month-apr');
			case 4:
				return t('month-may');
			case 5:
				return t('month-jun');
			case 6:
				return t('month-jul');
			case 7:
				return t('month-aug');
			case 8:
				return t('month-sept');
			case 9:
				return t('month-oct');
			case 10:
				return t('month-nov');
			default:
				return t('month-dec');
		}
	});
var $author$project$Utils$DateFormatter$shortDayFormatter = F2(
	function (sharedState, day) {
		var t = $author$project$I18n$get(sharedState.pa);
		switch (day) {
			case 0:
				return t('day-mon-short');
			case 1:
				return t('day-tue-short');
			case 2:
				return t('day-wed-short');
			case 3:
				return t('day-thu-short');
			case 4:
				return t('day-fri-short');
			case 5:
				return t('day-sat-short');
			default:
				return t('day-sun-short');
		}
	});
var $author$project$Pages$CourseDetail$datePickerSettings = function (sharedState) {
	var curTime = A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		sharedState.jx);
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			nc: $author$project$Utils$DateFormatter$shortDayFormatter(sharedState),
			nO: _List_fromArray(
				[
					$author$project$Utils$Styles$lineInputStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3]))
				]),
			n0: $author$project$Utils$DateFormatter$monthFormatter(sharedState)
		});
};
var $author$project$Pages$CourseDetail$EnrollmentsResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CourseDetail$GroupsDisplayResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$CourseDetail$OwnGroupsResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Request$Courses$coursesEnrollmentGetTeam = F2(
	function (courseId, msg) {
		var roles = A2(
			$elm$core$String$join,
			',',
			A2(
				$elm$core$List$map,
				$elm$core$String$fromInt,
				A2(
					$elm$core$List$map,
					$author$project$Api$Data$CourseRole$roleToInt,
					_List_fromArray(
						[2, 1]))));
		var params = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'roles', roles)
			]);
		return A3($author$project$Api$Request$Courses$coursesEnrollmentGet, courseId, params, msg);
	});
var $author$project$Api$Data$Team$Team = F4(
	function (id, user_id, members, member_mails) {
		return {ki: id, kQ: member_mails, kR: members, mG: user_id};
	});
var $author$project$Api$Data$Team$decoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'member_mails',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'members',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'user_id',
			$elm$json$Json$Decode$int,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'id',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
				$elm$core$Maybe$Nothing,
				$elm$json$Json$Decode$succeed($author$project$Api$Data$Team$Team)))));
var $author$project$Api$Endpoint$team = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'team'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamGet = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$team(courseId)),
			msg,
			$author$project$Api$Data$Team$decoder);
	});
var $author$project$Pages$CourseDetail$determineInitialRoleRequests = F2(
	function (model, role) {
		switch (role) {
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ef: $krisajenkins$remotedata$RemoteData$Loading}),
					A2($author$project$Api$Request$Courses$courseGroupsGet, model.ju, $author$project$Pages$CourseDetail$GroupsDisplayResponse));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cM: $krisajenkins$remotedata$RemoteData$Loading, ba: $krisajenkins$remotedata$RemoteData$Loading}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Request$Courses$coursesEnrollmentGetTeam, model.ju, $author$project$Pages$CourseDetail$EnrollmentsResponse),
								A2($author$project$Api$Request$Courses$courseOwnGroupGet, model.ju, $author$project$Pages$CourseDetail$OwnGroupsResponse),
								A2($author$project$Api$Request$Courses$courseGroupsGet, model.ju, $author$project$Pages$CourseDetail$GroupsDisplayResponse)
							])));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cM: $krisajenkins$remotedata$RemoteData$Loading, ba: $krisajenkins$remotedata$RemoteData$Loading, gd: $krisajenkins$remotedata$RemoteData$Loading}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2($author$project$Api$Request$Courses$coursesEnrollmentGetTeam, model.ju, $author$project$Pages$CourseDetail$EnrollmentsResponse),
								A2($author$project$Api$Request$Courses$courseOwnGroupGet, model.ju, $author$project$Pages$CourseDetail$OwnGroupsResponse),
								A2($author$project$Api$Request$Team$teamGet, model.ju, $author$project$Pages$CourseDetail$TeamGetResponse)
							])));
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Pages$CourseDetail$determineRole = F2(
	function (course_id, enrollments) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.lJ;
				},
				A2(
					$elm$core$List$filter,
					function (enrollment) {
						return _Utils_eq(enrollment.jv, course_id);
					},
					enrollments)));
	});
var $author$project$Api$Endpoint$exam = F2(
	function (courseId, examId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'exams',
					$elm$core$String$fromInt(examId)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Exam$examDelete = F3(
	function (courseId, examId, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$exam, courseId, examId)),
			msg);
	});
var $author$project$Api$Endpoint$examEnrollment = F2(
	function (courseId, examId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'exams',
					$elm$core$String$fromInt(examId),
					'enrollments'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Exam$examEnrollmentDelete = F3(
	function (courseId, examId, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$examEnrollment, courseId, examId)),
			msg);
	});
var $author$project$Api$Request$Exam$examEnrollmentPost = F3(
	function (courseId, examId, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$examEnrollment, courseId, examId)),
			$elm$http$Http$emptyBody,
			msg);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $author$project$Api$Data$Exam$examEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.kY)),
				_Utils_Tuple2(
				'exam_time',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.jT)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(model.jC)),
				_Utils_Tuple2(
				'course_id',
				$elm$json$Json$Encode$int(model.jv))
			]));
};
var $author$project$Api$Request$Exam$examPost = F3(
	function (courseId, examNew, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseExams(courseId)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Exam$examEncoder(examNew)),
			msg);
	});
var $author$project$Api$Request$Exam$examPut = F4(
	function (courseId, examId, examNew, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$exam, courseId, examId)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Exam$examEncoder(examNew)),
			msg);
	});
var $author$project$Components$Groups$GroupView$init = F5(
	function (courseId, ownGroups, allGroups, role, summaries) {
		return _Utils_Tuple2(
			{
				i0: allGroups,
				ju: courseId,
				nD: $elm$core$List$head(ownGroups),
				kP: $author$project$Material$defaultModel,
				h2: ownGroups,
				lJ: role,
				eY: '',
				gy: summaries
			},
			$elm$core$Platform$Cmd$none);
	});
var $justinmimbs$date$Date$toIsoString = $justinmimbs$date$Date$format('yyyy-MM-dd');
var $author$project$Utils$DateAndTimeUtils$dateToPosix = function (date) {
	var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(
		$justinmimbs$date$Date$toIsoString(date));
	if (_v0.$ === 1) {
		return $elm$core$Result$Err('Failed to convert date to posix');
	} else {
		var time = _v0.a;
		return $elm$core$Result$Ok(time);
	}
};
var $author$project$Utils$DateAndTimeUtils$utcOffsetMinutes = F3(
	function (multiplier, hours, minutes) {
		return multiplier * ((hours * 60) + minutes);
	});
var $author$project$Utils$DateAndTimeUtils$partsToMinutes = function (parts) {
	return A3($author$project$Utils$DateAndTimeUtils$utcOffsetMinutes, parts.hU, parts.ho, parts.hS);
};
var $author$project$Utils$DateAndTimeUtils$pickerTimeWithOffsetToMillis = F2(
	function (offset, time) {
		var timeInSeconds = (((time.ho * 60) * 60) + (time.hS * 60)) + time.gu;
		var offsetInSeconds = $author$project$Utils$DateAndTimeUtils$partsToMinutes(offset) * 60;
		return (timeInSeconds - offsetInSeconds) * 1000;
	});
var $author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset = F3(
	function (date, time, offset) {
		var timeMillis = A2($author$project$Utils$DateAndTimeUtils$pickerTimeWithOffsetToMillis, offset, time);
		var dateMillis = $elm$time$Time$posixToMillis(
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				$elm$core$Result$toMaybe(
					$author$project$Utils$DateAndTimeUtils$dateToPosix(date))));
		return $elm$time$Time$millisToPosix(dateMillis + timeMillis);
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Pages$CourseDetail$setField = F3(
	function (model, field, value) {
		switch (field.$) {
			case 0:
				return _Utils_update(
					model,
					{eO: value});
			case 1:
				return _Utils_update(
					model,
					{ii: value});
			case 2:
				var examId = field.a;
				var exams = A2(
					$elm$core$Dict$map,
					F2(
						function (id, e) {
							return _Utils_eq(id, examId) ? _Utils_update(
								e,
								{kY: value}) : e;
						}),
					model.t);
				return _Utils_update(
					model,
					{t: exams});
			case 3:
				var examId = field.a;
				var exams = A2(
					$elm$core$Dict$map,
					F2(
						function (id, e) {
							return _Utils_eq(id, examId) ? _Utils_update(
								e,
								{jC: value}) : e;
						}),
					model.t);
				return _Utils_update(
					model,
					{t: exams});
			default:
				return model;
		}
	});
var $author$project$Api$Endpoint$teamForm = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'team',
				'form'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamFormPost = F3(
	function (courseId, userId, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamForm(courseId)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'user_id',
							$elm$json$Json$Encode$int(userId))
						]))),
			msg,
			$author$project$Api$Data$Team$decoder);
	});
var $author$project$Api$Helper$expectJson2 = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			function (response) {
				switch (response.$) {
					case 0:
						var url = response.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadUrl(url));
					case 1:
						return $elm$core$Result$Err($elm$http$Http$Timeout);
					case 2:
						return $elm$core$Result$Err($elm$http$Http$NetworkError);
					case 3:
						var metadata = response.a;
						var body = response.b;
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(body));
					default:
						var metadata = response.a;
						var body = response.b;
						var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
						if (!_v1.$) {
							var value = _v1.a;
							return $elm$core$Result$Ok(value);
						} else {
							var err = _v1.a;
							return $elm$core$Result$Err(
								$elm$http$Http$BadBody(
									$elm$json$Json$Decode$errorToString(err)));
						}
				}
			});
	});
var $author$project$Api$Helper$put2 = F4(
	function (url, body, msg, decoder) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: A2(
					$author$project$Api$Helper$expectJson2,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
					decoder),
				ar: _List_Nil,
				as: 'PUT',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Endpoint$teamJoin = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'team',
				'join'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamJoinPut = F3(
	function (courseId, teamId, msg) {
		return A4(
			$author$project$Api$Helper$put2,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamJoin(courseId)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'team_id',
							$elm$json$Json$Encode$int(teamId))
						]))),
			msg,
			$author$project$Api$Data$Team$decoder);
	});
var $author$project$Api$Endpoint$teamLeave = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'team',
				'leave'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamLeavePut = F2(
	function (courseId, msg) {
		return A4(
			$author$project$Api$Helper$put2,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamLeave(courseId)),
			$elm$http$Http$emptyBody,
			msg,
			$author$project$Api$Data$Team$decoder);
	});
var $author$project$Api$Data$Bool$BoolResponse = function (bool) {
	return {jd: bool};
};
var $author$project$Api$Data$Bool$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bool',
	$elm$json$Json$Decode$bool,
	$elm$json$Json$Decode$succeed($author$project$Api$Data$Bool$BoolResponse));
var $author$project$Api$Helper$put = F4(
	function (url, body, msg, decoder) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: A2(
					$elm$http$Http$expectJson,
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg),
					decoder),
				ar: _List_Nil,
				as: 'PUT',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Endpoint$teamUserConfirmed = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'team',
				'userconfirmed'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamUserConfirmedPut = F2(
	function (courseId, msg) {
		return A4(
			$author$project$Api$Helper$put,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamUserConfirmed(courseId)),
			$elm$http$Http$emptyBody,
			msg,
			$author$project$Api$Data$Bool$decoder);
	});
var $author$project$Api$Endpoint$teamsIncomplete = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'teams'
			]),
		_List_Nil);
};
var $author$project$Api$Request$Team$teamsIncompleteGet = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamsIncomplete(courseId)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$Team$decoder));
	});
var $stephenreddek$elm_time_picker$TimePicker$defaultSettings = {
	cH: false,
	cW: false,
	cX: 1,
	ej: $elm$core$Basics$always(false),
	ek: $elm$core$Basics$always(false),
	el: $elm$core$Basics$always(false),
	em: $elm$core$Basics$always(false),
	n_: 1,
	eD: 'Select time',
	gt: 1,
	ci: true,
	eT: true,
	oK: true,
	pf: false
};
var $author$project$Pages$CourseDetail$timePickerSettings = function () {
	var defaultSettings = $stephenreddek$elm_time_picker$TimePicker$defaultSettings;
	return _Utils_update(
		defaultSettings,
		{n_: 15, oK: false, pf: true});
}();
var $author$project$Utils$Utils$tupleMapThree = F4(
	function (funcA, funcB, funcC, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		var z = _v0.c;
		return _Utils_Tuple3(
			funcA(x),
			funcB(y),
			funcC(z));
	});
var $author$project$Components$Groups$AdminView$ReassignUserResponse = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Api$Data$GroupEnrollmentChange$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$int(model.mF))
			]));
};
var $author$project$Api$Endpoint$groupsEnrollment = F3(
	function (courseId, id, params) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'groups',
					$elm$core$String$fromInt(id),
					'enrollments'
				]),
			params);
	});
var $author$project$Api$Request$Groups$groupsEnrollmentPost = F4(
	function (courseId, id, groupEnrollment, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A3($author$project$Api$Endpoint$groupsEnrollment, courseId, id, _List_Nil)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$GroupEnrollmentChange$encoder(groupEnrollment)),
			msg);
	});
var $author$project$Components$Groups$AdminView$changeUsersGroup = F4(
	function (model, user, oldGroup, newGroup) {
		var enrollmentUpdates = _List_fromArray(
			[oldGroup.ki, newGroup.ki]);
		var enrollmentRequestBody = {mF: user.ki};
		return A4(
			$author$project$Api$Request$Groups$groupsEnrollmentPost,
			model.jv,
			newGroup.ki,
			enrollmentRequestBody,
			$author$project$Components$Groups$AdminView$ReassignUserResponse(enrollmentUpdates));
	});
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $elm_community$maybe_extra$Maybe$Extra$foldrValues = F2(
	function (item, list) {
		if (item.$ === 1) {
			return list;
		} else {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$foldrValues, _List_Nil);
var $author$project$Components$Groups$AdminView$fillGroupDictFromRequest = function (model) {
	var _v0 = _Utils_Tuple2(
		model.ef,
		$elm$core$Dict$isEmpty(model.cL));
	if ((_v0.a.$ === 3) && (!_v0.b)) {
		var groups = _v0.a.a;
		return A2(
			F2(
				function (m, groupEnrollmentDict) {
					return _Utils_update(
						m,
						{fK: groupEnrollmentDict});
				}),
			model,
			$elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (ue) {
						return _Utils_Tuple2(
							function ($) {
								return $.ki;
							}(ue.a),
							ue);
					},
					$elm_community$maybe_extra$Maybe$Extra$values(
						A2(
							$elm$core$List$map,
							function (g) {
								return A2(
									$elm$core$Maybe$map,
									function (ue) {
										return _Utils_Tuple2(g, ue);
									},
									$elm_community$maybe_extra$Maybe$Extra$join(
										A2(
											$elm$core$Maybe$map,
											$krisajenkins$remotedata$RemoteData$toMaybe,
											A2($elm$core$Dict$get, g.ki, model.cL))));
							},
							groups)))));
	} else {
		return model;
	}
};
var $author$project$Components$Groups$AdminView$GetEnrollmentResponse = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Api$Request$Groups$groupsEnrollmentGetAll = F3(
	function (courseId, groupId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A3($author$project$Api$Endpoint$groupsEnrollment, courseId, groupId, _List_Nil)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$UserEnrollment$decoder));
	});
var $author$project$Components$Groups$AdminView$performUserEnrollmentRequestForGroups = F2(
	function (model, groupIds) {
		return $elm$core$Platform$Cmd$batch(
			A2(
				$elm$core$List$map,
				function (id) {
					return A3(
						$author$project$Api$Request$Groups$groupsEnrollmentGetAll,
						model.jv,
						id,
						$author$project$Components$Groups$AdminView$GetEnrollmentResponse(id));
				},
				groupIds));
	});
var $author$project$Components$Groups$AdminView$updateReasignUserResponse = F3(
	function (model, groupChangedIds, response) {
		if (response.$ === 3) {
			return _Utils_Tuple3(
				model,
				A2($author$project$Components$Groups$AdminView$performUserEnrollmentRequestForGroups, model, groupChangedIds),
				$author$project$SharedState$NoUpdate);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Groups$AdminView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Components$Groups$AdminView$fillGroupDictFromRequest(
						_Utils_update(
							model,
							{ef: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 1:
				var gId = msg.a;
				var response = msg.b;
				var newDict = A3($elm$core$Dict$insert, gId, response, model.cL);
				return _Utils_Tuple3(
					$author$project$Components$Groups$AdminView$fillGroupDictFromRequest(
						_Utils_update(
							model,
							{cL: newDict})),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var courseId = msg.a;
				var groupId = msg.b;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							A2($author$project$Routing$Helpers$MailToGroupRoute, courseId, groupId))),
					$author$project$SharedState$NoUpdate);
			case 3:
				var courseId = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							$author$project$Routing$Helpers$MailToCourseRoute(courseId))),
					$author$project$SharedState$NoUpdate);
			case 4:
				var groupId = msg.a;
				var up = _Utils_eq(
					model.gM,
					$elm$core$Maybe$Just(groupId)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(groupId);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gM: up}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				var user = msg.a;
				var oldGroup = msg.b;
				var newGroup = msg.c;
				return _Utils_Tuple3(
					model,
					A4($author$project$Components$Groups$AdminView$changeUsersGroup, model, user, oldGroup, newGroup),
					$author$project$SharedState$NoUpdate);
			case 6:
				var groupChangedIds = msg.a;
				var response = msg.b;
				return A3($author$project$Components$Groups$AdminView$updateReasignUserResponse, model, groupChangedIds, response);
			case 7:
				var courseId = msg.a;
				var groupId = msg.b;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							A2($author$project$Routing$Helpers$EditGroupRoute, courseId, groupId))),
					$author$project$SharedState$NoUpdate);
			case 8:
				var courseId = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							$author$project$Routing$Helpers$CreateGroupRoute(courseId))),
					$author$project$SharedState$NoUpdate);
			default:
				var userId = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Groups$BiddingView$GetGroupBidResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Toasty$Info = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Components$Groups$BiddingView$SendBid = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Api$Endpoint$courseGroupBid = F2(
	function (courseId, groupId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'groups',
					$elm$core$String$fromInt(groupId),
					'bids'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Courses$coursesBidsPost = F4(
	function (courseId, groupId, bid, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseGroupBid, courseId, groupId)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'bid',
							$elm$json$Json$Encode$int(bid))
						]))),
			msg);
	});
var $author$project$Components$Groups$BiddingView$DebounceMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $jinjor$elm_debounce$Debounce$Later = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$later = $jinjor$elm_debounce$Debounce$Later;
var $author$project$Components$Groups$BiddingView$debounceConfig = function (id) {
	return {
		oQ: $jinjor$elm_debounce$Debounce$later(2000),
		o7: $author$project$Components$Groups$BiddingView$DebounceMsg(id)
	};
};
var $jinjor$elm_debounce$Debounce$Debounce = $elm$core$Basics$identity;
var $jinjor$elm_debounce$Debounce$init = {a3: _List_Nil, et: false};
var $jinjor$elm_debounce$Debounce$Flush = function (a) {
	return {$: 1, a: a};
};
var $jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom = function (a) {
	return {$: 2, a: a};
};
var $jinjor$elm_debounce$Debounce$delayCmd = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $jinjor$elm_debounce$Debounce$length = function (_v0) {
	var input = _v0.a3;
	return $elm$core$List$length(input);
};
var $jinjor$elm_debounce$Debounce$push = F3(
	function (config, a, _v0) {
		var d = _v0;
		var newDebounce = _Utils_update(
			d,
			{
				a3: A2($elm$core$List$cons, a, d.a3)
			});
		var selfCmd = function () {
			var _v1 = config.oQ;
			switch (_v1.$) {
				case 0:
					var offset = _v1.a;
					return d.et ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush($elm$core$Maybe$Nothing));
				case 1:
					var offset = _v1.a;
					var delay = _v1.b;
					return d.et ? $elm$core$Platform$Cmd$none : A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						offset,
						$jinjor$elm_debounce$Debounce$Flush(
							$elm$core$Maybe$Just(delay)));
				default:
					var delay = _v1.a;
					return A2(
						$jinjor$elm_debounce$Debounce$delayCmd,
						delay,
						$jinjor$elm_debounce$Debounce$SendIfLengthNotChangedFrom(
							$jinjor$elm_debounce$Debounce$length(newDebounce)));
			}
		}();
		return _Utils_Tuple2(
			newDebounce,
			A2($elm$core$Platform$Cmd$map, config.o7, selfCmd));
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $jinjor$elm_debounce$Debounce$takeLast = F3(
	function (send, head, tail) {
		return _Utils_Tuple2(
			_List_Nil,
			send(head));
	});
var $jinjor$elm_debounce$Debounce$update = F4(
	function (config, send, msg, _v0) {
		var d = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
			case 1:
				var tryAgainAfter = msg.a;
				var _v2 = d.a3;
				if (_v2.b) {
					var head = _v2.a;
					var tail = _v2.b;
					var selfCmd = function () {
						if (!tryAgainAfter.$) {
							var delay = tryAgainAfter.a;
							return A2(
								$jinjor$elm_debounce$Debounce$delayCmd,
								delay,
								$jinjor$elm_debounce$Debounce$Flush(
									$elm$core$Maybe$Just(delay)));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					var _v3 = A2(send, head, tail);
					var input = _v3.a;
					var sendCmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{a3: input, et: true}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									sendCmd,
									A2($elm$core$Platform$Cmd$map, config.o7, selfCmd)
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{et: false}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				var lastInputLength = msg.a;
				var _v5 = _Utils_Tuple2(
					_Utils_cmp(
						$elm$core$List$length(d.a3),
						lastInputLength) < 1,
					d.a3);
				if (_v5.a && _v5.b.b) {
					var _v6 = _v5.b;
					var head = _v6.a;
					var tail = _v6.b;
					var _v7 = A2(send, head, tail);
					var input = _v7.a;
					var cmd = _v7.b;
					return _Utils_Tuple2(
						_Utils_update(
							d,
							{a3: input}),
						cmd);
				} else {
					return _Utils_Tuple2(d, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$SharedState$RefreshLogin = {$: 5};
var $author$project$Utils$Utils$handleLogoutErrors = F4(
	function (model, sharedState, handler, err) {
		if ((err.$ === 3) && (err.a === 401)) {
			var _v1 = sharedState.pg;
			if (!_v1.$) {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$RefreshLogin);
			} else {
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
					$author$project$SharedState$NoUpdate);
			}
		} else {
			return handler(err);
		}
	});
var $author$project$Components$Groups$BiddingView$initGroupMsgHandler = F2(
	function (maybeGroup, maybeBid) {
		return {i9: maybeBid, nD: maybeGroup, dm: $jinjor$elm_debounce$Debounce$init};
	});
var $author$project$Components$Groups$BiddingView$updateOrInitGroupMsgHandler = F4(
	function (model, groupId, maybeGroup, maybeBid) {
		return _Utils_update(
			model,
			{
				R: function () {
					var _v0 = A2($elm$core$Dict$get, groupId, model.R);
					if (!_v0.$) {
						var gmhs = _v0.a;
						return A3(
							$elm$core$Dict$update,
							groupId,
							$elm$core$Maybe$map(
								function (_v1) {
									var _v2 = _Utils_Tuple2(maybeGroup, maybeBid);
									if (!_v2.a.$) {
										var group = _v2.a.a;
										return _Utils_update(
											gmhs,
											{
												nD: $elm$core$Maybe$Just(group)
											});
									} else {
										if (!_v2.b.$) {
											var bid = _v2.b.a;
											return _Utils_update(
												gmhs,
												{
													i9: $elm$core$Maybe$Just(bid)
												});
										} else {
											return gmhs;
										}
									}
								}),
							model.R);
					} else {
						return A3(
							$elm$core$Dict$insert,
							groupId,
							A2($author$project$Components$Groups$BiddingView$initGroupMsgHandler, maybeGroup, maybeBid),
							model.R);
					}
				}()
			});
	});
var $author$project$Components$Groups$BiddingView$updateHandleGetGroupsResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var groups = response.a;
				return _Utils_Tuple3(
					A3(
						$elm$core$List$foldl,
						F2(
							function (g, m) {
								return A4(
									$author$project$Components$Groups$BiddingView$updateOrInitGroupMsgHandler,
									m,
									g.ki,
									$elm$core$Maybe$Just(g),
									$elm$core$Maybe$Nothing);
							}),
						_Utils_update(
							model,
							{fJ: response}),
						groups),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fJ: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Groups$BiddingView$updateHandleGetOldBidsResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var bids = response.a;
				return _Utils_Tuple3(
					A3(
						$elm$core$List$foldl,
						F2(
							function (b, m) {
								return A4(
									$author$project$Components$Groups$BiddingView$updateOrInitGroupMsgHandler,
									m,
									b.ke,
									$elm$core$Maybe$Nothing,
									$elm$core$Maybe$Just(b.i9));
							}),
						_Utils_update(
							model,
							{fI: response}),
						bids),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{fI: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Groups$BiddingView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A3($author$project$Components$Groups$BiddingView$updateHandleGetGroupsResponse, sharedState, model, response);
			case 1:
				var response = msg.a;
				return A3($author$project$Components$Groups$BiddingView$updateHandleGetOldBidsResponse, sharedState, model, response);
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 3:
				var groupId = msg.a;
				var bid = msg.b;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Request$Courses$coursesBidsPost, model.ju, groupId, bid, $author$project$Components$Groups$BiddingView$GetGroupBidResponse),
					$author$project$SharedState$ShowToast(
						A2($author$project$Components$Toasty$Info, 'Info', 'Your bids have been sent')));
			case 4:
				var field = msg.a;
				var val = msg.b;
				var groupId = field;
				var toInt = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(val));
				var maybeDebounceCmd = A2(
					$elm$core$Maybe$map,
					function (gms) {
						return A3(
							$jinjor$elm_debounce$Debounce$push,
							$author$project$Components$Groups$BiddingView$debounceConfig(groupId),
							toInt,
							gms.dm);
					},
					A2($elm$core$Dict$get, groupId, model.R));
				var updatedGms = A3(
					$elm$core$Dict$update,
					groupId,
					$elm$core$Maybe$map(
						function (gms) {
							return _Utils_update(
								gms,
								{
									i9: $elm$core$Maybe$Just(toInt),
									dm: function () {
										if (!maybeDebounceCmd.$) {
											var debounceCmd = maybeDebounceCmd.a;
											return debounceCmd.a;
										} else {
											return $jinjor$elm_debounce$Debounce$init;
										}
									}()
								});
						}),
					model.R);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{R: updatedGms}),
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2($elm$core$Maybe$map, $elm$core$Tuple$second, maybeDebounceCmd)),
					$author$project$SharedState$NoUpdate);
			default:
				var groupId = msg.a;
				var subMsg = msg.b;
				var _v3 = A2($elm$core$Dict$get, groupId, model.R);
				if (!_v3.$) {
					var gmhs = _v3.a;
					var _v4 = A4(
						$jinjor$elm_debounce$Debounce$update,
						$author$project$Components$Groups$BiddingView$debounceConfig(groupId),
						$jinjor$elm_debounce$Debounce$takeLast(
							function (b) {
								return $author$project$Utils$Utils$perform(
									A2($author$project$Components$Groups$BiddingView$SendBid, groupId, b));
							}),
						subMsg,
						gmhs.dm);
					var debounce = _v4.a;
					var cmd = _v4.b;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								R: A3(
									$elm$core$Dict$update,
									groupId,
									$elm$core$Maybe$map(
										function (_v5) {
											return _Utils_update(
												gmhs,
												{dm: debounce});
										}),
									model.R)
							}),
						cmd,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
		}
	});
var $author$project$Components$Groups$GroupView$Mdc = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Groups$GroupView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var group = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							nD: $elm$core$Maybe$Just(group)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var msg_ = msg.a;
				var _v1 = A3($author$project$Material$update, $author$project$Components$Groups$GroupView$Mdc, msg_, model);
				var newModel = _v1.a;
				var newCommand = _v1.b;
				return _Utils_Tuple3(newModel, newCommand, $author$project$SharedState$NoUpdate);
			default:
				var filter = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eY: filter}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.bA;
		var focused = model.fE;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fE: $elm$core$Maybe$Just(date),
							cl: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							fE: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fE: $elm$core$Maybe$Nothing, aR: $elm$core$Maybe$Nothing, B: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aR: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = settings.id(
							A2($elm$core$Maybe$withDefault, '', model.aR));
						if (!_v5.$) {
							var date = _v5.a;
							return settings.fP(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
						} else {
							var e = _v5.a;
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								fE: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.fE;
									}
								}(),
								aR: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.aR;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bA: false, B: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bA: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bA: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $stephenreddek$elm_time_picker$TimePicker$Changed = function (a) {
	return {$: 1, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$NoChange = {$: 0};
var $stephenreddek$elm_time_picker$TimePicker$defaultPeriodIn12HourFormatForSelection = F2(
	function (settings, time) {
		return settings.pf ? time : (((time.ho >= 0) && (time.ho <= 6)) ? _Utils_update(
			time,
			{ho: time.ho + 12}) : time);
	});
var $stephenreddek$elm_time_picker$TimePicker$defaultTime = {ho: 0, hS: 0, gu: 0};
var $stephenreddek$elm_time_picker$TimePicker$AM = 0;
var $stephenreddek$elm_time_picker$TimePicker$PM = 1;
var $stephenreddek$elm_time_picker$TimePicker$periodFromTime = function (time) {
	return (time.ho >= 12) ? 1 : 0;
};
var $stephenreddek$elm_time_picker$TimePicker$isValidTime = F2(
	function (settings, time) {
		var isValidSecond = (!settings.em(time.gu)) && ((time.gu >= 0) && (time.gu <= 59));
		var isValidPeriod = settings.pf || (!settings.el(
			$stephenreddek$elm_time_picker$TimePicker$periodFromTime(time)));
		var isValidMinute = (!settings.ek(time.hS)) && ((time.hS >= 0) && (time.hS <= 59));
		var isValidHour = (!settings.ej(time.ho)) && ((time.ho >= 0) && (time.ho <= 23));
		return isValidHour && (isValidMinute && (isValidSecond && isValidPeriod));
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {cY: index, nW: match, od: number, oS: submatches};
	});
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$String$toLower = _String_toLower;
var $stephenreddek$elm_time_picker$TimePicker$parsePeriod = function (text) {
	var _v0 = $elm$core$String$toLower(text);
	switch (_v0) {
		case 'am':
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(0));
		case 'pm':
			return $elm$core$Result$Ok(
				$elm$core$Maybe$Just(1));
		default:
			return $elm$core$Result$Err(0);
	}
};
var $stephenreddek$elm_time_picker$TimePicker$defaultPeriodIn12HourFormatForInput = F2(
	function (settings, time) {
		return settings.pf ? time : (((time.ho > 0) && (time.ho <= 6)) ? _Utils_update(
			time,
			{ho: time.ho + 12}) : time);
	});
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $stephenreddek$elm_time_picker$TimePicker$setTimeWithPeriod = F2(
	function (period, time) {
		if (!period) {
			return (time.ho >= 12) ? _Utils_update(
				time,
				{ho: time.ho - 12}) : time;
		} else {
			return (time.ho >= 12) ? time : _Utils_update(
				time,
				{ho: time.ho + 12});
		}
	});
var $stephenreddek$elm_time_picker$TimePicker$parseTimeParts = F3(
	function (settings, period, timeParts) {
		var withPeriod = function (time) {
			return ((time.ho >= 0) && (time.ho <= 12)) ? A2(
				$elm$core$Maybe$withDefault,
				A2($stephenreddek$elm_time_picker$TimePicker$defaultPeriodIn12HourFormatForInput, settings, time),
				A2(
					$elm$core$Maybe$map,
					F2(
						function (b, a) {
							return A2($stephenreddek$elm_time_picker$TimePicker$setTimeWithPeriod, a, b);
						})(time),
					period)) : time;
		};
		var setSeconds = F2(
			function (seconds, time) {
				return _Utils_update(
					time,
					{gu: seconds});
			});
		var setMinutes = F2(
			function (minutes, time) {
				return _Utils_update(
					time,
					{hS: minutes});
			});
		var setHours = F2(
			function (hours, time) {
				return _Utils_update(
					time,
					{ho: hours});
			});
		var partSetter = F2(
			function (val, setter) {
				return val ? _List_fromArray(
					[setter]) : _List_Nil;
			});
		var allSetters = _Utils_ap(
			A2(partSetter, settings.ci, setHours),
			_Utils_ap(
				A2(partSetter, settings.eT, setMinutes),
				A2(partSetter, settings.oK, setSeconds)));
		return $elm$core$List$isEmpty(timeParts) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : ((_Utils_cmp(
			$elm$core$List$length(timeParts),
			$elm$core$List$length(allSetters)) > 0) ? $elm$core$Result$Err(0) : $elm$core$Result$Ok(
			$elm$core$Maybe$Just(
				withPeriod(
					A3(
						$elm$core$List$foldl,
						F2(
							function (_v0, timeAcc) {
								var val = _v0.a;
								var setter = _v0.b;
								return A2(setter, val, timeAcc);
							}),
						$stephenreddek$elm_time_picker$TimePicker$defaultTime,
						A3(
							$elm$core$List$map2,
							F2(
								function (a, b) {
									return _Utils_Tuple2(a, b);
								}),
							timeParts,
							allSetters))))));
	});
var $elm$core$String$trim = _String_trim;
var $stephenreddek$elm_time_picker$TimePicker$parseText = F2(
	function (settings, text) {
		var trimmed = $elm$core$String$trim(text);
		var periodRegex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{m3: true, n1: false},
				'(am|pm)$'));
		var periodFindResults = A3($elm$regex$Regex$findAtMost, 1, periodRegex, trimmed);
		var combineTimeParts = function () {
			var step = F2(
				function (e, acc) {
					if (e.$ === 1) {
						return $elm$core$Result$Err(0);
					} else {
						var x = e.a;
						return A2(
							$elm$core$Result$map,
							$elm$core$List$cons(x),
							acc);
					}
				});
			return A2(
				$elm$core$List$foldr,
				step,
				$elm$core$Result$Ok(_List_Nil));
		}();
		var _v0 = function () {
			if (periodFindResults.b) {
				var periodMatch = periodFindResults.a;
				return _Utils_Tuple2(
					$elm$core$String$trim(
						A3($elm$core$String$slice, 0, periodMatch.cY, trimmed)),
					$stephenreddek$elm_time_picker$TimePicker$parsePeriod(periodMatch.nW));
			} else {
				return _Utils_Tuple2(
					trimmed,
					$elm$core$Result$Ok($elm$core$Maybe$Nothing));
			}
		}();
		var timeText = _v0.a;
		var period = _v0.b;
		if (!period.$) {
			var parsedPeriod = period.a;
			return $elm$core$String$isEmpty(timeText) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2(
				$elm$core$Result$andThen,
				A2($stephenreddek$elm_time_picker$TimePicker$parseTimeParts, settings, parsedPeriod),
				combineTimeParts(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$String$toInt,
							$elm$core$Result$fromMaybe(0)),
						A2($elm$core$String$split, ':', timeText))));
		} else {
			return $elm$core$Result$Err(0);
		}
	});
var $stephenreddek$elm_time_picker$TimePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var value = model.fa;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: false, fa: $elm$core$Maybe$Nothing}),
					$stephenreddek$elm_time_picker$TimePicker$Changed($elm$core$Maybe$Nothing));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: true}),
					$stephenreddek$elm_time_picker$TimePicker$NoChange);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{B: false}),
					$stephenreddek$elm_time_picker$TimePicker$NoChange);
			case 3:
				var hours = msg.a;
				var updatedTime = function () {
					if (!value.$) {
						var time = value.a;
						return $elm$core$Maybe$Just(
							_Utils_update(
								time,
								{ho: hours}));
					} else {
						return $elm$core$Maybe$Just(
							A2(
								$stephenreddek$elm_time_picker$TimePicker$defaultPeriodIn12HourFormatForSelection,
								settings,
								_Utils_update(
									$stephenreddek$elm_time_picker$TimePicker$defaultTime,
									{ho: hours})));
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing, fa: updatedTime}),
					$stephenreddek$elm_time_picker$TimePicker$Changed(updatedTime));
			case 4:
				var minutes = msg.a;
				var timeToUpdate = A2($elm$core$Maybe$withDefault, $stephenreddek$elm_time_picker$TimePicker$defaultTime, value);
				var updatedTime = $elm$core$Maybe$Just(
					_Utils_update(
						timeToUpdate,
						{hS: minutes}));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing, fa: updatedTime}),
					$stephenreddek$elm_time_picker$TimePicker$Changed(updatedTime));
			case 5:
				var seconds = msg.a;
				var timeToUpdate = A2($elm$core$Maybe$withDefault, $stephenreddek$elm_time_picker$TimePicker$defaultTime, value);
				var updatedTime = $elm$core$Maybe$Just(
					_Utils_update(
						timeToUpdate,
						{gu: seconds}));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing, fa: updatedTime}),
					$stephenreddek$elm_time_picker$TimePicker$Changed(updatedTime));
			case 6:
				var period = msg.a;
				var updatedTime = $elm$core$Maybe$Just(
					A2(
						$stephenreddek$elm_time_picker$TimePicker$setTimeWithPeriod,
						period,
						A2($elm$core$Maybe$withDefault, $stephenreddek$elm_time_picker$TimePicker$defaultTime, value)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing, fa: updatedTime}),
					$stephenreddek$elm_time_picker$TimePicker$Changed(updatedTime));
			case 7:
				return _Utils_Tuple2(model, $stephenreddek$elm_time_picker$TimePicker$NoChange);
			case 8:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aR: $elm$core$Maybe$Just(text)
						}),
					$stephenreddek$elm_time_picker$TimePicker$NoChange);
			default:
				var text = msg.a;
				var parsedTime = A2($stephenreddek$elm_time_picker$TimePicker$parseText, settings, text);
				var isValidInput = A2(
					$elm$core$Result$withDefault,
					false,
					A2(
						$elm$core$Result$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$map(
								$stephenreddek$elm_time_picker$TimePicker$isValidTime(settings)),
							$elm$core$Maybe$withDefault(true)),
						parsedTime));
				var updatedValue = isValidInput ? A2($elm$core$Result$withDefault, value, parsedTime) : value;
				var timeEvent = _Utils_eq(updatedValue, value) ? $stephenreddek$elm_time_picker$TimePicker$NoChange : $stephenreddek$elm_time_picker$TimePicker$Changed(updatedValue);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aR: $elm$core$Maybe$Nothing, fa: updatedValue}),
					timeEvent);
		}
	});
var $author$project$Components$UserAvatarEmailView$updateFromUserAvatar = F2(
	function (sharedState, userId) {
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			sharedState.f1,
			$author$project$Routing$Helpers$reverseRoute(
				$author$project$Routing$Helpers$MailToUsersRoute(userId)));
	});
var $author$project$Pages$CourseDetail$GroupsSummaryResponse = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Api$Data$GroupSummary$GroupSummary = F2(
	function (sheets, achievements) {
		return {mT: achievements, oJ: sheets};
	});
var $author$project$Api$Data$GroupSummary$Achievement = F2(
	function (user_info, points) {
		return {oo: points, ph: user_info};
	});
var $author$project$Api$Data$GroupSummary$UserInfo = F5(
	function (id, first_name, last_name, studentNumber, email) {
		return {jM: email, ny: first_name, ki: id, nT: last_name, oR: studentNumber};
	});
var $author$project$Api$Data$GroupSummary$userInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'email',
	$elm$json$Json$Decode$string,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'student_number',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'last_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'first_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Api$Data$GroupSummary$UserInfo))))));
var $author$project$Api$Data$GroupSummary$achievementDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'points',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user_info',
		$author$project$Api$Data$GroupSummary$userInfoDecoder,
		$elm$json$Json$Decode$succeed($author$project$Api$Data$GroupSummary$Achievement)));
var $author$project$Api$Data$GroupSummary$Sheet = F2(
	function (id, name) {
		return {ki: id, kY: name};
	});
var $author$project$Api$Data$GroupSummary$sheetDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$Api$Data$GroupSummary$Sheet)));
var $author$project$Api$Data$GroupSummary$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'achievements',
	$elm$json$Json$Decode$list($author$project$Api$Data$GroupSummary$achievementDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sheets',
		$elm$json$Json$Decode$list($author$project$Api$Data$GroupSummary$sheetDecoder),
		$elm$json$Json$Decode$succeed($author$project$Api$Data$GroupSummary$GroupSummary)));
var $author$project$Api$Endpoint$groupSummary = F2(
	function (course_id, params) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(course_id),
					'grades',
					'summary'
				]),
			params);
	});
var $author$project$Api$Request$Courses$courseGroupSummaryGet = F3(
	function (course_id, params, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$groupSummary, course_id, params)),
			msg,
			$author$project$Api$Data$GroupSummary$decoder);
	});
var $author$project$Api$Request$Courses$courseGroupSummaryPerGroup = F3(
	function (courseId, groupId, msg) {
		var params = _List_fromArray(
			[
				A2($elm$url$Url$Builder$int, 'group_id', groupId)
			]);
		return A3($author$project$Api$Request$Courses$courseGroupSummaryGet, courseId, params, msg);
	});
var $author$project$Components$Groups$AdminView$performUserEnrollmentRequests = function (model) {
	var _v0 = model.ef;
	if (_v0.$ === 3) {
		var groups = _v0.a;
		return A2(
			$author$project$Components$Groups$AdminView$performUserEnrollmentRequestForGroups,
			model,
			A2(
				$elm$core$List$map,
				function (g) {
					return g.ki;
				},
				groups));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Components$Groups$AdminView$init = F2(
	function (courseId, groups) {
		var model = {
			jv: courseId,
			cL: $elm$core$Dict$empty,
			fK: $elm$core$Dict$empty,
			ef: $krisajenkins$remotedata$RemoteData$Success(groups),
			kP: $author$project$Material$defaultModel,
			gM: $elm$core$Maybe$Nothing
		};
		return _Utils_Tuple2(
			model,
			$author$project$Components$Groups$AdminView$performUserEnrollmentRequests(model));
	});
var $author$project$Components$Groups$BiddingView$GetGroupsResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Groups$BiddingView$GetOldGroupBidsResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$courseBids = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'bids'
			]),
		_List_Nil);
};
var $author$project$Api$Data$GroupBid$GroupBid = F4(
	function (id, groupId, userId, bid) {
		return {i9: bid, ke: groupId, ki: id, mF: userId};
	});
var $author$project$Api$Data$GroupBid$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'bid',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'group_id',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Api$Data$GroupBid$GroupBid)))));
var $author$project$Api$Request$Courses$coursesBidsGet = F2(
	function (id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseBids(id)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$GroupBid$decoder));
	});
var $author$project$Components$Groups$BiddingView$init = function (courseId) {
	return _Utils_Tuple2(
		{ju: courseId, hf: _List_Nil, R: $elm$core$Dict$empty, fI: $krisajenkins$remotedata$RemoteData$Loading, fJ: $krisajenkins$remotedata$RemoteData$Loading},
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Api$Request$Courses$courseGroupsGet, courseId, $author$project$Components$Groups$BiddingView$GetGroupsResponse),
					A2($author$project$Api$Request$Courses$coursesBidsGet, courseId, $author$project$Components$Groups$BiddingView$GetOldGroupBidsResponse)
				])));
};
var $author$project$Pages$CourseDetail$updateGroupDisplay = F2(
	function (sharedState, model) {
		var _v0 = _Utils_Tuple2(model.ba, model.Y);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				_v0$3:
				while (true) {
					if (!_v0.b.$) {
						switch (_v0.a.$) {
							case 2:
								switch (_v0.b.a) {
									case 0:
										var err = _v0.a.a;
										var _v1 = _v0.b.a;
										return A4(
											$author$project$Utils$Utils$handleLogoutErrors,
											model,
											sharedState,
											function (e) {
												var maybeInit = function () {
													if ((e.$ === 3) && (e.a === 404)) {
														return $elm$core$Maybe$Just(
															A3(
																$elm$core$Tuple$mapBoth,
																function (subModel) {
																	return $author$project$Pages$CourseDetail$BiddingModel(subModel);
																},
																function (subMsg) {
																	return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$BiddingMsg, subMsg);
																},
																$author$project$Components$Groups$BiddingView$init(model.ju)));
													} else {
														return $elm$core$Maybe$Nothing;
													}
												}();
												return _Utils_Tuple3(
													_Utils_update(
														model,
														{
															aO: A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeInit)
														}),
													A2(
														$elm$core$Maybe$withDefault,
														$elm$core$Platform$Cmd$none,
														A2(
															$elm$core$Maybe$map,
															function (subInit) {
																return A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$GroupMsg, subInit.b);
															},
															maybeInit)),
													$author$project$SharedState$NoUpdate);
											},
											err);
									case 2:
										break _v0$2;
									default:
										break _v0$3;
								}
							case 3:
								break _v0$1;
							default:
								if (_v0.b.a === 2) {
									break _v0$2;
								} else {
									break _v0$3;
								}
						}
					} else {
						if (_v0.a.$ === 3) {
							break _v0$1;
						} else {
							break _v0$3;
						}
					}
				}
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			}
			var _v6 = _v0.b.a;
			var _v7 = model.ef;
			if (_v7.$ === 3) {
				var groups = _v7.a;
				var groupInit = A3(
					$elm$core$Tuple$mapBoth,
					$author$project$Pages$CourseDetail$GroupAdminModel,
					$elm$core$Platform$Cmd$map($author$project$Pages$CourseDetail$GroupAdminMsg),
					A2($author$project$Components$Groups$AdminView$init, model.ju, groups));
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aO: $elm$core$Maybe$Just(groupInit.a)
						}),
					A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$GroupMsg, groupInit.b),
					$author$project$SharedState$NoUpdate);
			} else {
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			}
		}
		var ownGroups = _v0.a.a;
		var _v3 = _Utils_Tuple2(model.ef, model.Y);
		_v3$2:
		while (true) {
			if (!_v3.b.$) {
				switch (_v3.b.a) {
					case 0:
						var _v4 = _v3.b.a;
						var groupInit = A3(
							$elm$core$Tuple$mapBoth,
							$author$project$Pages$CourseDetail$DetailModel,
							$elm$core$Platform$Cmd$map($author$project$Pages$CourseDetail$DetailMsg),
							A5($author$project$Components$Groups$GroupView$init, model.ju, ownGroups, _List_Nil, 0, model.gy));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									aO: $elm$core$Maybe$Just(groupInit.a)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$GroupMsg, groupInit.b),
							$author$project$SharedState$NoUpdate);
					case 1:
						if (_v3.a.$ === 3) {
							var allGroups = _v3.a.a;
							var _v5 = _v3.b.a;
							var groupInit = A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Pages$CourseDetail$DetailModel,
								$elm$core$Platform$Cmd$map($author$project$Pages$CourseDetail$DetailMsg),
								A5($author$project$Components$Groups$GroupView$init, model.ju, ownGroups, allGroups, 1, model.gy));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aO: $elm$core$Maybe$Just(groupInit.a)
									}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$GroupMsg, groupInit.b)
											]),
										A2(
											$elm$core$List$map,
											function (g) {
												return A3(
													$author$project$Api$Request$Courses$courseGroupSummaryPerGroup,
													model.ju,
													g.ki,
													$author$project$Pages$CourseDetail$GroupsSummaryResponse(g.ki));
											},
											ownGroups))),
								$author$project$SharedState$NoUpdate);
						} else {
							break _v3$2;
						}
					default:
						break _v3$2;
				}
			} else {
				break _v3$2;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
	});
var $author$project$Pages$CourseDetail$TeamConfirmed = function (a) {
	return {$: 40, a: a};
};
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Api$Endpoint$teamConfirmed = F2(
	function (courseId, teamId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'team',
					$elm$core$String$fromInt(teamId),
					'confirmed'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Team$teamConfirmedGet = F3(
	function (courseId, teamId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$teamConfirmed, courseId, teamId)),
			msg,
			$author$project$Api$Data$Bool$decoder);
	});
var $author$project$Api$Request$Team$teamUserConfirmedGet = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$teamUserConfirmed(courseId)),
			msg,
			$author$project$Api$Data$Bool$decoder);
	});
var $author$project$Pages$CourseDetail$updateStudentTeam = F2(
	function (sharedState, model) {
		var hasGroup = function () {
			var _v10 = model.ba;
			if (_v10.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		var _v0 = function () {
			var _v1 = model.gd;
			if (_v1.$ === 3) {
				var team = _v1.a;
				return _Utils_Tuple2(
					$elm_community$maybe_extra$Maybe$Extra$isJust(team.ki),
					team.ki);
			} else {
				return _Utils_Tuple2(false, $elm$core$Maybe$Nothing);
			}
		}();
		var hasTeam = _v0.a;
		var teamID = _v0.b;
		var _v2 = _Utils_Tuple2(hasGroup, model.gd);
		_v2$2:
		while (true) {
			if (_v2.a) {
				switch (_v2.b.$) {
					case 3:
						var _v3 = _Utils_Tuple2(model.e0, model.dz);
						_v3$2:
						while (true) {
							switch (_v3.a.$) {
								case 0:
									if (!_v3.b.$) {
										var _v4 = _v3.a;
										var _v5 = _v3.b;
										var _v6 = _Utils_Tuple2(hasTeam, model.aP);
										if (!_v6.a) {
											if (!_v6.b.$) {
												var _v7 = _v6.b;
												return _Utils_Tuple3(
													_Utils_update(
														model,
														{aP: $krisajenkins$remotedata$RemoteData$Loading}),
													A2($author$project$Api$Request$Team$teamsIncompleteGet, model.ju, $author$project$Pages$CourseDetail$TeamsIncompleteGet),
													$author$project$SharedState$NoUpdate);
											} else {
												return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
											}
										} else {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{e0: $krisajenkins$remotedata$RemoteData$Loading, dz: $krisajenkins$remotedata$RemoteData$Loading}),
												$elm$core$Platform$Cmd$batch(
													_List_fromArray(
														[
															A2($author$project$Api$Request$Team$teamUserConfirmedGet, model.ju, $author$project$Pages$CourseDetail$TeamUserConfirmed),
															A3(
															$author$project$Api$Request$Team$teamConfirmedGet,
															model.ju,
															A2($elm$core$Maybe$withDefault, 0, teamID),
															$author$project$Pages$CourseDetail$TeamConfirmed)
														])),
												$author$project$SharedState$NoUpdate);
										}
									} else {
										break _v3$2;
									}
								case 3:
									var teamConfirmed = _v3.a.a;
									if (teamConfirmed.jd) {
										return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
									} else {
										var _v8 = model.aP;
										if (!_v8.$) {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{aP: $krisajenkins$remotedata$RemoteData$Loading}),
												A2($author$project$Api$Request$Team$teamsIncompleteGet, model.ju, $author$project$Pages$CourseDetail$TeamsIncompleteGet),
												$author$project$SharedState$NoUpdate);
										} else {
											return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
										}
									}
								default:
									break _v3$2;
							}
						}
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					case 0:
						var _v9 = _v2.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aP: $krisajenkins$remotedata$RemoteData$Loading}),
							A2($author$project$Api$Request$Team$teamsIncompleteGet, model.ju, $author$project$Pages$CourseDetail$TeamsIncompleteGet),
							$author$project$SharedState$NoUpdate);
					default:
						break _v2$2;
				}
			} else {
				break _v2$2;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
	});
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Pages$CourseDetail$update = F3(
	function (sharedState, msg, model) {
		_v0$43:
		while (true) {
			switch (msg.$) {
				case 0:
					var route = msg.a;
					return _Utils_Tuple3(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							sharedState.f1,
							$author$project$Routing$Helpers$reverseRoute(route)),
						$author$project$SharedState$NoUpdate);
				case 1:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cB: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 2:
					if (msg.a.$ === 3) {
						var roles = msg.a.a;
						var _v1 = A2($author$project$Pages$CourseDetail$determineRole, model.ju, roles);
						if (!_v1.$) {
							var role = _v1.a;
							var updatedModel = _Utils_update(
								model,
								{
									Y: $elm$core$Maybe$Just(role),
									fp: $krisajenkins$remotedata$RemoteData$Success(roles)
								});
							var _v2 = A2($author$project$Pages$CourseDetail$determineInitialRoleRequests, updatedModel, role);
							var newModel = _v2.a;
							var newCmds = _v2.b;
							return _Utils_Tuple3(newModel, newCmds, $author$project$SharedState$NoUpdate);
						} else {
							return _Utils_Tuple3(
								model,
								A2(
									$elm$browser$Browser$Navigation$pushUrl,
									sharedState.f1,
									$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$CoursesRoute)),
								$author$project$SharedState$NoUpdate);
						}
					} else {
						break _v0$43;
					}
				case 17:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eP: $krisajenkins$remotedata$RemoteData$Loading}),
						A3($author$project$Api$Request$Courses$coursesEnrollmentGetByEmail, model.ju, model.eO, $author$project$Pages$CourseDetail$SearchUserForEnrollmentResponse),
						$author$project$SharedState$NoUpdate);
				case 4:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eP: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 3:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cM: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 16:
					var field = msg.a;
					var value = msg.b;
					return _Utils_Tuple3(
						A3($author$project$Pages$CourseDetail$setField, model, field, value),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 19:
					var enrollment = msg.a;
					return _Utils_Tuple3(
						model,
						A4($author$project$Api$Request$Courses$coursesEnrollmentsUserPut, model.ju, enrollment.mE.ki, enrollment.lJ, $author$project$Pages$CourseDetail$EnrollmentChangedResponse),
						$author$project$SharedState$NoUpdate);
				case 5:
					if (msg.a.$ === 3) {
						return _Utils_Tuple3(
							model,
							$author$project$Utils$Utils$perform($author$project$Pages$CourseDetail$SearchUserForEnrollment),
							$author$project$SharedState$NoUpdate);
					} else {
						break _v0$43;
					}
				case 14:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gv: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 15:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{fY: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 22:
					var url = msg.a;
					return _Utils_Tuple3(
						model,
						$elm$file$File$Download$url(url),
						$author$project$SharedState$NoUpdate);
				case 21:
					var userId = msg.a;
					return _Utils_Tuple3(
						model,
						A2($author$project$Components$UserAvatarEmailView$updateFromUserAvatar, sharedState, userId),
						$author$project$SharedState$NoUpdate);
				case 23:
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				case 6:
					var response = msg.a;
					var _v3 = A2(
						$author$project$Pages$CourseDetail$updateGroupDisplay,
						sharedState,
						_Utils_update(
							model,
							{ba: response}));
					var model1 = _v3.a;
					var cmd = _v3.b;
					var upd = _v3.c;
					var _v4 = function () {
						var _v5 = model.Y;
						if ((!_v5.$) && (!_v5.a)) {
							var _v6 = _v5.a;
							return A2($author$project$Pages$CourseDetail$updateStudentTeam, sharedState, model1);
						} else {
							return _Utils_Tuple3(model1, cmd, upd);
						}
					}();
					var model2 = _v4.a;
					var cmd1 = _v4.b;
					var upd1 = _v4.c;
					return _Utils_Tuple3(
						model2,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[cmd, cmd1])),
						upd);
				case 7:
					var response = msg.a;
					return A2(
						$author$project$Pages$CourseDetail$updateGroupDisplay,
						sharedState,
						_Utils_update(
							model,
							{ef: response}));
				case 38:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return A2(
								$author$project$Pages$CourseDetail$updateStudentTeam,
								sharedState,
								_Utils_update(
									model,
									{gd: response}));
						case 2:
							var err = response.a;
							var errorMsg = function () {
								switch (err.$) {
									case 0:
										var url = err.a;
										return 'BadUrl: ' + url;
									case 1:
										return 'Timeout';
									case 2:
										return 'Networerror';
									case 3:
										var status = err.a;
										return 'BadStatus: ' + $elm$core$String$fromInt(status);
									default:
										var dbg = err.a;
										var _v9 = A2(
											$elm$json$Json$Decode$decodeString,
											A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
											dbg);
										if (!_v9.$) {
											var s = _v9.a;
											return s;
										} else {
											return 'BadBody';
										}
								}
							}();
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', errorMsg)));
						default:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'TeamGet response failed somehow')));
					}
				case 39:
					var response = msg.a;
					return A2(
						$author$project$Pages$CourseDetail$updateStudentTeam,
						sharedState,
						_Utils_update(
							model,
							{aP: response}));
				case 40:
					var response = msg.a;
					return A2(
						$author$project$Pages$CourseDetail$updateStudentTeam,
						sharedState,
						_Utils_update(
							model,
							{e0: response}));
				case 41:
					var response = msg.a;
					return A2(
						$author$project$Pages$CourseDetail$updateStudentTeam,
						sharedState,
						_Utils_update(
							model,
							{dz: response}));
				case 42:
					var user_id = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{gd: $krisajenkins$remotedata$RemoteData$Loading}),
						A3($author$project$Api$Request$Team$teamFormPost, model.ju, user_id, $author$project$Pages$CourseDetail$TeamJoinResponse),
						$author$project$SharedState$NoUpdate);
				case 43:
					var team_id = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aP: $krisajenkins$remotedata$RemoteData$Loading}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Api$Request$Team$teamJoinPut, model.ju, team_id, $author$project$Pages$CourseDetail$TeamJoinResponse)
								])),
						$author$project$SharedState$NoUpdate);
				case 44:
					var response = msg.a;
					var _v10 = A3(
						$author$project$Pages$CourseDetail$update,
						sharedState,
						$author$project$Pages$CourseDetail$TeamGetResponse(response),
						model);
					var model1 = _v10.a;
					var cmd = _v10.b;
					var upd = _v10.c;
					return _Utils_Tuple3(
						model1,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($author$project$Api$Request$Team$teamsIncompleteGet, model.ju, $author$project$Pages$CourseDetail$TeamsIncompleteGet)
								])),
						upd);
				case 45:
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Request$Team$teamUserConfirmedPut, model.ju, $author$project$Pages$CourseDetail$TeamUserConfirmed),
						$author$project$SharedState$NoUpdate);
				case 46:
					return _Utils_Tuple3(
						model,
						A2($author$project$Api$Request$Team$teamLeavePut, model.ju, $author$project$Pages$CourseDetail$TeamLeaveResponse),
						$author$project$SharedState$NoUpdate);
				case 47:
					var response = msg.a;
					var _v11 = A3(
						$author$project$Pages$CourseDetail$update,
						sharedState,
						$author$project$Pages$CourseDetail$TeamGetResponse(response),
						model);
					var model1 = _v11.a;
					var cmd = _v11.b;
					var upd = _v11.c;
					return _Utils_Tuple3(
						model1,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									cmd,
									A2($author$project$Api$Request$Team$teamsIncompleteGet, model.ju, $author$project$Pages$CourseDetail$TeamsIncompleteGet)
								])),
						upd);
				case 8:
					var groupId = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							var summary = response.a;
							var ownGroups = function () {
								var _v14 = model.ba;
								if (_v14.$ === 3) {
									var groups = _v14.a;
									return groups;
								} else {
									return _List_Nil;
								}
							}();
							var newSummaries = A3($elm$core$Dict$insert, groupId, summary, model.gy);
							var allGroups = function () {
								var _v13 = model.ef;
								if (_v13.$ === 3) {
									var groups = _v13.a;
									return groups;
								} else {
									return _List_Nil;
								}
							}();
							var groupInit = A3(
								$elm$core$Tuple$mapBoth,
								$author$project$Pages$CourseDetail$DetailModel,
								$elm$core$Platform$Cmd$map($author$project$Pages$CourseDetail$DetailMsg),
								A5($author$project$Components$Groups$GroupView$init, model.ju, ownGroups, allGroups, 1, newSummaries));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										aO: $elm$core$Maybe$Just(groupInit.a),
										gy: newSummaries
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$NoUpdate);
						case 2:
							var err = response.a;
							var errorMsg = function () {
								switch (err.$) {
									case 0:
										var url = err.a;
										return 'BadUrl: ' + url;
									case 1:
										return 'Timeout';
									case 2:
										return 'Networerror';
									case 3:
										var status = err.a;
										return 'BadStatus: ' + $elm$core$String$fromInt(status);
									default:
										var dbg = err.a;
										return 'BadBody: ' + dbg;
								}
							}();
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', errorMsg)));
						default:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'Summary response failed somehow')));
					}
				case 13:
					var subMsg = msg.a;
					var _v16 = function () {
						var _v17 = _Utils_Tuple2(model.aO, subMsg);
						_v17$3:
						while (true) {
							if (!_v17.a.$) {
								switch (_v17.a.a.$) {
									case 0:
										if (!_v17.b.$) {
											var biddingModel = _v17.a.a.a;
											var bidMsg = _v17.b.a;
											return A4(
												$author$project$Utils$Utils$tupleMapThree,
												function (m) {
													return $elm$core$Maybe$Just(
														$author$project$Pages$CourseDetail$BiddingModel(m));
												},
												function (m) {
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Pages$CourseDetail$GroupMsg,
														A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$BiddingMsg, m));
												},
												$elm$core$Basics$identity,
												A3($author$project$Components$Groups$BiddingView$update, sharedState, bidMsg, biddingModel));
										} else {
											break _v17$3;
										}
									case 1:
										if (_v17.b.$ === 1) {
											var detailModel = _v17.a.a.a;
											var detailMsg = _v17.b.a;
											return A4(
												$author$project$Utils$Utils$tupleMapThree,
												function (m) {
													return $elm$core$Maybe$Just(
														$author$project$Pages$CourseDetail$DetailModel(m));
												},
												function (m) {
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Pages$CourseDetail$GroupMsg,
														A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$DetailMsg, m));
												},
												$elm$core$Basics$identity,
												A3($author$project$Components$Groups$GroupView$update, sharedState, detailMsg, detailModel));
										} else {
											break _v17$3;
										}
									default:
										if (_v17.b.$ === 2) {
											var adminModel = _v17.a.a.a;
											var adminMsg = _v17.b.a;
											return A4(
												$author$project$Utils$Utils$tupleMapThree,
												function (m) {
													return $elm$core$Maybe$Just(
														$author$project$Pages$CourseDetail$GroupAdminModel(m));
												},
												function (m) {
													return A2(
														$elm$core$Platform$Cmd$map,
														$author$project$Pages$CourseDetail$GroupMsg,
														A2($elm$core$Platform$Cmd$map, $author$project$Pages$CourseDetail$GroupAdminMsg, m));
												},
												$elm$core$Basics$identity,
												A3($author$project$Components$Groups$AdminView$update, sharedState, adminMsg, adminModel));
										} else {
											break _v17$3;
										}
								}
							} else {
								break _v17$3;
							}
						}
						return _Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}();
					var subModel = _v16.a;
					var subCmd = _v16.b;
					var subSharedState = _v16.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aO: subModel}),
						subCmd,
						subSharedState);
				case 11:
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eE: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 25:
					var response = msg.a;
					if (response.$ === 3) {
						var exams = response.a;
						var newExams = $elm$core$Dict$fromList(
							A2(
								$elm$core$List$map,
								function (e) {
									return _Utils_Tuple2(e.ki, e);
								},
								A2(
									$elm$core$List$filter,
									function (en) {
										return _Utils_eq(en.jv, model.ju);
									},
									exams)));
						var examTimes = A2(
							$elm$core$Dict$map,
							F2(
								function (id, e) {
									return $elm$core$Maybe$Just(
										A2(
											$author$project$Utils$DateAndTimeUtils$pickerTimeFromPosix,
											A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
											e.jT));
								}),
							newExams);
						var timePickers = A2(
							$elm$core$Dict$map,
							F2(
								function (id, time) {
									return $stephenreddek$elm_time_picker$TimePicker$init(time);
								}),
							examTimes);
						var examDates = A2(
							$elm$core$Dict$map,
							F2(
								function (id, e) {
									return $elm$core$Maybe$Just(
										A2(
											$justinmimbs$date$Date$fromPosix,
											A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
											A2(
												$elm$core$Maybe$withDefault,
												$elm$time$Time$millisToPosix(0),
												$elm$core$Maybe$Just(e.jT))));
								}),
							newExams);
						var datePickers = A2(
							$elm$core$Dict$map,
							F2(
								function (id, e) {
									return $CurrySoftware$elm_datepicker$DatePicker$initFromDate(
										A2(
											$justinmimbs$date$Date$fromPosix,
											A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
											A2(
												$elm$core$Maybe$withDefault,
												$elm$time$Time$millisToPosix(0),
												$elm$core$Maybe$Just(e.jT))));
								}),
							newExams);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{ab: datePickers, F: examDates, ac: timePickers, G: examTimes, t: newExams}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 24:
					var response = msg.a;
					switch (response.$) {
						case 3:
							var enrollments = response.a;
							var examEnrollments = $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (en) {
										return _Utils_Tuple2(en.jS, en);
									},
									A2(
										$elm$core$List$filter,
										function (en) {
											return _Utils_eq(en.jv, model.ju);
										},
										enrollments)));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{a0: examEnrollments}),
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$NoUpdate);
						case 2:
							var err = response.a;
							var errorMsg = function () {
								switch (err.$) {
									case 0:
										var url = err.a;
										return 'BadUrl: ' + url;
									case 1:
										return 'Timeout';
									case 2:
										return 'Networerror';
									case 3:
										var status = err.a;
										return 'BadStatus: ' + $elm$core$String$fromInt(status);
									default:
										var dbg = err.a;
										return 'BadBody: ' + dbg;
								}
							}();
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', errorMsg)));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 12:
					var exam_id = msg.a;
					return _Utils_Tuple3(
						model,
						A2($elm$core$Dict$member, exam_id, model.a0) ? A3(
							$author$project$Api$Request$Exam$examEnrollmentDelete,
							model.ju,
							exam_id,
							$author$project$Pages$CourseDetail$ToggleExamEnrollmentResponse(exam_id)) : A3(
							$author$project$Api$Request$Exam$examEnrollmentPost,
							model.ju,
							exam_id,
							$author$project$Pages$CourseDetail$ToggleExamEnrollmentResponse(exam_id)),
						$author$project$SharedState$NoUpdate);
				case 26:
					var exam_id = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								model,
								$author$project$Api$Request$Exam$examEnrollmentsStudentGet($author$project$Pages$CourseDetail$ExamEnrollmentResponse),
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Success, 'Success', 'Änderung gespeichert')));
						case 2:
							var err = response.a;
							var errorMsg = function () {
								switch (err.$) {
									case 0:
										var url = err.a;
										return 'BadUrl: ' + url;
									case 1:
										return 'Timeout';
									case 2:
										return 'Networerror';
									case 3:
										var status = err.a;
										return 'BadStatus: ' + $elm$core$String$fromInt(status);
									default:
										var dbg = err.a;
										return 'BadBody: ' + dbg;
								}
							}();
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', errorMsg)));
						default:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'Could not save changes!')));
					}
				case 27:
					var field = msg.a;
					var value = msg.b;
					return _Utils_Tuple3(
						A3($author$project$Pages$CourseDetail$setField, model, field, value),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 28:
					var examId = msg.a;
					var subMsg = msg.b;
					var maybeOldPicker = A2($elm$core$Dict$get, examId, model.ab);
					var maybeOldDate = A2($elm$core$Dict$get, examId, model.F);
					var _v23 = _Utils_Tuple2(maybeOldPicker, maybeOldDate);
					if ((!_v23.a.$) && (!_v23.b.$)) {
						var oldPicker = _v23.a.a;
						var oldDate = _v23.b.a;
						var _v24 = A3(
							$CurrySoftware$elm_datepicker$DatePicker$update,
							$author$project$Pages$CourseDetail$datePickerSettings(sharedState),
							subMsg,
							oldPicker);
						var newDatePicker = _v24.a;
						var event = _v24.b;
						var newDate = function () {
							if (event.$ === 2) {
								var date = event.a;
								return $elm$core$Maybe$Just(date);
							} else {
								return oldDate;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ab: A3($elm$core$Dict$insert, examId, newDatePicker, model.ab),
									F: A3($elm$core$Dict$insert, examId, newDate, model.F)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 29:
					var examId = msg.a;
					var subMsg = msg.b;
					var maybeOldTime = A2($elm$core$Dict$get, examId, model.G);
					var maybeOldPicker = A2($elm$core$Dict$get, examId, model.ac);
					var _v26 = _Utils_Tuple2(maybeOldPicker, maybeOldTime);
					if ((!_v26.a.$) && (!_v26.b.$)) {
						var oldPicker = _v26.a.a;
						var oldTime = _v26.b.a;
						var _v27 = A3($stephenreddek$elm_time_picker$TimePicker$update, $author$project$Pages$CourseDetail$timePickerSettings, subMsg, oldPicker);
						var newTimePicker = _v27.a;
						var event = _v27.b;
						var newTime = function () {
							if (event.$ === 1) {
								var time = event.a;
								return time;
							} else {
								return oldTime;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									ac: A3($elm$core$Dict$insert, examId, newTimePicker, model.ac),
									G: A3($elm$core$Dict$insert, examId, newTime, model.G)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 31:
					var exam = msg.a;
					var maybeTime = A2($elm$core$Dict$get, exam.ki, model.G);
					var maybeDate = A2($elm$core$Dict$get, exam.ki, model.F);
					var _v29 = _Utils_Tuple2(maybeDate, maybeTime);
					if ((((!_v29.a.$) && (!_v29.a.a.$)) && (!_v29.b.$)) && (!_v29.b.a.$)) {
						var date = _v29.a.a.a;
						var time = _v29.b.a.a;
						var newExamTime = A3(
							$author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset,
							date,
							time,
							{ho: 2, hS: 0, hU: 1});
						var newExam = A5($author$project$Api$Data$Exam$Exam, exam.ki, exam.kY, exam.jC, newExamTime, exam.jv);
						return _Utils_Tuple3(
							model,
							A3($author$project$Api$Request$Exam$examPost, model.ju, newExam, $author$project$Pages$CourseDetail$ExamCreateResponse),
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 32:
					var response = msg.a;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{ab: $elm$core$Dict$empty, F: $elm$core$Dict$empty, ac: $elm$core$Dict$empty, G: $elm$core$Dict$empty, t: $elm$core$Dict$empty}),
								A2($author$project$Api$Request$Exam$examsGet, model.ju, $author$project$Pages$CourseDetail$ExamsResponse),
								$author$project$SharedState$NoUpdate);
						case 2:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'Failed to save new exam')));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 34:
					var examId = msg.a;
					return _Utils_Tuple3(
						model,
						A3(
							$author$project$Api$Request$Exam$examDelete,
							model.ju,
							examId,
							$author$project$Pages$CourseDetail$ExamDeleteResponse(examId)),
						$author$project$SharedState$NoUpdate);
				case 35:
					var examId = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ab: A2($elm$core$Dict$remove, examId, model.ab),
										F: A2($elm$core$Dict$remove, examId, model.F),
										ac: A2($elm$core$Dict$remove, examId, model.ac),
										G: A2($elm$core$Dict$remove, examId, model.G),
										t: A2($elm$core$Dict$remove, examId, model.t)
									}),
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Success, 'Success', 'Prüfung wurde gelöscht.')));
						case 2:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'Could not delete Exam')));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 30:
					var examId = msg.a;
					var maybeTime = A2($elm$core$Dict$get, examId, model.G);
					var maybeOldExam = A2($elm$core$Dict$get, examId, model.t);
					var maybeDate = A2($elm$core$Dict$get, examId, model.F);
					var _v32 = _Utils_Tuple3(maybeOldExam, maybeDate, maybeTime);
					if (((((!_v32.a.$) && (!_v32.b.$)) && (!_v32.b.a.$)) && (!_v32.c.$)) && (!_v32.c.a.$)) {
						var oldExam = _v32.a.a;
						var date = _v32.b.a.a;
						var time = _v32.c.a.a;
						var newExamTime = A3(
							$author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset,
							date,
							time,
							{ho: 2, hS: 0, hU: 1});
						var newExam = A5($author$project$Api$Data$Exam$Exam, examId, oldExam.kY, oldExam.jC, newExamTime, oldExam.jv);
						return _Utils_Tuple3(
							model,
							A4(
								$author$project$Api$Request$Exam$examPut,
								model.ju,
								examId,
								newExam,
								$author$project$Pages$CourseDetail$ExamUpdateResponse(examId)),
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Error, 'Error', 'Updating exam failed')));
					}
				case 33:
					var examId = msg.a;
					var response = msg.b;
					switch (response.$) {
						case 3:
							var maybeTime = A2($elm$core$Dict$get, examId, model.G);
							var maybeOldExam = A2($elm$core$Dict$get, examId, model.t);
							var maybeDate = A2($elm$core$Dict$get, examId, model.F);
							var _v34 = _Utils_Tuple3(maybeOldExam, maybeDate, maybeTime);
							if (((((!_v34.a.$) && (!_v34.b.$)) && (!_v34.b.a.$)) && (!_v34.c.$)) && (!_v34.c.a.$)) {
								var oldExam = _v34.a.a;
								var date = _v34.b.a.a;
								var time = _v34.c.a.a;
								var newExamTime = A3(
									$author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset,
									date,
									time,
									{ho: 0, hS: 0, hU: 1});
								var newExam = A5($author$project$Api$Data$Exam$Exam, examId, oldExam.kY, oldExam.jC, newExamTime, oldExam.jv);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											t: A3($elm$core$Dict$insert, examId, newExam, model.t)
										}),
									$elm$core$Platform$Cmd$none,
									$author$project$SharedState$ShowToast(
										A2($author$project$Components$Toasty$Success, 'Success', 'Änderung gespeichert.')));
							} else {
								return _Utils_Tuple3(
									model,
									$elm$core$Platform$Cmd$none,
									$author$project$SharedState$ShowToast(
										A2($author$project$Components$Toasty$Success, 'Success', 'Änderungn gespeichert. Darstellungsfehler.')));
							}
						case 2:
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$ShowToast(
									A2($author$project$Components$Toasty$Error, 'Error', 'Server reports: Updating exam failed')));
						default:
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				case 37:
					var newExam = $author$project$Pages$CourseDetail$initNewExam;
					var curTime = A2(
						$elm$core$Maybe$withDefault,
						$elm$time$Time$millisToPosix(0),
						sharedState.jx);
					var datePickers = A3(
						$elm$core$Dict$insert,
						newExam.ki,
						$CurrySoftware$elm_datepicker$DatePicker$initFromDate(
							A2(
								$justinmimbs$date$Date$fromPosix,
								A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$time$Time$millisToPosix(0),
									$elm$core$Maybe$Just(curTime)))),
						model.ab);
					var examDates = A3(
						$elm$core$Dict$insert,
						newExam.ki,
						$elm$core$Maybe$Just(
							A2(
								$justinmimbs$date$Date$fromPosix,
								A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
								A2(
									$elm$core$Maybe$withDefault,
									$elm$time$Time$millisToPosix(0),
									$elm$core$Maybe$Just(curTime)))),
						model.F);
					var examTimes = A3(
						$elm$core$Dict$insert,
						newExam.ki,
						$elm$core$Maybe$Just(
							A2(
								$author$project$Utils$DateAndTimeUtils$pickerTimeFromPosix,
								A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
								curTime)),
						model.G);
					var exams = A3(
						$elm$core$Dict$insert,
						newExam.ki,
						_Utils_update(
							newExam,
							{jv: model.ju, jT: curTime}),
						model.t);
					var timePickers = A3(
						$elm$core$Dict$insert,
						newExam.ki,
						$stephenreddek$elm_time_picker$TimePicker$init(
							$elm$core$Maybe$Just(
								A2(
									$author$project$Utils$DateAndTimeUtils$pickerTimeFromPosix,
									A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_),
									curTime))),
						model.ac);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ab: datePickers, F: examDates, ac: timePickers, G: examTimes, t: exams}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				default:
					break _v0$43;
			}
		}
		return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
	});
var $author$project$Pages$CourseEditor$CourseCreateResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CourseEditor$CourseEditResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CourseEditor$ToastyMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Data$Course$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.kY)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(model.jC)),
				_Utils_Tuple2(
				'begins_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.i8)),
				_Utils_Tuple2(
				'ends_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.jQ)),
				_Utils_Tuple2(
				'required_percentage',
				$elm$json$Json$Encode$int(model.lE))
			]));
};
var $author$project$Api$Request$Courses$coursePut = F3(
	function (id, courseUp, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$course(id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Course$encoder(courseUp)),
			msg);
	});
var $author$project$Api$Request$Courses$coursesPost = F2(
	function (courseNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$courses),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Course$encoder(courseNew)),
			msg,
			$author$project$Api$Data$Course$decoder);
	});
var $author$project$Pages$CourseEditor$fillModelFromResponse = F3(
	function (sharedState, course, model) {
		var timezone = A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_);
		var endDate = A2($justinmimbs$date$Date$fromPosix, timezone, course.jQ);
		var beginDate = A2($justinmimbs$date$Date$fromPosix, timezone, course.i8);
		return _Utils_update(
			model,
			{
				aH: $elm$core$Maybe$Just(beginDate),
				bX: course.kY,
				jC: course.jC,
				an: $elm$core$Maybe$Just(endDate),
				lE: function (num) {
					return (!num) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
						$elm$core$String$fromInt(num));
				}(course.lE)
			});
	});
var $author$project$Pages$CourseEditor$fillRequestFromModel = function (model) {
	var defaultPosix = $elm$time$Time$millisToPosix(0);
	var defaultDate = A2($justinmimbs$date$Date$fromPosix, $elm$time$Time$utc, defaultPosix);
	var endDate = A2($elm$core$Maybe$withDefault, defaultDate, model.an);
	var endPosix = A2(
		$elm$core$Maybe$withDefault,
		defaultPosix,
		$elm$core$Result$toMaybe(
			$author$project$Utils$DateAndTimeUtils$dateToPosix(endDate)));
	var beginDate = A2($elm$core$Maybe$withDefault, defaultDate, model.aH);
	var beginPosix = A2(
		$elm$core$Maybe$withDefault,
		defaultPosix,
		$elm$core$Result$toMaybe(
			$author$project$Utils$DateAndTimeUtils$dateToPosix(beginDate)));
	return {
		i8: beginPosix,
		jC: model.jC,
		jQ: endPosix,
		ki: model.ki,
		kY: model.bX,
		lE: A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(
				A2($elm$core$Maybe$withDefault, '0', model.lE)))
	};
};
var $author$project$Pages$CourseEditor$BeginsAtDate = 3;
var $author$project$Pages$CourseEditor$Description = 1;
var $author$project$Pages$CourseEditor$EndsAtDate = 4;
var $author$project$Pages$CourseEditor$Name = 0;
var $author$project$Pages$CourseEditor$RequiredPercentage = 2;
var $rtfeldman$elm_validate$Validate$firstErrorHelp = F2(
	function (validators, subject) {
		firstErrorHelp:
		while (true) {
			if (!validators.b) {
				return _List_Nil;
			} else {
				var getErrors = validators.a;
				var rest = validators.b;
				var _v1 = getErrors(subject);
				if (!_v1.b) {
					var $temp$validators = rest,
						$temp$subject = subject;
					validators = $temp$validators;
					subject = $temp$subject;
					continue firstErrorHelp;
				} else {
					var errors = _v1;
					return errors;
				}
			}
		}
	});
var $rtfeldman$elm_validate$Validate$firstError = function (validators) {
	var getErrors = function (subject) {
		return A2($rtfeldman$elm_validate$Validate$firstErrorHelp, validators, subject);
	};
	return getErrors;
};
var $rtfeldman$elm_validate$Validate$ifFalse = F2(
	function (test, error) {
		var getErrors = function (subject) {
			return test(subject) ? _List_Nil : _List_fromArray(
				[error]);
		};
		return getErrors;
	});
var $justinmimbs$date$Date$compare = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($elm$core$Basics$compare, a, b);
	});
var $author$project$Pages$CourseEditor$isDateInFuture = F2(
	function (sharedState, maybeDate) {
		var currentTimezone = A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_);
		var currentDate = A2(
			$justinmimbs$date$Date$fromPosix,
			currentTimezone,
			A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				sharedState.jx));
		if (!maybeDate.$) {
			var date = maybeDate.a;
			var _v1 = A2($justinmimbs$date$Date$compare, date, currentDate);
			switch (_v1) {
				case 0:
					return false;
				case 1:
					return true;
				default:
					return true;
			}
		} else {
			return false;
		}
	});
var $author$project$Pages$CourseEditor$ifDateNotInFuture = F3(
	function (sharedState, subjectToMaybeDate, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$author$project$Pages$CourseEditor$isDateInFuture,
					sharedState,
					subjectToMaybeDate(subject));
			},
			error);
	});
var $author$project$Pages$CourseEditor$isFirstDateOlder = F2(
	function (maybeFirstDate, maybeSecondDate) {
		var _v0 = _Utils_Tuple2(maybeFirstDate, maybeSecondDate);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var firstDate = _v0.a.a;
			var secondDate = _v0.b.a;
			var _v1 = A2($justinmimbs$date$Date$compare, firstDate, secondDate);
			if (!_v1) {
				return true;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Pages$CourseEditor$ifFirstDateNotOlder = F3(
	function (subject1ToMaybeDate, subject2ToMaybeDate, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$author$project$Pages$CourseEditor$isFirstDateOlder,
					subject1ToMaybeDate(subject),
					subject2ToMaybeDate(subject));
			},
			error);
	});
var $author$project$Pages$CourseEditor$isPercentageRequiredAndOk = function (maybePercentage) {
	if (!maybePercentage.$) {
		var percentage = maybePercentage.a;
		var _v1 = $elm$core$String$toInt(percentage);
		if (_v1.$ === 1) {
			return false;
		} else {
			var perc = _v1.a;
			return ((perc >= 0) && (perc <= 100)) ? true : false;
		}
	} else {
		return true;
	}
};
var $author$project$Pages$CourseEditor$ifIsNotPercentage = F2(
	function (subjectToMaybeString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return $author$project$Pages$CourseEditor$isPercentageRequiredAndOk(
					subjectToMaybeString(subject));
			},
			error);
	});
var $author$project$Pages$CourseEditor$isNothingOrInt = function (maybeString) {
	if (!maybeString.$) {
		var string = maybeString.a;
		var _v1 = $elm$core$String$toInt(string);
		if (_v1.$ === 1) {
			return false;
		} else {
			return true;
		}
	} else {
		return true;
	}
};
var $author$project$Pages$CourseEditor$ifJustAndNotInt = F2(
	function (subjectToMaybeString, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return $author$project$Pages$CourseEditor$isNothingOrInt(
					subjectToMaybeString(subject));
			},
			error);
	});
var $rtfeldman$elm_validate$Validate$ifNothing = F2(
	function (subjectToMaybe, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifTrue,
			function (subject) {
				return _Utils_eq(
					subjectToMaybe(subject),
					$elm$core$Maybe$Nothing);
			},
			error);
	});
var $author$project$Pages$CourseEditor$modelValidator = function (sharedState) {
	return $rtfeldman$elm_validate$Validate$all(
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.bX;
				},
				_Utils_Tuple2(0, 'Bitte gib einen Kursnamen ein.')),
				A2(
				$rtfeldman$elm_validate$Validate$ifBlank,
				function ($) {
					return $.jC;
				},
				_Utils_Tuple2(1, 'Bitte gib eine Kursbeschreibung ein.')),
				$rtfeldman$elm_validate$Validate$firstError(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						function ($) {
							return $.aH;
						},
						_Utils_Tuple2(3, 'Setze ein Startdatum.')),
						A3(
						$author$project$Pages$CourseEditor$ifFirstDateNotOlder,
						function ($) {
							return $.aH;
						},
						function ($) {
							return $.an;
						},
						_Utils_Tuple2(3, 'Das Startdatum muss vor dem Enddatum liegen.'))
					])),
				$rtfeldman$elm_validate$Validate$firstError(
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_validate$Validate$ifNothing,
						function ($) {
							return $.an;
						},
						_Utils_Tuple2(4, 'Setze ein Enddatum.')),
						A3(
						$author$project$Pages$CourseEditor$ifDateNotInFuture,
						sharedState,
						function ($) {
							return $.an;
						},
						_Utils_Tuple2(4, 'Das Datum darf nicht in der Vergangenheit liegen.')),
						A3(
						$author$project$Pages$CourseEditor$ifFirstDateNotOlder,
						function ($) {
							return $.aH;
						},
						function ($) {
							return $.an;
						},
						_Utils_Tuple2(4, 'Das Enddatum muss nach dem Startdatum liegen.'))
					])),
				$rtfeldman$elm_validate$Validate$firstError(
				_List_fromArray(
					[
						A2(
						$author$project$Pages$CourseEditor$ifJustAndNotInt,
						function ($) {
							return $.lE;
						},
						_Utils_Tuple2(2, 'Die benötigten Prozent müssen eine Prozentzahl sein.')),
						A2(
						$author$project$Pages$CourseEditor$ifIsNotPercentage,
						function ($) {
							return $.lE;
						},
						_Utils_Tuple2(2, 'Die benötigten Prozent müssen zwischen 0 und 100% liegen.'))
					]))
			]));
};
var $author$project$Pages$CourseEditor$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{bX: value});
			case 1:
				return _Utils_update(
					model,
					{jC: value});
			case 2:
				return _Utils_update(
					model,
					{
						lE: $elm$core$Maybe$Just(value)
					});
			default:
				return model;
		}
	});
var $author$project$Pages$CourseEditor$settings = function (sharedState) {
	var curTime = A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		sharedState.jx);
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			nc: $author$project$Utils$DateFormatter$shortDayFormatter(sharedState),
			nO: _List_fromArray(
				[
					$author$project$Utils$Styles$lineInputStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3]))
				]),
			n0: $author$project$Utils$DateFormatter$monthFormatter(sharedState)
		});
};
var $pablen$toasty$Toasty$Leaving = 1;
var $pablen$toasty$Toasty$Remove = function (a) {
	return {$: 1, a: a};
};
var $pablen$toasty$Toasty$Temporary = 0;
var $pablen$toasty$Toasty$Entered = 0;
var $pablen$toasty$Toasty$TransitionOut = function (a) {
	return {$: 2, a: a};
};
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $pablen$toasty$Toasty$getNewId = function (seed) {
	return A2(
		$elm$random$Random$step,
		A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt),
		seed);
};
var $pablen$toasty$Toasty$addToast_ = F5(
	function (removeBehaviour, _v0, tagger, toast, _v1) {
		var cfg = _v0;
		var model = _v1.a;
		var cmd = _v1.b;
		var _v2 = model.iC;
		var toasts = _v2.a;
		var seed = _v2.b;
		var _v3 = $pablen$toasty$Toasty$getNewId(seed);
		var newId = _v3.a;
		var newSeed = _v3.b;
		var task = function () {
			if (!removeBehaviour) {
				return A2(
					$elm$core$Task$perform,
					function (_v5) {
						return tagger(
							$pablen$toasty$Toasty$TransitionOut(newId));
					},
					$elm$core$Process$sleep(cfg.ha));
			} else {
				return $elm$core$Platform$Cmd$none;
			}
		}();
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					iC: A2(
						$pablen$toasty$Toasty$Stack,
						_Utils_ap(
							toasts,
							_List_fromArray(
								[
									_Utils_Tuple3(newId, 0, toast)
								])),
						newSeed)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, task])));
	});
var $pablen$toasty$Toasty$addToast = $pablen$toasty$Toasty$addToast_(0);
var $pablen$toasty$Toasty$update = F4(
	function (_v0, tagger, msg, model) {
		var cfg = _v0;
		var _v1 = model.iC;
		var toasts = _v1.a;
		var seed = _v1.b;
		switch (msg.$) {
			case 0:
				var toast = msg.a;
				return A4(
					$pablen$toasty$Toasty$addToast,
					$pablen$toasty$Toasty$config,
					tagger,
					toast,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 1:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$filter,
					function (_v3) {
						var id = _v3.a;
						var toast = _v3.b;
						var status = _v3.c;
						return !_Utils_eq(id, targetId);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iC: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var targetId = msg.a;
				var newStack = A2(
					$elm$core$List$map,
					function (_v5) {
						var id = _v5.a;
						var status = _v5.b;
						var toast = _v5.c;
						return _Utils_eq(id, targetId) ? _Utils_Tuple3(id, 1, toast) : _Utils_Tuple3(id, status, toast);
					},
					toasts);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							iC: A2($pablen$toasty$Toasty$Stack, newStack, seed)
						}),
					A2(
						$elm$core$Task$perform,
						function (_v4) {
							return tagger(
								$pablen$toasty$Toasty$Remove(targetId));
						},
						$elm$core$Process$sleep(cfg.iI)));
		}
	});
var $pablen$toasty$Toasty$addToastIf = F5(
	function (cfg, tagger, condition, toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = model.iC;
		var toasts = _v1.a;
		var seed = _v1.b;
		var shouldAddToast = condition(
			A2(
				$elm$core$List$map,
				function (_v2) {
					var id = _v2.a;
					var st = _v2.b;
					var t = _v2.c;
					return t;
				},
				toasts));
		return shouldAddToast ? A4(
			$pablen$toasty$Toasty$addToast,
			cfg,
			tagger,
			toast,
			_Utils_Tuple2(model, cmd)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $pablen$toasty$Toasty$addToastIfUnique = F4(
	function (cfg, tagger, toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A5(
			$pablen$toasty$Toasty$addToastIf,
			cfg,
			tagger,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$elm$core$List$member(toast)),
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$CourseEditor$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$CourseEditor$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $elm$browser$Browser$Navigation$back = F2(
	function (key, n) {
		return A2(_Browser_go, key, -n);
	});
var $author$project$Pages$CourseEditor$updateHandleCreateOrEditResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2($elm$browser$Browser$Navigation$back, sharedState.f1, 1),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var errorString = function () {
							_v2$3:
							while (true) {
								switch (e.$) {
									case 3:
										switch (e.a) {
											case 400:
												return 'Bad Data. Something is off in the data.';
											case 403:
												return 'You are not allowed to do this!';
											default:
												break _v2$3;
										}
									case 4:
										var message = e.a;
										return 'Bad return: ' + message;
									default:
										break _v2$3;
								}
							}
							return 'Something other went wrong';
						}();
						var _v1 = A2(
							$author$project$Pages$CourseEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $rtfeldman$elm_validate$Validate$Valid = $elm$core$Basics$identity;
var $rtfeldman$elm_validate$Validate$validate = F2(
	function (_v0, subject) {
		var getErrors = _v0;
		var _v1 = getErrors(subject);
		if (!_v1.b) {
			return $elm$core$Result$Ok(subject);
		} else {
			var errors = _v1;
			return $elm$core$Result$Err(errors);
		}
	});
var $author$project$Pages$CourseEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 4:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$CourseEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 1:
				if (msg.a.$ === 3) {
					var course = msg.a.a;
					var new_model = A3($author$project$Pages$CourseEditor$fillModelFromResponse, sharedState, course, model);
					return _Utils_Tuple3(
						_Utils_update(
							new_model,
							{cT: $krisajenkins$remotedata$RemoteData$NotAsked}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var response = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cT: response}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				}
			case 7:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							lE: _Utils_eq(model.lE, $elm$core$Maybe$Nothing) ? $elm$core$Maybe$Just('0') : $elm$core$Maybe$Nothing
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 8:
				var _v1 = A2(
					$rtfeldman$elm_validate$Validate$validate,
					$author$project$Pages$CourseEditor$modelValidator(sharedState),
					model);
				if (_v1.$ === 1) {
					var errors = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var body = $author$project$Pages$CourseEditor$fillRequestFromModel(model);
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: _List_Nil}),
						function () {
							var _v2 = model.cE;
							if (_v2) {
								return A2($author$project$Api$Request$Courses$coursesPost, body, $author$project$Pages$CourseEditor$CourseCreateResponse);
							} else {
								return A3($author$project$Api$Request$Courses$coursePut, model.ki, body, $author$project$Pages$CourseEditor$CourseEditResponse);
							}
						}(),
						$author$project$SharedState$NoUpdate);
				}
			case 2:
				var response = msg.a;
				return A3($author$project$Pages$CourseEditor$updateHandleCreateOrEditResponse, sharedState, model, response);
			case 3:
				var response = msg.a;
				return A3($author$project$Pages$CourseEditor$updateHandleCreateOrEditResponse, sharedState, model, response);
			case 5:
				var subMsg = msg.a;
				var _v3 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$CourseEditor$settings(sharedState),
					subMsg,
					model.dO);
				var newDatePicker = _v3.a;
				var event = _v3.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.aH;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aH: newDate, dO: newDatePicker}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				var subMsg = msg.a;
				var _v5 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$CourseEditor$settings(sharedState),
					subMsg,
					model.d4);
				var newDatePicker = _v5.a;
				var event = _v5.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.an;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{an: newDate, d4: newDatePicker}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				var subMsg = msg.a;
				var _v7 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$CourseEditor$ToastyMsg, subMsg, model);
				var newModel = _v7.a;
				var newCmd = _v7.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$DeleteCourseResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$Courses$DisenrollResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$Courses$EnrollResponse = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$Courses$ToastyMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Api$Request$Courses$courseDelete = F2(
	function (id, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$course(id)),
			msg);
	});
var $author$project$Api$Request$Courses$coursesEnrollmentDelete = F2(
	function (courseId, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseEnrollment, courseId, _List_Nil)),
			msg);
	});
var $author$project$Api$Request$Courses$coursesEnrollmentPost = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$courseEnrollment, courseId, _List_Nil)),
			$elm$http$Http$emptyBody,
			msg);
	});
var $author$project$Pages$Courses$updateHandleAccountEnrollments = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cq: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$updateHandleCourses = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cB: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cB: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cB: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$Courses$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$Courses$updateHandleDelete = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$Courses$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'You\'ve deleted the course'),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{cC: $elm$core$Maybe$Nothing, b1: false}),
						$author$project$Api$Request$Courses$coursesGet($author$project$Pages$Courses$CoursesResponse)));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$Courses$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to delete'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$updateHandleDisenroll = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$Courses$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'You are now disenrolled'),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{cD: $elm$core$Maybe$Nothing, b2: false}),
						$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$Courses$AccountEnrollmentsResponse)));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$Courses$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to disenroll'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$updateHandleEnroll = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$Courses$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'You are now enrolled'),
					_Utils_Tuple2(
						model,
						$author$project$Api$Request$Account$accountEnrollmentGet($author$project$Pages$Courses$AccountEnrollmentsResponse)));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$Courses$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to enroll'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Courses$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A3($author$project$Pages$Courses$updateHandleCourses, sharedState, model, response);
			case 1:
				var response = msg.a;
				return A3($author$project$Pages$Courses$updateHandleAccountEnrollments, sharedState, model, response);
			case 2:
				var course = msg.a;
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Request$Courses$coursesEnrollmentPost, course.ki, $author$project$Pages$Courses$EnrollResponse),
					$author$project$SharedState$NoUpdate);
			case 3:
				var course = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cD: $elm$core$Maybe$Just(course),
							b2: true
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				var course = msg.a;
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Request$Courses$coursesEnrollmentDelete, course.ki, $author$project$Pages$Courses$DisenrollResponse),
					$author$project$SharedState$NoUpdate);
			case 6:
				var response = msg.a;
				return A3($author$project$Pages$Courses$updateHandleEnroll, sharedState, model, response);
			case 7:
				var response = msg.a;
				return A3($author$project$Pages$Courses$updateHandleDisenroll, sharedState, model, response);
			case 8:
				var course = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cC: $elm$core$Maybe$Just(course),
							b1: true
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 9:
				var course = msg.a;
				return _Utils_Tuple3(
					model,
					A2($author$project$Api$Request$Courses$courseDelete, course.ki, $author$project$Pages$Courses$DeleteCourseResponse),
					$author$project$SharedState$NoUpdate);
			case 10:
				var response = msg.a;
				return A3($author$project$Pages$Courses$updateHandleDelete, sharedState, model, response);
			case 14:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{du: !model.du}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 11:
				var visible = msg.a;
				if (!visible) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cC: $elm$core$Maybe$Nothing, b1: visible}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b1: visible}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				}
			case 5:
				var visible = msg.a;
				if (!visible) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cD: $elm$core$Maybe$Nothing, b2: visible}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{b2: visible}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				}
			case 13:
				var subMsg = msg.a;
				var _v3 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$Courses$ToastyMsg, subMsg, model);
				var newModel = _v3.a;
				var newCmd = _v3.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Dashboard$GetMissingItem = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Pages$Dashboard$GetOwnGroup = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Pages$Dashboard$GradeRequest = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Dashboard$TaskRequest = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$Endpoint$courseMissingGrades = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'grades',
				'missing'
			]),
		_List_Nil);
};
var $author$project$Api$Data$MissingGrade$MissingGrade = F4(
	function (grade, course_id, sheet_id, task_id) {
		return {jv: course_id, kd: grade, lZ: sheet_id, ml: task_id};
	});
var $author$project$Api$Data$MissingGrade$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'task_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'sheet_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'course_id',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'grade',
				$author$project$Api$Data$Grade$decoder,
				$elm$json$Json$Decode$succeed($author$project$Api$Data$MissingGrade$MissingGrade)))));
var $author$project$Api$Request$Courses$courseGradeMissing = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseMissingGrades(courseId)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$MissingGrade$decoder));
	});
var $author$project$Api$Endpoint$courseMissingTasks = function (courseId) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(courseId),
				'tasks',
				'missing'
			]),
		_List_Nil);
};
var $author$project$Api$Data$MissingTask$MissingTask = F3(
	function (task, course_id, sheet_id) {
		return {jv: course_id, lZ: sheet_id, mk: task};
	});
var $author$project$Api$Data$MissingTask$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'sheet_id',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'course_id',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'task',
			$author$project$Api$Data$Task$decoder,
			$elm$json$Json$Decode$succeed($author$project$Api$Data$MissingTask$MissingTask))));
var $author$project$Api$Request$Courses$courseTaskMissing = F2(
	function (courseId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseMissingTasks(courseId)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$MissingTask$decoder));
	});
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Pages$Dashboard$fillFusedEnrollmentAndDecideRequests = function (model) {
	var nextRequests = function (m) {
		var _v1 = _Utils_Tuple2(m.cU, m.cS);
		if ((_v1.a.$ === 3) && (_v1.b.$ === 3)) {
			return $elm$core$Platform$Cmd$batch(
				A2(
					$elm$core$List$map,
					function (fe) {
						var _v2 = fe.lJ;
						switch (_v2) {
							case 0:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Pages$Dashboard$GetMissingItem(fe.E.ki),
											A2($author$project$Api$Request$Courses$courseTaskMissing, fe.E.ki, $author$project$Pages$Dashboard$TaskRequest)),
											A2(
											$author$project$Api$Request$Courses$courseOwnGroupGet,
											fe.E.ki,
											$author$project$Pages$Dashboard$GetOwnGroup(fe.E.ki))
										]));
							case 1:
								return $elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2(
											$elm$core$Platform$Cmd$map,
											$author$project$Pages$Dashboard$GetMissingItem(fe.E.ki),
											A2($author$project$Api$Request$Courses$courseGradeMissing, fe.E.ki, $author$project$Pages$Dashboard$GradeRequest)),
											A2(
											$author$project$Api$Request$Courses$courseOwnGroupGet,
											fe.E.ki,
											$author$project$Pages$Dashboard$GetOwnGroup(fe.E.ki))
										]));
							default:
								return $elm$core$Platform$Cmd$none;
						}
					},
					$elm$core$Dict$values(m.aN)));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	};
	return function (m) {
		return _Utils_Tuple3(
			m,
			nextRequests(m),
			$author$project$SharedState$NoUpdate);
	}(
		function () {
			var _v0 = _Utils_Tuple2(model.cU, model.cS);
			if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
				var courses = _v0.a.a;
				var enrollments = _v0.b.a;
				return function (fe) {
					return _Utils_update(
						model,
						{aN: fe});
				}(
					$elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (fe) {
								return _Utils_Tuple2(fe.E.ki, fe);
							},
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								A2(
									$elm$core$List$map,
									function (e) {
										return A2(
											$elm$core$Maybe$map,
											function (c) {
												return {E: c, fK: $elm$core$Maybe$Nothing, f$: $elm$core$Maybe$Nothing, lJ: e.lJ};
											},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													function (c) {
														return _Utils_eq(c.ki, e.jv);
													},
													courses)));
									},
									enrollments)))));
			} else {
				return model;
			}
		}());
};
var $author$project$Pages$Dashboard$updateFusedEnrollmentWithGroups = F3(
	function (model, courseId, groupRequest) {
		return function (maybeGroup) {
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						aN: A3(
							$elm$core$Dict$update,
							courseId,
							$elm$core$Maybe$map(
								function (fe) {
									return _Utils_update(
										fe,
										{fK: maybeGroup});
								}),
							model.aN)
					}),
				$elm$core$Platform$Cmd$none,
				$author$project$SharedState$NoUpdate);
		}(
			$krisajenkins$remotedata$RemoteData$toMaybe(groupRequest));
	});
var $author$project$Pages$Dashboard$GetSheet = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Dashboard$GetTasks = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Dashboard$GradeTodo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Dashboard$TaskTodo = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Pages$Dashboard$updateFusedEnrollmentWithTodosAndNextRequests = F3(
	function (model, courseId, todoRequest) {
		return function (maybeTodos) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aN: A3(
							$elm$core$Dict$update,
							courseId,
							$elm$core$Maybe$map(
								function (fe) {
									return _Utils_update(
										fe,
										{f$: maybeTodos});
								}),
							model.aN)
					}),
				function () {
					if (!maybeTodos.$) {
						var todos = maybeTodos.a;
						return $elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (_v3) {
									var cid = _v3.a;
									var sid = _v3.b;
									return $elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A3($author$project$Api$Request$Sheet$sheetGet, cid, sid, $author$project$Pages$Dashboard$GetSheet),
												A3($author$project$Api$Request$Sheet$sheetTasksGet, cid, sid, $author$project$Pages$Dashboard$GetTasks)
											]));
								},
								$elm$core$Set$toList(
									$elm$core$Set$fromList(
										function (todo) {
											if (!todo.$) {
												var tasks = todo.a;
												return A2(
													$elm$core$List$map,
													function (t) {
														return _Utils_Tuple2(t.jv, t.lZ);
													},
													tasks);
											} else {
												var grades = todo.a;
												return A2(
													$elm$core$List$map,
													function (g) {
														return _Utils_Tuple2(g.jv, g.lZ);
													},
													grades);
											}
										}(todos)))));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}());
		}(
			$krisajenkins$remotedata$RemoteData$toMaybe(
				function () {
					if (!todoRequest.$) {
						var response = todoRequest.a;
						return A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (mts) {
								return $author$project$Pages$Dashboard$TaskTodo(mts);
							},
							response);
					} else {
						var response = todoRequest.a;
						return A2(
							$krisajenkins$remotedata$RemoteData$map,
							function (mgs) {
								return $author$project$Pages$Dashboard$GradeTodo(mgs);
							},
							response);
					}
				}()));
	});
var $author$project$Pages$Dashboard$updateSheetsDict = F2(
	function (model, sheetRequest) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (sheet) {
					return _Utils_update(
						model,
						{
							bO: A3($elm$core$Dict$insert, sheet.ki, sheet, model.bO)
						});
				},
				$krisajenkins$remotedata$RemoteData$toMaybe(sheetRequest)));
	});
var $author$project$Pages$Dashboard$updateTasksDict = F2(
	function (model, tasksRequest) {
		return A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (tasks) {
					return A3(
						$elm$core$List$foldl,
						F2(
							function (task, m) {
								return _Utils_update(
									m,
									{
										e$: A3($elm$core$Dict$insert, task.ki, task, m.e$)
									});
							}),
						model,
						tasks);
				},
				$krisajenkins$remotedata$RemoteData$toMaybe(tasksRequest)));
	});
var $author$project$Pages$Dashboard$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var response = msg.a;
				return $author$project$Pages$Dashboard$fillFusedEnrollmentAndDecideRequests(
					_Utils_update(
						model,
						{cU: response}));
			case 2:
				var response = msg.a;
				return $author$project$Pages$Dashboard$fillFusedEnrollmentAndDecideRequests(
					_Utils_update(
						model,
						{cS: response}));
			case 3:
				var courseId = msg.a;
				var response = msg.b;
				return A2(
					$author$project$Utils$Utils$tupleExtend,
					A3($author$project$Pages$Dashboard$updateFusedEnrollmentWithTodosAndNextRequests, model, courseId, response),
					$author$project$SharedState$NoUpdate);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Dashboard$updateSheetsDict, model, response),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Pages$Dashboard$updateTasksDict, model, response),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				var courseId = msg.a;
				var response = msg.b;
				return A3($author$project$Pages$Dashboard$updateFusedEnrollmentWithGroups, model, courseId, response);
		}
	});
var $author$project$Pages$GroupEditor$CreateResponse = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$GroupEditor$EditResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$GroupEditor$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$GroupEditor$SearchUserResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Data$User$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(model.j_)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(model.kB)),
				_Utils_Tuple2(
				'avatar_url',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.i3)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.jM)),
				_Utils_Tuple2(
				'student_number',
				$elm$json$Json$Encode$string(model.oR)),
				_Utils_Tuple2(
				'semester',
				$elm$json$Json$Encode$int(model.lW)),
				_Utils_Tuple2(
				'subject',
				$elm$json$Json$Encode$string(model.mb)),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string(model.kA)),
				_Utils_Tuple2(
				'root',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$bool, model.lK))
			]));
};
var $author$project$Api$Data$Group$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(model.jC)),
				_Utils_Tuple2(
				'tutor',
				$author$project$Api$Data$User$encoder(model.mB)),
				_Utils_Tuple2(
				'course_id',
				$elm$json$Json$Encode$int(model.ju))
			]));
};
var $author$project$Api$Request$Courses$courseGroupsPost = F3(
	function (id, groupNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseGroups(id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Group$encoder(groupNew)),
			msg,
			$author$project$Api$Data$Group$decoder);
	});
var $author$project$Api$Request$Courses$coursesEnrollmentGetByQuery = F3(
	function (courseId, query, msg) {
		var params = _List_fromArray(
			[
				A2($elm$url$Url$Builder$string, 'q', query)
			]);
		return A3($author$project$Api$Request$Courses$coursesEnrollmentGet, courseId, params, msg);
	});
var $author$project$Pages$GroupEditor$fillModelFromGroup = F2(
	function (model, group) {
		return _Utils_update(
			model,
			{
				ju: group.ju,
				jC: group.jC,
				ke: group.ki,
				cc: $elm$core$Maybe$Just(group.mB)
			});
	});
var $author$project$Pages$GroupEditor$fillRequestFromModel = F2(
	function (model, tutor) {
		return {ju: model.ju, jC: model.jC, ki: model.ke, mB: tutor};
	});
var $author$project$Api$Request$Groups$groupsPut = F4(
	function (courseId, id, groupUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$group, courseId, id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Group$encoder(groupUpdate)),
			msg);
	});
var $author$project$Pages$GroupEditor$setField = F3(
	function (field, value, model) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{jC: value});
			case 1:
				return _Utils_update(
					model,
					{eN: value});
			default:
				return _Utils_update(
					model,
					{gs: value});
		}
	});
var $author$project$Pages$GroupEditor$updateHandleCreateOrEditResponse = F2(
	function (model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Utils$Utils$perform(
						$author$project$Pages$GroupEditor$NavigateTo(
							$author$project$Routing$Helpers$CourseDetailRoute(model.ju))),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$GroupEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 9:
				switch (msg.a.$) {
					case 3:
						var group = msg.a.a;
						return _Utils_Tuple3(
							A2($author$project$Pages$GroupEditor$fillModelFromGroup, model, group),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					case 2:
						var err = msg.a.a;
						return _Utils_Tuple3(
							model,
							$author$project$Utils$Utils$perform(
								$author$project$Pages$GroupEditor$NavigateTo(
									$author$project$Routing$Helpers$CourseDetailRoute(model.ju))),
							$author$project$SharedState$NoUpdate);
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dp: $krisajenkins$remotedata$RemoteData$Loading}),
					A3($author$project$Api$Request$Courses$coursesEnrollmentGetByEmail, model.ju, model.eN, $author$project$Pages$GroupEditor$SearchUserResponse),
					$author$project$SharedState$NoUpdate);
			case 2:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dp: $krisajenkins$remotedata$RemoteData$Loading}),
					A3($author$project$Api$Request$Courses$coursesEnrollmentGetByQuery, model.ju, model.gs, $author$project$Pages$GroupEditor$SearchUserResponse),
					$author$project$SharedState$NoUpdate);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dp: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				var user = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							cc: $elm$core$Maybe$Just(user)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$GroupEditor$setField, field, value, model),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				var _v1 = model.cc;
				if (!_v1.$) {
					var tutor = _v1.a;
					return _Utils_Tuple3(
						model,
						model.bY ? A3(
							$author$project$Api$Request$Courses$courseGroupsPost,
							model.ju,
							A2($author$project$Pages$GroupEditor$fillRequestFromModel, model, tutor),
							$author$project$Pages$GroupEditor$CreateResponse) : A4(
							$author$project$Api$Request$Groups$groupsPut,
							model.ju,
							model.ke,
							A2($author$project$Pages$GroupEditor$fillRequestFromModel, model, tutor),
							$author$project$Pages$GroupEditor$EditResponse),
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 7:
				var response = msg.a;
				return A2($author$project$Pages$GroupEditor$updateHandleCreateOrEditResponse, model, response);
			case 8:
				var response = msg.a;
				return A2($author$project$Pages$GroupEditor$updateHandleCreateOrEditResponse, model, response);
			default:
				var userId = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Login$LoginResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Login$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Login$ShowToastAndRedirect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Login$Email = 0;
var $author$project$Pages$Login$Password = 1;
var $author$project$Pages$Login$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.jM;
			},
			_Utils_Tuple2(0, 'Bitte gib deine E-Mail Adresse ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.le;
			},
			_Utils_Tuple2(1, 'Bitte gib dein Passwort ein.'))
		]));
var $author$project$Pages$Login$setField = F3(
	function (model, field, value) {
		if (!field) {
			return _Utils_update(
				model,
				{jM: value});
		} else {
			return _Utils_update(
				model,
				{le: value});
		}
	});
var $damienklinnert$elm_spinner$Spinner$update = F2(
	function (msg, _v0) {
		var time = _v0;
		if (!msg.$) {
			return time;
		} else {
			var newTime = msg.a;
			return newTime;
		}
	});
var $author$project$Pages$Login$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$Login$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var _v1 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$Login$modelValidator, model);
				if (_v1.$ === 1) {
					var errors = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var account = {
						jM: $elm$core$Maybe$Just(model.jM),
						le: $elm$core$Maybe$Just(model.le)
					};
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: _List_Nil, eu: $krisajenkins$remotedata$RemoteData$Loading}),
						A2($author$project$Api$Request$Auth$sessionPost, account, $author$project$Pages$Login$LoginResponse),
						$author$project$SharedState$NoUpdate);
				}
			case 3:
				switch (msg.a.$) {
					case 2:
						var err = msg.a.a;
						var errorString = function () {
							_v2$2:
							while (true) {
								if (err.$ === 3) {
									switch (err.a) {
										case 400:
											return 'Wrong Password or Username!';
										case 422:
											return 'Your email is not confirmed!';
										default:
											break _v2$2;
									}
								} else {
									break _v2$2;
								}
							}
							return 'Something went wrong';
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									eu: $krisajenkins$remotedata$RemoteData$Failure(err)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Error, 'Error', errorString)));
					case 3:
						var role = msg.a.a;
						return _Utils_Tuple3(
							model,
							$author$project$Utils$Utils$perform(
								$author$project$Pages$Login$ShowToastAndRedirect(
									A2($author$project$Components$Toasty$Success, 'Logged in', 'You are now logged in.'))),
							A2($author$project$SharedState$UpdateRoleAndMail, role, model.jM));
					default:
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 4:
				var toast = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Utils$Utils$perform(
						$author$project$Pages$Login$NavigateTo($author$project$Routing$Helpers$DashboardRoute)),
					$author$project$SharedState$ShowToast(toast));
			default:
				var spinmsg = msg.a;
				var spinnerModel = A2($damienklinnert$elm_spinner$Spinner$update, spinmsg, model.eW);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eW: spinnerModel}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MailConfirmation$update = F3(
	function (sharedState, msg, model) {
		if (msg.$ === 3) {
			var response = msg.a;
			return _Utils_Tuple3(
				model,
				A2(
					$elm$browser$Browser$Navigation$pushUrl,
					sharedState.f1,
					$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
				$author$project$SharedState$ShowToast(
					A2($author$project$Components$Toasty$Success, 'Success', 'Your email has been confirmed')));
		} else {
			var response = msg;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{fo: response}),
				$elm$core$Platform$Cmd$none,
				$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MailEditor$SendMessageResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$MailEditor$ToastyMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$MailEditor$modelToMail = function (model) {
	return {kS: model.kS, mb: model.mb};
};
var $author$project$Api$Endpoint$courseEmail = function (id) {
	return A2(
		$author$project$Api$Endpoint$url,
		_List_fromArray(
			[
				'courses',
				$elm$core$String$fromInt(id),
				'emails'
			]),
		_List_Nil);
};
var $author$project$Api$Data$Mail$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'subject',
				$elm$json$Json$Encode$string(model.mb)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(model.kS))
			]));
};
var $author$project$Api$Request$Mail$sendCourseMailPost = F3(
	function (courseId, mailObject, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseEmail(courseId)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Mail$encoder(mailObject)),
			msg);
	});
var $author$project$Api$Endpoint$groupEmail = F2(
	function (courseId, groupId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'groups',
					$elm$core$String$fromInt(groupId),
					'emails'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Mail$sendGroupMailPost = F4(
	function (courseId, groupId, mailObject, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$groupEmail, courseId, groupId)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Mail$encoder(mailObject)),
			msg);
	});
var $author$project$Pages$MailEditor$setField = F3(
	function (model, field, value) {
		if (!field) {
			return _Utils_update(
				model,
				{mb: value});
		} else {
			return _Utils_update(
				model,
				{kS: value});
		}
	});
var $author$project$Pages$MailEditor$updateHandleCourseResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var course = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							db: A2($author$project$Pages$MailEditor$Course, course.ki, response)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MailEditor$updateHandleGroupResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var group = response.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							db: A3($author$project$Pages$MailEditor$Group, group.ju, group.ki, response)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MailEditor$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$MailEditor$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$MailEditor$updateHandleSendMessageResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$DashboardRoute)),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				var _v1 = A2(
					$author$project$Pages$MailEditor$addToast,
					A2($author$project$Components$Toasty$Error, 'Error', 'Failed to deliver Email'),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MailEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var _v1 = model.db;
				switch (_v1.$) {
					case 0:
						var users = _v1.a;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					case 1:
						var courseId = _v1.a;
						var groupId = _v1.b;
						var group = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c0: true}),
							A4(
								$author$project$Api$Request$Mail$sendGroupMailPost,
								courseId,
								groupId,
								$author$project$Pages$MailEditor$modelToMail(model),
								$author$project$Pages$MailEditor$SendMessageResponse),
							$author$project$SharedState$NoUpdate);
					default:
						var courseId = _v1.a;
						var course = _v1.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c0: true}),
							A3(
								$author$project$Api$Request$Mail$sendCourseMailPost,
								courseId,
								$author$project$Pages$MailEditor$modelToMail(model),
								$author$project$Pages$MailEditor$SendMessageResponse),
							$author$project$SharedState$NoUpdate);
				}
			case 9:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$MailEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 7:
				var subMsg = msg.a;
				var _v2 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$MailEditor$ToastyMsg, subMsg, model);
				var newModel = _v2.a;
				var newCmd = _v2.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 2:
				var response = msg.a;
				return A3($author$project$Pages$MailEditor$updateHandleSendMessageResponse, sharedState, model, response);
			case 3:
				var user = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 4:
				var response = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 6:
				var response = msg.a;
				return A3($author$project$Pages$MailEditor$updateHandleGroupResponse, sharedState, model, response);
			default:
				var response = msg.a;
				return A3($author$project$Pages$MailEditor$updateHandleCourseResponse, sharedState, model, response);
		}
	});
var $author$project$Pages$MaterialEditor$DeleteResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$MaterialEditor$GotFiles = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Pages$MaterialEditor$ToastyMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$MaterialEditor$CreateResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$MaterialEditor$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$MaterialEditor$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Api$Data$Material$typeEncoder = function (materialType) {
	if (!materialType) {
		return $elm$json$Json$Encode$int(1);
	} else {
		return $elm$json$Json$Encode$int(0);
	}
};
var $author$project$Api$Data$Material$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.kY)),
				_Utils_Tuple2(
				'kind',
				$author$project$Api$Data$Material$typeEncoder(model.kJ)),
				_Utils_Tuple2(
				'publish_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.ly)),
				_Utils_Tuple2(
				'lecture_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.kC)),
				_Utils_Tuple2(
				'required_role',
				$elm$json$Json$Encode$int(model.lF))
			]));
};
var $author$project$Api$Request$Courses$courseMaterialsPost = F3(
	function (id, materialNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseMaterials(id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Material$encoder(materialNew)),
			msg,
			$author$project$Api$Data$Material$decoder);
	});
var $author$project$Pages$MaterialEditor$setupMaterial = F5(
	function (name, publish, lecture, materialType, requiredRole) {
		return {jZ: $elm$core$Maybe$Nothing, ki: 0, kC: lecture, kJ: materialType, kY: name, ly: publish, lF: requiredRole};
	});
var $author$project$Pages$MaterialEditor$createRequest = function (model) {
	var _v0 = _Utils_Tuple2(model.bM, model.bF);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var publish = _v0.a.a;
		var lecture = _v0.b.a;
		return _Utils_Tuple2(
			model,
			A3(
				$author$project$Api$Request$Courses$courseMaterialsPost,
				model.jv,
				A5($author$project$Pages$MaterialEditor$setupMaterial, model.kY, publish, lecture, model.bH, model.bc),
				$author$project$Pages$MaterialEditor$CreateResponse));
	} else {
		return A2(
			$author$project$Pages$MaterialEditor$addToast,
			A2($author$project$Components$Toasty$Error, 'Error', 'There was an error with the data provided.'),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	}
};
var $author$project$Pages$MaterialEditor$datePickerSettings = function (sharedState) {
	var curTime = A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		sharedState.jx);
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			nc: $author$project$Utils$DateFormatter$shortDayFormatter(sharedState),
			nO: _List_fromArray(
				[
					$author$project$Utils$Styles$lineInputStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3]))
				]),
			n0: $author$project$Utils$DateFormatter$monthFormatter(sharedState)
		});
};
var $elm$file$File$Select$files = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				var f = _v0.a;
				var fs = _v0.b;
				return A2(toMsg, f, fs);
			},
			_File_uploadOneOrMore(mimes));
	});
var $author$project$Utils$DateAndTimeUtils$utcOffsetsPartsList = _List_fromArray(
	[
		{ho: 12, hS: 0, hU: -1},
		{ho: 11, hS: 0, hU: -1},
		{ho: 10, hS: 0, hU: -1},
		{ho: 9, hS: 30, hU: -1},
		{ho: 9, hS: 0, hU: -1},
		{ho: 8, hS: 0, hU: -1},
		{ho: 7, hS: 0, hU: -1},
		{ho: 6, hS: 0, hU: -1},
		{ho: 5, hS: 0, hU: -1},
		{ho: 4, hS: 0, hU: -1},
		{ho: 3, hS: 30, hU: -1},
		{ho: 3, hS: 0, hU: -1},
		{ho: 2, hS: 0, hU: -1},
		{ho: 1, hS: 0, hU: -1},
		{ho: 0, hS: 0, hU: 1},
		{ho: 1, hS: 0, hU: 1},
		{ho: 2, hS: 0, hU: 1},
		{ho: 3, hS: 0, hU: 1},
		{ho: 3, hS: 30, hU: 1},
		{ho: 4, hS: 0, hU: 1},
		{ho: 4, hS: 30, hU: 1},
		{ho: 5, hS: 0, hU: 1},
		{ho: 5, hS: 30, hU: 1},
		{ho: 5, hS: 45, hU: 1},
		{ho: 6, hS: 0, hU: 1},
		{ho: 6, hS: 30, hU: 1},
		{ho: 7, hS: 0, hU: 1},
		{ho: 8, hS: 0, hU: 1},
		{ho: 8, hS: 45, hU: 1},
		{ho: 9, hS: 0, hU: 1},
		{ho: 9, hS: 30, hU: 1},
		{ho: 10, hS: 0, hU: 1},
		{ho: 10, hS: 30, hU: 1},
		{ho: 11, hS: 0, hU: 1},
		{ho: 12, hS: 0, hU: 1},
		{ho: 12, hS: 45, hU: 1},
		{ho: 13, hS: 0, hU: 1},
		{ho: 14, hS: 0, hU: 1}
	]);
var $author$project$Utils$DateAndTimeUtils$findIndexFromParts = function (toSearch) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var part = _v0.b;
					return _Utils_eq(part, toSearch);
				},
				A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, $author$project$Utils$DateAndTimeUtils$utcOffsetsPartsList))));
};
var $author$project$Utils$DateAndTimeUtils$offsetToParts = function (offset) {
	var multiplier = (offset < 0) ? (-1) : 1;
	var minutes = A2(
		$elm$core$Basics$modBy,
		60,
		$elm$core$Basics$abs(offset));
	var hours = ($elm$core$Basics$abs(offset) / 60) | 0;
	return {ho: hours, hS: minutes, hU: multiplier};
};
var $author$project$Utils$DateAndTimeUtils$timeZoneToUtcOffsetMinutes = function (zone) {
	var oneDay = ((24 * 60) * 60) * 1000;
	var minuteUtc = A2(
		$elm$time$Time$toMinute,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(oneDay));
	var minute = A2(
		$elm$time$Time$toMinute,
		zone,
		$elm$time$Time$millisToPosix(oneDay));
	var minuteOffset = minute - minuteUtc;
	var hourUtc = A2(
		$elm$time$Time$toHour,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(oneDay));
	var hour = A2(
		$elm$time$Time$toHour,
		zone,
		$elm$time$Time$millisToPosix(oneDay));
	var hourOffset = (hour - hourUtc) * 60;
	var dayUtc = A2(
		$elm$time$Time$toDay,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(oneDay));
	var day = A2(
		$elm$time$Time$toDay,
		zone,
		$elm$time$Time$millisToPosix(oneDay));
	var dayOffset = ((day - dayUtc) * 24) * 60;
	var offset = (dayOffset + hourOffset) + minuteOffset;
	return offset;
};
var $author$project$Utils$DateAndTimeUtils$splitPosixInDateTimeAndOffset = F2(
	function (zone, posix) {
		var second = A2($elm$time$Time$toSecond, zone, posix);
		var offsetParts = $author$project$Utils$DateAndTimeUtils$offsetToParts(
			$author$project$Utils$DateAndTimeUtils$timeZoneToUtcOffsetMinutes(zone));
		var minute = A2($elm$time$Time$toMinute, zone, posix);
		var hour = A2($elm$time$Time$toHour, zone, posix);
		return _Utils_Tuple3(
			A2($justinmimbs$date$Date$fromPosix, zone, posix),
			{ho: hour, hS: minute, gu: second},
			offsetParts);
	});
var $author$project$Pages$MaterialEditor$fillModelFromRequest = F3(
	function (sharedState, model, material) {
		var timezone = A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_);
		var _v0 = A2($author$project$Utils$DateAndTimeUtils$splitPosixInDateTimeAndOffset, timezone, material.ly);
		var publishedDate = _v0.a;
		var publishedTime = _v0.b;
		var _v1 = A2($author$project$Utils$DateAndTimeUtils$splitPosixInDateTimeAndOffset, timezone, material.kC);
		var lectureDate = _v1.a;
		var lectureTime = _v1.b;
		var offset = _v1.c;
		var utcOffsetPos = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
			$author$project$Utils$DateAndTimeUtils$findIndexFromParts(offset));
		return _Utils_update(
			model,
			{
				ki: material.ki,
				a4: $elm$core$Maybe$Just(lectureDate),
				bE: $elm$core$Maybe$Just(lectureTime),
				bF: $elm$core$Maybe$Just(material.kC),
				c1: $stephenreddek$elm_time_picker$TimePicker$init(
					$elm$core$Maybe$Just(lectureTime)),
				bH: material.kJ,
				kY: material.kY,
				bb: $elm$core$Maybe$Just(publishedDate),
				bL: $elm$core$Maybe$Just(publishedTime),
				bM: $elm$core$Maybe$Just(material.ly),
				dk: $stephenreddek$elm_time_picker$TimePicker$init(
					$elm$core$Maybe$Just(publishedTime)),
				bc: material.lF,
				aB: utcOffsetPos
			});
	});
var $author$project$Api$Request$Material$materialDelete = F3(
	function (courseId, id, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$material, courseId, id)),
			msg);
	});
var $author$project$Pages$MaterialEditor$LectureDate = 4;
var $author$project$Pages$MaterialEditor$LectureTime = 3;
var $author$project$Pages$MaterialEditor$Name = 0;
var $author$project$Pages$MaterialEditor$PublishedDate = 2;
var $author$project$Pages$MaterialEditor$PublishedTime = 1;
var $author$project$Pages$MaterialEditor$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.kY;
			},
			_Utils_Tuple2(0, 'Bitte gib einen Blattnamen ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.bL;
			},
			_Utils_Tuple2(1, 'Bitte gib eine Freigabezeit ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.bb;
			},
			_Utils_Tuple2(2, 'Bitte gib ein Freigabedatum ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.bE;
			},
			_Utils_Tuple2(3, 'Bitte gib eine Vorlesungszeit ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifNothing,
			function ($) {
				return $.a4;
			},
			_Utils_Tuple2(4, 'Bitte gib ein Vorlesungsdatum ein.'))
		]));
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{y: nodeList, u: nodeListSize, x: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Pages$MaterialEditor$joinTime = F3(
	function (date, time, utcOffsetPos) {
		var offsetPartsArray = $elm$core$Array$fromList($author$project$Utils$DateAndTimeUtils$utcOffsetsPartsList);
		var offset = A2(
			$elm$core$Maybe$withDefault,
			{ho: 0, hS: 0, hU: 1},
			A2($elm$core$Array$get, utcOffsetPos, offsetPartsArray));
		return A3($author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset, date, time, offset);
	});
var $author$project$Pages$MaterialEditor$testIfTimeIsReady = F3(
	function (maybeDate, maybeTime, offset) {
		var _v0 = _Utils_Tuple2(maybeDate, maybeTime);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var date = _v0.a.a;
			var time = _v0.b.a;
			return $elm$core$Maybe$Just(
				A3($author$project$Pages$MaterialEditor$joinTime, date, time, offset));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$MaterialEditor$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{kY: value});
			case 5:
				var newPos = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
					$elm$core$String$toInt(value));
				return _Utils_update(
					model,
					{
						bF: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, model.a4, model.bE, newPos),
						bM: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, model.bb, model.bL, newPos),
						aB: newPos
					});
			default:
				return model;
		}
	});
var $author$project$Pages$MaterialEditor$timePickerSettings = function () {
	var defaultSettings = $stephenreddek$elm_time_picker$TimePicker$defaultSettings;
	return _Utils_update(
		defaultSettings,
		{n_: 15, oK: false, pf: true});
}();
var $author$project$Utils$DateAndTimeUtils$timeZoneToIndex = function (zone) {
	return $author$project$Utils$DateAndTimeUtils$findIndexFromParts(
		$author$project$Utils$DateAndTimeUtils$offsetToParts(
			$author$project$Utils$DateAndTimeUtils$timeZoneToUtcOffsetMinutes(zone)));
};
var $author$project$Pages$MaterialEditor$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$MaterialEditor$updateHandleDelete = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Utils$Utils$perform(
						$author$project$Pages$MaterialEditor$NavigateTo(
							$author$project$Routing$Helpers$CourseDetailRoute(model.jv))),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v1 = A2(
							$author$project$Pages$MaterialEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to delete'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MaterialEditor$updateHandleFileUpload = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							$author$project$Routing$Helpers$CourseDetailRoute(model.jv))),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var errorString = function () {
							_v2$3:
							while (true) {
								switch (e.$) {
									case 3:
										switch (e.a) {
											case 400:
												return 'Bad Data. Something is off in the data.';
											case 403:
												return 'You are not allowed to do this!';
											default:
												break _v2$3;
										}
									case 4:
										var message = e.a;
										return 'Bad return: ' + message;
									default:
										break _v2$3;
								}
							}
							return 'Something other went wrong';
						}();
						var _v1 = A2(
							$author$project$Pages$MaterialEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MaterialEditor$updateHandleGetMaterial = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var material = response.a;
				var newModel = A3($author$project$Pages$MaterialEditor$fillModelFromRequest, sharedState, model, material);
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{c6: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v1 = A2(
							$author$project$Pages$MaterialEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Error receiving material data'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{c6: response}),
							newCmd,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c6: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MaterialEditor$FileUploadResponse = function (a) {
	return {$: 21, a: a};
};
var $author$project$Api$Endpoint$materialFile = F2(
	function (courseId, materialId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'materials',
					$elm$core$String$fromInt(materialId),
					'file'
				]),
			_List_Nil);
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$Helper$postFile = F3(
	function (url, file, msg) {
		return $elm$http$Http$request(
			{
				al: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'file_data', file)
						])),
				ao: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg)),
				ar: _List_Nil,
				as: 'POST',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Just('file_upload'),
				aA: url
			});
	});
var $author$project$Api$Request$Material$materialFilePost = F4(
	function (courseId, id, file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$materialFile, courseId, id)),
			file,
			msg);
	});
var $author$project$Pages$MaterialEditor$updateHandleSend = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = _Utils_Tuple2(model.fx, model.d6);
				if (_v1.a) {
					if (!_v1.b.$) {
						var file = _v1.b.a;
						return _Utils_Tuple3(
							model,
							A4($author$project$Api$Request$Material$materialFilePost, model.jv, model.ki, file, $author$project$Pages$MaterialEditor$FileUploadResponse),
							$author$project$SharedState$NoUpdate);
					} else {
						var _v2 = _v1.b;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				} else {
					return _Utils_Tuple3(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							sharedState.f1,
							$author$project$Routing$Helpers$reverseRoute(
								$author$project$Routing$Helpers$CourseDetailRoute(model.jv))),
						$author$project$SharedState$NoUpdate);
				}
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var errorString = function () {
							_v4$4:
							while (true) {
								switch (e.$) {
									case 3:
										switch (e.a) {
											case 400:
												return 'Bad Data. Something is off in the data.';
											case 403:
												return 'You are not allowed to do this!';
											case 500:
												return 'Server not happy. Wrong file type? Must be .zip or .pdf';
											default:
												break _v4$4;
										}
									case 4:
										var message = e.a;
										return 'Bad return: ' + message;
									default:
										break _v4$4;
								}
							}
							return 'Something other went wrong';
						}();
						var _v3 = A2(
							$author$project$Pages$MaterialEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v3.a;
						var newCmd = _v3.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$MaterialEditor$UpdateResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Request$Material$materialPut = F4(
	function (courseId, id, materialUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$material, courseId, id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Material$encoder(materialUpdate)),
			msg);
	});
var $author$project$Pages$MaterialEditor$updateRequest = function (model) {
	var _v0 = _Utils_Tuple2(model.bM, model.bF);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var publish = _v0.a.a;
		var lecture = _v0.b.a;
		return _Utils_Tuple2(
			model,
			A4(
				$author$project$Api$Request$Material$materialPut,
				model.jv,
				model.ki,
				A5($author$project$Pages$MaterialEditor$setupMaterial, model.kY, publish, lecture, model.bH, model.bc),
				$author$project$Pages$MaterialEditor$UpdateResponse));
	} else {
		return A2(
			$author$project$Pages$MaterialEditor$addToast,
			A2($author$project$Components$Toasty$Error, 'Error', 'There was an error with the data provided.'),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	}
};
var $author$project$Pages$MaterialEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var subMsg = msg.a;
				var _v1 = A3($stephenreddek$elm_time_picker$TimePicker$update, $author$project$Pages$MaterialEditor$timePickerSettings, subMsg, model.dk);
				var updatedPicker = _v1.a;
				var timeEvent = _v1.b;
				var newTime = function () {
					if (!timeEvent.$) {
						return model.bL;
					} else {
						var time = timeEvent.a;
						return time;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bL: newTime,
							bM: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, model.bb, newTime, model.aB),
							dk: updatedPicker
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var subMsg = msg.a;
				var _v3 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$MaterialEditor$datePickerSettings(sharedState),
					subMsg,
					model.eI);
				var newDatePicker = _v3.a;
				var event = _v3.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.bb;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bb: newDate,
							eI: newDatePicker,
							bM: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, newDate, model.bL, model.aB)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 3:
				var subMsg = msg.a;
				var _v5 = A3($stephenreddek$elm_time_picker$TimePicker$update, $author$project$Pages$MaterialEditor$timePickerSettings, subMsg, model.c1);
				var updatedPicker = _v5.a;
				var timeEvent = _v5.b;
				var newTime = function () {
					if (!timeEvent.$) {
						return model.bE;
					} else {
						var time = timeEvent.a;
						return time;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bE: newTime,
							bF: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, model.a4, newTime, model.aB),
							c1: updatedPicker
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				var subMsg = msg.a;
				var _v7 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$MaterialEditor$datePickerSettings(sharedState),
					subMsg,
					model.eq);
				var newDatePicker = _v7.a;
				var event = _v7.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.a4;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a4: newDate,
							eq: newDatePicker,
							bF: A3($author$project$Pages$MaterialEditor$testIfTimeIsReady, newDate, model.bE, model.aB)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aB: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
								$author$project$Utils$DateAndTimeUtils$timeZoneToIndex(
									A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				var response = msg.a;
				return A3($author$project$Pages$MaterialEditor$updateHandleGetMaterial, sharedState, model, response);
			case 7:
				var _v9 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$MaterialEditor$modelValidator, model);
				if (_v9.$ === 1) {
					var errors = _v9.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var _v10 = $author$project$Pages$MaterialEditor$createRequest(model);
					var newModel = _v10.a;
					var newCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{hf: _List_Nil}),
						newCmd,
						$author$project$SharedState$NoUpdate);
				}
			case 8:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var material = response.a;
						return A3($author$project$Pages$MaterialEditor$fillModelFromRequest, sharedState, model, material);
					} else {
						return model;
					}
				}();
				return A3($author$project$Pages$MaterialEditor$updateHandleSend, sharedState, newModel, response);
			case 9:
				var _v12 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$MaterialEditor$modelValidator, model);
				if (_v12.$ === 1) {
					var errors = _v12.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var _v13 = $author$project$Pages$MaterialEditor$updateRequest(model);
					var newModel = _v13.a;
					var newCmd = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{hf: _List_Nil}),
						newCmd,
						$author$project$SharedState$NoUpdate);
				}
			case 10:
				var response = msg.a;
				return A3($author$project$Pages$MaterialEditor$updateHandleSend, sharedState, model, response);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d_: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 12:
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Request$Material$materialDelete, model.jv, model.ki, $author$project$Pages$MaterialEditor$DeleteResponse),
					$author$project$SharedState$NoUpdate);
			case 13:
				var response = msg.a;
				return A3($author$project$Pages$MaterialEditor$updateHandleDelete, sharedState, model, response);
			case 14:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$MaterialEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 18:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['application/zip', 'application/pdf']),
						$author$project$Pages$MaterialEditor$GotFiles),
					$author$project$SharedState$NoUpdate);
			case 19:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 20:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 17:
				var file = msg.a;
				var files = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d6: $elm$core$Maybe$Just(file),
							fx: true,
							bB: false
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 21:
				var response = msg.a;
				return A3($author$project$Pages$MaterialEditor$updateHandleFileUpload, sharedState, model, response);
			case 15:
				var matType = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: matType}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 16:
				var role = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bc: role}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 22:
				var subMsg = msg.a;
				var _v14 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$MaterialEditor$ToastyMsg, subMsg, model);
				var newModel = _v14.a;
				var newCmd = _v14.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 23:
				var visible = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d_: visible}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$PasswordReset$SetPasswordResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$PasswordReset$ToastyMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$PasswordReset$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$PasswordReset$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$PasswordReset$modelToUpdatePassword = function (model) {
	return {jM: model.jM, lb: model.lb, lH: model.iD};
};
var $author$project$Pages$PasswordReset$Password = 0;
var $author$project$Pages$PasswordReset$PasswordRepeat = 1;
var $author$project$Pages$PasswordReset$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.lb;
					},
					_Utils_Tuple2(0, 'Bitte gib ein Passwort ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $elm$core$String$length(model.lb) < 7;
					},
					_Utils_Tuple2(0, 'Das Passwort muss mindestens 7 Zeichen lang sein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.dg;
					},
					_Utils_Tuple2(1, 'Bitte gib dein Passwort erneut ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifFalse,
					function (model) {
						return _Utils_eq(model.lb, model.dg);
					},
					_Utils_Tuple2(0, 'Die Passwörter müssen identisch sein.'))
				]))
		]));
var $author$project$Pages$PasswordReset$setField = F3(
	function (model, field, value) {
		if (!field) {
			return _Utils_update(
				model,
				{lb: value});
		} else {
			return _Utils_update(
				model,
				{dg: value});
		}
	});
var $author$project$Api$Data$UpdatePassword$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.jM)),
				_Utils_Tuple2(
				'reset_password_token',
				$elm$json$Json$Encode$string(model.lH)),
				_Utils_Tuple2(
				'plain_password',
				$elm$json$Json$Encode$string(model.lb))
			]));
};
var $author$project$Api$Endpoint$updatePassword = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['auth', 'update_password']),
	_List_Nil);
var $author$project$Api$Request$Auth$updatePasswordPost = F2(
	function (updatePasswordObject, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$updatePassword),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$UpdatePassword$encoder(updatePasswordObject)),
			msg);
	});
var $author$project$Pages$PasswordReset$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$PasswordReset$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var _v1 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$PasswordReset$modelValidator, model);
				if (_v1.$ === 1) {
					var errors = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: _List_Nil}),
						A2(
							$author$project$Api$Request$Auth$updatePasswordPost,
							$author$project$Pages$PasswordReset$modelToUpdatePassword(model),
							$author$project$Pages$PasswordReset$SetPasswordResponse),
						$author$project$SharedState$NoUpdate);
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								sharedState.f1,
								$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
							$author$project$SharedState$NoUpdate);
					case 2:
						var err = msg.a.a;
						var _v2 = A2(
							$author$project$Pages$PasswordReset$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'There was a problem changing your password.'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					default:
						var response = msg.a;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			default:
				var subMsg = msg.a;
				var _v3 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$PasswordReset$ToastyMsg, subMsg, model);
				var newModel = _v3.a;
				var newCmd = _v3.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$GotFiles = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$ProfileEditor$GotPreview = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$ProfileEditor$ToastyMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$ProfileEditor$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{j_: value});
			case 1:
				return _Utils_update(
					model,
					{kB: value});
			case 2:
				return _Utils_update(
					model,
					{jM: value});
			case 3:
				return _Utils_update(
					model,
					{oR: value});
			case 4:
				return _Utils_update(
					model,
					{lW: value});
			case 5:
				return _Utils_update(
					model,
					{mb: value});
			case 7:
				return _Utils_update(
					model,
					{lb: value});
			case 8:
				return _Utils_update(
					model,
					{dg: value});
			default:
				return _Utils_update(
					model,
					{k3: value});
		}
	});
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Pages$ProfileEditor$userToModel = F2(
	function (model, user) {
		return _Utils_update(
			model,
			{
				jM: user.jM,
				j_: user.j_,
				kB: user.kB,
				dj: function () {
					var _v0 = user.i3;
					if (!_v0.$) {
						var url = _v0.a;
						return url;
					} else {
						return 'images/defaultAvatar.png';
					}
				}(),
				lW: $elm$core$String$fromInt(user.lW),
				oR: user.oR,
				mb: user.mb
			});
	});
var $author$project$Pages$ProfileEditor$updateAccountGetResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var user = response.a;
				var newModel = A2($author$project$Pages$ProfileEditor$userToModel, model, user);
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{mE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{mE: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$RequestInformationUpdate = {$: 10};
var $author$project$Pages$ProfileEditor$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$ProfileEditor$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$ProfileEditor$updateAccountUpdateResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$ProfileEditor$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'Profile updated!'),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{k3: '', lb: '', dg: ''}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								newCmd,
								$author$project$Utils$Utils$perform($author$project$Pages$ProfileEditor$RequestInformationUpdate)
							])),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$ProfileEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to update profile!'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$updateAvatarUpdateResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$ProfileEditor$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'Profile updated!'),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{dL: $elm$core$Maybe$Nothing, cv: false, dj: ''}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								newCmd,
								$author$project$Utils$Utils$perform($author$project$Pages$ProfileEditor$RequestInformationUpdate)
							])),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$ProfileEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to update profile!'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$AccountUpdateResponse = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$ProfileEditor$AvatarUpdateResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$ProfileEditor$UserUpdateResponse = function (a) {
	return {$: 12, a: a};
};
var $author$project$Api$Endpoint$account = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['account']),
	_List_Nil);
var $author$project$Api$Data$AccountUpdate$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'account',
				$author$project$Api$Data$Account$encoder(model.iV)),
				_Utils_Tuple2(
				'old_plain_password',
				$elm$json$Json$Encode$string(model.k3))
			]));
};
var $author$project$Api$Helper$patchExpectNothing = F3(
	function (url, body, msg) {
		return $elm$http$Http$request(
			{
				al: body,
				ao: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeR, $krisajenkins$remotedata$RemoteData$fromResult, msg)),
				ar: _List_Nil,
				as: 'PATCH',
				ax: $elm$core$Maybe$Nothing,
				az: $elm$core$Maybe$Nothing,
				aA: url
			});
	});
var $author$project$Api$Request$Account$accountPatch = F2(
	function (accountUpdate, msg) {
		return A3(
			$author$project$Api$Helper$patchExpectNothing,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$account),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$AccountUpdate$encoder(accountUpdate)),
			msg);
	});
var $author$project$Pages$ProfileEditor$Email = 2;
var $author$project$Pages$ProfileEditor$OldPassword = 6;
var $author$project$Pages$ProfileEditor$Password = 7;
var $elm$regex$Regex$contains = _Regex_contains;
var $rtfeldman$elm_validate$Validate$validEmail = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	A2(
		$elm$regex$Regex$fromStringWith,
		{m3: true, n1: false},
		'^[a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$'));
var $rtfeldman$elm_validate$Validate$isValidEmail = function (email) {
	return A2($elm$regex$Regex$contains, $rtfeldman$elm_validate$Validate$validEmail, email);
};
var $rtfeldman$elm_validate$Validate$ifInvalidEmail = F2(
	function (subjectToEmail, errorFromEmail) {
		var getErrors = function (subject) {
			var email = subjectToEmail(subject);
			return $rtfeldman$elm_validate$Validate$isValidEmail(email) ? _List_Nil : _List_fromArray(
				[
					errorFromEmail(email)
				]);
		};
		return getErrors;
	});
var $author$project$Pages$ProfileEditor$accountValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.jM;
					},
					_Utils_Tuple2(2, 'Bitte gib deine E-Mail ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifInvalidEmail,
					function ($) {
						return $.jM;
					},
					function (value) {
						return _Utils_Tuple2(2, 'Die eingegebene E-Mail Addresse ' + (value + ' ist nicht gültig.'));
					})
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifFalse,
					function (model) {
						return _Utils_eq(model.lb, model.dg);
					},
					_Utils_Tuple2(7, 'Die Passwörter müssen identisch sein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return ($elm$core$String$length(model.lb) < 7) && ($elm$core$String$length(model.lb) > 0);
					},
					_Utils_Tuple2(7, 'Das Passwort muss mindestens 7 Zeichen lang sein.'))
				])),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.k3;
			},
			_Utils_Tuple2(6, 'Bitte gib dein altes Passwort ein.'))
		]));
var $author$project$Api$Endpoint$accountAvatar = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['account', 'avatar']),
	_List_Nil);
var $author$project$Api$Request$Account$accountAvatarPost = F2(
	function (file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$accountAvatar),
			file,
			msg);
	});
var $author$project$Pages$ProfileEditor$avatarUpdateRequest = F2(
	function (model, msg) {
		var _v0 = model.dL;
		if (!_v0.$) {
			var file = _v0.a;
			return A2($author$project$Api$Request$Account$accountAvatarPost, file, msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$ProfileEditor$checkIfAccountChanged = function (model) {
	var _v0 = model.mE;
	if (_v0.$ === 3) {
		var user = _v0.a;
		return (!_Utils_eq(model.jM, user.jM)) || (model.lb !== '');
	} else {
		return false;
	}
};
var $author$project$Pages$ProfileEditor$checkIfUserChanged = function (model) {
	var _v0 = model.mE;
	if (_v0.$ === 3) {
		var user = _v0.a;
		var toCompare = _List_fromArray(
			[
				_Utils_Tuple2(model.j_, user.j_),
				_Utils_Tuple2(model.kB, user.kB),
				_Utils_Tuple2(model.oR, user.oR),
				_Utils_Tuple2(
				model.lW,
				$elm$core$String$fromInt(user.lW)),
				_Utils_Tuple2(model.mb, user.mb)
			]);
		return A2(
			$elm$core$List$any,
			function (_v1) {
				var fromModel = _v1.a;
				var fromUser = _v1.b;
				return !_Utils_eq(fromModel, fromUser);
			},
			toCompare);
	} else {
		return false;
	}
};
var $author$project$Pages$ProfileEditor$modelToAccount = function (model) {
	return {
		iV: {
			jM: (model.jM === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.jM),
			le: (model.lb === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(model.lb)
		},
		k3: model.k3
	};
};
var $author$project$Api$Request$Me$mePut = F2(
	function (userUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$me),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$User$encoder(userUpdate)),
			msg);
	});
var $author$project$Types$languageToBackendString = function (lang) {
	if (!lang) {
		return 'en';
	} else {
		return 'de';
	}
};
var $author$project$Pages$ProfileEditor$modelToUser = F2(
	function (sharedState, model) {
		var _v0 = model.mE;
		if (_v0.$ === 3) {
			var user = _v0.a;
			return $elm$core$Maybe$Just(
				{
					i3: $elm$core$Maybe$Nothing,
					jM: model.jM,
					j_: model.j_,
					ki: user.ki,
					kA: $author$project$Types$languageToBackendString(sharedState.lV),
					kB: model.kB,
					lK: $elm$core$Maybe$Nothing,
					lW: A2(
						$elm$core$Maybe$withDefault,
						1,
						$elm$core$String$toInt(model.lW)),
					oR: model.oR,
					mb: model.mb
				});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$ProfileEditor$userUpdateRequest = F3(
	function (sharedState, model, msg) {
		var _v0 = _Utils_Tuple2(
			model.mE,
			A2($author$project$Pages$ProfileEditor$modelToUser, sharedState, model));
		if ((_v0.a.$ === 3) && (!_v0.b.$)) {
			var user = _v0.a.a;
			var userUpdate = _v0.b.a;
			return A2($author$project$Api$Request$Me$mePut, userUpdate, msg);
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Pages$ProfileEditor$FirstName = 0;
var $author$project$Pages$ProfileEditor$LastName = 1;
var $author$project$Pages$ProfileEditor$Semester = 4;
var $author$project$Pages$ProfileEditor$StudentNumber = 3;
var $author$project$Pages$ProfileEditor$Subject = 5;
var $rtfeldman$elm_validate$Validate$isInt = function (str) {
	var _v0 = $elm$core$String$toInt(str);
	if (_v0.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $rtfeldman$elm_validate$Validate$ifNotInt = F2(
	function (subjectToString, errorFromString) {
		var getErrors = function (subject) {
			var str = subjectToString(subject);
			return $rtfeldman$elm_validate$Validate$isInt(str) ? _List_Nil : _List_fromArray(
				[
					errorFromString(str)
				]);
		};
		return getErrors;
	});
var $author$project$Pages$ProfileEditor$isNegative = function (numberString) {
	var _v0 = $elm$core$String$toInt(numberString);
	if (!_v0.$) {
		var num = _v0.a;
		return num < 0;
	} else {
		return true;
	}
};
var $author$project$Pages$ProfileEditor$isZero = function (numberString) {
	var _v0 = $elm$core$String$toInt(numberString);
	if (!_v0.$) {
		var num = _v0.a;
		return !num;
	} else {
		return true;
	}
};
var $author$project$Pages$ProfileEditor$userValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.lW;
					},
					_Utils_Tuple2(4, 'Bitte gib dein Semester ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifNotInt,
					function ($) {
						return $.lW;
					},
					function (value) {
						return _Utils_Tuple2(4, value + ' ist keine gültige Zahl.');
					}),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$ProfileEditor$isZero(model.lW);
					},
					_Utils_Tuple2(4, 'Auch als Informatiker beginnt das erste Semester mit 1 :).')),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$ProfileEditor$isNegative(model.lW);
					},
					_Utils_Tuple2(4, 'Es gibt keine negativen Semester.'))
				])),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.j_;
			},
			_Utils_Tuple2(0, 'Bitte gib deinen Vornamen ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.kB;
			},
			_Utils_Tuple2(1, 'Bitte gib deinen Nachnamen ein.')),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.oR;
					},
					_Utils_Tuple2(3, 'Bitte gib deine Martrikelnummer ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifNotInt,
					function ($) {
						return $.oR;
					},
					function (value) {
						return _Utils_Tuple2(3, value + ' ist keine gültige Zahl.');
					}),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$ProfileEditor$isNegative(model.oR);
					},
					_Utils_Tuple2(3, 'Matrikelnummern sind positiv.'))
				])),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.mb;
			},
			_Utils_Tuple2(5, 'Bitte gib dein Fach ein.'))
		]));
var $author$project$Pages$ProfileEditor$updateSave = F2(
	function (sharedState, model) {
		var cmds = _List_fromArray(
			[
				{
				fk: $author$project$Pages$ProfileEditor$checkIfAccountChanged(model),
				gl: A2(
					$author$project$Api$Request$Account$accountPatch,
					$author$project$Pages$ProfileEditor$modelToAccount(model),
					$author$project$Pages$ProfileEditor$AccountUpdateResponse),
				gJ: function (m) {
					return _Utils_update(
						m,
						{
							bq: function () {
								var _v1 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$ProfileEditor$accountValidator, m);
								if (_v1.$ === 1) {
									var err = _v1.a;
									return err;
								} else {
									return _List_Nil;
								}
							}()
						});
				}
			},
				{
				fk: $author$project$Pages$ProfileEditor$checkIfUserChanged(model),
				gl: A3($author$project$Pages$ProfileEditor$userUpdateRequest, sharedState, model, $author$project$Pages$ProfileEditor$UserUpdateResponse),
				gJ: function (m) {
					return _Utils_update(
						m,
						{
							bi: function () {
								var _v2 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$ProfileEditor$userValidator, m);
								if (_v2.$ === 1) {
									var err = _v2.a;
									return err;
								} else {
									return _List_Nil;
								}
							}()
						});
				}
			},
				{
				fk: model.cv,
				gl: A2($author$project$Pages$ProfileEditor$avatarUpdateRequest, model, $author$project$Pages$ProfileEditor$AvatarUpdateResponse),
				gJ: function (m) {
					return m;
				}
			}
			]);
		var changed = A2(
			$elm$core$List$filter,
			function ($) {
				return $.fk;
			},
			cmds);
		var requests = A2(
			$elm$core$List$map,
			function ($) {
				return $.gl;
			},
			changed);
		var updatedModel = A3(
			$elm$core$List$foldl,
			function ($) {
				return $.gJ;
			},
			model,
			changed);
		var _v0 = _Utils_Tuple2(updatedModel.bi, updatedModel.bq);
		if ((!_v0.a.b) && (!_v0.b.b)) {
			return _Utils_Tuple3(
				updatedModel,
				$elm$core$Platform$Cmd$batch(requests),
				$author$project$SharedState$NoUpdate);
		} else {
			return _Utils_Tuple3(updatedModel, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$updateUserUpdateResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = A2(
					$author$project$Pages$ProfileEditor$addToast,
					A2($author$project$Components$Toasty$Success, 'Success', 'Profile updated!'),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(
					newModel,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								newCmd,
								$author$project$Utils$Utils$perform($author$project$Pages$ProfileEditor$RequestInformationUpdate)
							])),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v2 = A2(
							$author$project$Pages$ProfileEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to update profile!'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$ProfileEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var response = msg.a;
				return A3($author$project$Pages$ProfileEditor$updateAccountGetResponse, sharedState, model, response);
			case 1:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$ProfileEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 7:
				return A2($author$project$Pages$ProfileEditor$updateSave, sharedState, model);
			case 8:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 9:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 4:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['image/*']),
						$author$project$Pages$ProfileEditor$GotFiles),
					$author$project$SharedState$NoUpdate);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var file = msg.a;
				var files = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							dL: $elm$core$Maybe$Just(file),
							cv: true,
							bB: false
						}),
					A2(
						$elm$core$Task$perform,
						$author$project$Pages$ProfileEditor$GotPreview,
						$elm$file$File$toUrl(file)),
					$author$project$SharedState$NoUpdate);
			case 3:
				var urls = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dj: urls}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 11:
				var response = msg.a;
				return A3($author$project$Pages$ProfileEditor$updateAccountUpdateResponse, sharedState, model, response);
			case 12:
				var response = msg.a;
				return A3($author$project$Pages$ProfileEditor$updateUserUpdateResponse, sharedState, model, response);
			case 13:
				var response = msg.a;
				return A3($author$project$Pages$ProfileEditor$updateAvatarUpdateResponse, sharedState, model, response);
			case 10:
				var _v1 = model.mE;
				if (_v1.$ === 1) {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{mE: $krisajenkins$remotedata$RemoteData$Loading}),
						$author$project$Api$Request$Me$meGet($author$project$Pages$ProfileEditor$UserGetResponse),
						$author$project$SharedState$NoUpdate);
				}
			case 14:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 15:
				var visible = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gR: visible}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 16:
				var subMsg = msg.a;
				var _v2 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$ProfileEditor$ToastyMsg, subMsg, model);
				var newModel = _v2.a;
				var newCmd = _v2.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Registration$ToastyMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$Registration$Degree = 8;
var $author$project$Pages$Registration$Email = 0;
var $author$project$Pages$Registration$FirstName = 3;
var $author$project$Pages$Registration$LastName = 4;
var $author$project$Pages$Registration$Password = 1;
var $author$project$Pages$Registration$PasswordRepeat = 2;
var $author$project$Pages$Registration$Plagiarism = 9;
var $author$project$Pages$Registration$Semester = 6;
var $author$project$Pages$Registration$StudentNumber = 5;
var $author$project$Pages$Registration$Subject = 7;
var $author$project$Pages$Registration$isNegative = function (numberString) {
	var _v0 = $elm$core$String$toInt(numberString);
	if (!_v0.$) {
		var num = _v0.a;
		return num < 0;
	} else {
		return true;
	}
};
var $author$project$Pages$Registration$isZero = function (numberString) {
	var _v0 = $elm$core$String$toInt(numberString);
	if (!_v0.$) {
		var num = _v0.a;
		return !num;
	} else {
		return true;
	}
};
var $author$project$Pages$Registration$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.jM;
					},
					_Utils_Tuple2(0, 'Bitte gib deine E-Mail ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifInvalidEmail,
					function ($) {
						return $.jM;
					},
					function (value) {
						return _Utils_Tuple2(0, 'Die eingegebene E-Mail Addresse ' + (value + ' ist nicht gültig.'));
					})
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.lW;
					},
					_Utils_Tuple2(6, 'Bitte gib dein Semester ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifNotInt,
					function ($) {
						return $.lW;
					},
					function (value) {
						return _Utils_Tuple2(6, value + ' ist keine gültige Zahl.');
					}),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$Registration$isZero(model.lW);
					},
					_Utils_Tuple2(6, 'Auch als Informatiker beginnt das erste Semester mit 1 :).')),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$Registration$isNegative(model.lW);
					},
					_Utils_Tuple2(6, 'Es gibt keine negativen Semester.'))
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.lb;
					},
					_Utils_Tuple2(1, 'Bitte gib ein Passwort ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $elm$core$String$length(model.lb) < 7;
					},
					_Utils_Tuple2(1, 'Das Passwort muss mindestens 7 Zeichen lang sein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.dg;
					},
					_Utils_Tuple2(2, 'Bitte gib dein Passwort erneut ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifFalse,
					function (model) {
						return _Utils_eq(model.lb, model.dg);
					},
					_Utils_Tuple2(1, 'Die Passwörter müssen identisch sein.'))
				])),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.hi;
			},
			_Utils_Tuple2(3, 'Bitte gib deinen Vornamen ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.hD;
			},
			_Utils_Tuple2(4, 'Bitte gib deinen Nachnamen ein.')),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifBlank,
					function ($) {
						return $.oR;
					},
					_Utils_Tuple2(5, 'Bitte gib deine Martrikelnummer ein.')),
					A2(
					$rtfeldman$elm_validate$Validate$ifNotInt,
					function ($) {
						return $.oR;
					},
					function (value) {
						return _Utils_Tuple2(5, value + ' ist keine gültige Zahl.');
					}),
					A2(
					$rtfeldman$elm_validate$Validate$ifTrue,
					function (model) {
						return $author$project$Pages$Registration$isNegative(model.oR);
					},
					_Utils_Tuple2(5, 'Matrikelnummern sind positiv.'))
				])),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.cG;
			},
			_Utils_Tuple2(8, 'Bitte gib deinen angestrebten Abschluss ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.mb;
			},
			_Utils_Tuple2(7, 'Bitte gib dein Fach ein.')),
			A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function ($) {
				return $.c$;
			},
			_Utils_Tuple2(9, 'Bitte bestätigen sie die Plagiatsregeln'))
		]));
var $author$project$Pages$Registration$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{jM: value});
			case 1:
				return _Utils_update(
					model,
					{lb: value});
			case 2:
				return _Utils_update(
					model,
					{dg: value});
			case 3:
				return _Utils_update(
					model,
					{hi: value});
			case 4:
				return _Utils_update(
					model,
					{hD: value});
			case 5:
				return _Utils_update(
					model,
					{oR: value});
			case 6:
				return _Utils_update(
					model,
					{lW: value});
			case 7:
				return _Utils_update(
					model,
					{mb: value});
			case 8:
				return _Utils_update(
					model,
					{cG: value});
			default:
				return model;
		}
	});
var $author$project$Pages$Registration$RegistrationResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Data$UserAccount$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user',
				$author$project$Api$Data$User$encoder(model.mE)),
				_Utils_Tuple2(
				'account',
				$author$project$Api$Data$Account$encoder(model.iV))
			]));
};
var $author$project$Api$Request$Account$accountPost = F2(
	function (accountNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$account),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$UserAccount$encoder(accountNew)),
			msg,
			$author$project$Api$Data$User$decoder);
	});
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{m3: false, n1: false},
		string);
};
var $author$project$Utils$EmailHelper$isInvalid = function (email) {
	var emailPattern = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]*'));
	return !A2($elm$regex$Regex$contains, emailPattern, email);
};
var $author$project$Pages$Registration$modelToBody = F2(
	function (sharedState, model) {
		return {
			iV: {
				jM: $elm$core$Maybe$Just(model.jM),
				le: $elm$core$Maybe$Just(model.lb)
			},
			mE: {
				i3: $elm$core$Maybe$Nothing,
				jM: model.jM,
				j_: model.hi,
				ki: 0,
				kA: $author$project$Types$languageToBackendString(sharedState.lV),
				kB: model.hD,
				lK: $elm$core$Maybe$Nothing,
				lW: A2(
					$elm$core$Maybe$withDefault,
					1,
					$elm$core$String$toInt(model.lW)),
				oR: model.oR,
				mb: model.cG + (' ' + model.mb)
			}
		};
	});
var $author$project$Pages$Registration$updateHandleRegister = F4(
	function (sharedState, model, force, validationResult) {
		var _v0 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$Registration$modelValidator, model);
		if (_v0.$ === 1) {
			var errors = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{hf: errors}),
				$elm$core$Platform$Cmd$none,
				$author$project$SharedState$NoUpdate);
		} else {
			var _v1 = _Utils_Tuple2(
				$author$project$Utils$EmailHelper$isInvalid(model.jM),
				force);
			if (_v1.a && (!_v1.b)) {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ex: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			} else {
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{hf: _List_Nil, ch: $krisajenkins$remotedata$RemoteData$Loading}),
					A2(
						$author$project$Api$Request$Account$accountPost,
						A2($author$project$Pages$Registration$modelToBody, sharedState, model),
						$author$project$Pages$Registration$RegistrationResponse),
					$author$project$SharedState$NoUpdate);
			}
		}
	});
var $author$project$Pages$Registration$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$Registration$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$Registration$updateHandleRegistrationResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ch: response}),
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
					$author$project$SharedState$ShowToast(
						A2($author$project$Components$Toasty$Success, 'Success', 'Confirmation email has been sent')));
			case 2:
				if (response.a.$ === 4) {
					var error = response.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{ch: response}),
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							sharedState.f1,
							$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
						$author$project$SharedState$NoUpdate);
				} else {
					var err = response.a;
					var _v1 = A2(
						$author$project$Pages$Registration$addToast,
						A2($author$project$Components$Toasty$Error, 'Error', 'Failed to register'),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{ch: response}),
							$elm$core$Platform$Cmd$none));
					var newModel = _v1.a;
					var newCmd = _v1.b;
					return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ch: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Registration$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 2:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$Registration$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 1:
				var force = msg.a;
				return A4(
					$author$project$Pages$Registration$updateHandleRegister,
					sharedState,
					model,
					force,
					A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$Registration$modelValidator, model));
			case 4:
				var response = msg.a;
				return A3($author$project$Pages$Registration$updateHandleRegistrationResponse, sharedState, model, response);
			case 3:
				var subMsg = msg.a;
				var _v1 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$Registration$ToastyMsg, subMsg, model);
				var newModel = _v1.a;
				var newCmd = _v1.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 5:
				var state = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ex: state}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{c$: !model.c$}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$RequestPasswordReset$RequestResetResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$RequestPasswordReset$ToastyMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$RequestPasswordReset$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$RequestPasswordReset$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Pages$RequestPasswordReset$Email = 0;
var $author$project$Pages$RequestPasswordReset$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.jM;
			},
			_Utils_Tuple2(0, 'Bitte gib deine E-Mail ein.'))
		]));
var $author$project$Api$Endpoint$requestPasswordReset = A2(
	$author$project$Api$Endpoint$url,
	_List_fromArray(
		['auth', 'request_password_reset']),
	_List_Nil);
var $author$project$Api$Request$Auth$requestPasswordResetPost = F2(
	function (email, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap($author$project$Api$Endpoint$requestPasswordReset),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'email',
							$elm$json$Json$Encode$string(email))
						]))),
			msg);
	});
var $author$project$Pages$RequestPasswordReset$setField = F3(
	function (model, field, value) {
		return _Utils_update(
			model,
			{jM: value});
	});
var $author$project$Pages$RequestPasswordReset$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$RequestPasswordReset$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var _v1 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$RequestPasswordReset$modelValidator, model);
				if (_v1.$ === 1) {
					var errors = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: _List_Nil}),
						A2($author$project$Api$Request$Auth$requestPasswordResetPost, model.jM, $author$project$Pages$RequestPasswordReset$RequestResetResponse),
						$author$project$SharedState$NoUpdate);
				}
			case 3:
				switch (msg.a.$) {
					case 3:
						return _Utils_Tuple3(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								sharedState.f1,
								$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Success, 'Success', 'A mail with a password-reset-link was sent.')));
					case 2:
						var err = msg.a.a;
						var errorString = function () {
							if ((err.$ === 3) && (err.a === 422)) {
								return 'Your email is not confirmed!';
							} else {
								return 'There was a problem requesting your password reset.';
							}
						}();
						var _v2 = A2(
							$author$project$Pages$RequestPasswordReset$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v2.a;
						var newCmd = _v2.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					default:
						var response = msg.a;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			default:
				var subMsg = msg.a;
				var _v4 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$RequestPasswordReset$ToastyMsg, subMsg, model);
				var newModel = _v4.a;
				var newCmd = _v4.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetDetail$AdminTaskMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SheetDetail$GetPointOverview = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$SheetDetail$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Tasks$TutorView$NoOp = {$: 2};
var $author$project$Pages$SheetDetail$StudentTaskMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SheetDetail$TutorTaskMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Tasks$AdminView$UploadProgress = function (a) {
	return {$: 10, a: a};
};
var $author$project$Components$Tasks$StudentView$UploadProgress = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$SheetDetail$AdminTaskModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SheetDetail$StudentTaskModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SheetDetail$TaskMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$SheetDetail$TutorTaskModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$Tasks$StudentView$GetCurrentRatingResponse = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Tasks$StudentView$GetGradeResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Tasks$StudentView$TeamGetResponse = function (a) {
	return {$: 17, a: a};
};
var $author$project$Api$Data$TaskRatingResponse$TaskRatingResponse = F3(
	function (task_id, average_rating, own_rating) {
		return {i4: average_rating, k4: own_rating, ml: task_id};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Api$Data$TaskRatingResponse$decoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'own_rating',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'average_rating',
		$elm$json$Json$Decode$float,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'task_id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$Api$Data$TaskRatingResponse$TaskRatingResponse))));
var $author$project$Api$Endpoint$taskRating = F2(
	function (courseId, taskId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(taskId),
					'ratings'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskRatingGet = F3(
	function (courseId, taskId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskRating, courseId, taskId)),
			msg,
			$author$project$Api$Data$TaskRatingResponse$decoder);
	});
var $author$project$Api$Endpoint$taskResult = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(id),
					'result'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskResultGet = F3(
	function (courseId, id, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskResult, courseId, id)),
			msg,
			$author$project$Api$Data$Grade$decoder);
	});
var $author$project$Components$Tasks$StudentView$init = F2(
	function (courseId, task) {
		return _Utils_Tuple2(
			{dU: true, ju: courseId, aq: $krisajenkins$remotedata$RemoteData$Loading, bB: false, ki: task.ki, gd: $krisajenkins$remotedata$RemoteData$NotAsked, cg: 0, dm: $jinjor$elm_debounce$Debounce$init, bP: $elm$core$Maybe$Nothing, mk: task, e0: $krisajenkins$remotedata$RemoteData$Loading, gK: $elm$core$Maybe$Nothing, gL: 0, aV: $krisajenkins$remotedata$RemoteData$NotAsked},
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$Api$Request$Task$taskResultGet, courseId, task.ki, $author$project$Components$Tasks$StudentView$GetGradeResponse),
						A3($author$project$Api$Request$Task$taskRatingGet, courseId, task.ki, $author$project$Components$Tasks$StudentView$GetCurrentRatingResponse),
						A2($author$project$Api$Request$Team$teamGet, courseId, $author$project$Components$Tasks$StudentView$TeamGetResponse)
					])));
	});
var $author$project$Components$Tasks$TutorView$init = F3(
	function (courseId, task, ownGroups) {
		return _Utils_Tuple2(
			{ju: courseId, ki: task.ki, h2: ownGroups, mk: task},
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Components$Tasks$AdminView$initModel = _Utils_Tuple2(
	{dM: 0, dU: true, ju: 0, dW: false, hf: _List_Nil, ki: -1, kO: '0', kY: '', lj: '', eG: $elm$core$Maybe$Nothing, gh: false, ln: '', ls: '', eH: $elm$core$Maybe$Nothing, gj: false, lw: '', lZ: 0, iB: _List_Nil, gK: $elm$core$Maybe$Nothing, aV: $elm$core$Dict$empty},
	$elm$core$Platform$Cmd$none);
var $author$project$Components$Tasks$AdminView$initCreate = F2(
	function (courseId, sheetId) {
		var _v0 = $author$project$Components$Tasks$AdminView$initModel;
		var model = _v0.a;
		var cmds = _v0.b;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{ju: courseId, dW: true, lZ: sheetId}),
			cmds);
	});
var $author$project$Components$Tasks$AdminView$fillModelFromTask = F2(
	function (model, task) {
		return _Utils_update(
			model,
			{
				ki: task.ki,
				kO: $elm$core$String$fromInt(task.kO),
				kY: task.kY,
				lj: A2($elm$core$Maybe$withDefault, '', task.lj),
				ln: A2($elm$core$Maybe$withDefault, '', task.ln),
				ls: A2($elm$core$Maybe$withDefault, '', task.ls),
				lw: A2($elm$core$Maybe$withDefault, '', task.lw)
			});
	});
var $author$project$Components$Tasks$AdminView$initFromTask = F2(
	function (courseId, task) {
		var _v0 = $author$project$Components$Tasks$AdminView$initModel;
		var inital = _v0.a;
		var cmds = _v0.b;
		var model = _Utils_update(
			inital,
			{ju: courseId});
		return _Utils_Tuple2(
			A2($author$project$Components$Tasks$AdminView$fillModelFromTask, model, task),
			cmds);
	});
var $author$project$Pages$SheetDetail$fillModelTaskDict = function (model) {
	var _v0 = _Utils_Tuple2(model.lJ, model.gA);
	if ((!_v0.a.$) && (_v0.b.$ === 3)) {
		var role = _v0.a.a;
		var tasks = _v0.b.a;
		switch (role) {
			case 2:
				var taskIdModelCmdsList = A3(
					$author$project$Utils$Utils$flip,
					$elm$core$List$append,
					_List_fromArray(
						[
							_Utils_Tuple2(
							-1,
							A2($author$project$Components$Tasks$AdminView$initCreate, model.jv, model.ki))
						]),
					A2(
						$elm$core$List$map,
						function (task) {
							return _Utils_Tuple2(
								task.ki,
								A2($author$project$Components$Tasks$AdminView$initFromTask, model.jv, task));
						},
						tasks));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							e$: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (_v2) {
										var id = _v2.a;
										var _v3 = _v2.b;
										var taskModel = _v3.a;
										return _Utils_Tuple2(
											id,
											$author$project$Pages$SheetDetail$AdminTaskModel(taskModel));
									},
									taskIdModelCmdsList))
						}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (_v4) {
								var id = _v4.a;
								var _v5 = _v4.b;
								var cmd = _v5.b;
								return A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$SheetDetail$TaskMsg(id),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$AdminTaskMsg, cmd));
							},
							taskIdModelCmdsList)));
			case 0:
				var taskIdModelCmdsList = A2(
					$elm$core$List$map,
					function (task) {
						return _Utils_Tuple2(
							task.ki,
							A2($author$project$Components$Tasks$StudentView$init, model.jv, task));
					},
					tasks);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							e$: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									function (_v6) {
										var id = _v6.a;
										var _v7 = _v6.b;
										var taskModel = _v7.a;
										return _Utils_Tuple2(
											id,
											$author$project$Pages$SheetDetail$StudentTaskModel(taskModel));
									},
									taskIdModelCmdsList))
						}),
					$elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							function (_v8) {
								var id = _v8.a;
								var _v9 = _v8.b;
								var cmd = _v9.b;
								return A2(
									$elm$core$Platform$Cmd$map,
									$author$project$Pages$SheetDetail$TaskMsg(id),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$StudentTaskMsg, cmd));
							},
							taskIdModelCmdsList)));
			default:
				var _v10 = model.gc;
				if (_v10.$ === 3) {
					var groups = _v10.a;
					var taskIdModelCmdsList = A2(
						$elm$core$List$map,
						function (task) {
							return _Utils_Tuple2(
								task.ki,
								A3($author$project$Components$Tasks$TutorView$init, model.jv, task, groups));
						},
						tasks);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e$: $elm$core$Dict$fromList(
									A2(
										$elm$core$List$map,
										function (_v11) {
											var id = _v11.a;
											var _v12 = _v11.b;
											var taskModel = _v12.a;
											return _Utils_Tuple2(
												id,
												$author$project$Pages$SheetDetail$TutorTaskModel(taskModel));
										},
										taskIdModelCmdsList))
							}),
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (_v13) {
									var id = _v13.a;
									var _v14 = _v13.b;
									var cmd = _v14.b;
									return A2(
										$elm$core$Platform$Cmd$map,
										$author$project$Pages$SheetDetail$TaskMsg(id),
										A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$TutorTaskMsg, cmd));
								},
								taskIdModelCmdsList)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Api$Endpoint$sheetFile = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'sheets',
					$elm$core$String$fromInt(id),
					'file'
				]),
			_List_Nil);
	});
var $author$project$Api$Endpoint$sheetPoints = F2(
	function (courseId, sheetId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'sheets',
					$elm$core$String$fromInt(sheetId),
					'points'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Sheet$sheetPointsGet = F3(
	function (courseId, sheetId, msg) {
		return A3(
			$author$project$Api$Helper$get,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheetPoints, courseId, sheetId)),
			msg,
			$elm$json$Json$Decode$list($author$project$Api$Data$PointOverview$decoder));
	});
var $author$project$Components$Tasks$AdminView$GotFiles = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Tasks$AdminView$anythingUploading = function (model) {
	return A2(
		$elm$core$List$any,
		$krisajenkins$remotedata$RemoteData$isLoading,
		$elm$core$Dict$values(model.aV));
};
var $author$project$Components$Tasks$AdminView$TaskCreateRequest = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Tasks$AdminView$TaskUpdateRequest = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Tasks$AdminView$fillTaskFromModel = function (model) {
	return {
		ki: 0,
		kO: A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(model.kO)),
		kY: model.kY,
		lj: $elm$core$Maybe$Just(model.lj),
		ln: $elm$core$Maybe$Nothing,
		ls: $elm$core$Maybe$Just(model.ls),
		lw: $elm$core$Maybe$Nothing
	};
};
var $author$project$Api$Data$Task$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.kY)),
				_Utils_Tuple2(
				'max_points',
				$elm$json$Json$Encode$int(model.kO)),
				_Utils_Tuple2(
				'public_tests_url',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.lw)),
				_Utils_Tuple2(
				'public_docker_image',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.ls)),
				_Utils_Tuple2(
				'private_tests_url',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.ln)),
				_Utils_Tuple2(
				'private_docker_image',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.lj))
			]));
};
var $author$project$Api$Request$Sheet$sheetTasksPost = F4(
	function (courseId, id, taskNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheetTasks, courseId, id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Task$encoder(taskNew)),
			msg,
			$author$project$Api$Data$Task$decoder);
	});
var $author$project$Api$Request$Task$taskPut = F4(
	function (courseId, id, taskUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$task, courseId, id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Task$encoder(taskUpdate)),
			msg);
	});
var $author$project$Components$Tasks$AdminView$createOrUpdate = function (model) {
	return model.dW ? A4(
		$author$project$Api$Request$Sheet$sheetTasksPost,
		model.ju,
		model.lZ,
		$author$project$Components$Tasks$AdminView$fillTaskFromModel(model),
		$author$project$Components$Tasks$AdminView$TaskCreateRequest) : A4(
		$author$project$Api$Request$Task$taskPut,
		model.ju,
		model.ki,
		$author$project$Components$Tasks$AdminView$fillTaskFromModel(model),
		$author$project$Components$Tasks$AdminView$TaskUpdateRequest);
};
var $author$project$Components$Tasks$AdminView$fileTypeToInt = function (fileType) {
	if (!fileType) {
		return 1;
	} else {
		return 2;
	}
};
var $elm$http$Http$fractionSent = function (p) {
	return (!p.l_) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.oG / p.l_);
};
var $author$project$Components$Tasks$AdminView$Private = 1;
var $author$project$Components$Tasks$AdminView$Public = 0;
var $author$project$Components$Tasks$AdminView$intToFileType = function (fileTypeAsInt) {
	return (fileTypeAsInt === 1) ? 0 : 1;
};
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Components$Tasks$AdminView$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 1:
				return _Utils_update(
					model,
					{kY: value});
			case 0:
				return _Utils_update(
					model,
					{kO: value});
			case 2:
				return _Utils_update(
					model,
					{ls: value});
			default:
				return _Utils_update(
					model,
					{lj: value});
		}
	});
var $author$project$Components$Tasks$AdminView$updateFile = F3(
	function (fileType, val, model) {
		if (!fileType) {
			return _Utils_update(
				model,
				{eH: val});
		} else {
			return _Utils_update(
				model,
				{eG: val});
		}
	});
var $author$project$Components$Tasks$AdminView$updateHover = F3(
	function (fileType, val, model) {
		if (!fileType) {
			return _Utils_update(
				model,
				{gj: val});
		} else {
			return _Utils_update(
				model,
				{gh: val});
		}
	});
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Tasks$AdminView$uploadFailure = function (model) {
	return A2(
		$elm$core$List$any,
		function (state) {
			return $krisajenkins$remotedata$RemoteData$isFailure(state);
		},
		$elm$core$Dict$values(model.aV));
};
var $author$project$Components$Tasks$AdminView$FileUploadResponse = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Api$Endpoint$taskPrivateFiles = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(id),
					'private_file'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskPrivateFilesPost = F4(
	function (courseId, id, file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskPrivateFiles, courseId, id)),
			file,
			msg);
	});
var $author$project$Api$Endpoint$taskPublicFiles = F2(
	function (courseId, id) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(id),
					'public_file'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskPublicFilesPost = F4(
	function (courseId, id, file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskPublicFiles, courseId, id)),
			file,
			msg);
	});
var $author$project$Components$Tasks$AdminView$uploadFiles = function (model) {
	var _v0 = function () {
		var _v1 = _Utils_Tuple2(model.eH, model.eG);
		if (!_v1.a.$) {
			if (!_v1.b.$) {
				var _public = _v1.a.a;
				var _private = _v1.b.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[0, 1]),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A4(
								$author$project$Api$Request$Task$taskPublicFilesPost,
								model.ju,
								model.ki,
								_public,
								$author$project$Components$Tasks$AdminView$FileUploadResponse(0)),
								A4(
								$author$project$Api$Request$Task$taskPrivateFilesPost,
								model.ju,
								model.ki,
								_private,
								$author$project$Components$Tasks$AdminView$FileUploadResponse(1))
							])));
			} else {
				var _public = _v1.a.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[0]),
					A4(
						$author$project$Api$Request$Task$taskPublicFilesPost,
						model.ju,
						model.ki,
						_public,
						$author$project$Components$Tasks$AdminView$FileUploadResponse(0)));
			}
		} else {
			if (!_v1.b.$) {
				var _private = _v1.b.a;
				return _Utils_Tuple2(
					_List_fromArray(
						[1]),
					A4(
						$author$project$Api$Request$Task$taskPrivateFilesPost,
						model.ju,
						model.ki,
						_private,
						$author$project$Components$Tasks$AdminView$FileUploadResponse(1)));
			} else {
				return _Utils_Tuple2(_List_Nil, $elm$core$Platform$Cmd$none);
			}
		}
	}();
	var fileTypes = _v0.a;
	var cmds = _v0.b;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{
				iB: fileTypes,
				aV: $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (ftype) {
							return _Utils_Tuple2(
								$author$project$Components$Tasks$AdminView$fileTypeToInt(ftype),
								$krisajenkins$remotedata$RemoteData$Loading);
						},
						fileTypes))
			}),
		cmds,
		$author$project$SharedState$NoUpdate);
};
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Components$Tasks$AdminView$uploadSuccess = function (model) {
	return A2(
		$elm$core$List$all,
		function (state) {
			return $krisajenkins$remotedata$RemoteData$isSuccess(state);
		},
		$elm$core$Dict$values(model.aV));
};
var $author$project$Components$Tasks$AdminView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(
					model,
					$author$project$Components$Tasks$AdminView$createOrUpdate(model),
					$author$project$SharedState$NoUpdate);
			case 1:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Components$Tasks$AdminView$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var fileType = msg.a;
				var file = msg.b;
				var files = msg.c;
				return _Utils_Tuple3(
					A3(
						$author$project$Components$Tasks$AdminView$updateFile,
						fileType,
						$elm$core$Maybe$Just(file),
						A3($author$project$Components$Tasks$AdminView$updateHover, fileType, false, model)),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 3:
				var fileType = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['application/zip']),
						$author$project$Components$Tasks$AdminView$GotFiles(fileType)),
					$author$project$SharedState$NoUpdate);
			case 4:
				var fileType = msg.a;
				return _Utils_Tuple3(
					A3($author$project$Components$Tasks$AdminView$updateHover, fileType, true, model),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				var fileType = msg.a;
				return _Utils_Tuple3(
					A3($author$project$Components$Tasks$AdminView$updateHover, fileType, false, model),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 9:
				var fileType = msg.a;
				var response = msg.b;
				var newModel = _Utils_update(
					model,
					{
						aV: A3(
							$elm$core$Dict$update,
							$author$project$Components$Tasks$AdminView$fileTypeToInt(fileType),
							$elm$core$Maybe$map(
								function (_v1) {
									return response;
								}),
							model.aV)
					});
				var uploadDone = (!$author$project$Components$Tasks$AdminView$anythingUploading(newModel)) && ($author$project$Components$Tasks$AdminView$uploadSuccess(newModel) || $author$project$Components$Tasks$AdminView$uploadFailure(newModel));
				var finalModel = uploadDone ? _Utils_update(
					newModel,
					{gK: sharedState.jx}) : newModel;
				return _Utils_Tuple3(
					finalModel,
					uploadDone ? $elm$browser$Browser$Navigation$reload : $elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 10:
				var progress = msg.a;
				var percentage = function () {
					if (!progress.$) {
						var p = progress.a;
						return $elm$http$Http$fractionSent(p);
					} else {
						return 0.0;
					}
				}();
				var fileTypes = A2(
					$elm$core$List$map,
					function (_v3) {
						var ftype = _v3.a;
						return $author$project$Components$Tasks$AdminView$intToFileType(ftype);
					},
					A2(
						$elm$core$List$filter,
						function (_v2) {
							var state = _v2.b;
							return _Utils_eq(state, $krisajenkins$remotedata$RemoteData$Loading);
						},
						$elm$core$Dict$toList(model.aV)));
				var prog = ($elm$core$List$length(fileTypes) > 0) ? $elm$core$Basics$round(
					((model.dM + (100 * percentage)) / 2) / $elm$core$List$length(fileTypes)) : 0;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dM: prog}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				if (msg.a.$ === 3) {
					var task = msg.a.a;
					return _Utils_Tuple3(
						A2($author$project$Components$Tasks$AdminView$fillModelFromTask, model, task),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var response = msg.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 7:
				if (msg.a.$ === 3) {
					var task = msg.a.a;
					return $author$project$Components$Tasks$AdminView$uploadFiles(
						_Utils_update(
							model,
							{ki: task.ki}));
				} else {
					var response = msg.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 8:
				if (msg.a.$ === 3) {
					return $author$project$Components$Tasks$AdminView$uploadFiles(model);
				} else {
					var response = msg.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dU: !model.dU}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Tasks$StudentView$GotFiles = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Components$Tasks$StudentView$RateResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$Tasks$StudentView$SendRating = function (a) {
	return {$: 7, a: a};
};
var $author$project$Components$Tasks$StudentView$TeamConfirmed = function (a) {
	return {$: 18, a: a};
};
var $author$project$Components$Tasks$StudentView$UpdateGrade = {$: 5};
var $author$project$Components$Tasks$StudentView$UploadSubmissionResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$Tasks$StudentView$DebounceMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Components$Tasks$StudentView$debounceConfig = {
	oQ: $jinjor$elm_debounce$Debounce$later(2000),
	o7: $author$project$Components$Tasks$StudentView$DebounceMsg
};
var $author$project$Utils$Utils$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(time));
	});
var $elm$file$File$name = _File_name;
var $elm$file$File$size = _File_size;
var $author$project$Api$Request$Task$taskRatingPost = F4(
	function (courseId, taskId, rating, msg) {
		return A3(
			$author$project$Api$Helper$postExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskRating, courseId, taskId)),
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'rating',
							$elm$json$Json$Encode$int(rating))
						]))),
			msg);
	});
var $author$project$Api$Endpoint$taskSubmission = F2(
	function (courseId, taskId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(taskId),
					'submission'
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskSubmissionPost = F4(
	function (courseId, taskId, file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$taskSubmission, courseId, taskId)),
			file,
			msg);
	});
var $author$project$Components$Tasks$StudentView$updateHandleGradeResponse = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var grade = response.a;
				return (grade.lt === 2) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{aq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate) : _Utils_Tuple3(
					_Utils_update(
						model,
						{aq: response}),
					A2($author$project$Utils$Utils$delay, 5000, $author$project$Components$Tasks$StudentView$UpdateGrade),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{aq: response}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{aq: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Components$Tasks$StudentView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var _v1 = model.bP;
				if (!_v1.$) {
					var file = _v1.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{aV: $krisajenkins$remotedata$RemoteData$Loading}),
						A4($author$project$Api$Request$Task$taskSubmissionPost, model.ju, model.ki, file, $author$project$Components$Tasks$StudentView$UploadSubmissionResponse),
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 1:
				if (msg.a.$ === 3) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gK: sharedState.jx,
								aV: $krisajenkins$remotedata$RemoteData$Success(0)
							}),
						A2($author$project$Utils$Utils$delay, 1000, $author$project$Components$Tasks$StudentView$UpdateGrade),
						$author$project$SharedState$ShowToast(
							A2($author$project$Components$Toasty$Info, 'Info', 'Your files have been uploaded and will be validated.')));
				} else {
					var response = msg.a;
					var newUpdate = function () {
						switch (response.$) {
							case 3:
								return $author$project$SharedState$NoUpdate;
							case 2:
								switch (response.a.$) {
									case 3:
										var status = response.a.a;
										switch (status) {
											case 500:
												return $author$project$SharedState$ShowToast(
													A2($author$project$Components$Toasty$Error, 'Error', 'Server rejected file. Too large or no .zip file'));
											case 401:
												return $author$project$SharedState$ShowToast(
													A2($author$project$Components$Toasty$Error, 'Error', 'Your session run out'));
											default:
												return $author$project$SharedState$NoUpdate;
										}
									case 1:
										var _v4 = response.a;
										return $author$project$SharedState$ShowToast(
											A2($author$project$Components$Toasty$Error, 'Error', 'Your request timed out, make sure your internet connection is strong enough'));
									case 2:
										var _v5 = response.a;
										return $author$project$SharedState$ShowToast(
											A2($author$project$Components$Toasty$Error, 'Error', 'You lost your network connection'));
									default:
										return $author$project$SharedState$NoUpdate;
								}
							default:
								return $author$project$SharedState$NoUpdate;
						}
					}();
					var newModel = _Utils_update(
						model,
						{aV: response});
					var finalModel = ((!$krisajenkins$remotedata$RemoteData$isLoading(newModel.aV)) && ($krisajenkins$remotedata$RemoteData$isSuccess(newModel.aV) || $krisajenkins$remotedata$RemoteData$isFailure(newModel.aV))) ? _Utils_update(
						newModel,
						{gK: sharedState.jx}) : newModel;
					return _Utils_Tuple3(finalModel, $elm$core$Platform$Cmd$none, newUpdate);
				}
			case 2:
				var progress = msg.a;
				var percentage = function () {
					if (!progress.$) {
						var p = progress.a;
						return $elm$http$Http$fractionSent(p);
					} else {
						return 0.0;
					}
				}();
				var prog = _Utils_eq(model.aV, $krisajenkins$remotedata$RemoteData$Loading) ? $elm$core$Basics$round(100 * percentage) : $elm$core$Basics$round(0);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{gL: prog}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 3:
				if (msg.a.$ === 3) {
					var rating = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cg: rating.k4}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 4:
				var response = msg.a;
				return A3($author$project$Components$Tasks$StudentView$updateHandleGradeResponse, sharedState, model, response);
			case 5:
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Request$Task$taskResultGet, model.ju, model.ki, $author$project$Components$Tasks$StudentView$GetGradeResponse),
					$author$project$SharedState$NoUpdate);
			case 6:
				var rating = msg.b;
				var toInt = A2(
					$elm$core$Maybe$withDefault,
					0,
					$elm$core$String$toInt(rating));
				var _v7 = A3($jinjor$elm_debounce$Debounce$push, $author$project$Components$Tasks$StudentView$debounceConfig, toInt, model.dm);
				var debounce = _v7.a;
				var cmd = _v7.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{cg: toInt, dm: debounce}),
					cmd,
					$author$project$SharedState$NoUpdate);
			case 7:
				var rating = msg.a;
				return _Utils_Tuple3(
					model,
					A4($author$project$Api$Request$Task$taskRatingPost, model.ju, model.ki, rating, $author$project$Components$Tasks$StudentView$RateResponse),
					$author$project$SharedState$ShowToast(
						A2($author$project$Components$Toasty$Success, 'Success', 'Your rating has been changed')));
			case 8:
				var response = msg.a;
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 9:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dU: !model.dU}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 10:
				var file = msg.a;
				var files = msg.b;
				var _v8 = _Utils_Tuple2(
					$elm$file$File$size(file) < 7340032,
					A2(
						$elm$core$String$contains,
						'.zip',
						$elm$file$File$name(file)));
				if (_v8.a) {
					if (_v8.b) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bB: false,
									bP: $elm$core$Maybe$Just(file)
								}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bB: false, bP: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Error, 'Error', 'Only zip files are allowed for submissions')));
					}
				} else {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bB: false, bP: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$ShowToast(
							A2($author$project$Components$Toasty$Error, 'Error', 'Only files with a size of up to 7mb are allowed')));
				}
			case 11:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['application/zip']),
						$author$project$Components$Tasks$StudentView$GotFiles),
					$author$project$SharedState$NoUpdate);
			case 12:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 13:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 15:
				var subMsg = msg.a;
				var _v9 = A4(
					$jinjor$elm_debounce$Debounce$update,
					$author$project$Components$Tasks$StudentView$debounceConfig,
					$jinjor$elm_debounce$Debounce$takeLast(
						function (r) {
							return $author$project$Utils$Utils$perform(
								$author$project$Components$Tasks$StudentView$SendRating(r));
						}),
					subMsg,
					model.dm);
				var debounce = _v9.a;
				var cmd = _v9.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dm: debounce}),
					cmd,
					$author$project$SharedState$NoUpdate);
			case 16:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$SharedState$NoUpdate);
			case 17:
				var response = msg.a;
				switch (response.$) {
					case 3:
						var team = response.a;
						var _v11 = team.ki;
						if (_v11.$ === 1) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{gd: response}),
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$NoUpdate);
						} else {
							var id = _v11.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{gd: response, e0: $krisajenkins$remotedata$RemoteData$Loading}),
								A3($author$project$Api$Request$Team$teamConfirmedGet, model.ju, id, $author$project$Components$Tasks$StudentView$TeamConfirmed),
								$author$project$SharedState$NoUpdate);
						}
					case 2:
						var err = response.a;
						var errorMsg = function () {
							switch (err.$) {
								case 0:
									var url = err.a;
									return 'BadUrl: ' + url;
								case 1:
									return 'Timeout';
								case 2:
									return 'Networerror';
								case 3:
									var status = err.a;
									return 'BadStatus: ' + $elm$core$String$fromInt(status);
								default:
									var dbg = err.a;
									var _v13 = A2(
										$elm$json$Json$Decode$decodeString,
										A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string),
										dbg);
									if (!_v13.$) {
										var s = _v13.a;
										return s;
									} else {
										return 'BadBody';
									}
							}
						}();
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Error, 'Error', errorMsg)));
					default:
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$ShowToast(
								A2($author$project$Components$Toasty$Error, 'Error', 'TeamGet response failed somehow')));
				}
			case 18:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e0: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Api$Endpoint$groupSubmissionFile = F3(
	function (courseId, taskId, groupId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'tasks',
					$elm$core$String$fromInt(taskId),
					'groups',
					$elm$core$String$fromInt(groupId),
					'file'
				]),
			_List_Nil);
	});
var $author$project$Components$Tasks$TutorView$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var courseId = msg.a;
				var taskId = msg.b;
				var groupId = msg.c;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(
						$author$project$Api$Endpoint$unwrap(
							A3($author$project$Api$Endpoint$groupSubmissionFile, courseId, taskId, groupId))),
					$author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetDetail$getUpdateForTasks = F4(
	function (sharedState, model, id, taskMsg) {
		var _v0 = _Utils_Tuple2(
			taskMsg,
			A2($elm$core$Dict$get, id, model.e$));
		_v0$3:
		while (true) {
			if (!_v0.b.$) {
				switch (_v0.a.$) {
					case 0:
						if (!_v0.b.a.$) {
							var subMsg = _v0.a.a;
							var taskModel = _v0.b.a.a;
							var _v1 = A3($author$project$Components$Tasks$AdminView$update, sharedState, subMsg, taskModel);
							var newModel = _v1.a;
							var newCmd = _v1.b;
							var newSharedState = _v1.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$author$project$Pages$SheetDetail$AdminTaskModel(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$AdminTaskMsg, newCmd),
									newSharedState));
						} else {
							break _v0$3;
						}
					case 1:
						if (_v0.b.a.$ === 1) {
							var subMsg = _v0.a.a;
							var taskModel = _v0.b.a.a;
							var _v2 = A3($author$project$Components$Tasks$StudentView$update, sharedState, subMsg, taskModel);
							var newModel = _v2.a;
							var newCmd = _v2.b;
							var newSharedState = _v2.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$author$project$Pages$SheetDetail$StudentTaskModel(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$StudentTaskMsg, newCmd),
									newSharedState));
						} else {
							break _v0$3;
						}
					default:
						if (_v0.b.a.$ === 2) {
							var subMsg = _v0.a.a;
							var taskModel = _v0.b.a.a;
							var _v3 = A3($author$project$Components$Tasks$TutorView$update, sharedState, subMsg, taskModel);
							var newModel = _v3.a;
							var newCmd = _v3.b;
							var newSharedState = _v3.c;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									$author$project$Pages$SheetDetail$TutorTaskModel(newModel),
									A2($elm$core$Platform$Cmd$map, $author$project$Pages$SheetDetail$TutorTaskMsg, newCmd),
									newSharedState));
						} else {
							break _v0$3;
						}
				}
			} else {
				break _v0$3;
			}
		}
		return $elm$core$Maybe$Nothing;
	});
var $author$project$Pages$SheetDetail$updateTask = F5(
	function (sharedState, model, id, currentCmds, taskMsg) {
		var _v0 = A4($author$project$Pages$SheetDetail$getUpdateForTasks, sharedState, model, id, taskMsg);
		if (!_v0.$) {
			var _v1 = _v0.a;
			var newModel = _v1.a;
			var newCmd = _v1.b;
			var newSharedState = _v1.c;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						e$: A3(
							$elm$core$Dict$update,
							id,
							$elm$core$Maybe$map(
								function (_v2) {
									return newModel;
								}),
							model.e$)
					}),
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							currentCmds,
							A2(
							$elm$core$Platform$Cmd$map,
							$author$project$Pages$SheetDetail$TaskMsg(id),
							newCmd)
						])),
				newSharedState);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetDetail$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 2:
				var progress = msg.a;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (_v1, _v2) {
							var taskId = _v1.a;
							var modelType = _v1.b;
							var updatedModel = _v2.a;
							var cmd = _v2.b;
							return A5(
								$author$project$Pages$SheetDetail$updateTask,
								sharedState,
								updatedModel,
								taskId,
								cmd,
								function () {
									switch (modelType.$) {
										case 0:
											return $author$project$Pages$SheetDetail$AdminTaskMsg(
												$author$project$Components$Tasks$AdminView$UploadProgress(progress));
										case 1:
											return $author$project$Pages$SheetDetail$StudentTaskMsg(
												$author$project$Components$Tasks$StudentView$UploadProgress(progress));
										default:
											return $author$project$Pages$SheetDetail$TutorTaskMsg($author$project$Components$Tasks$TutorView$NoOp);
									}
								}());
						}),
					_Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate),
					$elm$core$Dict$toList(model.e$));
			case 3:
				var response = msg.a;
				var _v4 = $author$project$Pages$SheetDetail$fillModelTaskDict(
					_Utils_update(
						model,
						{gA: response}));
				var newModel = _v4.a;
				var cmds = _v4.b;
				return _Utils_Tuple3(newModel, cmds, $author$project$SharedState$NoUpdate);
			case 5:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eS: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 9:
				var courseId = msg.a;
				var sheetId = msg.b;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(
						$author$project$Api$Endpoint$unwrap(
							A2($author$project$Api$Endpoint$sheetFile, courseId, sheetId))),
					$author$project$SharedState$NoUpdate);
			case 7:
				if (msg.a.$ === 3) {
					var course = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								gn: $elm$core$Maybe$Just(course.lE)
							}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 6:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eE: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				if (msg.a.$ === 3) {
					var roles = msg.a.a;
					var maybeRole = $elm$core$List$head(
						A2(
							$elm$core$List$map,
							function (enrollment) {
								return enrollment.lJ;
							},
							A2(
								$elm$core$List$filter,
								function (enrollment) {
									return _Utils_eq(model.jv, enrollment.jv);
								},
								roles)));
					if (!maybeRole.$) {
						var role = maybeRole.a;
						var _v6 = $author$project$Pages$SheetDetail$fillModelTaskDict(
							_Utils_update(
								model,
								{lJ: maybeRole}));
						var newModel = _v6.a;
						var cmds = _v6.b;
						if (!role) {
							return _Utils_Tuple3(
								_Utils_update(
									newModel,
									{eE: $krisajenkins$remotedata$RemoteData$Loading}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											cmds,
											A3($author$project$Api$Request$Sheet$sheetPointsGet, model.jv, model.ki, $author$project$Pages$SheetDetail$GetPointOverview)
										])),
								$author$project$SharedState$NoUpdate);
						} else {
							return _Utils_Tuple3(newModel, cmds, $author$project$SharedState$NoUpdate);
						}
					} else {
						return _Utils_Tuple3(
							model,
							$author$project$Utils$Utils$perform(
								$author$project$Pages$SheetDetail$NavigateTo($author$project$Routing$Helpers$CoursesRoute)),
							$author$project$SharedState$NoUpdate);
					}
				} else {
					var response = msg.a;
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 1:
				var id = msg.a;
				var taskMsg = msg.b;
				return A5($author$project$Pages$SheetDetail$updateTask, sharedState, model, id, $elm$core$Platform$Cmd$none, taskMsg);
			default:
				var response = msg.a;
				var _v8 = $author$project$Pages$SheetDetail$fillModelTaskDict(
					_Utils_update(
						model,
						{gc: response}));
				var newModel = _v8.a;
				var cmds = _v8.b;
				return _Utils_Tuple3(newModel, cmds, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetEditor$DeleteResponse = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$SheetEditor$GotFiles = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Pages$SheetEditor$ToastyMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$SheetEditor$CreateResponse = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$SheetEditor$addToast = F2(
	function (toast, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		return A4(
			$pablen$toasty$Toasty$addToastIfUnique,
			$author$project$Components$Toasty$config,
			$author$project$Pages$SheetEditor$ToastyMsg,
			toast,
			_Utils_Tuple2(model, cmd));
	});
var $author$project$Api$Data$Sheet$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.kY)),
				_Utils_Tuple2(
				'publish_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.lx)),
				_Utils_Tuple2(
				'due_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.jJ))
			]));
};
var $author$project$Api$Request$Courses$courseSheetsPost = F3(
	function (id, sheetNew, msg) {
		return A4(
			$author$project$Api$Helper$post,
			$author$project$Api$Endpoint$unwrap(
				$author$project$Api$Endpoint$courseSheets(id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Sheet$encoder(sheetNew)),
			msg,
			$author$project$Api$Data$Sheet$decoder);
	});
var $author$project$Pages$SheetEditor$setupSheet = F3(
	function (name, publish, deadline) {
		return {jJ: deadline, ki: 0, kY: name, lx: publish};
	});
var $author$project$Pages$SheetEditor$createRequest = function (model) {
	var _v0 = _Utils_Tuple2(model.bM, model.Z);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var publish = _v0.a.a;
		var deadline = _v0.b.a;
		return _Utils_Tuple2(
			model,
			A3(
				$author$project$Api$Request$Courses$courseSheetsPost,
				model.jv,
				A3($author$project$Pages$SheetEditor$setupSheet, model.kY, publish, deadline),
				$author$project$Pages$SheetEditor$CreateResponse));
	} else {
		return A2(
			$author$project$Pages$SheetEditor$addToast,
			A2($author$project$Components$Toasty$Error, 'Error', 'There was an error with the data provided.'),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	}
};
var $author$project$Pages$SheetEditor$datePickerSettings = function (sharedState) {
	var curTime = A2(
		$elm$core$Maybe$withDefault,
		$elm$time$Time$millisToPosix(0),
		sharedState.jx);
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			nc: $author$project$Utils$DateFormatter$shortDayFormatter(sharedState),
			nO: _List_fromArray(
				[
					$author$project$Utils$Styles$lineInputStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3]))
				]),
			n0: $author$project$Utils$DateFormatter$monthFormatter(sharedState)
		});
};
var $author$project$Pages$SheetEditor$fillModelFromRequest = F3(
	function (sharedState, model, sheet) {
		var timezone = A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_);
		var _v0 = A2($author$project$Utils$DateAndTimeUtils$splitPosixInDateTimeAndOffset, timezone, sheet.lx);
		var publishedDate = _v0.a;
		var publishedTime = _v0.b;
		var _v1 = A2($author$project$Utils$DateAndTimeUtils$splitPosixInDateTimeAndOffset, timezone, sheet.jJ);
		var deadlineDate = _v1.a;
		var deadlineTime = _v1.b;
		var offset = _v1.c;
		var utcOffsetPos = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
			$author$project$Utils$DateAndTimeUtils$findIndexFromParts(offset));
		return _Utils_update(
			model,
			{
				a_: $elm$core$Maybe$Just(deadlineDate),
				bt: $elm$core$Maybe$Just(deadlineTime),
				Z: $elm$core$Maybe$Just(sheet.jJ),
				cF: $stephenreddek$elm_time_picker$TimePicker$init(
					$elm$core$Maybe$Just(deadlineTime)),
				ki: sheet.ki,
				kY: sheet.kY,
				bb: $elm$core$Maybe$Just(publishedDate),
				bL: $elm$core$Maybe$Just(publishedTime),
				bM: $elm$core$Maybe$Just(sheet.lx),
				dk: $stephenreddek$elm_time_picker$TimePicker$init(
					$elm$core$Maybe$Just(publishedTime)),
				aB: utcOffsetPos
			});
	});
var $author$project$Pages$SheetEditor$DeadlineDate = 4;
var $author$project$Pages$SheetEditor$DeadlineTime = 3;
var $author$project$Pages$SheetEditor$Name = 0;
var $author$project$Pages$SheetEditor$PublishedDate = 2;
var $author$project$Pages$SheetEditor$PublishedTime = 1;
var $author$project$Pages$SheetEditor$isFirstDateOlder = F2(
	function (maybeFirstPosix, maybeSecondPosix) {
		var _v0 = _Utils_Tuple2(maybeFirstPosix, maybeSecondPosix);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var firstPosix = _v0.a.a;
			var secondPosix = _v0.b.a;
			return _Utils_cmp(
				$elm$time$Time$posixToMillis(firstPosix),
				$elm$time$Time$posixToMillis(secondPosix)) < 0;
		} else {
			return true;
		}
	});
var $author$project$Pages$SheetEditor$ifFirstPosixNotOlder = F3(
	function (subjectToMaybePosix1, subjectToMaybePosix2, error) {
		return A2(
			$rtfeldman$elm_validate$Validate$ifFalse,
			function (subject) {
				return A2(
					$author$project$Pages$SheetEditor$isFirstDateOlder,
					subjectToMaybePosix1(subject),
					subjectToMaybePosix2(subject));
			},
			error);
	});
var $author$project$Pages$SheetEditor$modelValidator = $rtfeldman$elm_validate$Validate$all(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_validate$Validate$ifBlank,
			function ($) {
				return $.kY;
			},
			_Utils_Tuple2(0, 'Bitte gib einen Blattnamen ein.')),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.bL;
					},
					_Utils_Tuple2(1, 'Bitte gib eine Startzeit ein.')),
					A3(
					$author$project$Pages$SheetEditor$ifFirstPosixNotOlder,
					function ($) {
						return $.bM;
					},
					function ($) {
						return $.Z;
					},
					_Utils_Tuple2(1, 'Die Startzeit muss vor der Endzeit liegen.'))
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.bb;
					},
					_Utils_Tuple2(2, 'Bitte gib ein Startdatum ein.')),
					A3(
					$author$project$Pages$SheetEditor$ifFirstPosixNotOlder,
					function ($) {
						return $.bM;
					},
					function ($) {
						return $.Z;
					},
					_Utils_Tuple2(2, 'Die Startzeit muss vor der Endzeit liegen.'))
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.bt;
					},
					_Utils_Tuple2(3, 'Bitte gib eine Endzeit ein.')),
					A3(
					$author$project$Pages$SheetEditor$ifFirstPosixNotOlder,
					function ($) {
						return $.bM;
					},
					function ($) {
						return $.Z;
					},
					_Utils_Tuple2(3, 'Die Startzeit muss vor der Endzeit liegen.'))
				])),
			$rtfeldman$elm_validate$Validate$firstError(
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_validate$Validate$ifNothing,
					function ($) {
						return $.a_;
					},
					_Utils_Tuple2(4, 'Bitte gib ein Enddatum ein.')),
					A3(
					$author$project$Pages$SheetEditor$ifFirstPosixNotOlder,
					function ($) {
						return $.bM;
					},
					function ($) {
						return $.Z;
					},
					_Utils_Tuple2(4, 'Die Startzeit muss vor der Endzeit liegen.'))
				]))
		]));
var $author$project$Pages$SheetEditor$joinTime = F3(
	function (date, time, utcOffsetPos) {
		var offsetPartsArray = $elm$core$Array$fromList($author$project$Utils$DateAndTimeUtils$utcOffsetsPartsList);
		var offset = A2(
			$elm$core$Maybe$withDefault,
			{ho: 0, hS: 0, hU: 1},
			A2($elm$core$Array$get, utcOffsetPos, offsetPartsArray));
		return A3($author$project$Utils$DateAndTimeUtils$joinDateTimeAndOffset, date, time, offset);
	});
var $author$project$Pages$SheetEditor$testIfTimeIsReady = F3(
	function (maybeDate, maybeTime, offset) {
		var _v0 = _Utils_Tuple2(maybeDate, maybeTime);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var date = _v0.a.a;
			var time = _v0.b.a;
			return $elm$core$Maybe$Just(
				A3($author$project$Pages$SheetEditor$joinTime, date, time, offset));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Pages$SheetEditor$setField = F3(
	function (model, field, value) {
		switch (field) {
			case 0:
				return _Utils_update(
					model,
					{kY: value});
			case 5:
				var newPos = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
					$elm$core$String$toInt(value));
				return _Utils_update(
					model,
					{
						Z: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, model.a_, model.bt, newPos),
						bM: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, model.bb, model.bL, newPos),
						aB: newPos
					});
			default:
				return model;
		}
	});
var $author$project$Api$Request$Sheet$sheetDelete = F3(
	function (courseId, id, msg) {
		return A2(
			$author$project$Api$Helper$deleteExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheet, courseId, id)),
			msg);
	});
var $author$project$Pages$SheetEditor$timePickerSettings = function () {
	var defaultSettings = $stephenreddek$elm_time_picker$TimePicker$defaultSettings;
	return _Utils_update(
		defaultSettings,
		{n_: 15, oK: false, pf: true});
}();
var $author$project$Pages$SheetEditor$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SheetEditor$updateHandleDelete = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Utils$Utils$perform(
						$author$project$Pages$SheetEditor$NavigateTo(
							$author$project$Routing$Helpers$CourseDetailRoute(model.jv))),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v1 = A2(
							$author$project$Pages$SheetEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Failed to delete'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetEditor$updateHandleFileUpload = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(
							A2($author$project$Routing$Helpers$SheetDetailRoute, model.jv, model.ki))),
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var errorString = function () {
							_v2$3:
							while (true) {
								switch (e.$) {
									case 3:
										switch (e.a) {
											case 400:
												return 'Bad Data. Something is off in the data.';
											case 403:
												return 'You are not allowed to do this!';
											default:
												break _v2$3;
										}
									case 4:
										var message = e.a;
										return 'Bad return: ' + message;
									default:
										break _v2$3;
								}
							}
							return 'Something other went wrong';
						}();
						var _v1 = A2(
							$author$project$Pages$SheetEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetEditor$updateHandleGetSheet = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var sheet = response.a;
				var newModel = A3($author$project$Pages$SheetEditor$fillModelFromRequest, sharedState, model, sheet);
				return _Utils_Tuple3(
					_Utils_update(
						newModel,
						{dr: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var _v1 = A2(
							$author$project$Pages$SheetEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', 'Error receiving sheet data'),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{dr: response}),
							newCmd,
							$author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{dr: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetEditor$FileUploadResponse = function (a) {
	return {$: 19, a: a};
};
var $author$project$Api$Request$Sheet$sheetFilePost = F4(
	function (courseId, id, file, msg) {
		return A3(
			$author$project$Api$Helper$postFile,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheetFile, courseId, id)),
			file,
			msg);
	});
var $author$project$Pages$SheetEditor$updateHandleSend = F3(
	function (sharedState, model, response) {
		switch (response.$) {
			case 3:
				var _v1 = _Utils_Tuple2(model.fx, model.d6);
				if (_v1.a) {
					if (!_v1.b.$) {
						var file = _v1.b.a;
						return _Utils_Tuple3(
							model,
							A4($author$project$Api$Request$Sheet$sheetFilePost, model.jv, model.ki, file, $author$project$Pages$SheetEditor$FileUploadResponse),
							$author$project$SharedState$NoUpdate);
					} else {
						var _v2 = _v1.b;
						return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					}
				} else {
					return _Utils_Tuple3(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							sharedState.f1,
							$author$project$Routing$Helpers$reverseRoute(
								A2($author$project$Routing$Helpers$SheetDetailRoute, model.jv, model.ki))),
						$author$project$SharedState$NoUpdate);
				}
			case 2:
				var err = response.a;
				return A4(
					$author$project$Utils$Utils$handleLogoutErrors,
					model,
					sharedState,
					function (e) {
						var errorString = function () {
							_v4$3:
							while (true) {
								switch (e.$) {
									case 3:
										switch (e.a) {
											case 400:
												return 'Bad Data. Something is off in the data.';
											case 403:
												return 'You are not allowed to do this!';
											default:
												break _v4$3;
										}
									case 4:
										var message = e.a;
										return 'Bad return: ' + message;
									default:
										break _v4$3;
								}
							}
							return 'Something other went wrong';
						}();
						var _v3 = A2(
							$author$project$Pages$SheetEditor$addToast,
							A2($author$project$Components$Toasty$Error, 'Error', errorString),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
						var newModel = _v3.a;
						var newCmd = _v3.b;
						return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
					},
					err);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SheetEditor$UpdateResponse = function (a) {
	return {$: 10, a: a};
};
var $author$project$Api$Request$Sheet$sheetPut = F4(
	function (courseId, id, sheetUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$sheet, courseId, id)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Sheet$encoder(sheetUpdate)),
			msg);
	});
var $author$project$Pages$SheetEditor$updateRequest = function (model) {
	var _v0 = _Utils_Tuple2(model.bM, model.Z);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var publish = _v0.a.a;
		var deadline = _v0.b.a;
		return _Utils_Tuple2(
			model,
			A4(
				$author$project$Api$Request$Sheet$sheetPut,
				model.jv,
				model.ki,
				A3($author$project$Pages$SheetEditor$setupSheet, model.kY, publish, deadline),
				$author$project$Pages$SheetEditor$UpdateResponse));
	} else {
		return A2(
			$author$project$Pages$SheetEditor$addToast,
			A2($author$project$Components$Toasty$Error, 'Error', 'There was an error with the data provided.'),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	}
};
var $author$project$Pages$SheetEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var subMsg = msg.a;
				var _v1 = A3($stephenreddek$elm_time_picker$TimePicker$update, $author$project$Pages$SheetEditor$timePickerSettings, subMsg, model.dk);
				var updatedPicker = _v1.a;
				var timeEvent = _v1.b;
				var newTime = function () {
					if (!timeEvent.$) {
						return model.bL;
					} else {
						var time = timeEvent.a;
						return time;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bL: newTime,
							bM: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, model.bb, newTime, model.aB),
							dk: updatedPicker
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var subMsg = msg.a;
				var _v3 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$SheetEditor$datePickerSettings(sharedState),
					subMsg,
					model.eI);
				var newDatePicker = _v3.a;
				var event = _v3.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.bb;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bb: newDate,
							eI: newDatePicker,
							bM: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, newDate, model.bL, model.aB)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 3:
				var subMsg = msg.a;
				var _v5 = A3($stephenreddek$elm_time_picker$TimePicker$update, $author$project$Pages$SheetEditor$timePickerSettings, subMsg, model.cF);
				var updatedPicker = _v5.a;
				var timeEvent = _v5.b;
				var newTime = function () {
					if (!timeEvent.$) {
						return model.bt;
					} else {
						var time = timeEvent.a;
						return time;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							bt: newTime,
							Z: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, model.a_, newTime, model.aB),
							cF: updatedPicker
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				var subMsg = msg.a;
				var _v7 = A3(
					$CurrySoftware$elm_datepicker$DatePicker$update,
					$author$project$Pages$SheetEditor$datePickerSettings(sharedState),
					subMsg,
					model.dX);
				var newDatePicker = _v7.a;
				var event = _v7.b;
				var newDate = function () {
					if (event.$ === 2) {
						var date = event.a;
						return $elm$core$Maybe$Just(date);
					} else {
						return model.a_;
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							a_: newDate,
							dX: newDatePicker,
							Z: A3($author$project$Pages$SheetEditor$testIfTimeIsReady, newDate, model.bt, model.aB)
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							aB: A2(
								$elm$core$Maybe$withDefault,
								$author$project$Utils$DateAndTimeUtils$utcZeroOffsetIndex,
								$author$project$Utils$DateAndTimeUtils$timeZoneToIndex(
									A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_)))
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				var response = msg.a;
				return A3($author$project$Pages$SheetEditor$updateHandleGetSheet, sharedState, model, response);
			case 7:
				var _v9 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$SheetEditor$modelValidator, model);
				if (_v9.$ === 1) {
					var errors = _v9.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var _v10 = $author$project$Pages$SheetEditor$createRequest(model);
					var newModel = _v10.a;
					var newCmd = _v10.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{hf: _List_Nil}),
						newCmd,
						$author$project$SharedState$NoUpdate);
				}
			case 8:
				var response = msg.a;
				var newModel = function () {
					if (response.$ === 3) {
						var sheet = response.a;
						return A3($author$project$Pages$SheetEditor$fillModelFromRequest, sharedState, model, sheet);
					} else {
						return model;
					}
				}();
				return A3($author$project$Pages$SheetEditor$updateHandleSend, sharedState, newModel, response);
			case 9:
				var _v12 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Pages$SheetEditor$modelValidator, model);
				if (_v12.$ === 1) {
					var errors = _v12.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{hf: errors}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				} else {
					var _v13 = $author$project$Pages$SheetEditor$updateRequest(model);
					var newModel = _v13.a;
					var newCmd = _v13.b;
					return _Utils_Tuple3(
						_Utils_update(
							newModel,
							{hf: _List_Nil}),
						newCmd,
						$author$project$SharedState$NoUpdate);
				}
			case 10:
				var response = msg.a;
				return A3($author$project$Pages$SheetEditor$updateHandleSend, sharedState, model, response);
			case 11:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d$: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 12:
				return _Utils_Tuple3(
					model,
					A3($author$project$Api$Request$Sheet$sheetDelete, model.jv, model.ki, $author$project$Pages$SheetEditor$DeleteResponse),
					$author$project$SharedState$NoUpdate);
			case 13:
				var response = msg.a;
				return A3($author$project$Pages$SheetEditor$updateHandleDelete, sharedState, model, response);
			case 14:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$SheetEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 16:
				return _Utils_Tuple3(
					model,
					A2(
						$elm$file$File$Select$files,
						_List_fromArray(
							['application/zip']),
						$author$project$Pages$SheetEditor$GotFiles),
					$author$project$SharedState$NoUpdate);
			case 17:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: true}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 18:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bB: false}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 15:
				var file = msg.a;
				var files = msg.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d6: $elm$core$Maybe$Just(file),
							fx: true,
							bB: false
						}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 19:
				var response = msg.a;
				return A3($author$project$Pages$SheetEditor$updateHandleFileUpload, sharedState, model, response);
			case 20:
				var subMsg = msg.a;
				var _v14 = A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Pages$SheetEditor$ToastyMsg, subMsg, model);
				var newModel = _v14.a;
				var newCmd = _v14.b;
				return _Utils_Tuple3(newModel, newCmd, $author$project$SharedState$NoUpdate);
			case 21:
				var visible = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d$: visible}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			default:
				return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$SubmissionGradingEditor$GetSendGradeResponse = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$SubmissionGradingEditor$fillGradeDict = function (model) {
	var _v0 = model.fF;
	if (_v0.$ === 3) {
		var grades = _v0.a;
		return function (_v1) {
			var fd = _v1.a;
			var gd = _v1.b;
			return _Utils_update(
				model,
				{bw: fd, b6: gd});
		}(
			A2(
				$elm$core$Tuple$pair,
				$elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (g) {
							return _Utils_Tuple2(g.ki, g.jX);
						},
						grades)),
				$elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (g) {
							return _Utils_Tuple2(g.ki, g);
						},
						A2(
							$elm$core$List$filter,
							function (g) {
								return !A2($elm$core$String$contains, 'Fehlerhafte Abgabe!', g.lu);
							},
							grades)))));
	} else {
		return model;
	}
};
var $author$project$Pages$SubmissionGradingEditor$setField = F3(
	function (model, field, value) {
		if (!field.$) {
			var id = field.a;
			return _Utils_update(
				model,
				{
					bw: A3(
						$elm$core$Dict$update,
						id,
						$elm$core$Maybe$map(
							function (_v1) {
								return value;
							}),
						model.bw)
				});
		} else {
			var id = field.a;
			return _Utils_update(
				model,
				{
					b6: A3(
						$elm$core$Dict$update,
						id,
						function (maybeGrade) {
							if (!maybeGrade.$) {
								var grade = maybeGrade.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										grade,
										{
											iX: A2(
												$elm$core$Maybe$withDefault,
												0,
												$elm$core$String$toInt(value))
										}));
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						model.b6)
				});
		}
	});
var $author$project$Api$Data$Grade$executionStateEncoder = function (executionState) {
	switch (executionState) {
		case 0:
			return $elm$json$Json$Encode$int(0);
		case 1:
			return $elm$json$Json$Encode$int(1);
		default:
			return $elm$json$Json$Encode$int(2);
	}
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Data$Grade$testStatusEncoder = function (testStatus) {
	if (!testStatus) {
		return $elm$json$Json$Encode$int(0);
	} else {
		return $elm$json$Json$Encode$int(1);
	}
};
var $author$project$Api$Data$Grade$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(model.ki)),
				_Utils_Tuple2(
				'updated_at',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(model.mD)),
				_Utils_Tuple2(
				'public_execution_state',
				$author$project$Api$Data$Grade$executionStateEncoder(model.lt)),
				_Utils_Tuple2(
				'private_execution_state',
				$author$project$Api$Data$Grade$executionStateEncoder(model.lk)),
				_Utils_Tuple2(
				'public_test_log',
				$elm$json$Json$Encode$string(model.lu)),
				_Utils_Tuple2(
				'private_test_log',
				$elm$json$Json$Encode$string(model.ll)),
				_Utils_Tuple2(
				'public_test_status',
				$author$project$Api$Data$Grade$testStatusEncoder(model.lv)),
				_Utils_Tuple2(
				'private_test_status',
				$author$project$Api$Data$Grade$testStatusEncoder(model.lm)),
				_Utils_Tuple2(
				'acquired_points',
				$elm$json$Json$Encode$int(model.iX)),
				_Utils_Tuple2(
				'feedback',
				$elm$json$Json$Encode$string(model.jX)),
				_Utils_Tuple2(
				'tutor_id',
				$elm$json$Json$Encode$int(model.mC)),
				_Utils_Tuple2(
				'submission_id',
				$elm$json$Json$Encode$int(model.mc)),
				_Utils_Tuple2(
				'users',
				A2($elm$json$Json$Encode$list, $author$project$Api$Data$User$encoder, model.mH)),
				_Utils_Tuple2(
				'file_url',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.jZ)),
				_Utils_Tuple2(
				'plagiat',
				$elm$json$Json$Encode$bool(model.ld))
			]));
};
var $author$project$Api$Endpoint$grade = F2(
	function (courseId, gradeId) {
		return A2(
			$author$project$Api$Endpoint$url,
			_List_fromArray(
				[
					'courses',
					$elm$core$String$fromInt(courseId),
					'grades',
					$elm$core$String$fromInt(gradeId)
				]),
			_List_Nil);
	});
var $author$project$Api$Request$Task$taskGradePut = F4(
	function (courseId, gradeId, gradeUpdate, msg) {
		return A3(
			$author$project$Api$Helper$putExpectNothing,
			$author$project$Api$Endpoint$unwrap(
				A2($author$project$Api$Endpoint$grade, courseId, gradeId)),
			$elm$http$Http$jsonBody(
				$author$project$Api$Data$Grade$encoder(gradeUpdate)),
			msg);
	});
var $author$project$Pages$SubmissionGradingEditor$update = F3(
	function (sharedState, msg, model) {
		switch (msg.$) {
			case 0:
				var route = msg.a;
				return _Utils_Tuple3(
					model,
					A2(
						$elm$browser$Browser$Navigation$pushUrl,
						sharedState.f1,
						$author$project$Routing$Helpers$reverseRoute(route)),
					$author$project$SharedState$NoUpdate);
			case 1:
				var response = msg.a;
				return _Utils_Tuple3(
					$author$project$Pages$SubmissionGradingEditor$fillGradeDict(
						_Utils_update(
							model,
							{fF: response})),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 2:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fG: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 3:
				var response = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fH: response}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 4:
				var gradeId = msg.a;
				var response = msg.b;
				var timeUpdate = _Utils_update(
					model,
					{
						ed: A3(
							$elm$core$Dict$insert,
							gradeId,
							A2(
								$elm$core$Maybe$withDefault,
								$elm$time$Time$millisToPosix(0),
								sharedState.jx),
							model.ed)
					});
				var timeModel = function () {
					switch (response.$) {
						case 3:
							return timeUpdate;
						case 2:
							return timeUpdate;
						default:
							return model;
					}
				}();
				var responseModel = _Utils_update(
					timeModel,
					{
						ec: A3($elm$core$Dict$insert, gradeId, response, model.ec)
					});
				return _Utils_Tuple3(responseModel, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
			case 5:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ee: !model.ee}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 6:
				var field = msg.a;
				var value = msg.b;
				return _Utils_Tuple3(
					A3($author$project$Pages$SubmissionGradingEditor$setField, model, field, value),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
			case 7:
				var gradeId = msg.a;
				var _v2 = _Utils_Tuple2(
					A2($elm$core$Dict$get, gradeId, model.b6),
					A2($elm$core$Dict$get, gradeId, model.bw));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var grade = _v2.a.a;
					var feedback = _v2.b.a;
					return _Utils_Tuple3(
						model,
						A4(
							$author$project$Api$Request$Task$taskGradePut,
							model.ju,
							gradeId,
							_Utils_update(
								grade,
								{jX: feedback}),
							$author$project$Pages$SubmissionGradingEditor$GetSendGradeResponse(gradeId)),
						$author$project$SharedState$NoUpdate);
				} else {
					return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
				}
			case 8:
				var url = msg.a;
				return _Utils_Tuple3(
					model,
					$elm$file$File$Download$url(url),
					$author$project$SharedState$NoUpdate);
			default:
				var subMsg = msg.a;
				var spinnerModel = A2($damienklinnert$elm_spinner$Spinner$update, subMsg, model.eW);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eW: spinnerModel}),
					$elm$core$Platform$Cmd$none,
					$author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Pages$Terms$update = F3(
	function (sharedState, msg, model) {
		var response = msg;
		if (response.$ === 3) {
			var terms = response.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{oY: terms.oY}),
				$elm$core$Platform$Cmd$none,
				$author$project$SharedState$NoUpdate);
		} else {
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$Api$Data$Role$encoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'root',
				$elm$json$Json$Encode$bool(model.lK))
			]));
};
var $author$project$Utils$PersistantState$stateEncoder = F2(
	function (role, mail) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(mail)),
					_Utils_Tuple2(
					'role',
					$author$project$Api$Data$Role$encoder(role))
				]));
	});
var $author$project$Utils$PersistantState$sharedStateUpdateToStorage = function (sharedStateUpdate) {
	if (sharedStateUpdate.$ === 4) {
		var role = sharedStateUpdate.a;
		var mail = sharedStateUpdate.b;
		return $author$project$Utils$PersistantState$storeCache(
			$elm$core$Maybe$Just(
				A2($author$project$Utils$PersistantState$stateEncoder, role, mail)));
	} else {
		return $elm$core$Platform$Cmd$none;
	}
};
var $author$project$Routing$Router$updateWith = F4(
	function (toModel, toMsg, model, _v0) {
		var subModel = _v0.a;
		var subCmd = _v0.b;
		var subSharedStateUpdate = _v0.c;
		var _v1 = function () {
			switch (subSharedStateUpdate.$) {
				case 5:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cb: true}),
						$elm$core$Platform$Cmd$none,
						$author$project$SharedState$NoUpdate);
				case 6:
					var toast = subSharedStateUpdate.a;
					return A3(
						$author$project$Utils$Utils$flip,
						$author$project$Utils$Utils$tupleExtend,
						$author$project$SharedState$NoUpdate,
						A4(
							$pablen$toasty$Toasty$addToastIfUnique,
							$author$project$Components$Toasty$config,
							$author$project$Routing$Router$ToastyMsg,
							toast,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
				default:
					return _Utils_Tuple3(
						model,
						$author$project$Utils$PersistantState$sharedStateUpdateToStorage(subSharedStateUpdate),
						subSharedStateUpdate);
			}
		}();
		var newModel = _v1.a;
		var newCmd = _v1.b;
		var newSharedState = _v1.c;
		return _Utils_Tuple3(
			_Utils_update(
				newModel,
				{
					b0: toModel(subModel)
				}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						newCmd,
						A2($elm$core$Platform$Cmd$map, toMsg, subCmd)
					])),
			newSharedState);
	});
var $author$project$Routing$Router$update = F3(
	function (sharedState, msg, model) {
		update:
		while (true) {
			var _v0 = _Utils_Tuple2(msg, model.b0);
			_v0$35:
			while (true) {
				switch (_v0.a.$) {
					case 0:
						var location = _v0.a.a;
						var route = $author$project$Routing$Helpers$parseUrl(location);
						var _v1 = A3($author$project$Routing$Router$navigateTo, route, sharedState, model);
						var newModel = _v1.a;
						var newCmd = _v1.b;
						var newSharedStateUpdate = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								newModel,
								{eM: route}),
							newCmd,
							newSharedStateUpdate);
					case 1:
						var route = _v0.a.a;
						return _Utils_Tuple3(
							model,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								sharedState.f1,
								$author$project$Routing$Helpers$reverseRoute(route)),
							$author$project$SharedState$NoUpdate);
					case 2:
						var subMsg = _v0.a.a;
						return A3(
							$author$project$Utils$Utils$flip,
							$author$project$Utils$Utils$tupleExtend,
							$author$project$SharedState$NoUpdate,
							A4($pablen$toasty$Toasty$update, $author$project$Components$Toasty$config, $author$project$Routing$Router$ToastyMsg, subMsg, model));
					case 3:
						var lang = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{lV: lang}),
							$author$project$Routing$Router$getTranslations(lang),
							$author$project$SharedState$NoUpdate);
					case 11:
						var webData = _v0.a.a;
						if (webData.$ === 3) {
							var translations = webData.a;
							return _Utils_Tuple3(
								model,
								$elm$core$Platform$Cmd$none,
								A2($author$project$SharedState$UpdateLanguage, model.lV, translations));
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
						}
					case 6:
						var state = _v0.a.a;
						return _Utils_Tuple3(
							model,
							$elm$core$Platform$Cmd$none,
							$author$project$Utils$PersistantState$stateMsgToSharedStateUpdate(state));
					case 9:
						var _v3 = _v0.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cb: false}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Api$Request$Auth$sessionDelete($author$project$Routing$Router$LogoutCompleted),
										$author$project$Utils$PersistantState$logout
									])),
							$author$project$SharedState$NoUpdate);
					case 10:
						if (_v0.a.a.$ === 3) {
							return _Utils_Tuple3(
								model,
								A2(
									$elm$browser$Browser$Navigation$pushUrl,
									sharedState.f1,
									$author$project$Routing$Helpers$reverseRoute($author$project$Routing$Helpers$LoginRoute)),
								$author$project$SharedState$NoUpdate);
						} else {
							return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
						}
					case 14:
						if (!_v0.b.$) {
							var loginMsg = _v0.a.a;
							var login = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$LoginModel,
								$author$project$Routing$Router$LoginMsg,
								model,
								A3($author$project$Pages$Login$update, sharedState, loginMsg, login));
						} else {
							break _v0$35;
						}
					case 15:
						if (_v0.b.$ === 1) {
							var registrationMsg = _v0.a.a;
							var registration = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$RegistrationModel,
								$author$project$Routing$Router$RegistrationMsg,
								model,
								A3($author$project$Pages$Registration$update, sharedState, registrationMsg, registration));
						} else {
							break _v0$35;
						}
					case 16:
						if (_v0.b.$ === 2) {
							var dashboardMsg = _v0.a.a;
							var dashboard = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$DashboardModel,
								$author$project$Routing$Router$DashboardMsg,
								model,
								A3($author$project$Pages$Dashboard$update, sharedState, dashboardMsg, dashboard));
						} else {
							break _v0$35;
						}
					case 19:
						if (_v0.b.$ === 5) {
							var coursesMsg = _v0.a.a;
							var courses = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$CoursesModel,
								$author$project$Routing$Router$CoursesMsg,
								model,
								A3($author$project$Pages$Courses$update, sharedState, coursesMsg, courses));
						} else {
							break _v0$35;
						}
					case 21:
						if (_v0.b.$ === 7) {
							var courseEditorMsg = _v0.a.a;
							var courseEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$CourseEditorModel,
								$author$project$Routing$Router$CourseEditorMsg,
								model,
								A3($author$project$Pages$CourseEditor$update, sharedState, courseEditorMsg, courseEditor));
						} else {
							break _v0$35;
						}
					case 22:
						if (_v0.b.$ === 8) {
							var materialEditorMsg = _v0.a.a;
							var materialEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$MaterialEditorModel,
								$author$project$Routing$Router$MaterialEditorMsg,
								model,
								A3($author$project$Pages$MaterialEditor$update, sharedState, materialEditorMsg, materialEditor));
						} else {
							break _v0$35;
						}
					case 20:
						if (_v0.b.$ === 6) {
							var courseDetailMsg = _v0.a.a;
							var courseDetail = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$CourseDetailModel,
								$author$project$Routing$Router$CourseDetailMsg,
								model,
								A3($author$project$Pages$CourseDetail$update, sharedState, courseDetailMsg, courseDetail));
						} else {
							break _v0$35;
						}
					case 24:
						if (_v0.b.$ === 10) {
							var sheetEditorMsg = _v0.a.a;
							var sheetEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$SheetEditorModel,
								$author$project$Routing$Router$SheetEditorMsg,
								model,
								A3($author$project$Pages$SheetEditor$update, sharedState, sheetEditorMsg, sheetEditor));
						} else {
							break _v0$35;
						}
					case 23:
						if (_v0.b.$ === 9) {
							var sheetDetailMsg = _v0.a.a;
							var sheetDetail = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$SheetDetailModel,
								$author$project$Routing$Router$SheetDetailMsg,
								model,
								A3($author$project$Pages$SheetDetail$update, sharedState, sheetDetailMsg, sheetDetail));
						} else {
							break _v0$35;
						}
					case 13:
						if (_v0.b.$ === 9) {
							var progress = _v0.a.a;
							var sheetDetail = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$SheetDetailModel,
								$author$project$Routing$Router$SheetDetailMsg,
								model,
								A3(
									$author$project$Pages$SheetDetail$update,
									sharedState,
									$author$project$Pages$SheetDetail$UploadProgressMsg(progress),
									sheetDetail));
						} else {
							break _v0$35;
						}
					case 12:
						switch (_v0.b.$) {
							case 0:
								var spinnerMsg = _v0.a.a;
								var login = _v0.b.a;
								return A4(
									$author$project$Routing$Router$updateWith,
									$author$project$Routing$Router$LoginModel,
									$author$project$Routing$Router$LoginMsg,
									model,
									A3(
										$author$project$Pages$Login$update,
										sharedState,
										$author$project$Pages$Login$SpinnerMsg(spinnerMsg),
										login));
							case 11:
								var spinnerMsg = _v0.a.a;
								var submissionEditor = _v0.b.a;
								return A4(
									$author$project$Routing$Router$updateWith,
									$author$project$Routing$Router$SubmissionGradingEditorModel,
									$author$project$Routing$Router$SubmissionGradingEditorMsg,
									model,
									A3(
										$author$project$Pages$SubmissionGradingEditor$update,
										sharedState,
										$author$project$Pages$SubmissionGradingEditor$SpinnerMsg(spinnerMsg),
										submissionEditor));
							default:
								break _v0$35;
						}
					case 25:
						if (_v0.b.$ === 11) {
							var submissionEditorMsg = _v0.a.a;
							var submissionEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$SubmissionGradingEditorModel,
								$author$project$Routing$Router$SubmissionGradingEditorMsg,
								model,
								A3($author$project$Pages$SubmissionGradingEditor$update, sharedState, submissionEditorMsg, submissionEditor));
						} else {
							break _v0$35;
						}
					case 17:
						if (_v0.b.$ === 3) {
							var adminMsg = _v0.a.a;
							var admin = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$AdminModel,
								$author$project$Routing$Router$AdminMsg,
								model,
								A3($author$project$Pages$Admin$update, sharedState, adminMsg, admin));
						} else {
							break _v0$35;
						}
					case 18:
						if (_v0.b.$ === 4) {
							var termsMsg = _v0.a.a;
							var terms = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$TermsOfUseModel,
								$author$project$Routing$Router$TermsMsg,
								model,
								A3($author$project$Pages$Terms$update, sharedState, termsMsg, terms));
						} else {
							break _v0$35;
						}
					case 26:
						if (_v0.b.$ === 12) {
							var profileEditorMsg = _v0.a.a;
							var profileEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$ProfileEditorModel,
								$author$project$Routing$Router$ProfileEditorMsg,
								model,
								A3($author$project$Pages$ProfileEditor$update, sharedState, profileEditorMsg, profileEditor));
						} else {
							break _v0$35;
						}
					case 27:
						if (_v0.b.$ === 13) {
							var mailConfirmationMsg = _v0.a.a;
							var mailConfirmation = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$MailConfirmationModel,
								$author$project$Routing$Router$MailConfirmationMsg,
								model,
								A3($author$project$Pages$MailConfirmation$update, sharedState, mailConfirmationMsg, mailConfirmation));
						} else {
							break _v0$35;
						}
					case 28:
						if (_v0.b.$ === 14) {
							var requestPasswordResetMsg = _v0.a.a;
							var requestPasswordReset = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$RequestPasswordResetModel,
								$author$project$Routing$Router$RequestPasswordResetMsg,
								model,
								A3($author$project$Pages$RequestPasswordReset$update, sharedState, requestPasswordResetMsg, requestPasswordReset));
						} else {
							break _v0$35;
						}
					case 29:
						if (_v0.b.$ === 15) {
							var passwordResetMsg = _v0.a.a;
							var passwordReset = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$PasswordResetModel,
								$author$project$Routing$Router$PasswordResetMsg,
								model,
								A3($author$project$Pages$PasswordReset$update, sharedState, passwordResetMsg, passwordReset));
						} else {
							break _v0$35;
						}
					case 30:
						if (_v0.b.$ === 16) {
							var mailEditorMsg = _v0.a.a;
							var mailEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$MailEditorModel,
								$author$project$Routing$Router$MailEditorMsg,
								model,
								A3($author$project$Pages$MailEditor$update, sharedState, mailEditorMsg, mailEditor));
						} else {
							break _v0$35;
						}
					case 31:
						if (_v0.b.$ === 17) {
							var groupEditorMsg = _v0.a.a;
							var groupEditor = _v0.b.a;
							return A4(
								$author$project$Routing$Router$updateWith,
								$author$project$Routing$Router$GroupEditorModel,
								$author$project$Routing$Router$GroupEditorMsg,
								model,
								A3($author$project$Pages$GroupEditor$update, sharedState, groupEditorMsg, groupEditor));
						} else {
							break _v0$35;
						}
					case 4:
						var state = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cb: state}),
							$elm$core$Platform$Cmd$none,
							$author$project$SharedState$NoUpdate);
					case 5:
						var _v4 = _v0.a;
						var field = _v4.a;
						var val = _v4.b;
						var newModel = A3($author$project$Routing$Router$setField, model, field, val);
						return _Utils_Tuple3(newModel, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
					case 7:
						var _v5 = _v0.a;
						var request = A2($author$project$Routing$Router$modelToLoginRequest, sharedState, model);
						var _v6 = A2($rtfeldman$elm_validate$Validate$validate, $author$project$Routing$Router$modelValidator, model);
						if (_v6.$ === 1) {
							var errors = _v6.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{hf: errors}),
								$elm$core$Platform$Cmd$none,
								$author$project$SharedState$NoUpdate);
						} else {
							if (!request.$) {
								var body = request.a;
								return _Utils_Tuple3(
									model,
									A2($author$project$Api$Request$Auth$sessionPost, body, $author$project$Routing$Router$LoginResponse),
									$author$project$SharedState$NoUpdate);
							} else {
								var $temp$sharedState = sharedState,
									$temp$msg = $author$project$Routing$Router$Logout,
									$temp$model = model;
								sharedState = $temp$sharedState;
								msg = $temp$msg;
								model = $temp$model;
								continue update;
							}
						}
					case 8:
						switch (_v0.a.a.$) {
							case 2:
								var err = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{le: ''}),
									$elm$core$Platform$Cmd$none,
									$author$project$SharedState$NoUpdate);
							case 3:
								var role = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cb: false, le: ''}),
									$elm$core$Platform$Cmd$none,
									$author$project$SharedState$NoUpdate);
							default:
								break _v0$35;
						}
					default:
						break _v0$35;
				}
			}
			return _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, $author$project$SharedState$NoUpdate);
		}
	});
var $author$project$SharedState$update = F2(
	function (sharedState, sharedStateUpdate) {
		switch (sharedStateUpdate.$) {
			case 1:
				var time = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{
						jx: $elm$core$Maybe$Just(time)
					});
			case 2:
				var zone = sharedStateUpdate.a;
				return _Utils_update(
					sharedState,
					{
						o_: $elm$core$Maybe$Just(zone)
					});
			case 3:
				var language = sharedStateUpdate.a;
				var translations = sharedStateUpdate.b;
				return _Utils_update(
					sharedState,
					{lV: language, pa: translations});
			case 4:
				var role = sharedStateUpdate.a;
				var mail = sharedStateUpdate.b;
				return _Utils_update(
					sharedState,
					{
						lJ: $elm$core$Maybe$Just(role),
						pg: $elm$core$Maybe$Just(mail)
					});
			case 0:
				return sharedState;
			case 5:
				return sharedState;
			default:
				return sharedState;
		}
	});
var $author$project$Main$updateRouter = F2(
	function (model, routerMsg) {
		var _v0 = model.D;
		if (_v0.$ === 1) {
			var sharedState = _v0.a;
			var routerModel = _v0.b;
			var _v1 = A3($author$project$Routing$Router$update, sharedState, routerMsg, routerModel);
			var nextRouterModel = _v1.a;
			var routerCmd = _v1.b;
			var sharedStateUpdate = _v1.c;
			var nextSharedState = A2($author$project$SharedState$update, sharedState, sharedStateUpdate);
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						D: A2($author$project$Main$Ready, nextSharedState, nextRouterModel)
					}),
				A2($elm$core$Platform$Cmd$map, $author$project$Main$RouterMsg, routerCmd));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$SharedState$UpdateTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$updateTime = F2(
	function (model, time) {
		var _v0 = model.D;
		switch (_v0.$) {
			case 0:
				var zone = _v0.b;
				var state = _v0.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D: A3(
								$author$project$Main$NotReady,
								$elm$core$Maybe$Just(time),
								zone,
								state)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var sharedState = _v0.a;
				var routerModel = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D: A2(
								$author$project$Main$Ready,
								A2(
									$author$project$SharedState$update,
									sharedState,
									$author$project$SharedState$UpdateTime(time)),
								routerModel)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$SharedState$UpdateTimezone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$updateTimeZone = F2(
	function (model, zone) {
		var _v0 = model.D;
		switch (_v0.$) {
			case 0:
				var time = _v0.a;
				var state = _v0.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D: A3(
								$author$project$Main$NotReady,
								time,
								$elm$core$Maybe$Just(zone),
								state)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var sharedState = _v0.a;
				var routerModel = _v0.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							D: A2(
								$author$project$Main$Ready,
								A2(
									$author$project$SharedState$update,
									sharedState,
									$author$project$SharedState$UpdateTimezone(zone)),
								routerModel)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$FailedToInitialize = {$: 2};
var $author$project$Types$German = 1;
var $author$project$Routing$Router$init = F2(
	function (url, lang) {
		var currentRoute = $author$project$Routing$Helpers$parseUrl(url);
		return _Utils_Tuple2(
			{b0: $author$project$Routing$Router$NotFound, hf: _List_Nil, cb: false, le: '', eM: currentRoute, lV: lang, iC: $pablen$toasty$Toasty$initialState},
			$author$project$Utils$Utils$perform(
				$author$project$Routing$Router$UrlChange(url)));
	});
var $author$project$Main$updateTranslations = F2(
	function (model, webData) {
		switch (webData.$) {
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{D: $author$project$Main$FailedToInitialize}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var translations = webData.a;
				var _v1 = model.D;
				switch (_v1.$) {
					case 0:
						var time = _v1.a;
						var zone = _v1.b;
						var state = _v1.c;
						var _v2 = function () {
							if (!state.$) {
								var _v4 = state.a;
								var r = _v4.a;
								var m = _v4.b;
								return _Utils_Tuple2(
									$elm$core$Maybe$Just(r),
									$elm$core$Maybe$Just(m));
							} else {
								return _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing);
							}
						}();
						var role = _v2.a;
						var mail = _v2.b;
						var initSharedState = {jx: time, f1: model.f1, lJ: role, lV: 1, o_: zone, pa: translations, pg: mail};
						var _v5 = A2($author$project$Routing$Router$init, model.aA, initSharedState.lV);
						var initRouterModel = _v5.a;
						var routerCmd = _v5.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									D: A2($author$project$Main$Ready, initSharedState, initRouterModel)
								}),
							A2($elm$core$Platform$Cmd$map, $author$project$Main$RouterMsg, routerCmd));
					case 1:
						var sharedState = _v1.a;
						var routerModel = _v1.b;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									D: A2(
										$author$project$Main$Ready,
										A2(
											$author$project$SharedState$update,
											sharedState,
											A2($author$project$SharedState$UpdateLanguage, 1, translations)),
										routerModel)
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				var time = msg.a;
				return A2($author$project$Main$updateTime, model, time);
			case 7:
				var zone = msg.a;
				return A2($author$project$Main$updateTimeZone, model, zone);
			case 5:
				var webData = msg.a;
				return A2($author$project$Main$updateTranslations, model, webData);
			case 0:
				var url = msg.a;
				return A2(
					$author$project$Main$updateRouter,
					_Utils_update(
						model,
						{aA: url}),
					$author$project$Routing$Router$UrlChange(url));
			case 6:
				var routerMsg = msg.a;
				return A2($author$project$Main$updateRouter, model, routerMsg);
			case 3:
				var spinnerMsg = msg.a;
				return A2(
					$author$project$Main$updateRouter,
					model,
					$author$project$Routing$Router$SpinnerMsg(spinnerMsg));
			case 4:
				var progress = msg.a;
				return A2(
					$author$project$Main$updateRouter,
					model,
					$author$project$Routing$Router$UploadProgressMsg(progress));
			case 1:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$browser$Browser$Navigation$pushUrl,
							model.f1,
							$elm$url$Url$toString(url)));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$browser$Browser$Navigation$load(url));
				}
			case 8:
				var state = msg.a;
				return A2(
					$author$project$Main$updateRouter,
					model,
					$author$project$Routing$Router$PersistanceUpdate(state));
			default:
				var msg_ = msg.a;
				return A3($author$project$Material$update, $author$project$Main$Mdc, msg_, model);
		}
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Types$English = 0;
var $author$project$Routing$Router$NavigateTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Routing$Router$SelectedLanguage = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $elm$html$Html$button = _VirtualDom_node('button');
var $justgage$tachyons_elm$Tachyons$Classes$dark_red = 'dark-red';
var $justgage$tachyons_elm$Tachyons$Classes$db = 'db';
var $justgage$tachyons_elm$Tachyons$Classes$f6 = 'f6';
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $justgage$tachyons_elm$Tachyons$Classes$dark_gray = 'dark-gray';
var $justgage$tachyons_elm$Tachyons$Classes$bg_transparent = 'bg-transparent';
var $justgage$tachyons_elm$Tachyons$Classes$bn = 'bn';
var $justgage$tachyons_elm$Tachyons$Classes$button_reset = 'button-reset';
var $justgage$tachyons_elm$Tachyons$Classes$dib = 'dib';
var $justgage$tachyons_elm$Tachyons$Classes$dim = 'dim';
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_transparent = 'hover-bg-transparent';
var $justgage$tachyons_elm$Tachyons$Classes$link = 'link';
var $justgage$tachyons_elm$Tachyons$Classes$no_underline = 'no-underline';
var $justgage$tachyons_elm$Tachyons$Classes$ph2 = 'ph2';
var $justgage$tachyons_elm$Tachyons$Classes$pointer = 'pointer';
var $author$project$Utils$Styles$linkStyle = _List_fromArray(
	[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$ph2, $justgage$tachyons_elm$Tachyons$Classes$link, $justgage$tachyons_elm$Tachyons$Classes$dim, $justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$button_reset, $justgage$tachyons_elm$Tachyons$Classes$input_reset, $justgage$tachyons_elm$Tachyons$Classes$bg_transparent, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_transparent, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$no_underline]);
var $author$project$Utils$Styles$linkGreyStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$linkStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$dark_gray])));
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $justgage$tachyons_elm$Tachyons$Classes$ph3 = 'ph3';
var $justgage$tachyons_elm$Tachyons$Classes$ph5_m = 'ph5-m';
var $justgage$tachyons_elm$Tachyons$Classes$ph6_l = 'ph6-l';
var $elm$html$Html$small = _VirtualDom_node('small');
var $justgage$tachyons_elm$Tachyons$Classes$tc = 'tc';
var $justgage$tachyons_elm$Tachyons$Classes$lh_copy = 'lh-copy';
var $author$project$Utils$Styles$textStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$black_80, $justgage$tachyons_elm$Tachyons$Classes$lh_copy]));
var $justgage$tachyons_elm$Tachyons$Classes$ttu = 'ttu';
var $author$project$Routing$Router$footerView = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return A2(
			$elm$html$Html$footer,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$pv3, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph5_m, $justgage$tachyons_elm$Tachyons$Classes$ph6_l, $justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$db]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$small,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$f6])),
							$author$project$Utils$Styles$textStyle
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('© 2026 '),
							A2(
							$elm$html$Html$b,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$ttu]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Lehrstuhl Computergrafik (with some friendly help from the Lehrstuhl Datenbanksysteme), University Tübingen')
								])),
							$elm$html$Html$text('., All Rights Reserved')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$f6]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Utils$Styles$linkGreyStyle,
									$elm$html$Html$Events$onClick(
									$author$project$Routing$Router$SelectedLanguage(1))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Deutsch')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Utils$Styles$linkGreyStyle,
									$elm$html$Html$Events$onClick(
									$author$project$Routing$Router$SelectedLanguage(0))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('English')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Utils$Styles$linkGreyStyle,
									$elm$html$Html$Events$onClick(
									$author$project$Routing$Router$NavigateTo($author$project$Routing$Helpers$TermsOfUseRoute))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Terms of Use')
								]))
						]))
				]));
	});
var $justgage$tachyons_elm$Tachyons$Classes$helvetica = 'helvetica';
var $justgage$tachyons_elm$Tachyons$Classes$dtc = 'dtc';
var $justgage$tachyons_elm$Tachyons$Classes$f2_m = 'f2-m';
var $justgage$tachyons_elm$Tachyons$Classes$f_subheadline_l = 'f-subheadline-l';
var $justgage$tachyons_elm$Tachyons$Classes$fw6 = 'fw6';
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $justgage$tachyons_elm$Tachyons$Classes$ph4_l = 'ph4-l';
var $justgage$tachyons_elm$Tachyons$Classes$v_mid = 'v-mid';
var $author$project$Pages$Admin$view = F2(
	function (sharedState, model) {
		return A2($elm$html$Html$div, _List_Nil, _List_Nil);
	});
var $justgage$tachyons_elm$Tachyons$Classes$center = 'center';
var $justgage$tachyons_elm$Tachyons$Classes$mw8 = 'mw8';
var $justgage$tachyons_elm$Tachyons$Classes$ph4 = 'ph4';
var $justgage$tachyons_elm$Tachyons$Classes$ph5_ns = 'ph5-ns';
var $author$project$Components$CommonElements$normalPage = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$mw8, $justgage$tachyons_elm$Tachyons$Classes$ph4, $justgage$tachyons_elm$Tachyons$Classes$ph5_ns, $justgage$tachyons_elm$Tachyons$Classes$center]))
			]),
		childs);
};
var $justgage$tachyons_elm$Tachyons$Classes$ph0_ns = 'ph0-ns';
var $justgage$tachyons_elm$Tachyons$Classes$pv1 = 'pv1';
var $justgage$tachyons_elm$Tachyons$Classes$pv3_m = 'pv3-m';
var $justgage$tachyons_elm$Tachyons$Classes$pv5_l = 'pv5-l';
var $author$project$Components$CommonElements$pageContainer = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$ph0_ns, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
			]),
		childs);
};
var $justgage$tachyons_elm$Tachyons$Classes$b__gray = 'b--gray';
var $justgage$tachyons_elm$Tachyons$Classes$black = 'black';
var $justgage$tachyons_elm$Tachyons$Classes$dark_green = 'dark-green';
var $elm$html$Html$dd = _VirtualDom_node('dd');
var $elm$html$Html$dt = _VirtualDom_node('dt');
var $justgage$tachyons_elm$Tachyons$Classes$ml0 = 'ml0';
var $author$project$Components$CommonElements$dateElement = F2(
	function (label, formattedTime) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$dt,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6]))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$dd,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$ml0]))
					]),
				_List_fromArray(
					[formattedTime]))
			]);
	});
var $justgage$tachyons_elm$Tachyons$Classes$tracked = 'tracked';
var $author$project$Utils$Styles$dateStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ttu, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$dark_gray, $justgage$tachyons_elm$Tachyons$Classes$lh_copy]));
var $elm$html$Html$dl = _VirtualDom_node('dl');
var $author$project$Components$CommonElements$datesDisplayContainer = function (childs) {
	return A2(
		$elm$html$Html$dl,
		_List_fromArray(
			[$author$project$Utils$Styles$dateStyle]),
		childs);
};
var $justgage$tachyons_elm$Tachyons$Classes$f3 = 'f3';
var $author$project$Utils$DateFormatter$dayFormatter = F2(
	function (sharedState, day) {
		var t = $author$project$I18n$get(sharedState.pa);
		switch (day) {
			case 0:
				return t('day-mon');
			case 1:
				return t('day-tue');
			case 2:
				return t('day-wed');
			case 3:
				return t('day-thu');
			case 4:
				return t('day-fri');
			case 5:
				return t('day-sat');
			default:
				return t('day-sun');
		}
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $author$project$Utils$DateFormatter$fullDateFormatter = F2(
	function (sharedState, time) {
		var year = $elm$core$String$fromInt(
			A3(
				$author$project$Utils$Utils$flip,
				$elm$time$Time$toYear,
				time,
				A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_)));
		var weekDayType = A3(
			$author$project$Utils$Utils$flip,
			$elm$time$Time$toWeekday,
			time,
			A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_));
		var weekday = A2($author$project$Utils$DateFormatter$dayFormatter, sharedState, weekDayType);
		var monthType = A3(
			$author$project$Utils$Utils$flip,
			$elm$time$Time$toMonth,
			time,
			A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_));
		var month = A2($author$project$Utils$DateFormatter$monthFormatter, sharedState, monthType);
		var day = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A3(
					$author$project$Utils$Utils$flip,
					$elm$time$Time$toDay,
					time,
					A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_))));
		return $elm$html$Html$text(
			$elm$core$String$toUpper(weekday + (', ' + (month + (' ' + (day + (', ' + year)))))));
	});
var $justgage$tachyons_elm$Tachyons$Classes$gold = 'gold';
var $justgage$tachyons_elm$Tachyons$Classes$f2 = 'f2';
var $author$project$Utils$Styles$headerStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f2, $justgage$tachyons_elm$Tachyons$Classes$black]));
var $justgage$tachyons_elm$Tachyons$Classes$lh_title = 'lh-title';
var $justgage$tachyons_elm$Tachyons$Classes$mt0 = 'mt0';
var $justgage$tachyons_elm$Tachyons$Classes$overflow_hidden = 'overflow-hidden';
var $justgage$tachyons_elm$Tachyons$Classes$pb3 = 'pb3';
var $justgage$tachyons_elm$Tachyons$Classes$fl = 'fl';
var $justgage$tachyons_elm$Tachyons$Classes$pl2_ns = 'pl2-ns';
var $justgage$tachyons_elm$Tachyons$Classes$w_50_ns = 'w-50-ns';
var $author$project$Components$CommonElements$r2Column = F2(
	function (child1, child2) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns]))
					]),
				child1),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
					]),
				child2)
			]);
	});
var $justgage$tachyons_elm$Tachyons$Classes$red = 'red';
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm_explorations$markdown$Markdown$defaultOptions = {
	jA: $elm$core$Maybe$Nothing,
	nC: $elm$core$Maybe$Just(
		{m0: false, oW: false}),
	oy: true,
	oL: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$Pages$CourseDetail$viewCourseInfo = F2(
	function (sharedState, model) {
		var maybePoints = function () {
			var _v2 = _Utils_Tuple2(model.eE, model.cB);
			if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
				var points = _v2.a.a;
				var course = _v2.b.a;
				return $elm$core$List$isEmpty(points) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					function (_v3) {
						var fst = _v3.a;
						var snd = _v3.b;
						var thrd = _v3.c;
						return {
							iW: thrd,
							iX: fst,
							g1: function () {
								var acquiredPerc = $elm$core$Basics$round((fst / snd) * 100);
								return (_Utils_cmp(acquiredPerc, course.lE) < 0) ? $justgage$tachyons_elm$Tachyons$Classes$red : ((_Utils_cmp(acquiredPerc, course.lE + 5) < 0) ? $justgage$tachyons_elm$Tachyons$Classes$gold : $justgage$tachyons_elm$Tachyons$Classes$dark_green);
							}(),
							kO: snd
						};
					}(
						_Utils_Tuple3(
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.iX;
									},
									points)),
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.kO;
									},
									points)),
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.iW;
									},
									points)))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = model.cB;
		if (_v0.$ === 3) {
			var course = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$b__gray, 'small-border', $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$pb3, $justgage$tachyons_elm$Tachyons$Classes$overflow_hidden]))
					]),
				A2(
					$author$project$Components$CommonElements$r2Column,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$mb3, $justgage$tachyons_elm$Tachyons$Classes$mt0, $justgage$tachyons_elm$Tachyons$Classes$lh_title]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(course.kY)
										])),
									$author$project$Components$CommonElements$datesDisplayContainer(
									_Utils_ap(
										A2(
											$author$project$Components$CommonElements$dateElement,
											'Beginn ',
											A2($author$project$Utils$DateFormatter$fullDateFormatter, sharedState, course.i8)),
										_Utils_ap(
											A2(
												$author$project$Components$CommonElements$dateElement,
												'Ende ',
												A2($author$project$Utils$DateFormatter$fullDateFormatter, sharedState, course.jQ)),
											function () {
												if (!maybePoints.$) {
													var mp = maybePoints.a;
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$dt,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6]))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Erreichte Punkte:')
																])),
															A2(
															$elm$html$Html$h1,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[mp.g1, $justgage$tachyons_elm$Tachyons$Classes$mt0, $justgage$tachyons_elm$Tachyons$Classes$f3])),
																	$author$project$Utils$Styles$headerStyle
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$elm$core$String$fromInt(mp.iX) + ('/' + ($elm$core$String$fromInt(mp.iW) + (' (maximal erreichbar: ' + ($elm$core$String$fromInt(mp.kO) + ')')))))
																]))
														]);
												} else {
													return _List_fromArray(
														[
															$elm$html$Html$text('')
														]);
												}
											}())))
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm_explorations$markdown$Markdown$toHtml,
							_List_fromArray(
								[$author$project$Utils$Styles$textStyle]),
							course.jC)
						])));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$CommonElements$rContainer = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$w_100]))
			]),
		childs);
};
var $justgage$tachyons_elm$Tachyons$Classes$cf = 'cf';
var $justgage$tachyons_elm$Tachyons$Classes$ph2_ns = 'ph2-ns';
var $author$project$Components$CommonElements$rRow = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
			]),
		childs);
};
var $author$project$Components$CommonElements$rRowHeader = function (label) {
	return $author$project$Components$CommonElements$rRow(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[$author$project$Utils$Styles$headerStyle]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					]))
			]));
};
var $author$project$Components$Groups$AdminView$CreateGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$Components$CommonElements$PbbActive = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Components$CommonElements$PbbButton = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Groups$AdminView$SendMailToCourse = function (a) {
	return {$: 3, a: a};
};
var $justgage$tachyons_elm$Tachyons$Classes$ph4_ns = 'ph4-ns';
var $justgage$tachyons_elm$Tachyons$Classes$b = 'b';
var $justgage$tachyons_elm$Tachyons$Classes$b__dark_red = 'b--dark-red';
var $justgage$tachyons_elm$Tachyons$Classes$ba = 'ba';
var $justgage$tachyons_elm$Tachyons$Classes$bg_dark_red = 'bg-dark-red';
var $justgage$tachyons_elm$Tachyons$Classes$bg_white = 'bg-white';
var $justgage$tachyons_elm$Tachyons$Classes$border_box = 'border-box';
var $justgage$tachyons_elm$Tachyons$Classes$b__black_40 = 'b--black-40';
var $justgage$tachyons_elm$Tachyons$Classes$black_40 = 'black-40';
var $justgage$tachyons_elm$Tachyons$Classes$bg_animate = 'bg-animate';
var $justgage$tachyons_elm$Tachyons$Classes$items_center = 'items-center';
var $justgage$tachyons_elm$Tachyons$Classes$pa3 = 'pa3';
var $author$project$Utils$Styles$buttonStyle = _List_fromArray(
	[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$no_underline, $justgage$tachyons_elm$Tachyons$Classes$bg_animate, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$border_box, $justgage$tachyons_elm$Tachyons$Classes$bg_white, $justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$button_reset, $justgage$tachyons_elm$Tachyons$Classes$input_reset]);
var $author$project$Utils$Styles$buttonDisabled = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$black_40, $justgage$tachyons_elm$Tachyons$Classes$b__black_40, 'disabled-content'])));
var $justgage$tachyons_elm$Tachyons$Classes$b__white_40 = 'b--white-40';
var $justgage$tachyons_elm$Tachyons$Classes$bg_red = 'bg-red';
var $justgage$tachyons_elm$Tachyons$Classes$white = 'white';
var $author$project$Utils$Styles$buttonFailureStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$b__white_40, $justgage$tachyons_elm$Tachyons$Classes$bg_red])));
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_gray = 'hover-bg-dark-gray';
var $justgage$tachyons_elm$Tachyons$Classes$hover_white = 'hover-white';
var $author$project$Utils$Styles$buttonGreyStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$dark_gray, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_gray, $justgage$tachyons_elm$Tachyons$Classes$hover_white])));
var $justgage$tachyons_elm$Tachyons$Classes$bg_dark_green = 'bg-dark-green';
var $author$project$Utils$Styles$buttonSuccessStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$b__white_40, $justgage$tachyons_elm$Tachyons$Classes$bg_dark_green])));
var $justgage$tachyons_elm$Tachyons$Classes$mb4 = 'mb4';
var $justgage$tachyons_elm$Tachyons$Classes$mt5 = 'mt5';
var $justgage$tachyons_elm$Tachyons$Classes$pa2 = 'pa2';
var $justgage$tachyons_elm$Tachyons$Classes$relative = 'relative';
var $avh4$elm_color$Color$RgbaSpace = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $avh4$elm_color$Color$rgba = F4(
	function (r, g, b, a) {
		return A4($avh4$elm_color$Color$RgbaSpace, r, g, b, a);
	});
var $damienklinnert$elm_spinner$Spinner$Clockwise = 0;
var $author$project$Utils$Styles$spinnerStyle = {
	g1: $elm$core$Basics$always(
		A4($avh4$elm_color$Color$rgba, 1, 1, 1, 1)),
	m9: 1,
	nj: 0,
	nH: false,
	nU: 0,
	nV: 10,
	oh: 0.25,
	oq: 35,
	ow: 0,
	oz: 0.5,
	oI: true,
	oM: 1,
	o6: 100,
	o8: 50,
	o9: 50,
	mO: 8
};
var $author$project$Utils$Styles$spinnerRedStyle = _Utils_update(
	$author$project$Utils$Styles$spinnerStyle,
	{
		g1: $elm$core$Basics$always(
			A4($avh4$elm_color$Color$rgba, 165 / 255, 30 / 255, 55 / 255, 1))
	});
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $avh4$elm_color$Color$toCssString = function (_v0) {
	var r = _v0.a;
	var g = _v0.b;
	var b = _v0.c;
	var a = _v0.d;
	var roundTo = function (x) {
		return $elm$core$Basics$round(x * 1000) / 1000;
	};
	var pct = function (x) {
		return $elm$core$Basics$round(x * 10000) / 100;
	};
	return $elm$core$String$concat(
		_List_fromArray(
			[
				'rgba(',
				$elm$core$String$fromFloat(
				pct(r)),
				'%,',
				$elm$core$String$fromFloat(
				pct(g)),
				'%,',
				$elm$core$String$fromFloat(
				pct(b)),
				'%,',
				$elm$core$String$fromFloat(
				roundTo(a)),
				')'
			]));
};
var $elm$core$Basics$truncate = _Basics_truncate;
var $damienklinnert$elm_spinner$Spinner$barStyles = F3(
	function (cfg, time, n) {
		var scaledTrail = $elm$core$Basics$ceiling((cfg.nV * cfg.o6) / 100);
		var fullBlinkTime = 1000 / cfg.oM;
		var movePerLight = ((n / cfg.nV) * fullBlinkTime) | 0;
		var lineOpacity = A2($elm$core$Basics$modBy, fullBlinkTime | 0, 1000 - ((time | 0) + movePerLight)) / 1000;
		var trailedOpacity = A2($elm$core$Basics$max, 0, (cfg.nV * lineOpacity) - (cfg.nV - scaledTrail)) / scaledTrail;
		var directionBasedDeg = (!cfg.nj) ? (cfg.nV - n) : n;
		var deg = $elm$core$String$fromFloat(((360 / cfg.nV) * directionBasedDeg) + cfg.ow);
		var borderRadius = (cfg.m9 * cfg.mO) / 2;
		var baseLinedOpacity = $elm$core$String$fromFloat(
			A2($elm$core$Basics$max, cfg.oh, trailedOpacity));
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'background',
				$avh4$elm_color$Color$toCssString(
					cfg.g1(n))),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromFloat(cfg.mO) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(cfg.nU + cfg.mO) + 'px'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
				A2($elm$html$Html$Attributes$style, 'transform-origin', 'left'),
				A2(
				$elm$html$Html$Attributes$style,
				'transform',
				'rotate(' + (deg + ('deg) translate(' + ($elm$core$String$fromFloat(cfg.oq) + 'px, 0px)')))),
				A2(
				$elm$html$Html$Attributes$style,
				'border-radius',
				$elm$core$String$fromFloat(borderRadius) + 'px'),
				A2($elm$html$Html$Attributes$style, 'opacity', baseLinedOpacity),
				A2(
				$elm$html$Html$Attributes$style,
				'box-shadow',
				cfg.oI ? '0 0 4px #000' : 'none'),
				A2(
				$elm$html$Html$Attributes$style,
				'-webkit-box-shadow',
				cfg.oI ? '0 0 4px #000' : 'none')
			]);
	});
var $damienklinnert$elm_spinner$Spinner$outerStyle = function (cfg) {
	return _List_fromArray(
		[
			A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
			A2(
			$elm$html$Html$Attributes$style,
			'top',
			'calc(' + ($elm$core$String$fromFloat(cfg.o9) + '%)')),
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$elm$core$String$fromFloat(cfg.o8) + '%'),
			A2(
			$elm$html$Html$Attributes$style,
			'transform',
			'scale(' + ($elm$core$String$fromFloat(cfg.oz) + (')' + (cfg.nH ? ' translate3d(0px, 0px, 0px)' : ''))))
		]);
};
var $damienklinnert$elm_spinner$Spinner$view = F2(
	function (cfg, _v0) {
		var time = _v0;
		var range = A2(
			$elm$core$List$map,
			$elm$core$Basics$toFloat,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$Basics$floor(cfg.nV) - 1));
		var floatTime = $elm$time$Time$posixToMillis(time);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (i) {
					return A2(
						$elm$html$Html$div,
						$damienklinnert$elm_spinner$Spinner$outerStyle(cfg),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								A3($damienklinnert$elm_spinner$Spinner$barStyles, cfg, floatTime, i),
								_List_Nil)
							]));
				},
				range));
	});
var $author$project$Components$CommonElements$progressBarButton = function (barOrButtonState) {
	var baseButtonStyle = $justgage$tachyons_elm$Tachyons$classes(
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$mb4, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$w_100]));
	switch (barOrButtonState.$) {
		case 0:
			var buttonState = barOrButtonState.a;
			switch (buttonState.$) {
				case 0:
					var label = buttonState.a;
					var msg = buttonState.b;
					return A2(
						$elm$html$Html$button,
						A2(
							$elm$core$List$cons,
							baseButtonStyle,
							_List_fromArray(
								[
									$author$project$Utils$Styles$buttonGreyStyle,
									$elm$html$Html$Events$onClick(msg)
								])),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				case 1:
					var label = buttonState.a;
					return A2(
						$elm$html$Html$button,
						A2(
							$elm$core$List$cons,
							baseButtonStyle,
							_List_fromArray(
								[$author$project$Utils$Styles$buttonDisabled])),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]));
				default:
					var state = buttonState.a;
					if (!state.$) {
						var label = state.a;
						return A2(
							$elm$html$Html$button,
							A2(
								$elm$core$List$cons,
								baseButtonStyle,
								_List_fromArray(
									[$author$project$Utils$Styles$buttonSuccessStyle])),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					} else {
						var label = state.a;
						return A2(
							$elm$html$Html$button,
							A2(
								$elm$core$List$cons,
								baseButtonStyle,
								_List_fromArray(
									[$author$project$Utils$Styles$buttonFailureStyle])),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								]));
					}
			}
		case 1:
			var progress = barOrButtonState.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						baseButtonStyle,
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$b, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$border_box, $justgage$tachyons_elm$Tachyons$Classes$bg_white, $justgage$tachyons_elm$Tachyons$Classes$b__dark_red]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$bg_dark_red])),
								A2(
								$elm$html$Html$Attributes$style,
								'width',
								$elm$core$String$fromInt(progress) + '%'),
								A2($elm$html$Html$Attributes$style, 'height', '1.95rem')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(' ')
							]))
					]));
		default:
			var spinnerModel = barOrButtonState.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						baseButtonStyle,
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$relative, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt5, $justgage$tachyons_elm$Tachyons$Classes$mb3]))
					]),
				_List_fromArray(
					[
						A2($damienklinnert$elm_spinner$Spinner$view, $author$project$Utils$Styles$spinnerRedStyle, spinnerModel)
					]));
	}
};
var $author$project$Components$CommonElements$rRowButton = function (buttonState) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph4_ns, $justgage$tachyons_elm$Tachyons$Classes$ph3]))
			]),
		_List_fromArray(
			[
				$author$project$Components$CommonElements$progressBarButton(buttonState)
			]));
};
var $author$project$Components$Groups$AdminView$EditGroup = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Components$Groups$AdminView$SendMailToGroup = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $justgage$tachyons_elm$Tachyons$Classes$br_100 = 'br-100';
var $justgage$tachyons_elm$Tachyons$Classes$flex = 'flex';
var $justgage$tachyons_elm$Tachyons$Classes$h3_ns = 'h3-ns';
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_black = 'hover-bg-near-black';
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_white = 'hover-bg-near-white';
var $justgage$tachyons_elm$Tachyons$Classes$hover_near_white = 'hover-near-white';
var $elm$html$Html$i = _VirtualDom_node('i');
var $justgage$tachyons_elm$Tachyons$Classes$justify_start = 'justify-start';
var $elm$html$Html$li = _VirtualDom_node('li');
var $justgage$tachyons_elm$Tachyons$Classes$ml_auto = 'ml-auto';
var $justgage$tachyons_elm$Tachyons$Classes$mr0 = 'mr0';
var $justgage$tachyons_elm$Tachyons$Classes$mr2 = 'mr2';
var $justgage$tachyons_elm$Tachyons$Classes$pv0 = 'pv0';
var $justgage$tachyons_elm$Tachyons$Classes$pv2 = 'pv2';
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Components$CommonElements$nButtonList = function (listElements) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$ma0, $justgage$tachyons_elm$Tachyons$Classes$pv2, $justgage$tachyons_elm$Tachyons$Classes$ph0, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$black_80]))
			]),
		A2(
			$elm$core$List$map,
			function (elt) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_white, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$relative, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$justify_start, $justgage$tachyons_elm$Tachyons$Classes$pv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('material-icons'),
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$mr2, $justgage$tachyons_elm$Tachyons$Classes$ml0, $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$black_40, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_black, $justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$hover_near_white, $justgage$tachyons_elm$Tachyons$Classes$pointer])),
										$elm$html$Html$Events$onClick(elt.m2)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(elt.m1)
									])),
								$elm$html$Html$text(elt.af)
							]),
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (idx, b) {
									return A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('material-icons'),
												$justgage$tachyons_elm$Tachyons$classes(
												_Utils_ap(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$mr0, $justgage$tachyons_elm$Tachyons$Classes$ml3, $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$black_40, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_black, $justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$hover_near_white]),
													(!idx) ? _List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$ml_auto]) : _List_Nil)),
												$elm$html$Html$Events$onClick(b.ji)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(b.jh)
											]));
								}),
							elt.ov)));
			},
			listElements));
};
var $author$project$Components$Groups$AdminView$showGroups = F2(
	function (model, allGroups) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$nButtonList(
				A2(
					$elm$core$List$map,
					function (group) {
						var tutor = group.mB;
						return {
							m1: 'edit',
							m2: A2($author$project$Components$Groups$AdminView$EditGroup, model.jv, group.ki),
							af: tutor.j_ + (' ' + tutor.kB),
							ov: _List_fromArray(
								[
									{
									jh: 'mail',
									ji: A2($author$project$Components$Groups$AdminView$SendMailToGroup, model.jv, group.ki)
								}
								])
						};
					},
					allGroups))
			]);
	});
var $elm$core$List$sortBy = _List_sortBy;
var $author$project$Components$Groups$AdminView$view = F2(
	function (sharedState, model) {
		var allGroupsWithUsers = A2(
			$elm$core$List$sortBy,
			function (gu) {
				return function ($) {
					return $.kB;
				}(
					function ($) {
						return $.mB;
					}(gu.a));
			},
			$elm$core$Dict$values(model.fK));
		var allGroups = A2($elm$core$List$map, $elm$core$Tuple$first, allGroupsWithUsers);
		return $author$project$Components$CommonElements$rContainer(
			_Utils_ap(
				A2($author$project$Components$Groups$AdminView$showGroups, model, allGroups),
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2(
								$author$project$Components$CommonElements$PbbActive,
								'Create Group',
								$author$project$Components$Groups$AdminView$CreateGroup(model.jv)))),
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2(
								$author$project$Components$CommonElements$PbbActive,
								'Send E-Mail To Course',
								$author$project$Components$Groups$AdminView$SendMailToCourse(model.jv))))
					])));
	});
var $justgage$tachyons_elm$Tachyons$Classes$w_33_l = 'w-33-l';
var $justgage$tachyons_elm$Tachyons$Classes$w_50_m = 'w-50-m';
var $author$project$Components$CommonElements$r3Column = F3(
	function (child1, child2, child3) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_m, $justgage$tachyons_elm$Tachyons$Classes$w_33_l]))
					]),
				child1),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_m, $justgage$tachyons_elm$Tachyons$Classes$w_33_l, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
					]),
				child2),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_m, $justgage$tachyons_elm$Tachyons$Classes$w_33_l, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
					]),
				child3)
			]);
	});
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$Utils$Utils$split = F2(
	function (i, list) {
		var _v0 = A2($elm$core$List$take, i, list);
		if (!_v0.b) {
			return _List_Nil;
		} else {
			var listHead = _v0;
			return A2(
				$elm$core$List$cons,
				listHead,
				A2(
					$author$project$Utils$Utils$split,
					i,
					A2($elm$core$List$drop, i, list)));
		}
	});
var $author$project$Components$Groups$BiddingView$Rating = $elm$core$Basics$identity;
var $author$project$Components$Groups$BiddingView$SetBid = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Utils$Styles$listHeadingStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f3, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$lh_title, $justgage$tachyons_elm$Tachyons$Classes$black]));
var $justgage$tachyons_elm$Tachyons$Classes$bg_black_30 = 'bg-black-30';
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Utils$Styles$labelStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$black_80]));
var $justgage$tachyons_elm$Tachyons$Classes$mb1 = 'mb1';
var $author$project$Components$CommonElements$inputLabel = function (title) {
	return A2(
		$elm$html$Html$label,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$mb1])),
				$author$project$Utils$Styles$labelStyle
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(title)
			]));
};
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$Attributes$min = $elm$html$Html$Attributes$stringProperty('min');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$step = function (n) {
	return A2($elm$html$Html$Attributes$stringProperty, 'step', n);
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $justgage$tachyons_elm$Tachyons$Classes$pl0 = 'pl0';
var $author$project$Components$CommonElements$viewFormErrors = F2(
	function (field, errors) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$list, $justgage$tachyons_elm$Tachyons$Classes$pl0, $justgage$tachyons_elm$Tachyons$Classes$center]))
				]),
			A2(
				$elm$core$List$map,
				function (_v1) {
					var error = _v1.b;
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$red]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(error)
							]));
				},
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var fieldError = _v0.a;
						return _Utils_eq(fieldError, field);
					},
					errors)));
	});
var $author$project$Components$CommonElements$sliderInputElement = F4(
	function (inputConfig, field, errors, msg) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('range'),
						$elm$html$Html$Attributes$min(
						$elm$core$String$fromInt(inputConfig.kT)),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromInt(inputConfig.kK)),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromInt(inputConfig.fa)),
						$elm$html$Html$Attributes$step(
						$elm$core$String$fromInt(inputConfig.l6)),
						$elm$html$Html$Attributes$class('slider'),
						$elm$html$Html$Events$onInput(
						msg(field)),
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$bg_black_30]))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[$author$project$Utils$Styles$labelStyle]),
				_List_fromArray(
					[
						$elm$html$Html$text(inputConfig.pi)
					])),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $author$project$Components$Groups$BiddingView$viewGroupBid = F3(
	function (sharedState, model, data) {
		var _v0 = data.nD;
		if (!_v0.$) {
			var group = _v0.a;
			var tutor = group.mB;
			var curBid = A2($elm$core$Maybe$withDefault, 1, data.i9);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
					]),
				_Utils_ap(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[$author$project$Utils$Styles$listHeadingStyle]),
							_List_fromArray(
								[
									$elm$html$Html$text(group.jC)
								]))
						]),
					A4(
						$author$project$Components$CommonElements$sliderInputElement,
						{
							af: 'Präferenz (1 = Nein, 10 = Unbedingt)',
							kK: 10,
							kT: 1,
							l6: 1,
							fa: curBid,
							pi: $elm$core$String$fromInt(curBid)
						},
						group.ki,
						model.hf,
						$author$project$Components$Groups$BiddingView$SetBid)));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Components$Groups$BiddingView$view = F2(
	function (sharedState, model) {
		var groupChunks = A2(
			$author$project$Utils$Utils$split,
			2,
			$elm$core$Dict$values(model.R));
		return $author$project$Components$CommonElements$rContainer(
			A2(
				$elm$core$List$map,
				function (gbmsChunk) {
					_v0$3:
					while (true) {
						if (gbmsChunk.b) {
							if (gbmsChunk.b.b) {
								if (gbmsChunk.b.b.b) {
									if (!gbmsChunk.b.b.b.b) {
										var c1 = gbmsChunk.a;
										var _v1 = gbmsChunk.b;
										var c2 = _v1.a;
										var _v2 = _v1.b;
										var c3 = _v2.a;
										return $author$project$Components$CommonElements$rRow(
											A3(
												$author$project$Components$CommonElements$r3Column,
												_List_fromArray(
													[
														A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c1)
													]),
												_List_fromArray(
													[
														A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c2)
													]),
												_List_fromArray(
													[
														A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c3)
													])));
									} else {
										break _v0$3;
									}
								} else {
									var c1 = gbmsChunk.a;
									var _v3 = gbmsChunk.b;
									var c2 = _v3.a;
									return $author$project$Components$CommonElements$rRow(
										A2(
											$author$project$Components$CommonElements$r2Column,
											_List_fromArray(
												[
													A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c1)
												]),
											_List_fromArray(
												[
													A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c2)
												])));
								}
							} else {
								var c1 = gbmsChunk.a;
								return $author$project$Components$CommonElements$rRow(
									A2(
										$author$project$Components$CommonElements$r2Column,
										_List_fromArray(
											[
												A3($author$project$Components$Groups$BiddingView$viewGroupBid, sharedState, model, c1)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
													]),
												_List_Nil)
											])));
							}
						} else {
							break _v0$3;
						}
					}
					return $elm$html$Html$text('');
				},
				groupChunks));
	});
var $author$project$Components$Groups$GroupView$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$UserAvatarEmailView$initFromUser = function (user) {
	return _Utils_Tuple2(
		{
			i3: function () {
				var _v0 = user.i3;
				if (!_v0.$) {
					var avatarUrl = _v0.a;
					return avatarUrl;
				} else {
					return 'images/defaultAvatar.png';
				}
			}(),
			jM: user.jM,
			hi: user.j_,
			ki: user.ki,
			hD: user.kB
		},
		$elm$core$Platform$Cmd$none);
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $justgage$tachyons_elm$Tachyons$Classes$b__black_10 = 'b--black-10';
var $justgage$tachyons_elm$Tachyons$Classes$flex_auto = 'flex-auto';
var $justgage$tachyons_elm$Tachyons$Classes$h2 = 'h2';
var $elm$html$Html$img = _VirtualDom_node('img');
var $justgage$tachyons_elm$Tachyons$Classes$mh0 = 'mh0';
var $justgage$tachyons_elm$Tachyons$Classes$mv0 = 'mv0';
var $justgage$tachyons_elm$Tachyons$Classes$ph0_l = 'ph0-l';
var $justgage$tachyons_elm$Tachyons$Classes$pl2 = 'pl2';
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $justgage$tachyons_elm$Tachyons$Classes$tl = 'tl';
var $justgage$tachyons_elm$Tachyons$Classes$w2 = 'w2';
var $justgage$tachyons_elm$Tachyons$Classes$w3_ns = 'w3-ns';
var $author$project$Components$UserAvatarEmailView$view = F3(
	function (sharedState, model, maybeMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ph0_l]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(model.i3),
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$b__black_10, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$w3_ns, $justgage$tachyons_elm$Tachyons$Classes$w2]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$flex_auto, $justgage$tachyons_elm$Tachyons$Classes$pl2]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$author$project$Utils$Styles$listHeadingStyle,
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(model.hi + (' ' + model.hD))
								])),
							A2(
							$elm$html$Html$button,
							_Utils_ap(
								_List_fromArray(
									[
										$author$project$Utils$Styles$linkGreyStyle,
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$mh0]))
									]),
								A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									A2(
										$elm$core$Maybe$map,
										function (msg) {
											return _List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													msg(model.ki))
												]);
										},
										maybeMsg))),
							_List_fromArray(
								[
									$elm$html$Html$text(model.jM)
								]))
						]))
				]));
	});
var $author$project$Components$Groups$GroupView$UpdateStudentFilter = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Internal$Options$Class = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$cs = function (c) {
	return $author$project$Internal$Options$Class(c);
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Internal$Dispatch$flatten = function (decoders) {
	var tryMergeStep = F3(
		function (value, decoder, result) {
			return A2(
				$elm$core$Maybe$withDefault,
				result,
				A2(
					$elm$core$Maybe$map,
					function (_v0) {
						var message = _v0.kS;
						var stopPropagation = _v0.l7;
						var preventDefault = _v0.lh;
						return {
							kS: A2($elm$core$List$cons, message, result.kS),
							lh: preventDefault || result.lh,
							l7: stopPropagation || result.l7
						};
					},
					$elm$core$Result$toMaybe(
						A2($elm$json$Json$Decode$decodeValue, decoder, value))));
		});
	var tryMerge = function (value) {
		return A3(
			$elm$core$List$foldl,
			tryMergeStep(value),
			{kS: _List_Nil, lh: false, l7: false},
			decoders);
	};
	return A2($elm$json$Json$Decode$map, tryMerge, $elm$json$Json$Decode$value);
};
var $author$project$Internal$Dispatch$toAttributes = function (_v0) {
	var config = _v0;
	var _v1 = config.hM;
	if (!_v1.$) {
		var lift = _v1.a;
		return A2(
			$elm$core$List$map,
			function (_v3) {
				var event = _v3.a;
				var flatDecoder = _v3.b;
				return A2(
					$elm$html$Html$Events$custom,
					event,
					lift(flatDecoder));
			},
			$elm$core$Dict$toList(
				A2(
					$elm$core$Dict$map,
					function (_v2) {
						return $author$project$Internal$Dispatch$flatten;
					},
					config.bu)));
	} else {
		return A2(
			$elm$core$List$concatMap,
			function (_v4) {
				var event = _v4.a;
				var decoders = _v4.b;
				return A2(
					$elm$core$List$map,
					$elm$html$Html$Events$custom(event),
					decoders);
			},
			$elm$core$Dict$toList(config.bu));
	}
};
var $author$project$Internal$Options$addAttributes = F2(
	function (summary, attrs) {
		var styleText = A2(
			$elm$core$String$join,
			'; ',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var key = _v0.a;
					var value = _v0.b;
					return A2(
						$elm$core$String$join,
						': ',
						_List_fromArray(
							[key, value]));
				},
				summary.b$));
		var style = (styleText !== '') ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'style', styleText)
			]) : _List_Nil;
		var all = _Utils_ap(
			summary.bT,
			_Utils_ap(
				style,
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$html$Html$Attributes$class,
						$elm$core$List$reverse(summary.bW)),
					_Utils_ap(
						attrs,
						_Utils_ap(
							summary.b7,
							$author$project$Internal$Dispatch$toAttributes(summary._))))));
		return all;
	});
var $author$project$Internal$Options$Summary = F6(
	function (classes, css, attrs, internal, dispatch, config) {
		return {bT: attrs, bW: classes, jr: config, b$: css, _: dispatch, b7: internal};
	});
var $author$project$Internal$Dispatch$Config = $elm$core$Basics$identity;
var $author$project$Internal$Dispatch$add = F3(
	function (event, decoder, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{
				bu: A3(
					$elm$core$Dict$update,
					event,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							$elm$core$List$cons(decoder)),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Maybe$withDefault(
								_List_fromArray(
									[decoder])),
							$elm$core$Maybe$Just)),
					config.bu)
			});
	});
var $author$project$Internal$Dispatch$setLift = F2(
	function (lift, _v0) {
		var decoders = _v0.bu;
		return {
			bu: decoders,
			hM: $elm$core$Maybe$Just(lift)
		};
	});
var $author$project$Internal$Options$collect1_ = F2(
	function (options, acc) {
		switch (options.$) {
			case 0:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						bW: A2($elm$core$List$cons, x, acc.bW)
					});
			case 1:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						b$: A2($elm$core$List$cons, x, acc.b$)
					});
			case 2:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						bT: A2($elm$core$List$cons, x, acc.bT)
					});
			case 3:
				var x = options.a;
				return _Utils_update(
					acc,
					{
						b7: A2($elm$core$List$cons, x, acc.b7)
					});
			case 6:
				var event = options.a;
				var decoder = options.b;
				return _Utils_update(
					acc,
					{
						_: A3($author$project$Internal$Dispatch$add, event, decoder, acc._)
					});
			case 4:
				var opts = options.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1_, acc, opts);
			case 7:
				var lift = options.a;
				return _Utils_update(
					acc,
					{
						_: A2($author$project$Internal$Dispatch$setLift, lift, acc._)
					});
			case 5:
				return acc;
			default:
				return acc;
		}
	});
var $author$project$Internal$Dispatch$defaultConfig = {bu: $elm$core$Dict$empty, hM: $elm$core$Maybe$Nothing};
var $author$project$Internal$Options$collect_ = A2(
	$elm$core$List$foldl,
	$author$project$Internal$Options$collect1_,
	A6($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig, 0));
var $author$project$Internal$Options$styled = F2(
	function (ctor, props) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				$author$project$Internal$Options$collect_(props),
				_List_Nil));
	});
var $author$project$Internal$TextField$HelperLine$Implementation$helperLine = F2(
	function (options, list) {
		return A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$cs('mdc-text-field-helper-line'),
				options),
			list);
	});
var $author$project$Material$TextField$HelperLine$helperLine = $author$project$Internal$TextField$HelperLine$Implementation$helperLine;
var $author$project$Internal$Options$collect1 = F2(
	function (opt, acc) {
		switch (opt.$) {
			case 0:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						bW: A2($elm$core$List$cons, x, acc.bW)
					});
			case 1:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						b$: A2($elm$core$List$cons, x, acc.b$)
					});
			case 2:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						bT: A2($elm$core$List$cons, x, acc.bT)
					});
			case 3:
				var x = opt.a;
				return _Utils_update(
					acc,
					{
						b7: A2($elm$core$List$cons, x, acc.b7)
					});
			case 4:
				var opts = opt.a;
				return A3($elm$core$List$foldl, $author$project$Internal$Options$collect1, acc, opts);
			case 5:
				var g = opt.a;
				return _Utils_update(
					acc,
					{
						jr: g(acc.jr)
					});
			case 6:
				var event = opt.a;
				var decoder = opt.b;
				return _Utils_update(
					acc,
					{
						_: A3($author$project$Internal$Dispatch$add, event, decoder, acc._)
					});
			case 7:
				var lift = opt.a;
				return _Utils_update(
					acc,
					{
						_: A2($author$project$Internal$Dispatch$setLift, lift, acc._)
					});
			default:
				return acc;
		}
	});
var $author$project$Internal$Options$recollect = $elm$core$List$foldl($author$project$Internal$Options$collect1);
var $author$project$Internal$Options$apply = F4(
	function (summary, ctor, options, attrs) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				A2($author$project$Internal$Options$recollect, summary, options),
				attrs));
	});
var $author$project$Internal$Options$Attribute = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Options$aria = F2(
	function (key, val) {
		return $author$project$Internal$Options$Attribute(
			A2($elm$html$Html$Attributes$attribute, 'aria-' + key, val));
	});
var $author$project$Internal$Options$collect = A2(
	$elm$core$Basics$composeR,
	A5($author$project$Internal$Options$Summary, _List_Nil, _List_Nil, _List_Nil, _List_Nil, $author$project$Internal$Dispatch$defaultConfig),
	$author$project$Internal$Options$recollect);
var $author$project$Internal$TextField$HelperText$Implementation$defaultConfig = {gf: false, gN: false};
var $author$project$Internal$Options$None = {$: 8};
var $author$project$Internal$Options$nop = $author$project$Internal$Options$None;
var $author$project$Internal$Options$when = F2(
	function (guard, prop) {
		return guard ? prop : $author$project$Internal$Options$nop;
	});
var $author$project$Internal$TextField$HelperText$Implementation$helperText = F2(
	function (options, text) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TextField$HelperText$Implementation$defaultConfig, options);
		var config = summary.jr;
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-text-field-helper-text'),
					A2(
					$author$project$Internal$Options$when,
					config.gf,
					$author$project$Internal$Options$cs('mdc-text-field-helper-text--persistent')),
					A2(
					$author$project$Internal$Options$when,
					config.gN,
					$author$project$Internal$Options$cs('mdc-text-field-helper-text--validation-msg')),
					A2($author$project$Internal$Options$aria, 'hidden', 'true')
				]),
			_List_Nil,
			text);
	});
var $author$project$Material$TextField$HelperText$helperText = $author$project$Internal$TextField$HelperText$Implementation$helperText;
var $author$project$Internal$Options$Set = function (a) {
	return {$: 5, a: a};
};
var $author$project$Internal$Options$option = $author$project$Internal$Options$Set;
var $author$project$Internal$TextField$Implementation$label = A2(
	$elm$core$Basics$composeL,
	$author$project$Internal$Options$option,
	F2(
		function (str, config) {
			return _Utils_update(
				config,
				{
					fR: $elm$core$Maybe$Just(str)
				});
		}));
var $author$project$Material$TextField$label = $author$project$Internal$TextField$Implementation$label;
var $author$project$Internal$Options$Listener = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Internal$Options$on = F2(
	function (event, decodeMessage) {
		return A2(
			$author$project$Internal$Options$Listener,
			event,
			A2(
				$elm$json$Json$Decode$map,
				function (message) {
					return {kS: message, lh: false, l7: false};
				},
				decodeMessage));
	});
var $author$project$Internal$Options$onChange = function (f) {
	return A2(
		$author$project$Internal$Options$on,
		'change',
		A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
};
var $author$project$Material$Options$onChange = $author$project$Internal$Options$onChange;
var $author$project$Internal$Options$onInput = function (f) {
	return A2(
		$author$project$Internal$Options$on,
		'input',
		A2($elm$json$Json$Decode$map, f, $elm$html$Html$Events$targetValue));
};
var $author$project$Material$Options$onInput = $author$project$Internal$Options$onInput;
var $author$project$Internal$TextField$HelperText$Implementation$persistent = $author$project$Internal$Options$option(
	function (config) {
		return _Utils_update(
			config,
			{gf: true});
	});
var $author$project$Material$TextField$HelperText$persistent = $author$project$Internal$TextField$HelperText$Implementation$persistent;
var $elm$core$List$sortWith = _List_sortWith;
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $author$project$Material$Options$cs = $author$project$Internal$Options$cs;
var $author$project$Internal$Options$CSS = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$Options$css = F2(
	function (key, value) {
		return $author$project$Internal$Options$CSS(
			_Utils_Tuple2(key, value));
	});
var $author$project$Material$Options$css = $author$project$Internal$Options$css;
var $author$project$Material$Options$styled = $author$project$Internal$Options$styled;
var $author$project$Components$Groups$GroupView$textFieldContainer = function (options) {
	return A2(
		$author$project$Material$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Material$Options$cs('text-field-container'),
			A2(
				$elm$core$List$cons,
				A2($author$project$Material$Options$css, 'min-width', '200px'),
				options)));
};
var $author$project$Components$Groups$GroupView$textFieldRow = function (options) {
	return A2(
		$author$project$Material$Options$styled,
		$elm$html$Html$div,
		A2(
			$elm$core$List$cons,
			$author$project$Material$Options$cs('text-field-row'),
			A2(
				$elm$core$List$cons,
				A2($author$project$Material$Options$css, 'display', 'flex'),
				A2(
					$elm$core$List$cons,
					A2($author$project$Material$Options$css, 'align-items', 'flex-start'),
					A2(
						$elm$core$List$cons,
						A2($author$project$Material$Options$css, 'justify-content', 'space-between'),
						A2(
							$elm$core$List$cons,
							A2($author$project$Material$Options$css, 'flex-wrap', 'wrap'),
							options))))));
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$Internal$Options$internalId = function (id_) {
	return $author$project$Internal$Options$option(
		function (config) {
			return _Utils_update(
				config,
				{hp: id_});
		});
};
var $author$project$Internal$Msg$Dispatch = function (a) {
	return {$: 0, a: a};
};
var $author$project$Internal$Options$Lift = function (a) {
	return {$: 7, a: a};
};
var $author$project$Internal$Options$dispatch = function (lift) {
	return $author$project$Internal$Options$Lift(
		$elm$json$Json$Decode$map(
			function (_v0) {
				var message = _v0.kS;
				var stopPropagation = _v0.l7;
				var preventDefault = _v0.lh;
				return {
					kS: lift(
						$author$project$Internal$Msg$Dispatch(message)),
					lh: preventDefault,
					l7: stopPropagation
				};
			}));
};
var $author$project$Internal$Component$render = F3(
	function (get_model, view, ctor) {
		return F4(
			function (lift, idx, store, options) {
				return A3(
					view,
					A2(
						$elm$core$Basics$composeL,
						lift,
						ctor(idx)),
					A2(get_model, idx, store),
					A2(
						$elm$core$List$cons,
						$author$project$Internal$Options$dispatch(lift),
						options));
			});
	});
var $author$project$Internal$TextField$Model$Blur = {$: 0};
var $author$project$Internal$TextField$Model$Focus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Internal$TextField$Model$Input = function (a) {
	return {$: 2, a: a};
};
var $author$project$Internal$Dispatch$clear = function (_v0) {
	var config = _v0;
	return _Utils_update(
		config,
		{bu: $elm$core$Dict$empty});
};
var $author$project$Internal$Options$applyNativeControl = F3(
	function (summary, ctor, options) {
		return ctor(
			A2(
				$author$project$Internal$Options$addAttributes,
				A2(
					$author$project$Internal$Options$recollect,
					{
						bT: _List_Nil,
						bW: _List_Nil,
						jr: 0,
						b$: _List_Nil,
						_: $author$project$Internal$Dispatch$clear(summary._),
						b7: _List_Nil
					},
					_Utils_ap(summary.jr.k_, options)),
				_List_Nil));
	});
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $author$project$Internal$Options$attribute = A2(
	$elm$core$Basics$composeL,
	$author$project$Internal$Options$Attribute,
	$elm$html$Html$Attributes$map($elm$core$Basics$never));
var $elm$html$Html$Attributes$cols = function (n) {
	return A2(
		_VirtualDom_attribute,
		'cols',
		$elm$core$String$fromInt(n));
};
var $author$project$Internal$TextField$Model$Geometry = F3(
	function (width, height, labelWidth) {
		return {o: height, ky: labelWidth, mO: width};
	});
var $debois$elm_dom$DOM$childNode = function (idx) {
	return $elm$json$Json$Decode$at(
		_List_fromArray(
			[
				'childNodes',
				$elm$core$String$fromInt(idx)
			]));
};
var $elm$json$Json$Decode$map3 = _Json_map3;
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Internal$TextField$Implementation$decodeGeometry = $debois$elm_dom$DOM$target(
	$debois$elm_dom$DOM$parentElement(
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Internal$TextField$Model$Geometry,
			A2($debois$elm_dom$DOM$childNode, 2, $debois$elm_dom$DOM$offsetWidth),
			A2($debois$elm_dom$DOM$childNode, 2, $debois$elm_dom$DOM$offsetHeight),
			A2($debois$elm_dom$DOM$childNode, 1, $debois$elm_dom$DOM$offsetWidth))));
var $author$project$Internal$TextField$Implementation$defaultConfig = {
	dV: $elm$core$Maybe$Nothing,
	jB: $elm$core$Maybe$Nothing,
	cH: false,
	eb: false,
	hp: '',
	fN: false,
	kx: false,
	fR: $elm$core$Maybe$Nothing,
	fT: $elm$core$Maybe$Nothing,
	k_: _List_Nil,
	f5: $elm$core$Maybe$Nothing,
	f6: $elm$core$Maybe$Nothing,
	de: false,
	dh: $elm$core$Maybe$Nothing,
	eD: $elm$core$Maybe$Nothing,
	gm: false,
	ox: $elm$core$Maybe$Nothing,
	V: false,
	gI: $elm$core$Maybe$Nothing,
	pb: $elm$core$Maybe$Just('text'),
	fa: $elm$core$Maybe$Nothing
};
var $author$project$Internal$TextField$Model$defaultGeometry = {o: 0, ky: 0, mO: 0};
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Internal$Options$for = A2($elm$core$Basics$composeL, $author$project$Internal$Options$Attribute, $elm$html$Html$Attributes$for);
var $author$project$Internal$Options$onClick = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Internal$Options$role = function (value) {
	return $author$project$Internal$Options$Attribute(
		A2($elm$html$Html$Attributes$attribute, 'role', value));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Internal$Options$tabindex = function (value) {
	return $author$project$Internal$Options$Attribute(
		$elm$html$Html$Attributes$tabindex(value));
};
var $author$project$Internal$TextField$Implementation$iconView = F3(
	function (lift, icon, handler) {
		if (!icon.$) {
			var name = icon.a;
			return A3(
				$author$project$Internal$Options$styled,
				$elm$html$Html$i,
				_List_fromArray(
					[
						$author$project$Internal$Options$cs('material-icons mdc-text-field__icon'),
						A2(
						$author$project$Internal$Options$when,
						!_Utils_eq(handler, $elm$core$Maybe$Nothing),
						$author$project$Internal$Options$tabindex(0)),
						A2(
						$author$project$Internal$Options$when,
						!_Utils_eq(handler, $elm$core$Maybe$Nothing),
						$author$project$Internal$Options$role('button')),
						A2(
						$elm$core$Maybe$withDefault,
						$author$project$Internal$Options$nop,
						A2($elm$core$Maybe$map, $author$project$Internal$Options$onClick, handler))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $author$project$Internal$Options$id = A2($elm$core$Basics$composeL, $author$project$Internal$Options$Attribute, $elm$html$Html$Attributes$id);
var $author$project$Internal$Options$Many = function (a) {
	return {$: 4, a: a};
};
var $author$project$Internal$Options$many = $author$project$Internal$Options$Many;
var $author$project$Internal$Options$onBlur = function (msg) {
	return A2(
		$author$project$Internal$Options$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $elm$html$Html$Attributes$rows = function (n) {
	return A2(
		_VirtualDom_attribute,
		'rows',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Internal$TextField$Implementation$textField = F5(
	function (domId, lift, model, options, list) {
		var summary = A2($author$project$Internal$Options$collect, $author$project$Internal$TextField$Implementation$defaultConfig, options);
		var config = summary.jr;
		var focused = model.fE && (!config.cH);
		var isDirty = model.kr || A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$neq(''),
				config.fa));
		var htmlLabel = A3(
			$author$project$Internal$Options$styled,
			$elm$html$Html$label,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-floating-label'),
					A2(
					$author$project$Internal$Options$when,
					focused || isDirty,
					$author$project$Internal$Options$cs('mdc-floating-label--float-above')),
					$author$project$Internal$Options$for(config.hp)
				]),
			function () {
				var _v1 = config.fR;
				if (!_v1.$) {
					var str = _v1.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(str)
						]);
				} else {
					return _List_Nil;
				}
			}());
		var isInvalid = config.fN || function () {
			var _v0 = config.dh;
			if (!_v0.$) {
				var pattern_ = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A3(
						$elm$core$Maybe$map2,
						function (regex) {
							return A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								$elm$regex$Regex$contains(regex));
						},
						$elm$regex$Regex$fromString('^' + (pattern_ + '$')),
						model.fa));
			} else {
				return false;
			}
		}();
		var leadingIcon_ = A3($author$project$Internal$TextField$Implementation$iconView, lift, config.fT, config.f5);
		var trailingIcon_ = A3($author$project$Internal$TextField$Implementation$iconView, lift, config.gI, config.f6);
		return A5(
			$author$project$Internal$Options$apply,
			summary,
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$Internal$Options$cs('mdc-text-field'),
					A2(
					$author$project$Internal$Options$when,
					focused,
					$author$project$Internal$Options$cs('mdc-text-field--focused')),
					A2(
					$author$project$Internal$Options$when,
					config.cH,
					$author$project$Internal$Options$cs('mdc-text-field--disabled')),
					A2(
					$author$project$Internal$Options$when,
					config.eb,
					$author$project$Internal$Options$cs('mdc-text-field--fullwidth')),
					A2(
					$author$project$Internal$Options$when,
					isInvalid,
					$author$project$Internal$Options$cs('mdc-text-field--invalid')),
					A2(
					$author$project$Internal$Options$when,
					config.V,
					$author$project$Internal$Options$cs('mdc-text-field--textarea')),
					A2(
					$author$project$Internal$Options$when,
					config.de && (!config.V),
					$author$project$Internal$Options$cs('mdc-text-field--outlined')),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.fT, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('mdc-text-field--with-leading-icon')),
					A2(
					$author$project$Internal$Options$when,
					!_Utils_eq(config.gI, $elm$core$Maybe$Nothing),
					$author$project$Internal$Options$cs('mdc-text-field--with-trailing-icon'))
				]),
			_List_Nil,
			_Utils_ap(
				list,
				_List_fromArray(
					[
						leadingIcon_,
						A4(
						$author$project$Internal$Options$applyNativeControl,
						summary,
						config.V ? $elm$html$Html$textarea : $elm$html$Html$input,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-text-field__input'),
								$author$project$Internal$Options$id(config.hp),
								(config.de && (!config.V)) ? A2(
								$author$project$Internal$Options$on,
								'focus',
								A2(
									$elm$json$Json$Decode$map,
									A2($elm$core$Basics$composeL, lift, $author$project$Internal$TextField$Model$Focus),
									$author$project$Internal$TextField$Implementation$decodeGeometry)) : A2(
								$author$project$Internal$Options$on,
								'focus',
								$elm$json$Json$Decode$succeed(
									lift(
										$author$project$Internal$TextField$Model$Focus($author$project$Internal$TextField$Model$defaultGeometry)))),
								$author$project$Internal$Options$onBlur(
								lift($author$project$Internal$TextField$Model$Blur)),
								$author$project$Internal$Options$onInput(
								A2($elm$core$Basics$composeL, lift, $author$project$Internal$TextField$Model$Input)),
								A3(
								$elm$core$Basics$composeL,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Internal$Options$many,
									$elm$core$List$map($author$project$Internal$Options$attribute)),
								$elm$core$List$filterMap($elm$core$Basics$identity),
								_List_fromArray(
									[
										((!config.V) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$type_(
											A2($elm$core$Maybe$withDefault, 'text', config.pb))),
										(config.cH ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$disabled(true)),
										(config.gm ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										A2(
											$elm$html$Html$Attributes$property,
											'required',
											$elm$json$Json$Encode$bool(true))),
										((!_Utils_eq(config.dh, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										A2(
											$elm$html$Html$Attributes$property,
											'pattern',
											$elm$json$Json$Encode$string(
												A2($elm$core$Maybe$withDefault, '', config.dh)))),
										((!_Utils_eq(config.fa, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just : $elm$core$Basics$always($elm$core$Maybe$Nothing))(
										$elm$html$Html$Attributes$value(
											A2($elm$core$Maybe$withDefault, '', config.fa)))
									])),
								A2(
								$author$project$Internal$Options$when,
								!_Utils_eq(config.eD, $elm$core$Maybe$Nothing),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$placeholder(
										A2($elm$core$Maybe$withDefault, '', config.eD)))),
								A2(
								$author$project$Internal$Options$when,
								config.V && (!_Utils_eq(config.ox, $elm$core$Maybe$Nothing)),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$rows(
										A2($elm$core$Maybe$withDefault, 0, config.ox)))),
								A2(
								$author$project$Internal$Options$when,
								config.V && (!_Utils_eq(config.dV, $elm$core$Maybe$Nothing)),
								$author$project$Internal$Options$attribute(
									$elm$html$Html$Attributes$cols(
										A2($elm$core$Maybe$withDefault, 0, config.dV))))
							]),
						_List_Nil),
						((!config.eb) && ((!config.de) && (!config.V))) ? htmlLabel : $elm$html$Html$text(''),
						trailingIcon_,
						((!config.de) && (!config.V)) ? A3(
						$author$project$Internal$Options$styled,
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-line-ripple'),
								A2(
								$author$project$Internal$Options$when,
								model.fE,
								$author$project$Internal$Options$cs('mdc-line-ripple--active'))
							]),
						_List_Nil) : $elm$html$Html$text(''),
						(config.de || config.V) ? A3(
						$author$project$Internal$Options$styled,
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$Internal$Options$cs('mdc-notched-outline'),
								A2(
								$author$project$Internal$Options$when,
								focused || isDirty,
								$author$project$Internal$Options$cs('mdc-notched-outline--notched'))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__leading')
									]),
								_List_Nil),
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__notch')
									]),
								_List_fromArray(
									[htmlLabel])),
								A3(
								$author$project$Internal$Options$styled,
								$elm$html$Html$div,
								_List_fromArray(
									[
										$author$project$Internal$Options$cs('mdc-notched-outline__trailing')
									]),
								_List_Nil)
							])) : $elm$html$Html$text('')
					])));
	});
var $author$project$Internal$TextField$Implementation$view = F4(
	function (lift, domId, store, options) {
		return A7(
			$author$project$Internal$Component$render,
			$author$project$Internal$TextField$Implementation$getSet.j9,
			$author$project$Internal$TextField$Implementation$textField(domId),
			$author$project$Internal$Msg$TextFieldMsg,
			lift,
			domId,
			store,
			A2(
				$elm$core$List$cons,
				$author$project$Internal$Options$internalId(domId),
				options));
	});
var $author$project$Material$TextField$view = $author$project$Internal$TextField$Implementation$view;
var $author$project$Components$Groups$GroupView$viewStudentSummary = F2(
	function (model, summary) {
		var textField = F2(
			function (index, options) {
				return _List_fromArray(
					[
						A5(
						$author$project$Material$TextField$view,
						$author$project$Components$Groups$GroupView$Mdc,
						index,
						model.kP,
						A2(
							$elm$core$List$cons,
							$author$project$Material$TextField$label('Find Name'),
							options),
						_List_Nil),
						A2(
						$author$project$Material$TextField$HelperLine$helperLine,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$author$project$Material$TextField$HelperText$helperText,
								_List_fromArray(
									[$author$project$Material$TextField$HelperText$persistent]),
								_List_fromArray(
									[
										$elm$html$Html$text('Filter list by name - e.g. \'Alice\'')
									]))
							]))
					]);
			});
		var sheets = summary.oJ;
		var achievements = summary.mT;
		var achievements_sorted = A2(
			$elm$core$List$sortWith,
			F2(
				function (a, b) {
					return A2($elm$core$Basics$compare, a.ph.nT, b.ph.nT);
				}),
			achievements);
		var achievements_filtered = A2(
			$elm$core$List$filter,
			function (a) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toUpper(model.eY),
					$elm$core$String$toUpper(a.ph.ny)) || A2(
					$elm$core$String$contains,
					$elm$core$String$toUpper(model.eY),
					$elm$core$String$toUpper(a.ph.nT));
			},
			achievements_sorted);
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$h2,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Your Students')
					])),
				A2(
				$author$project$Components$Groups$GroupView$textFieldRow,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$Components$Groups$GroupView$textFieldContainer,
						_List_Nil,
						A2(
							textField,
							'text-field-student-overview-filter',
							_List_fromArray(
								[
									$author$project$Material$Options$onChange($author$project$Components$Groups$GroupView$UpdateStudentFilter),
									$author$project$Material$Options$onInput($author$project$Components$Groups$GroupView$UpdateStudentFilter)
								])))
					])),
				A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('striped'),
						$elm$html$Html$Attributes$class('overview-table')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$thead,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$tr,
								_List_fromArray(
									[$author$project$Utils$Styles$textStyle]),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('student-overview-head-horizontal')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Student')
																]))
														]))
												]))
										]),
									A2(
										$elm$core$List$map,
										function (sheet) {
											return A2(
												$elm$html$Html$th,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('student-overview-head-vertical')
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_Nil,
																_List_fromArray(
																	[
																		$elm$html$Html$text(sheet.kY)
																	]))
															]))
													]));
										},
										sheets)))
							])),
						A2(
						$elm$html$Html$tbody,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (achievement) {
								return A2(
									$elm$html$Html$tr,
									_List_fromArray(
										[$author$project$Utils$Styles$textStyle]),
									_Utils_ap(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(achievement.ph.ny + (' ' + achievement.ph.nT)),
														A2(
														$elm$html$Html$br,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('')
															])),
														A2(
														$elm$html$Html$small,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(achievement.ph.jM)
															]))
													]))
											]),
										A2(
											$elm$core$List$map,
											function (point) {
												return A2(
													$elm$html$Html$td,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(
															$elm$core$String$fromInt(point))
														]));
											},
											achievement.oo)));
							},
							achievements_filtered))
					]))
			]);
	});
var $author$project$Components$Groups$GroupView$view = F2(
	function (sharedState, model) {
		var _v0 = _Utils_Tuple2(model.lJ, model.nD);
		if ((!_v0.a) && (!_v0.b.$)) {
			var _v1 = _v0.a;
			var group = _v0.b.a;
			return $author$project$Components$CommonElements$rContainer(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							_List_fromArray(
								[
									$author$project$Components$CommonElements$rContainer(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[$author$project$Utils$Styles$labelStyle]),
											_List_fromArray(
												[
													$elm$html$Html$text('Tutor')
												])),
											A3(
											$author$project$Components$UserAvatarEmailView$view,
											sharedState,
											$author$project$Components$UserAvatarEmailView$initFromUser(group.mB).a,
											$elm$core$Maybe$Nothing)
										]))
								]),
							_List_fromArray(
								[
									$author$project$Components$CommonElements$rContainer(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[$author$project$Utils$Styles$labelStyle]),
											_List_fromArray(
												[
													$elm$html$Html$text('Gruppeninfo')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[$author$project$Utils$Styles$textStyle]),
											_List_fromArray(
												[
													$elm$html$Html$text(group.jC)
												]))
										]))
								])))
					]));
		} else {
			return $author$project$Components$CommonElements$rContainer(
				A2(
					$elm$core$List$map,
					function (group) {
						return $author$project$Components$CommonElements$rContainer(
							_List_fromArray(
								[
									$author$project$Components$CommonElements$rRow(
									A2(
										$author$project$Components$CommonElements$r2Column,
										_List_fromArray(
											[
												$author$project$Components$CommonElements$rContainer(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h3,
														_List_fromArray(
															[$author$project$Utils$Styles$labelStyle]),
														_List_fromArray(
															[
																$elm$html$Html$text('Tutor')
															])),
														A3(
														$author$project$Components$UserAvatarEmailView$view,
														sharedState,
														$author$project$Components$UserAvatarEmailView$initFromUser(group.mB).a,
														$elm$core$Maybe$Nothing)
													]))
											]),
										_List_fromArray(
											[
												$author$project$Components$CommonElements$rContainer(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h3,
														_List_fromArray(
															[$author$project$Utils$Styles$labelStyle]),
														_List_fromArray(
															[
																$elm$html$Html$text('Gruppeninfo')
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[$author$project$Utils$Styles$textStyle]),
														_List_fromArray(
															[
																$elm$html$Html$text(group.jC)
															]))
													]))
											]))),
									$author$project$Components$CommonElements$rContainer(
									function () {
										var maybeSummary = A2($elm$core$Dict$get, group.ki, model.gy);
										if (maybeSummary.$ === 1) {
											return _List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_fromArray(
														[$author$project$Utils$Styles$labelStyle]),
													_List_fromArray(
														[
															$elm$html$Html$text('Your Students')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[$author$project$Utils$Styles$textStyle]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															'No overview availiable in' + (' group ' + ($elm$core$String$fromInt(group.ki) + (' -  Number of Summaries availiable: ' + $elm$core$String$fromInt(
																$elm$core$List$length(
																	$elm$core$Dict$keys(model.gy)))))))
														]))
												]);
										} else {
											var summary = maybeSummary.a;
											return A2($author$project$Components$Groups$GroupView$viewStudentSummary, model, summary);
										}
									}()),
									$author$project$Components$CommonElements$rRowButton(
									$author$project$Components$CommonElements$PbbButton(
										A2(
											$author$project$Components$CommonElements$PbbActive,
											'Send E-Mail To Group',
											$author$project$Components$Groups$GroupView$NavigateTo(
												A2($author$project$Routing$Helpers$MailToGroupRoute, model.ju, group.ki)))))
								]));
					},
					model.h2));
		}
	});
var $author$project$Pages$CourseDetail$viewDetermineGroupDisplay = F3(
	function (courseRole, sharedState, model) {
		var _v0 = model.aO;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var biddingModel = _v0.a.a;
					return $author$project$Components$CommonElements$rContainer(
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rRowHeader('Teilnahme an Tutorien'),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$CourseDetail$GroupMsg,
								A2(
									$elm$html$Html$map,
									$author$project$Pages$CourseDetail$BiddingMsg,
									A2($author$project$Components$Groups$BiddingView$view, sharedState, biddingModel)))
							]));
				case 1:
					var detailModel = _v0.a.a;
					return $author$project$Components$CommonElements$rContainer(
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rRowHeader('Übungsgruppe'),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$CourseDetail$GroupMsg,
								A2(
									$elm$html$Html$map,
									$author$project$Pages$CourseDetail$DetailMsg,
									A2($author$project$Components$Groups$GroupView$view, sharedState, detailModel)))
							]));
				default:
					var adminModel = _v0.a.a;
					return $author$project$Components$CommonElements$rContainer(
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rRowHeader('Übungsgruppen'),
								A2(
								$elm$html$Html$map,
								$author$project$Pages$CourseDetail$GroupMsg,
								A2(
									$elm$html$Html$map,
									$author$project$Pages$CourseDetail$GroupAdminMsg,
									A2($author$project$Components$Groups$AdminView$view, sharedState, adminModel)))
							]));
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$CourseDetail$EnrollmentSearchField = {$: 0};
var $author$project$Pages$CourseDetail$SetField = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $justgage$tachyons_elm$Tachyons$Classes$h3 = 'h3';
var $justgage$tachyons_elm$Tachyons$Classes$ml2 = 'ml2';
var $justgage$tachyons_elm$Tachyons$Classes$mt3_ns = 'mt3-ns';
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $justgage$tachyons_elm$Tachyons$Classes$pa1 = 'pa1';
var $justgage$tachyons_elm$Tachyons$Classes$w_90 = 'w-90';
var $author$project$Components$CommonElements$searchElement = F4(
	function (inputConfig, field, inputMsg, clickMsg) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$h3, $justgage$tachyons_elm$Tachyons$Classes$mt3_ns, $justgage$tachyons_elm$Tachyons$Classes$mt0, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$author$project$Utils$Styles$lineInputStyle,
								$elm$html$Html$Attributes$type_(inputConfig.jY),
								$elm$html$Html$Attributes$placeholder(inputConfig.eD),
								$elm$html$Html$Events$onInput(
								inputMsg(field)),
								$elm_community$html_extra$Html$Events$Extra$onEnter(clickMsg),
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$measure, $justgage$tachyons_elm$Tachyons$Classes$w_90]))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('image'),
								$elm$html$Html$Attributes$src('images/magnify.svg'),
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$ml2, $justgage$tachyons_elm$Tachyons$Classes$w2, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$pa1, $justgage$tachyons_elm$Tachyons$Classes$dim])),
								$elm$html$Html$Events$onClick(clickMsg)
							]),
						_List_Nil)
					]))
			]);
	});
var $author$project$Pages$CourseDetail$ChangeEnrollment = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$CourseDetail$WriteEmailMsg = function (a) {
	return {$: 23, a: a};
};
var $justgage$tachyons_elm$Tachyons$Classes$flex_wrap = 'flex-wrap';
var $justgage$tachyons_elm$Tachyons$Classes$ml4_l = 'ml4-l';
var $justgage$tachyons_elm$Tachyons$Classes$mt0_l = 'mt0-l';
var $justgage$tachyons_elm$Tachyons$Classes$mt2 = 'mt2';
var $author$project$Components$CommonElements$multiButton = function (actions) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (_v0) {
				var label = _v0.a;
				var active = _v0.b;
				var msg = _v0.c;
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							active ? $author$project$Utils$Styles$buttonSuccessStyle : $author$project$Utils$Styles$buttonGreyStyle,
							$elm$html$Html$Events$onClick(msg),
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$mh0]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]));
			},
			actions));
};
var $justgage$tachyons_elm$Tachyons$Classes$ph5_l = 'ph5-l';
var $author$project$Pages$CourseDetail$viewUserSearchResult = F3(
	function (sharedState, model, maybeUserEnrollment) {
		if (!maybeUserEnrollment.$) {
			var userEnrollment = maybeUserEnrollment.a;
			var user = userEnrollment.mE;
			var avatar = function () {
				var _v1 = user.i3;
				if (!_v1.$) {
					var avatarUrl = _v1.a;
					return avatarUrl;
				} else {
					return 'images/defaultAvatar.png';
				}
			}();
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ph5_l]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						$author$project$Pages$CourseDetail$WriteEmailMsg,
						A3(
							$author$project$Components$UserAvatarEmailView$view,
							sharedState,
							$author$project$Components$UserAvatarEmailView$initFromUser(user).a,
							$elm$core$Maybe$Nothing)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$ml4_l, $justgage$tachyons_elm$Tachyons$Classes$ml0, $justgage$tachyons_elm$Tachyons$Classes$mt0_l, $justgage$tachyons_elm$Tachyons$Classes$mt2, $justgage$tachyons_elm$Tachyons$Classes$flex]))
							]),
						_List_fromArray(
							[
								$author$project$Components$CommonElements$multiButton(
								_List_fromArray(
									[
										_Utils_Tuple3(
										'Student',
										!userEnrollment.lJ,
										$author$project$Pages$CourseDetail$ChangeEnrollment(
											_Utils_update(
												userEnrollment,
												{lJ: 0}))),
										_Utils_Tuple3(
										'Tutor',
										userEnrollment.lJ === 1,
										$author$project$Pages$CourseDetail$ChangeEnrollment(
											_Utils_update(
												userEnrollment,
												{lJ: 1}))),
										_Utils_Tuple3(
										'Admin',
										userEnrollment.lJ === 2,
										$author$project$Pages$CourseDetail$ChangeEnrollment(
											_Utils_update(
												userEnrollment,
												{lJ: 2})))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$h2,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph5_ns])),
						$author$project$Utils$Styles$listHeadingStyle
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Not found')
					]));
		}
	});
var $author$project$Pages$CourseDetail$viewMemberSearch = F2(
	function (sharedState, model) {
		var displaySearchResults = function () {
			var _v0 = model.eP;
			if (_v0.$ === 3) {
				var userEnrollment = _v0.a;
				return A3(
					$author$project$Pages$CourseDetail$viewUserSearchResult,
					sharedState,
					model,
					$elm$core$List$head(userEnrollment));
			} else {
				return $elm$html$Html$text('');
			}
		}();
		return $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRow(
					A2(
						$author$project$Components$CommonElements$r2Column,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_fromArray(
									[$author$project$Utils$Styles$headerStyle]),
								_List_fromArray(
									[
										$elm$html$Html$text('Change role')
									]))
							]),
						A4(
							$author$project$Components$CommonElements$searchElement,
							{jY: 'email', eD: 'Search by E-Mail', fa: model.eO},
							$author$project$Pages$CourseDetail$EnrollmentSearchField,
							$author$project$Pages$CourseDetail$SetField,
							$author$project$Pages$CourseDetail$SearchUserForEnrollment))),
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[displaySearchResults]))
				]));
	});
var $author$project$Pages$CourseDetail$WriteTo = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$CourseDetail$compareRoleName = F2(
	function (userA, userB) {
		var _v0 = _Utils_Tuple2(userA.lJ, userB.lJ);
		_v0$6:
		while (true) {
			switch (_v0.a) {
				case 2:
					switch (_v0.b) {
						case 2:
							var _v1 = _v0.a;
							var _v2 = _v0.b;
							return A2($elm$core$Basics$compare, userA.mE.kB, userB.mE.kB);
						case 1:
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return 0;
						default:
							break _v0$6;
					}
				case 1:
					switch (_v0.b) {
						case 2:
							var _v5 = _v0.a;
							var _v6 = _v0.b;
							return 2;
						case 1:
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return A2($elm$core$Basics$compare, userA.mE.kB, userB.mE.kB);
						default:
							var _v9 = _v0.a;
							return 0;
					}
				default:
					if (_v0.b === 1) {
						var _v10 = _v0.b;
						return 2;
					} else {
						break _v0$6;
					}
			}
		}
		return A2($elm$core$Basics$compare, userA.mE.kB, userB.mE.kB);
	});
var $justgage$tachyons_elm$Tachyons$Classes$flex_row = 'flex-row';
var $justgage$tachyons_elm$Tachyons$Classes$w_third_l = 'w-third-l';
var $author$project$Pages$CourseDetail$viewTeam = F2(
	function (sharedState, model) {
		var _v0 = model.cM;
		if (_v0.$ === 3) {
			var enrollments = _v0.a;
			var sortedTeam = A2($elm$core$List$sortWith, $author$project$Pages$CourseDetail$compareRoleName, enrollments);
			return $author$project$Components$CommonElements$rContainer(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRowHeader('Team'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
							]),
						A2(
							$elm$core$List$map,
							function (uv) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$w_third_l, $justgage$tachyons_elm$Tachyons$Classes$w_50_m, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Components$UserAvatarEmailView$view,
											sharedState,
											uv,
											$elm$core$Maybe$Just($author$project$Pages$CourseDetail$WriteTo))
										]));
							},
							A2(
								$elm$core$List$map,
								$elm$core$Tuple$first,
								A2(
									$elm$core$List$map,
									function (ue) {
										return $author$project$Components$UserAvatarEmailView$initFromUser(ue.mE);
									},
									sortedTeam))))
					]));
		} else {
			return $elm$html$Html$text('Loading');
		}
	});
var $author$project$Pages$CourseDetail$viewDetermineTeamOrSearch = F3(
	function (courseRole, sharedState, model) {
		if (courseRole === 2) {
			return A2($author$project$Pages$CourseDetail$viewMemberSearch, sharedState, model);
		} else {
			return A2($author$project$Pages$CourseDetail$viewTeam, sharedState, model);
		}
	});
var $author$project$Pages$CourseDetail$CreateExam = {$: 37};
var $author$project$Pages$CourseDetail$ExamCreateNew = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$CourseDetail$ExamDate = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamDateMsg = F2(
	function (a, b) {
		return {$: 28, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamDelete = function (a) {
	return {$: 34, a: a};
};
var $author$project$Pages$CourseDetail$ExamDescription = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$CourseDetail$ExamName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$CourseDetail$ExamTime = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamTimeMsg = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Pages$CourseDetail$ExamUpdate = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$CourseDetail$SetExamField = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.mR - 1)) + ($justinmimbs$date$Date$monthToNumber(date.kV) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.jy,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.cz;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			jw: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			g7: date
		};
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.cz;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.fP(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.g$(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.g7;
		var today = _v0.cl;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.fE;
		var today = model.cl;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.fy) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.fy);
		var currentMonth = _v0.g7;
		var currentDates = _v0.jw;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				A2(
					$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
					{g7: currentMonth, cl: today},
					settings.fj)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.n0(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.fj)) ? $elm$html$Html$text(
											settings.iT(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.nc(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.hy));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.cz + 'input', true)
				]),
			settings.hx);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.hz)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.nO,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.eD),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.g8, pickedDate)),
						model.aR))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.cz + 'container', true),
			settings.g3);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.B ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Components$CommonElements$dateInputElement = F4(
	function (inputConfig, field, errors, msg) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$map,
				msg,
				A3($CurrySoftware$elm_datepicker$DatePicker$view, inputConfig.fa, inputConfig.lY, inputConfig.nb)),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $author$project$Components$CommonElements$iconButton = F2(
	function (icon, msg) {
		return A2(
			$elm$html$Html$i,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('material-icons'),
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$mr0, $justgage$tachyons_elm$Tachyons$Classes$ml_auto, $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$black_40, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_black, $justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$hover_near_white, $justgage$tachyons_elm$Tachyons$Classes$pointer])),
					$elm$html$Html$Events$onClick(msg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(icon)
				]));
	});
var $author$project$Components$CommonElements$inputElement = F4(
	function (inputConfig, field, errors, msg) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_(inputConfig.jY),
						$author$project$Utils$Styles$lineInputStyle,
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3])),
						$elm$html$Html$Attributes$placeholder(inputConfig.eD),
						$elm$html$Html$Events$onInput(
						msg(field)),
						$elm$html$Html$Attributes$value(inputConfig.fa)
					]),
				_List_Nil),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $justgage$tachyons_elm$Tachyons$Classes$bg_black_10 = 'bg-black-10';
var $justgage$tachyons_elm$Tachyons$Classes$br3 = 'br3';
var $author$project$Utils$Styles$textAreaReset = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'resize', 'vertical'),
		A2($elm$html$Html$Attributes$style, 'outline', 'none')
	]);
var $author$project$Components$CommonElements$textAreaElement = F4(
	function (inputConfig, field, errors, msg) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$textarea,
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Utils$Styles$lineInputStyle,
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$ph2, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3, $justgage$tachyons_elm$Tachyons$Classes$bg_black_10, $justgage$tachyons_elm$Tachyons$Classes$br3])),
							$elm$html$Html$Attributes$placeholder(inputConfig.eD),
							$elm$html$Html$Events$onInput(
							msg(field)),
							$elm$html$Html$Attributes$value(inputConfig.fa),
							$elm$html$Html$Attributes$rows(inputConfig.ox)
						]),
					$author$project$Utils$Styles$textAreaReset),
				_List_Nil),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $justgage$tachyons_elm$Tachyons$Classes$pt2 = 'pt2';
var $stephenreddek$elm_time_picker$TimePicker$Blur = {$: 2};
var $stephenreddek$elm_time_picker$TimePicker$Clear = {$: 0};
var $stephenreddek$elm_time_picker$TimePicker$Focus = {$: 1};
var $stephenreddek$elm_time_picker$TimePicker$NoOp = {$: 7};
var $stephenreddek$elm_time_picker$TimePicker$SubmitText = function (a) {
	return {$: 9, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$TextChanged = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $stephenreddek$elm_time_picker$TimePicker$cssPrefix = 'elm-time-picker-';
var $stephenreddek$elm_time_picker$TimePicker$paddedFormatter = function (value) {
	return (value < 10) ? ('0' + $elm$core$String$fromInt(value)) : $elm$core$String$fromInt(value);
};
var $stephenreddek$elm_time_picker$TimePicker$hourFormatter = F2(
	function (settings, value) {
		return settings.pf ? $stephenreddek$elm_time_picker$TimePicker$paddedFormatter(value) : ((!value) ? '12' : ((value > 12) ? $elm$core$String$fromInt(value - 12) : $elm$core$String$fromInt(value)));
	});
var $stephenreddek$elm_time_picker$TimePicker$isInAM = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ho;
				},
				function (hours) {
					return hours < 12;
				}),
			value));
};
var $stephenreddek$elm_time_picker$TimePicker$formatValue = F2(
	function (settings, time) {
		var secondsDisplay = settings.oK ? _List_fromArray(
			[
				$stephenreddek$elm_time_picker$TimePicker$paddedFormatter(time.gu)
			]) : _List_Nil;
		var periodDisplay = (settings.ci && (!settings.pf)) ? ($stephenreddek$elm_time_picker$TimePicker$isInAM(
			$elm$core$Maybe$Just(time)) ? ' AM' : ' PM') : '';
		var minutesDisplay = settings.eT ? _List_fromArray(
			[
				$stephenreddek$elm_time_picker$TimePicker$paddedFormatter(time.hS)
			]) : _List_Nil;
		var hoursDisplay = settings.ci ? _List_fromArray(
			[
				A2($stephenreddek$elm_time_picker$TimePicker$hourFormatter, settings, time.ho)
			]) : _List_Nil;
		var timePartsDisplay = A2(
			$elm$core$String$join,
			':',
			$elm$core$List$concat(
				_List_fromArray(
					[hoursDisplay, minutesDisplay, secondsDisplay])));
		return _Utils_ap(timePartsDisplay, periodDisplay);
	});
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $stephenreddek$elm_time_picker$TimePicker$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $stephenreddek$elm_time_picker$TimePicker$onChange = function (handler) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			$stephenreddek$elm_time_picker$TimePicker$alwaysStop,
			A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue)));
};
var $stephenreddek$elm_time_picker$TimePicker$onWithoutLosingFocus = F2(
	function (eventName, msg) {
		return A2(
			$elm$html$Html$Events$custom,
			eventName,
			$elm$json$Json$Decode$succeed(
				{kS: msg, lh: true, l7: true}));
	});
var $stephenreddek$elm_time_picker$TimePicker$SelectHour = function (a) {
	return {$: 3, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$SelectMinute = function (a) {
	return {$: 4, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$SelectPeriod = function (a) {
	return {$: 6, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$SelectSecond = function (a) {
	return {$: 5, a: a};
};
var $stephenreddek$elm_time_picker$TimePicker$dropdownOption = F4(
	function (valueText, isSelected, isDisabled, msg) {
		var optionalClick = (isDisabled || isSelected) ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Events$onClick(msg)
			]);
		return A2(
			$elm$html$Html$li,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('elm-time-picker-panel-select-option-selected', isSelected),
								_Utils_Tuple2('elm-time-picker-panel-select-option-disabled', isDisabled)
							]))
					]),
				optionalClick),
			_List_fromArray(
				[
					$elm$html$Html$text(valueText)
				]));
	});
var $stephenreddek$elm_time_picker$TimePicker$isInPM = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ho;
				},
				function (hours) {
					return hours >= 12;
				}),
			value));
};
var $stephenreddek$elm_time_picker$TimePicker$isInPeriod = F2(
	function (period, model) {
		if (!period) {
			return $stephenreddek$elm_time_picker$TimePicker$isInAM(model.fa);
		} else {
			return $stephenreddek$elm_time_picker$TimePicker$isInPM(model.fa);
		}
	});
var $stephenreddek$elm_time_picker$TimePicker$periodFormatter = function (period) {
	if (!period) {
		return 'AM';
	} else {
		return 'PM';
	}
};
var $stephenreddek$elm_time_picker$TimePicker$viewDropDown = F2(
	function (settings, model) {
		var steppingRange = F3(
			function (step, minVal, maxVal) {
				return A2(
					$elm$core$List$map,
					function (val) {
						return val * step;
					},
					A2($elm$core$List$range, minVal, (maxVal / step) | 0));
			});
		var seconds = A3(steppingRange, settings.gt, 0, 59);
		var roundToStep = F2(
			function (step, val) {
				return ((val / step) | 0) * step;
			});
		var toOption = F6(
			function (formatter, accessor, isDisabledValue, stepSize, toMsg, value) {
				var isSelected = _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							accessor,
							roundToStep(stepSize)),
						model.fa),
					$elm$core$Maybe$Just(value));
				return A4(
					$stephenreddek$elm_time_picker$TimePicker$dropdownOption,
					formatter(value),
					isSelected,
					isDisabledValue(value),
					toMsg(value));
			});
		var secondOptions = settings.oK ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-select')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A5(
								toOption,
								$stephenreddek$elm_time_picker$TimePicker$paddedFormatter,
								function ($) {
									return $.gu;
								},
								settings.em,
								settings.gt,
								$stephenreddek$elm_time_picker$TimePicker$SelectSecond),
							A2(
								$elm$core$List$filter,
								function (second) {
									return (!settings.cW) || (!settings.em(second));
								},
								seconds)))
					]))
			]) : _List_Nil;
		var periodSelectionOption = function (period) {
			return ((!settings.cW) || (!settings.el(period))) ? _List_fromArray(
				[
					A4(
					$stephenreddek$elm_time_picker$TimePicker$dropdownOption,
					$stephenreddek$elm_time_picker$TimePicker$periodFormatter(period),
					A2($stephenreddek$elm_time_picker$TimePicker$isInPeriod, period, model),
					settings.el(period),
					$stephenreddek$elm_time_picker$TimePicker$SelectPeriod(period))
				]) : _List_Nil;
		};
		var periodOptions = ((!settings.pf) && settings.ci) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-select')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						_Utils_ap(
							periodSelectionOption(0),
							periodSelectionOption(1)))
					]))
			]) : _List_Nil;
		var minutes = A3(steppingRange, settings.n_, 0, 59);
		var minuteOptions = settings.eT ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-select')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A5(
								toOption,
								$stephenreddek$elm_time_picker$TimePicker$paddedFormatter,
								function ($) {
									return $.hS;
								},
								settings.ek,
								settings.n_,
								$stephenreddek$elm_time_picker$TimePicker$SelectMinute),
							A2(
								$elm$core$List$filter,
								function (minute) {
									return (!settings.cW) || (!settings.ek(minute));
								},
								minutes)))
					]))
			]) : _List_Nil;
		var hours = settings.pf ? A3(steppingRange, settings.cX, 0, 23) : ($stephenreddek$elm_time_picker$TimePicker$isInPM(model.fa) ? A3(steppingRange, settings.cX, 12, 23) : A3(steppingRange, settings.cX, 0, 11));
		var hourOptions = settings.ci ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-select')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							A5(
								toOption,
								$stephenreddek$elm_time_picker$TimePicker$hourFormatter(settings),
								function ($) {
									return $.ho;
								},
								settings.ej,
								settings.cX,
								$stephenreddek$elm_time_picker$TimePicker$SelectHour),
							A2(
								$elm$core$List$filter,
								function (hour) {
									return (!settings.cW) || (!settings.ej(hour));
								},
								hours)))
					]))
			]) : _List_Nil;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-combobox'),
					A2($stephenreddek$elm_time_picker$TimePicker$onWithoutLosingFocus, 'mousedown', $stephenreddek$elm_time_picker$TimePicker$NoOp),
					A2($stephenreddek$elm_time_picker$TimePicker$onWithoutLosingFocus, 'mouseup', $stephenreddek$elm_time_picker$TimePicker$NoOp)
				]),
			_Utils_ap(
				hourOptions,
				_Utils_ap(
					minuteOptions,
					_Utils_ap(secondOptions, periodOptions))));
	});
var $stephenreddek$elm_time_picker$TimePicker$view = F2(
	function (settings, _v0) {
		var model = _v0;
		var optionsDisplay = (model.B && (!settings.cH)) ? _List_fromArray(
			[
				A2($stephenreddek$elm_time_picker$TimePicker$viewDropDown, settings, model)
			]) : _List_Nil;
		var optionalFocusOnClick = (!model.B) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick($stephenreddek$elm_time_picker$TimePicker$Focus)
			]) : _List_Nil;
		var optionalClear = settings.cH ? _List_Nil : _List_fromArray(
			[
				$elm$html$Html$Events$onClick($stephenreddek$elm_time_picker$TimePicker$Clear)
			]);
		var clearButton = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (_v1) {
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'panel-clear-btn'),
										$elm$html$Html$Attributes$href('#'),
										A2($stephenreddek$elm_time_picker$TimePicker$onWithoutLosingFocus, 'mousedown', $stephenreddek$elm_time_picker$TimePicker$NoOp),
										A2($stephenreddek$elm_time_picker$TimePicker$onWithoutLosingFocus, 'mouseup', $stephenreddek$elm_time_picker$TimePicker$NoOp)
									]),
								optionalClear),
							_List_Nil)
						]);
				},
				model.fa));
		var chosenTimeValue = $elm$html$Html$Attributes$value(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					$stephenreddek$elm_time_picker$TimePicker$formatValue(settings),
					model.fa)));
		var inputValue = A2(
			$elm$core$Maybe$withDefault,
			chosenTimeValue,
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$value, model.aR));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'container', true),
							_Utils_Tuple2($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'active', model.B)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'inner-container')
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class($stephenreddek$elm_time_picker$TimePicker$cssPrefix + 'input-container')
									]),
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_Utils_ap(
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Events$onFocus($stephenreddek$elm_time_picker$TimePicker$Focus),
														$elm$html$Html$Events$onBlur($stephenreddek$elm_time_picker$TimePicker$Blur),
														$elm$html$Html$Attributes$placeholder(settings.eD),
														$elm$html$Html$Attributes$disabled(settings.cH),
														$elm$html$Html$Events$onInput($stephenreddek$elm_time_picker$TimePicker$TextChanged),
														$stephenreddek$elm_time_picker$TimePicker$onChange($stephenreddek$elm_time_picker$TimePicker$SubmitText),
														inputValue
													]),
												optionalFocusOnClick),
											_List_Nil)
										]),
									clearButton))
							]),
						optionsDisplay))
				]));
	});
var $author$project$Components$CommonElements$timeInputElement = F4(
	function (inputConfig, field, errors, msg) {
		var originalConfig = inputConfig.lY;
		var updatedConfig = _Utils_update(
			originalConfig,
			{eD: inputConfig.eD});
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('default-time-picker')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						msg,
						A2($stephenreddek$elm_time_picker$TimePicker$view, updatedConfig, inputConfig.oZ))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$pt2]))
					]),
				_List_fromArray(
					[
						A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
					]))
			]);
	});
var $author$project$Pages$CourseDetail$viewExamEditor = F3(
	function (sharedState, model, exam) {
		var maybeTimePicker = A2($elm$core$Dict$get, exam.ki, model.ac);
		var maybeExamTime = A2($elm$core$Dict$get, exam.ki, model.G);
		var maybeExamDate = A2($elm$core$Dict$get, exam.ki, model.F);
		var maybeDatePicker = A2($elm$core$Dict$get, exam.ki, model.ab);
		var _v0 = _Utils_Tuple2(
			_Utils_Tuple2(maybeDatePicker, maybeExamDate),
			_Utils_Tuple2(maybeExamTime, maybeTimePicker));
		if ((((!_v0.a.a.$) && (!_v0.a.b.$)) && (!_v0.b.a.$)) && (!_v0.b.b.$)) {
			var _v1 = _v0.a;
			var datePicker = _v1.a.a;
			var examDate = _v1.b.a;
			var _v2 = _v0.b;
			var examTime = _v2.a.a;
			var timePicker = _v2.b.a;
			return $author$project$Components$CommonElements$rContainer(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRow(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{jY: 'text', af: 'Bezeichnung', eD: 'Hauptklausur', fa: exam.kY},
							$author$project$Pages$CourseDetail$ExamName(exam.ki),
							_List_Nil,
							$author$project$Pages$CourseDetail$SetExamField)),
						$author$project$Components$CommonElements$rRow(
						A4(
							$author$project$Components$CommonElements$textAreaElement,
							{af: 'Bezeichnung', eD: 'Hörsaal N7, N8, 90 Minuten', ox: 4, fa: exam.jC},
							$author$project$Pages$CourseDetail$ExamDescription(exam.ki),
							_List_Nil,
							$author$project$Pages$CourseDetail$SetExamField)),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$dateInputElement,
								{
									nb: datePicker,
									af: 'Datum',
									lY: $author$project$Pages$CourseDetail$datePickerSettings(sharedState),
									fa: examDate
								},
								$author$project$Pages$CourseDetail$ExamDate,
								_List_Nil,
								$author$project$Pages$CourseDetail$ExamDateMsg(exam.ki)),
							A4(
								$author$project$Components$CommonElements$timeInputElement,
								{af: 'Uhrzeit', eD: 'Uhrzeit auswählen', lY: $author$project$Pages$CourseDetail$timePickerSettings, oZ: timePicker},
								$author$project$Pages$CourseDetail$ExamTime,
								_List_Nil,
								$author$project$Pages$CourseDetail$ExamTimeMsg(exam.ki)))),
						(exam.ki === 42) ? $author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								A2(
								$author$project$Components$CommonElements$iconButton,
								'cloud_upload',
								$author$project$Pages$CourseDetail$ExamCreateNew(exam))
							])) : $author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								A2(
								$author$project$Components$CommonElements$iconButton,
								'check',
								$author$project$Pages$CourseDetail$ExamUpdate(exam.ki)),
								A2(
								$author$project$Components$CommonElements$iconButton,
								'delete',
								$author$project$Pages$CourseDetail$ExamDelete(exam.ki))
							]))
					]));
		} else {
			var _v3 = _v0.a;
			var _v4 = _v0.b;
			return $elm$html$Html$text('ERROR on date/time pickers');
		}
	});
var $author$project$Pages$CourseDetail$viewExamsAdmin = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$normalPage(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRowHeader('Klausuren'),
					$author$project$Components$CommonElements$rRow(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var id = _v0.a;
							var exam = _v0.b;
							return A3($author$project$Pages$CourseDetail$viewExamEditor, sharedState, model, exam);
						},
						$elm$core$Dict$toList(model.t))),
					$author$project$Components$CommonElements$nButtonList(
					_List_fromArray(
						[
							{m1: 'add_circle', m2: $author$project$Pages$CourseDetail$CreateExam, af: 'Create New Exam', ov: _List_Nil}
						]))
				]));
	});
var $justgage$tachyons_elm$Tachyons$Classes$pa4 = 'pa4';
var $author$project$Pages$CourseDetail$ToggleEnrollToExam = function (a) {
	return {$: 12, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $justgage$tachyons_elm$Tachyons$Classes$ma1 = 'ma1';
var $author$project$Components$CommonElements$checkBoxes = function (configs) {
	return A2(
		$elm$core$List$map,
		function (config) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$ma0, $justgage$tachyons_elm$Tachyons$Classes$pv2, $justgage$tachyons_elm$Tachyons$Classes$ph0, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$black_80]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Events$onClick(config.kS),
								$elm$html$Html$Attributes$checked(config.hA),
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$ma1]))
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$b]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(config.af)
							])),
						$author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								$elm$html$Html$text(config.jC)
							]))
					]));
		},
		configs);
};
var $justgage$tachyons_elm$Tachyons$Classes$f7 = 'f7';
var $author$project$Pages$CourseDetail$filterExam = F2(
	function (exams, enrollments) {
		var joinedExamAndEnrollment = A6(
			$elm$core$Dict$merge,
			F3(
				function (_v4, _v5, acc) {
					return acc;
				}),
			F3(
				function (key, a, b) {
					return A2(
						$elm$core$Dict$insert,
						key,
						_Utils_Tuple2(a, b));
				}),
			F3(
				function (_v6, _v7, acc) {
					return acc;
				}),
			exams,
			enrollments,
			$elm$core$Dict$empty);
		var examSuccess = A2(
			$elm$core$List$map,
			function (_v2) {
				var id = _v2.a;
				var _v3 = _v2.b;
				var exam = _v3.a;
				var enrollment = _v3.b;
				return (enrollment.l5 === 1) ? _Utils_Tuple3(true, id, exam) : _Utils_Tuple3(false, id, exam);
			},
			$elm$core$Dict$toList(joinedExamAndEnrollment));
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var use = _v0.a;
				var id = _v0.b;
				var exam = _v0.c;
				return _Utils_Tuple2(id, exam);
			},
			A2(
				$elm$core$List$filter,
				function (_v1) {
					var use = _v1.a;
					var id = _v1.b;
					var exam = _v1.c;
					return use;
				},
				examSuccess));
	});
var $author$project$Pages$CourseDetail$successFoldFunction = F3(
	function (key, exam, acc) {
		return acc || (exam.l5 === 1);
	});
var $author$project$Pages$CourseDetail$filterExamsForSuccess = F2(
	function (exams, enrollments) {
		var containsSuccess = A3($elm$core$Dict$foldl, $author$project$Pages$CourseDetail$successFoldFunction, false, enrollments);
		return containsSuccess ? A2($author$project$Pages$CourseDetail$filterExam, exams, enrollments) : $elm$core$Dict$toList(exams);
	});
var $author$project$Pages$CourseDetail$isExamOver = F2(
	function (sharedState, exam) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(exam.jT),
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, sharedState.jx))) < 0;
	});
var $author$project$Pages$CourseDetail$viewExamDetails = F2(
	function (sharedState, exam) {
		return $author$project$Components$CommonElements$rRow(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$b]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(exam.kY)
						]))
				]));
	});
var $author$project$Pages$CourseDetail$viewExamEnrollmentForm = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$rRow(
			A2(
				$elm$core$List$map,
				function (_v0) {
					var id = _v0.a;
					var e = _v0.b;
					if (A2($author$project$Pages$CourseDetail$isExamOver, sharedState, e)) {
						var _v1 = A2($elm$core$Dict$get, id, model.a0);
						if (!_v1.$) {
							var enrollment = _v1.a;
							var _v2 = enrollment.l5;
							switch (_v2) {
								case 0:
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$CourseDetail$viewExamDetails, sharedState, e),
												$author$project$Components$CommonElements$rRow(
												_List_fromArray(
													[
														$elm$html$Html$text('Du hast dich zur Prüfung angemeldet.')
													]))
											]));
								case 1:
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$CourseDetail$viewExamDetails, sharedState, e),
												$author$project$Components$CommonElements$rRow(
												_List_fromArray(
													[
														$elm$html$Html$text('Du hast mit der Note \''),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$b]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(enrollment.kI)
															])),
														$elm$html$Html$text('\' bestanden. Eventuelle Boni sind bereits mit eingerechnet.')
													])),
												$author$project$Components$CommonElements$rRow(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$f7]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Die Angabe zur Note ist ohne Gewähr und nur zu Ihrer Information. Es gilt die ans Prüfungssekretariat gemeldete Note.')
															]))
													]))
											]));
								case 2:
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$CourseDetail$viewExamDetails, sharedState, e),
												$author$project$Components$CommonElements$rRow(
												_List_fromArray(
													[
														$elm$html$Html$text('Du bist mit der Note \''),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$b]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(enrollment.kI)
															])),
														$elm$html$Html$text('\' durchgefallen.'),
														$author$project$Components$CommonElements$rRow(
														_List_fromArray(
															[
																A2(
																$elm$html$Html$span,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$f7]))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Die Angabe zur Note ist ohne Gewähr und nur zu Ihrer Information. Es gilt die ans Prüfungssekretariat gemeldete Note.')
																	]))
															]))
													]))
											]));
								default:
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Pages$CourseDetail$viewExamDetails, sharedState, e),
												$elm$html$Html$text('Undefinierter Zustand.')
											]));
							}
						} else {
							return $elm$html$Html$text('');
						}
					} else {
						var examInfo = {
							jC: e.jC,
							hA: A2($elm$core$Dict$member, id, model.a0),
							af: e.kY,
							kS: $author$project$Pages$CourseDetail$ToggleEnrollToExam(id)
						};
						var enrolledInfo = A2($elm$core$Dict$member, id, model.a0) ? A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$dark_green]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Du bist zur Prüfung angemeldet.')
								])) : A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$dark_red]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Du bist NICHT zur Prüfung angemeldet.')
								]));
						return $author$project$Components$CommonElements$rRow(
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
										]),
									_Utils_ap(
										$author$project$Components$CommonElements$checkBoxes(
											_List_fromArray(
												[examInfo])),
										_List_fromArray(
											[enrolledInfo])))
								]));
					}
				},
				A2($author$project$Pages$CourseDetail$filterExamsForSuccess, model.t, model.a0)));
	});
var $justgage$tachyons_elm$Tachyons$Classes$white_90 = 'white-90';
var $author$project$Pages$CourseDetail$viewExamEnrollmentRequest = F2(
	function (sharedState, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						['bg-dark-red', $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$white_90]))
				]),
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[
							$elm$html$Html$text('Du bist bisher '),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$b]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('NICHT ')
								])),
							$elm$html$Html$text('zur Prüfung angemeldet! '),
							$elm$html$Html$text('Du kannst in dieser Veranstaltung nur dann ECTS '),
							$elm$html$Html$text('erwerben, wenn Du Dich zuvor zur Prüfung angemeldet hast. '),
							$elm$html$Html$text('Ohne Anmeldung wird Deine Leistung im Übungsbetrieb zum '),
							$elm$html$Html$text('Ende des Semesters nicht gewertet.')
						]))
				]));
	});
var $author$project$Pages$CourseDetail$viewExamsStudents = F2(
	function (sharedState, model) {
		return $elm$core$Dict$isEmpty(model.t) ? $elm$html$Html$text('') : ($elm$core$Dict$isEmpty(model.a0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, 'bg-light-gold', $justgage$tachyons_elm$Tachyons$Classes$pa4]))
				]),
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							$author$project$Components$CommonElements$rRowHeader('Prüfungsanmeldung'),
							A2($author$project$Pages$CourseDetail$viewExamEnrollmentRequest, sharedState, model),
							A2($author$project$Pages$CourseDetail$viewExamEnrollmentForm, sharedState, model)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, 'bg-light-gold', $justgage$tachyons_elm$Tachyons$Classes$pa4]))
				]),
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							$author$project$Components$CommonElements$rRowHeader('Prüfungsanmeldung'),
							A2($author$project$Pages$CourseDetail$viewExamEnrollmentForm, sharedState, model)
						]))
				])));
	});
var $author$project$Pages$CourseDetail$viewExams = F2(
	function (sharedState, model) {
		var _v0 = model.Y;
		if (!_v0.$) {
			switch (_v0.a) {
				case 2:
					var _v1 = _v0.a;
					return A2($author$project$Pages$CourseDetail$viewExamsAdmin, sharedState, model);
				case 1:
					var _v2 = _v0.a;
					return $elm$html$Html$text('');
				default:
					var _v3 = _v0.a;
					return A2($author$project$Pages$CourseDetail$viewExamsStudents, sharedState, model);
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$CourseDetail$Download = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$CourseDetail$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$CourseDetail$viewMaterials = F3(
	function (sharedState, model, materialType) {
		var _v0 = function () {
			if (materialType === 1) {
				return _Utils_Tuple2('Folien', 'Neue Folie');
			} else {
				return _Utils_Tuple2('Material', 'Neues Material');
			}
		}();
		var materialTypeLabel = _v0.a;
		var createNewLabel = _v0.b;
		return $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRowHeader(materialTypeLabel),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
						]),
					function () {
						var _v2 = model.fY;
						if (_v2.$ === 3) {
							var materials = _v2.a;
							return A2(
								$elm$core$List$append,
								_List_fromArray(
									[
										_Utils_eq(
										model.Y,
										$elm$core$Maybe$Just(2)) ? $author$project$Components$CommonElements$nButtonList(
										_List_fromArray(
											[
												{
												m1: 'add_circle',
												m2: $author$project$Pages$CourseDetail$NavigateTo(
													$author$project$Routing$Helpers$CreateMaterialRoute(model.ju)),
												af: 'Create New',
												ov: _List_Nil
											}
											])) : $elm$html$Html$text('')
									]),
								_List_fromArray(
									[
										$author$project$Components$CommonElements$nButtonList(
										A2(
											$elm$core$List$map,
											function (m) {
												return {
													m1: 'get_app',
													m2: $author$project$Pages$CourseDetail$Download(
														A2($elm$core$Maybe$withDefault, '', m.jZ)),
													af: m.kY,
													ov: _Utils_eq(
														model.Y,
														$elm$core$Maybe$Just(2)) ? _List_fromArray(
														[
															{
															jh: 'edit',
															ji: $author$project$Pages$CourseDetail$NavigateTo(
																A2($author$project$Routing$Helpers$EditMaterialRoute, model.ju, m.ki))
														}
														]) : _List_Nil
												};
											},
											A2(
												$elm$core$List$sortBy,
												function (m) {
													return $elm$time$Time$posixToMillis(m.kC);
												},
												A2(
													$elm$core$List$filter,
													function (m) {
														return _Utils_eq(m.kJ, materialType);
													},
													materials))))
									]));
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Loading')
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Pages$CourseDetail$viewSheets = F2(
	function (sharedState, model) {
		var baseStyle = _List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$f3, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$lh_title]);
		var defaultStyle = $justgage$tachyons_elm$Tachyons$classes(
			A2($elm$core$List$cons, $justgage$tachyons_elm$Tachyons$Classes$black, baseStyle));
		var pointsDict = function () {
			var _v2 = _Utils_Tuple2(model.eE, model.cB);
			if ((_v2.a.$ === 3) && (_v2.b.$ === 3)) {
				var points = _v2.a.a;
				var course = _v2.b.a;
				return $elm$core$Dict$fromList(
					A2(
						$elm$core$List$map,
						function (p) {
							var acquiredPerc = $elm$core$Basics$round((p.iX / p.kO) * 100);
							return _Utils_Tuple2(
								A2($elm$core$Maybe$withDefault, -1, p.lZ),
								{
									iW: p.iW,
									iX: p.iX,
									g1: (_Utils_cmp(acquiredPerc, course.lE) < 0) ? $justgage$tachyons_elm$Tachyons$classes(
										A2($elm$core$List$cons, $justgage$tachyons_elm$Tachyons$Classes$red, baseStyle)) : ((_Utils_cmp(acquiredPerc, course.lE + 5) < 0) ? $justgage$tachyons_elm$Tachyons$classes(
										A2($elm$core$List$cons, $justgage$tachyons_elm$Tachyons$Classes$gold, baseStyle)) : $justgage$tachyons_elm$Tachyons$classes(
										A2($elm$core$List$cons, $justgage$tachyons_elm$Tachyons$Classes$dark_green, baseStyle))),
									kO: p.kO
								});
						},
						points));
			} else {
				return $elm$core$Dict$empty;
			}
		}();
		return $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRowHeader('Übungsaufgaben'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
						]),
					function () {
						var _v0 = model.gv;
						if (_v0.$ === 3) {
							var sheets = _v0.a;
							return A2(
								$elm$core$List$append,
								_List_fromArray(
									[
										_Utils_eq(
										model.Y,
										$elm$core$Maybe$Just(2)) ? $author$project$Components$CommonElements$nButtonList(
										_List_fromArray(
											[
												{
												m1: 'add_circle',
												m2: $author$project$Pages$CourseDetail$NavigateTo(
													$author$project$Routing$Helpers$CreateSheetRoute(model.ju)),
												af: 'Create New',
												ov: _List_Nil
											}
											])) : $elm$html$Html$text('')
									]),
								_List_fromArray(
									[
										$author$project$Components$CommonElements$nButtonList(
										A2(
											$elm$core$List$map,
											function (sheet) {
												var toDisplay = function () {
													var _v1 = A2($elm$core$Dict$get, sheet.ki, pointsDict);
													if (!_v1.$) {
														var mp = _v1.a;
														return _Utils_Tuple2(
															sheet.kY + (' - ' + ($elm$core$String$fromInt(mp.iX) + ('/' + ($elm$core$String$fromInt(mp.iW) + (' (maximal erreichbar: ' + ($elm$core$String$fromInt(mp.kO) + ')')))))),
															mp.g1);
													} else {
														return _Utils_Tuple2(sheet.kY, defaultStyle);
													}
												}();
												return {
													m1: 'get_app',
													m2: $author$project$Pages$CourseDetail$Download(
														$author$project$Api$Endpoint$unwrap(
															A2($author$project$Api$Endpoint$sheetFile, model.ju, sheet.ki))),
													af: toDisplay.a,
													ov: _Utils_ap(
														_Utils_eq(
															model.Y,
															$elm$core$Maybe$Just(2)) ? _List_fromArray(
															[
																{
																jh: 'edit',
																ji: $author$project$Pages$CourseDetail$NavigateTo(
																	A2($author$project$Routing$Helpers$EditSheetRoute, model.ju, sheet.ki))
															}
															]) : _List_Nil,
														_List_fromArray(
															[
																{
																jh: 'arrow_forward',
																ji: $author$project$Pages$CourseDetail$NavigateTo(
																	A2($author$project$Routing$Helpers$SheetDetailRoute, model.ju, sheet.ki))
															}
															]))
												};
											},
											A2(
												$elm$core$List$sortBy,
												function (sheet) {
													return $elm$time$Time$posixToMillis(sheet.jJ);
												},
												sheets)))
									]));
						} else {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Loading')
										]))
								]);
						}
					}())
				]));
	});
var $author$project$Pages$CourseDetail$TeamConfirm = {$: 45};
var $author$project$Pages$CourseDetail$TeamLeave = {$: 46};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $justgage$tachyons_elm$Tachyons$Classes$justify_between = 'justify-between';
var $justgage$tachyons_elm$Tachyons$Classes$sans_serif = 'sans-serif';
var $author$project$Pages$CourseDetail$viewStudentTeamCurrent = F3(
	function (sharedState, model, team) {
		var _v0 = team.ki;
		if (!_v0.$) {
			var id = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
						]),
					A3(
						$elm$core$List$map2,
						F2(
							function (name, email) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('images/defaultAvatar.png'),
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$b__black_10, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$w3_ns, $justgage$tachyons_elm$Tachyons$Classes$w2]))
												]),
											_List_Nil),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$flex_auto, $justgage$tachyons_elm$Tachyons$Classes$pl2]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h1,
													_List_fromArray(
														[
															$author$project$Utils$Styles$listHeadingStyle,
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(name)
														])),
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$author$project$Utils$Styles$linkGreyStyle,
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$link, $justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$mh0, $justgage$tachyons_elm$Tachyons$Classes$sans_serif])),
															$elm$html$Html$Attributes$href('mailto:' + email)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(email)
														]))
												]))
										]));
							}),
						team.kR,
						_Utils_eq(team.kQ, _List_Nil) ? A2(
							$elm$core$List$repeat,
							$elm$core$List$length(team.kR),
							'') : team.kQ))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$CourseDetail$TeamForm = function (a) {
	return {$: 42, a: a};
};
var $author$project$Pages$CourseDetail$TeamJoin = function (a) {
	return {$: 43, a: a};
};
var $author$project$Pages$CourseDetail$viewStudentTeamJoinable = F4(
	function (sharedState, model, team, teamConfirmed) {
		if ($elm_community$maybe_extra$Maybe$Extra$isNothing(team.ki) || (!teamConfirmed)) {
			var _v0 = model.aP;
			if (_v0.$ === 3) {
				var teams = _v0.a;
				return _List_fromArray(
					[
						$author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_fromArray(
									[
										$author$project$Utils$Styles$listHeadingStyle,
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$mt0]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Students without a team partner')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
							]),
						A2(
							$elm$core$List$concatMap,
							function (t) {
								return A2(
									$elm$core$List$map,
									function (name) {
										return $author$project$Components$CommonElements$rRow(
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$img,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$src('images/defaultAvatar.png'),
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$b__black_10, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$w3_ns, $justgage$tachyons_elm$Tachyons$Classes$w2]))
																]),
															_List_Nil),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h1,
																	_List_fromArray(
																		[
																			$author$project$Utils$Styles$listHeadingStyle,
																			$justgage$tachyons_elm$Tachyons$classes(
																			_List_fromArray(
																				[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(name)
																		])),
																	A2(
																	$author$project$Components$CommonElements$iconButton,
																	'add_circle',
																	function () {
																		var _v1 = t.ki;
																		if (_v1.$ === 1) {
																			return $author$project$Pages$CourseDetail$TeamForm(t.mG);
																		} else {
																			var id = _v1.a;
																			return $author$project$Pages$CourseDetail$TeamJoin(id);
																		}
																	}())
																]))
														]))
												]));
									},
									t.kR);
							},
							teams))
					]);
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$Pages$CourseDetail$viewStudentTeam = F3(
	function (role, sharedState, model) {
		var teamUserConfirmed = function () {
			var _v7 = model.dz;
			if (_v7.$ === 3) {
				var confirmed = _v7.a;
				return confirmed.jd;
			} else {
				return false;
			}
		}();
		var teamConfirmed = function () {
			var _v6 = model.e0;
			if (_v6.$ === 3) {
				var confirmed = _v6.a;
				return confirmed.jd;
			} else {
				return false;
			}
		}();
		var hasTeam = function () {
			var _v5 = model.gd;
			if (_v5.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		var hasGroup = function () {
			var _v4 = model.ba;
			if (_v4.$ === 3) {
				return true;
			} else {
				return false;
			}
		}();
		if (!role) {
			return $author$project$Components$CommonElements$rContainer(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRowHeader('Assignment Team'),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
							]),
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rContainer(
								function () {
									if (!hasGroup) {
										return _List_Nil;
									} else {
										var _v1 = model.gd;
										if (_v1.$ === 3) {
											var team = _v1.a;
											return _Utils_ap(
												($elm_community$maybe_extra$Maybe$Extra$isJust(team.ki) && (!teamConfirmed)) ? _List_fromArray(
													[
														$author$project$Components$CommonElements$rRow(
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h3,
																_List_fromArray(
																	[
																		$author$project$Utils$Styles$listHeadingStyle,
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$red, $justgage$tachyons_elm$Tachyons$Classes$mt0]))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Your team is not confirmed yet. ')
																	]))
															]))
													]) : _List_Nil,
												_Utils_ap(
													$elm_community$maybe_extra$Maybe$Extra$isNothing(team.ki) ? _List_fromArray(
														[
															$author$project$Components$CommonElements$rRow(
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h3,
																	_List_fromArray(
																		[
																			$author$project$Utils$Styles$listHeadingStyle,
																			$justgage$tachyons_elm$Tachyons$classes(
																			_List_fromArray(
																				[$justgage$tachyons_elm$Tachyons$Classes$red, $justgage$tachyons_elm$Tachyons$Classes$mt0]))
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text('You are not in a team.')
																		]))
																]))
														]) : _List_Nil,
													_Utils_ap(
														function () {
															if (!teamUserConfirmed) {
																var _v2 = team.ki;
																if (!_v2.$) {
																	var id = _v2.a;
																	return _List_fromArray(
																		[
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					$justgage$tachyons_elm$Tachyons$classes(
																					_List_fromArray(
																						[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
																				]),
																			_List_fromArray(
																				[
																					$author$project$Components$CommonElements$rRow(
																					_List_fromArray(
																						[
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									$justgage$tachyons_elm$Tachyons$classes(
																									_List_fromArray(
																										[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
																								]),
																							_List_fromArray(
																								[
																									A2(
																									$elm$html$Html$h1,
																									_List_fromArray(
																										[
																											$author$project$Utils$Styles$listHeadingStyle,
																											$justgage$tachyons_elm$Tachyons$classes(
																											_List_fromArray(
																												[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
																										]),
																									_List_fromArray(
																										[
																											$elm$html$Html$text('Confirm Now')
																										])),
																									A2($author$project$Components$CommonElements$iconButton, 'check_circle', $author$project$Pages$CourseDetail$TeamConfirm)
																								]))
																						]))
																				]))
																		]);
																} else {
																	return _List_Nil;
																}
															} else {
																return _List_Nil;
															}
														}(),
														_Utils_ap(
															function () {
																if (!teamConfirmed) {
																	var _v3 = team.ki;
																	if (!_v3.$) {
																		var id = _v3.a;
																		return _List_fromArray(
																			[
																				A2(
																				$elm$html$Html$div,
																				_List_fromArray(
																					[
																						$justgage$tachyons_elm$Tachyons$classes(
																						_List_fromArray(
																							[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$justify_start]))
																					]),
																				_List_fromArray(
																					[
																						$author$project$Components$CommonElements$rRow(
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$justgage$tachyons_elm$Tachyons$classes(
																										_List_fromArray(
																											[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$elm$html$Html$h1,
																										_List_fromArray(
																											[
																												$author$project$Utils$Styles$listHeadingStyle,
																												$justgage$tachyons_elm$Tachyons$classes(
																												_List_fromArray(
																													[$justgage$tachyons_elm$Tachyons$Classes$mv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
																											]),
																										_List_fromArray(
																											[
																												$elm$html$Html$text('Leave Team')
																											])),
																										A2($author$project$Components$CommonElements$iconButton, 'logout', $author$project$Pages$CourseDetail$TeamLeave)
																									]))
																							]))
																					]))
																			]);
																	} else {
																		return _List_Nil;
																	}
																} else {
																	return _List_Nil;
																}
															}(),
															_Utils_ap(
																A3($author$project$Pages$CourseDetail$viewStudentTeamCurrent, sharedState, model, team),
																A4($author$project$Pages$CourseDetail$viewStudentTeamJoinable, sharedState, model, team, teamConfirmed))))));
										} else {
											return _List_fromArray(
												[
													$elm$html$Html$text('Loading')
												]);
										}
									}
								}())
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $justgage$tachyons_elm$Tachyons$Classes$mw8_l = 'mw8-l';
var $justgage$tachyons_elm$Tachyons$Classes$ph3_l = 'ph3-l';
var $author$project$Components$CommonElements$widePage_mw8 = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph4, $justgage$tachyons_elm$Tachyons$Classes$ph3_l, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$mw8_l]))
			]),
		childs);
};
var $author$project$Pages$CourseDetail$view = F2(
	function (sharedState, model) {
		var _v0 = _Utils_Tuple2(model.fp, model.Y);
		if ((_v0.a.$ === 3) && (!_v0.b.$)) {
			var role = _v0.b.a;
			return $author$project$Components$CommonElements$pageContainer(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$widePage_mw8(
						_List_fromArray(
							[
								A2($author$project$Pages$CourseDetail$viewCourseInfo, sharedState, model)
							])),
						A2($author$project$Pages$CourseDetail$viewExams, sharedState, model),
						$author$project$Components$CommonElements$normalPage(
						_List_fromArray(
							[
								A2($author$project$Pages$CourseDetail$viewSheets, sharedState, model),
								A3($author$project$Pages$CourseDetail$viewMaterials, sharedState, model, 1),
								A3($author$project$Pages$CourseDetail$viewMaterials, sharedState, model, 0),
								A3($author$project$Pages$CourseDetail$viewDetermineGroupDisplay, role, sharedState, model),
								A3($author$project$Pages$CourseDetail$viewDetermineTeamOrSearch, role, sharedState, model),
								A3($author$project$Pages$CourseDetail$viewStudentTeam, role, sharedState, model)
							]))
					]));
		} else {
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $justgage$tachyons_elm$Tachyons$Classes$shadow_5 = 'shadow-5';
var $author$project$Components$Toasty$genericToast = F3(
	function (variantStyle, title, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$br3, $justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$shadow_5, $justgage$tachyons_elm$Tachyons$Classes$f6])),
					variantStyle
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ma0]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					$elm$core$String$isEmpty(message) ? $elm$html$Html$text('') : A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$mt2, $justgage$tachyons_elm$Tachyons$Classes$mt0]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(message)
						]))
				]));
	});
var $author$project$Components$Toasty$toastyFailure = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bg_red, $justgage$tachyons_elm$Tachyons$Classes$white]));
var $justgage$tachyons_elm$Tachyons$Classes$bg_dark_blue = 'bg-dark-blue';
var $author$project$Components$Toasty$toastyInfo = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bg_dark_blue, $justgage$tachyons_elm$Tachyons$Classes$white]));
var $author$project$Components$Toasty$toastySuccess = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bg_dark_green, $justgage$tachyons_elm$Tachyons$Classes$white]));
var $justgage$tachyons_elm$Tachyons$Classes$bg_orange = 'bg-orange';
var $author$project$Components$Toasty$toastyWarning = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bg_orange, $justgage$tachyons_elm$Tachyons$Classes$black]));
var $author$project$Components$Toasty$view = function (toast) {
	switch (toast.$) {
		case 0:
			var title = toast.a;
			var message = toast.b;
			return A3($author$project$Components$Toasty$genericToast, $author$project$Components$Toasty$toastySuccess, title, message);
		case 1:
			var title = toast.a;
			var message = toast.b;
			return A3($author$project$Components$Toasty$genericToast, $author$project$Components$Toasty$toastyWarning, title, message);
		case 2:
			var title = toast.a;
			var message = toast.b;
			return A3($author$project$Components$Toasty$genericToast, $author$project$Components$Toasty$toastyFailure, title, message);
		default:
			var title = toast.a;
			var message = toast.b;
			return A3($author$project$Components$Toasty$genericToast, $author$project$Components$Toasty$toastyInfo, title, message);
	}
};
var $pablen$toasty$Toasty$itemContainer = F4(
	function (_v0, tagger, _v1, toastView) {
		var cfg = _v0;
		var id = _v1.a;
		var status = _v1.b;
		var toast = _v1.c;
		var attrs = function () {
			if (!status) {
				return cfg.iG;
			} else {
				return cfg.iH;
			}
		}();
		return _Utils_Tuple2(
			$elm$core$String$fromInt(id),
			A2(
				$elm$html$Html$li,
				_Utils_ap(
					cfg.hB,
					_Utils_ap(
						attrs,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								tagger(
									$pablen$toasty$Toasty$TransitionOut(id)))
							]))),
				_List_fromArray(
					[
						toastView(toast)
					])));
	});
var $elm$html$Html$Keyed$ol = $elm$html$Html$Keyed$node('ol');
var $pablen$toasty$Toasty$view = F4(
	function (cfg, toastView, tagger, _v0) {
		var toasts = _v0.a;
		var seed = _v0.b;
		var _v1 = cfg;
		var c = _v1;
		return $elm$core$List$isEmpty(toasts) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$Keyed$ol,
			c.g2,
			A2(
				$elm$core$List$map,
				function (toast) {
					return A4($pablen$toasty$Toasty$itemContainer, cfg, tagger, toast, toastView);
				},
				toasts));
	});
var $author$project$Pages$CourseEditor$CreateOrEdit = {$: 8};
var $author$project$Pages$CourseEditor$SetField = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Components$CommonElements$r1Column = function (child) {
	return child;
};
var $author$project$Pages$CourseEditor$PointsRequiredToggle = {$: 7};
var $justgage$tachyons_elm$Tachyons$Classes$br_pill = 'br-pill';
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_red = 'hover-bg-dark-red';
var $author$project$Utils$Styles$buttonRedStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$b__dark_red, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_red, $justgage$tachyons_elm$Tachyons$Classes$hover_white])));
var $justgage$tachyons_elm$Tachyons$Classes$w_10 = 'w-10';
var $author$project$Pages$CourseEditor$viewRequiredPercentage = function (model) {
	var showElement = _Utils_eq(model.lE, $elm$core$Maybe$Nothing) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$input,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$type_('number'),
				$author$project$Utils$Styles$lineInputStyle,
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$w_10, $justgage$tachyons_elm$Tachyons$Classes$tc])),
				$elm$html$Html$Attributes$placeholder('Percentage'),
				$elm$html$Html$Events$onInput(
				$author$project$Pages$CourseEditor$SetField(2)),
				$elm$html$Html$Attributes$value(
				A2($elm$core$Maybe$withDefault, '0', model.lE))
			]),
		_List_Nil);
	var buttonText = _Utils_eq(model.lE, $elm$core$Maybe$Nothing) ? 'No percentage required' : 'Percentage required';
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$author$project$Utils$Styles$buttonRedStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$br_pill, $justgage$tachyons_elm$Tachyons$Classes$ph4, $justgage$tachyons_elm$Tachyons$Classes$pv3])),
					$elm$html$Html$Events$onClick($author$project$Pages$CourseEditor$PointsRequiredToggle)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonText)
				])),
			showElement
		]);
};
var $author$project$Pages$CourseEditor$viewForm = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRowHeader(
					model.cE ? 'Kurs erstellen' : 'Kurs bearbeiten'),
					$author$project$Components$CommonElements$rRow(
					$author$project$Components$CommonElements$r1Column(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{jY: 'text', af: 'Course Name', eD: 'Name', fa: model.bX},
							0,
							model.hf,
							$author$project$Pages$CourseEditor$SetField))),
					$author$project$Components$CommonElements$rRow(
					A2(
						$author$project$Components$CommonElements$r2Column,
						A4(
							$author$project$Components$CommonElements$dateInputElement,
							{
								nb: model.dO,
								af: 'Start',
								lY: $author$project$Pages$CourseEditor$settings(sharedState),
								fa: model.aH
							},
							3,
							model.hf,
							$author$project$Pages$CourseEditor$BeginDatePicker),
						A4(
							$author$project$Components$CommonElements$dateInputElement,
							{
								nb: model.d4,
								af: 'Ende',
								lY: $author$project$Pages$CourseEditor$settings(sharedState),
								fa: model.an
							},
							4,
							model.hf,
							$author$project$Pages$CourseEditor$EndDatePicker))),
					$author$project$Components$CommonElements$rRow(
					$author$project$Components$CommonElements$r1Column(
						A4(
							$author$project$Components$CommonElements$textAreaElement,
							{af: 'Beschreibung', eD: 'Beschreibung', ox: 1, fa: model.jC},
							1,
							model.hf,
							$author$project$Pages$CourseEditor$SetField))),
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$h3, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
								]),
							$author$project$Pages$CourseEditor$viewRequiredPercentage(model)),
							A2($author$project$Components$CommonElements$viewFormErrors, 2, model.hf)
						])),
					$author$project$Components$CommonElements$rRowButton(
					$author$project$Components$CommonElements$PbbButton(
						A2(
							$author$project$Components$CommonElements$PbbActive,
							model.cE ? 'Erstellen' : 'Bearbeiten',
							$author$project$Pages$CourseEditor$CreateOrEdit)))
				]));
	});
var $author$project$Pages$CourseEditor$viewFormLoadingOrError = F2(
	function (sharedState, model) {
		var _v0 = model.cT;
		_v0$4:
		while (true) {
			switch (_v0.$) {
				case 1:
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				case 2:
					if (_v0.a.$ === 3) {
						switch (_v0.a.a) {
							case 400:
								return $elm$html$Html$text('Wrong Format');
							case 401:
								return $elm$html$Html$text('Not Logged In');
							case 403:
								return $elm$html$Html$text('Not permitted');
							default:
								break _v0$4;
						}
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return A2($author$project$Pages$CourseEditor$viewForm, sharedState, model);
	});
var $author$project$Pages$CourseEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$CourseEditor$ToastyMsg, model.iC),
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							A2($author$project$Pages$CourseEditor$viewFormLoadingOrError, sharedState, model)
						]))
				]));
	});
var $author$project$Pages$Courses$NavigateTo = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$Courses$ToggleArchive = {$: 12};
var $justgage$tachyons_elm$Tachyons$Classes$b__dark_green = 'b--dark-green';
var $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_green = 'hover-bg-dark-green';
var $author$project$Utils$Styles$buttonGreenStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$buttonStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$dark_green, $justgage$tachyons_elm$Tachyons$Classes$b__dark_green, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_dark_green, $justgage$tachyons_elm$Tachyons$Classes$hover_white])));
var $justgage$tachyons_elm$Tachyons$Classes$content_start = 'content-start';
var $author$project$Pages$Courses$findEnrollmentForCourse = F2(
	function (course, enrollments) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (enrollment) {
					return _Utils_eq(enrollment.jv, course.ki);
				},
				enrollments));
	});
var $justgage$tachyons_elm$Tachyons$Classes$br4 = 'br4';
var $justgage$tachyons_elm$Tachyons$Classes$mb0_ns = 'mb0-ns';
var $author$project$Components$CommonElements$rRowHeaderActionButtons = F3(
	function (label, headerStyle, actions) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$items_center, 'small-border']))
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[headerStyle]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						])),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var actionLabel = _v0.a;
								var actionMsg = _v0.b;
								var baseStyle = _v0.c;
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											baseStyle,
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$br4, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$pv3, $justgage$tachyons_elm$Tachyons$Classes$ml3, $justgage$tachyons_elm$Tachyons$Classes$mb3, $justgage$tachyons_elm$Tachyons$Classes$mb0_ns])),
											$elm$html$Html$Events$onClick(actionMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(actionLabel)
										]));
							},
							actions))
					])));
	});
var $author$project$Pages$Courses$DeleteCourseDialogShown = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$Courses$PerformDelete = function (a) {
	return {$: 9, a: a};
};
var $author$project$Components$Dialog$Config = F5(
	function (dialogVisibleAttribute, dialogHiddenAttribute, callback, cancelable, noOp) {
		return {jk: callback, jl: cancelable, jE: dialogHiddenAttribute, jF: dialogVisibleAttribute, k1: noOp};
	});
var $author$project$Pages$Courses$NoOp = {$: 15};
var $justgage$tachyons_elm$Tachyons$Classes$dn = 'dn';
var $author$project$Utils$Styles$dialogGoneStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$dn]));
var $author$project$Utils$Styles$dialogVisibleStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$flex]));
var $author$project$Pages$Courses$deleteCourseDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Pages$Courses$DeleteCourseDialogShown, true, $author$project$Pages$Courses$NoOp);
var $justgage$tachyons_elm$Tachyons$Classes$b__black = 'b--black';
var $justgage$tachyons_elm$Tachyons$Classes$bw2 = 'bw2';
var $author$project$Components$Dialog$dialog = F5(
	function (element, givenAttributes, children, isVisible, config) {
		var clickEvent = A2(
			$elm$html$Html$Events$custom,
			'click',
			$elm$json$Json$Decode$succeed(
				{kS: config.k1, lh: true, l7: true}));
		return A2(
			element,
			A2($elm$core$List$cons, clickEvent, givenAttributes),
			children);
	});
var $justgage$tachyons_elm$Tachyons$Classes$b__black_60 = 'b--black-60';
var $justgage$tachyons_elm$Tachyons$Classes$measure_wide = 'measure-wide';
var $justgage$tachyons_elm$Tachyons$Classes$ph5 = 'ph5';
var $justgage$tachyons_elm$Tachyons$Classes$pv4 = 'pv4';
var $author$project$Utils$Styles$dialogContainerStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$bg_white, $justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$ba, $justgage$tachyons_elm$Tachyons$Classes$bw1, $justgage$tachyons_elm$Tachyons$Classes$b__black_60, $justgage$tachyons_elm$Tachyons$Classes$shadow_5, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$measure_wide, $justgage$tachyons_elm$Tachyons$Classes$ph5, $justgage$tachyons_elm$Tachyons$Classes$pv4]));
var $justgage$tachyons_elm$Tachyons$Classes$bottom_0 = 'bottom-0';
var $justgage$tachyons_elm$Tachyons$Classes$justify_center = 'justify-center';
var $justgage$tachyons_elm$Tachyons$Classes$left_0 = 'left-0';
var $justgage$tachyons_elm$Tachyons$Classes$z_max = 'z-max';
var $author$project$Utils$Styles$dialogOverlayStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$fixed, $justgage$tachyons_elm$Tachyons$Classes$top_0, $justgage$tachyons_elm$Tachyons$Classes$right_0, $justgage$tachyons_elm$Tachyons$Classes$bottom_0, $justgage$tachyons_elm$Tachyons$Classes$left_0, $justgage$tachyons_elm$Tachyons$Classes$bg_black_30, $justgage$tachyons_elm$Tachyons$Classes$justify_center, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$z_max]));
var $justgage$tachyons_elm$Tachyons$Classes$fr = 'fr';
var $author$project$Components$Dialog$modalDialog = F5(
	function (element, attributes, child, isVisible, config) {
		var visiblity = isVisible ? _List_fromArray(
			[config.jF]) : _List_fromArray(
			[config.jE]);
		var clickEvent = config.jl ? _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$custom,
				'click',
				$elm$json$Json$Decode$succeed(
					{
						kS: config.jk(!isVisible),
						lh: true,
						l7: true
					}))
			]) : _List_Nil;
		return A2(
			element,
			_Utils_ap(
				visiblity,
				_Utils_ap(clickEvent, attributes)),
			_List_fromArray(
				[
					A2(child, isVisible, config)
				]));
	});
var $justgage$tachyons_elm$Tachyons$Classes$ph1 = 'ph1';
var $author$project$Components$CommonElements$simpleDialog = F5(
	function (header, body, actions, state, config) {
		return A5(
			$author$project$Components$Dialog$modalDialog,
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Utils$Styles$dialogOverlayStyle]),
			A3(
				$author$project$Components$Dialog$dialog,
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Utils$Styles$dialogContainerStyle]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph1, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$b__black]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(header)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt4]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[$author$project$Utils$Styles$textStyle]),
								_List_fromArray(
									[
										$elm$html$Html$text(body)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$fr, $justgage$tachyons_elm$Tachyons$Classes$mt3]))
									]),
								A2(
									$elm$core$List$map,
									function (_v0) {
										var label = _v0.a;
										var buttonStyle = _v0.b;
										var msg = _v0.c;
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$ml3])),
													buttonStyle,
													$elm$html$Html$Events$onClick(msg)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(label)
												]));
									},
									actions))
							]))
					])),
			state,
			config);
	});
var $author$project$Pages$Courses$viewDeleteCourseDialog = F2(
	function (sharedState, model) {
		var _v0 = model.cC;
		if (!_v0.$) {
			var course = _v0.a;
			return A5(
				$author$project$Components$CommonElements$simpleDialog,
				'Delete the course?',
				'Are you sure you want to delete the course? This cannot be undone. The course and everything associated with the course like enrollments are gone.',
				_List_fromArray(
					[
						_Utils_Tuple3(
						'Delete',
						$author$project$Utils$Styles$buttonRedStyle,
						$author$project$Pages$Courses$PerformDelete(course)),
						_Utils_Tuple3(
						'Cancel',
						$author$project$Utils$Styles$buttonGreenStyle,
						$author$project$Pages$Courses$DeleteCourseDialogShown(false))
					]),
				model.b1,
				$author$project$Pages$Courses$deleteCourseDialogConfig);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Courses$DisenrollCourseDialogShown = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Courses$PerformDisenroll = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$Courses$disenrollCourseDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Pages$Courses$DisenrollCourseDialogShown, true, $author$project$Pages$Courses$NoOp);
var $author$project$Pages$Courses$viewDisenrollCourseDialog = F2(
	function (sharedState, model) {
		var _v0 = model.cD;
		if (!_v0.$) {
			var course = _v0.a;
			return A5(
				$author$project$Components$CommonElements$simpleDialog,
				'Disenroll from course?',
				'Are you sure you want to disenroll from the course? This cannot be undone. Your group, submissions and everything else will be lost!',
				_List_fromArray(
					[
						_Utils_Tuple3(
						'Disenroll',
						$author$project$Utils$Styles$buttonRedStyle,
						$author$project$Pages$Courses$PerformDisenroll(course)),
						_Utils_Tuple3(
						'Cancel',
						$author$project$Utils$Styles$buttonGreenStyle,
						$author$project$Pages$Courses$DisenrollCourseDialogShown(false))
					]),
				model.b2,
				$author$project$Pages$Courses$disenrollCourseDialogConfig);
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$Courses$Enroll = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Courses$RequestDelete = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$Courses$RequestDisenroll = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$article = _VirtualDom_node('article');
var $elm$html$Html$header = _VirtualDom_node('header');
var $justgage$tachyons_elm$Tachyons$Classes$pv5 = 'pv5';
var $author$project$Pages$Courses$viewRenderCourse = F3(
	function (sharedState, course, enrollment) {
		var showButtons = function () {
			if (enrollment.$ === 1) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'Enroll',
						$author$project$Pages$Courses$Enroll(course))
					]);
			} else {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'Show',
						$author$project$Pages$Courses$NavigateTo(
							$author$project$Routing$Helpers$CourseDetailRoute(course.ki)))
					]);
			}
		}();
		var buttonsHtml = A2(
			$elm$core$List$map,
			function (_v2) {
				var buttonText = _v2.a;
				var buttonMsg = _v2.b;
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$author$project$Utils$Styles$buttonGreyStyle,
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt3])),
							$elm$html$Html$Events$onClick(buttonMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(buttonText)
						]));
			},
			showButtons);
		var actionItems = _Utils_ap(
			function () {
				if (enrollment.$ === 1) {
					return _List_Nil;
				} else {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'images/logout-variant.svg',
							$author$project$Pages$Courses$RequestDisenroll(course))
						]);
				}
			}(),
			_Utils_eq(
				sharedState.lJ,
				$elm$core$Maybe$Just(
					{lK: true})) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'images/pencil.svg',
					$author$project$Pages$Courses$NavigateTo(
						$author$project$Routing$Helpers$EditCourseRoute(course.ki))),
					_Utils_Tuple2(
					'images/delete.svg',
					$author$project$Pages$Courses$RequestDelete(course))
				]) : _List_Nil);
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$pv5, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
								]),
							_Utils_ap(
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[$author$project$Utils$Styles$listHeadingStyle]),
										_List_fromArray(
											[
												$elm$html$Html$text(course.kY)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											function (_v0) {
												var icon = _v0.a;
												var msgAction = _v0.b;
												return A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('image'),
															$elm$html$Html$Attributes$src(icon),
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$ml2, $justgage$tachyons_elm$Tachyons$Classes$w2, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$pa1, $justgage$tachyons_elm$Tachyons$Classes$dim])),
															$elm$html$Html$Events$onClick(msgAction)
														]),
													_List_Nil);
											},
											actionItems))
									]))),
							$author$project$Components$CommonElements$datesDisplayContainer(
							_Utils_ap(
								A2(
									$author$project$Components$CommonElements$dateElement,
									'Beginn ',
									A2($author$project$Utils$DateFormatter$fullDateFormatter, sharedState, course.i8)),
								A2(
									$author$project$Components$CommonElements$dateElement,
									'Ende ',
									A2($author$project$Utils$DateFormatter$fullDateFormatter, sharedState, course.jQ))))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$elm_explorations$markdown$Markdown$toHtml,
								_List_fromArray(
									[$author$project$Utils$Styles$textStyle]),
								course.jC)
							]),
						buttonsHtml))
				]));
	});
var $author$project$Pages$Courses$view = F2(
	function (sharedState, model) {
		var translate = $author$project$I18n$get(sharedState.pa);
		var _v0 = _Utils_Tuple2(model.cB, model.cq);
		if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
			var courses = _v0.a.a;
			var enrollments = _v0.b.a;
			var userRole = A2(
				$elm$core$Maybe$withDefault,
				{lK: false},
				sharedState.lJ);
			var currentTime = A2(
				$elm$core$Maybe$withDefault,
				$elm$time$Time$millisToPosix(0),
				sharedState.jx);
			var oldCourses = A2(
				$elm$core$List$map,
				function (course) {
					return A3(
						$author$project$Pages$Courses$viewRenderCourse,
						sharedState,
						course,
						A2($author$project$Pages$Courses$findEnrollmentForCourse, course, enrollments));
				},
				A2(
					$elm$core$List$filter,
					function (course) {
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(currentTime),
							$elm$time$Time$posixToMillis(course.jQ)) > 0;
					},
					courses));
			var displayCourseOrNot = model.du ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_start, $justgage$tachyons_elm$Tachyons$Classes$content_start]))
					]),
				oldCourses) : $elm$html$Html$text('');
			var currentCourses = A2(
				$elm$core$List$map,
				function (course) {
					return A3(
						$author$project$Pages$Courses$viewRenderCourse,
						sharedState,
						course,
						A2($author$project$Pages$Courses$findEnrollmentForCourse, course, enrollments));
				},
				A2(
					$elm$core$List$filter,
					function (course) {
						return _Utils_cmp(
							$elm$time$Time$posixToMillis(currentTime),
							$elm$time$Time$posixToMillis(course.jQ)) < 0;
					},
					courses));
			var cTemp = _List_fromArray(
				[
					A3(
					$author$project$Components$CommonElements$rRowHeaderActionButtons,
					'Aktuell',
					$author$project$Utils$Styles$headerStyle,
					userRole.lK ? _List_fromArray(
						[
							_Utils_Tuple3(
							'+',
							$author$project$Pages$Courses$NavigateTo($author$project$Routing$Helpers$CreateCourseRoute),
							$author$project$Utils$Styles$buttonGreenStyle)
						]) : _List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_start, $justgage$tachyons_elm$Tachyons$Classes$content_start, $justgage$tachyons_elm$Tachyons$Classes$cf]))
						]),
					currentCourses)
				]);
			var content = ($elm$core$List$length(oldCourses) > 0) ? _Utils_ap(
				cTemp,
				_List_fromArray(
					[
						A3(
						$author$project$Components$CommonElements$rRowHeaderActionButtons,
						'Archiv',
						$author$project$Utils$Styles$headerStyle,
						_List_fromArray(
							[
								_Utils_Tuple3(
								model.du ? 'Hide' : 'Show',
								$author$project$Pages$Courses$ToggleArchive,
								$author$project$Utils$Styles$buttonGreyStyle)
							])),
						displayCourseOrNot
					])) : cTemp;
			return $author$project$Components$CommonElements$pageContainer(
				_List_fromArray(
					[
						A2($author$project$Pages$Courses$viewDisenrollCourseDialog, sharedState, model),
						A2($author$project$Pages$Courses$viewDeleteCourseDialog, sharedState, model),
						A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$Courses$ToastyMsg, model.iC),
						$author$project$Components$CommonElements$widePage_mw8(content)
					]));
		} else {
			return $author$project$Components$CommonElements$widePage_mw8(_List_Nil);
		}
	});
var $author$project$Components$CommonElements$oneButtonList = function (listElements) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$ma0, $justgage$tachyons_elm$Tachyons$Classes$pv2, $justgage$tachyons_elm$Tachyons$Classes$ph0, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$black_80]))
			]),
		A2(
			$elm$core$List$map,
			function (elt) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_white, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$relative, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$justify_start, $justgage$tachyons_elm$Tachyons$Classes$pv0, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mr2, $justgage$tachyons_elm$Tachyons$Classes$ml0, $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$br_100]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(elt.af)
								])),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('material-icons'),
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mr0, $justgage$tachyons_elm$Tachyons$Classes$ml_auto, $justgage$tachyons_elm$Tachyons$Classes$pa2, $justgage$tachyons_elm$Tachyons$Classes$black_40, $justgage$tachyons_elm$Tachyons$Classes$hover_bg_near_black, $justgage$tachyons_elm$Tachyons$Classes$br_100, $justgage$tachyons_elm$Tachyons$Classes$hover_near_white, $justgage$tachyons_elm$Tachyons$Classes$pointer])),
									$elm$html$Html$Events$onClick(elt.ji)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(elt.jh)
								]))
						]));
			},
			listElements));
};
var $justgage$tachyons_elm$Tachyons$Classes$mt4_ns = 'mt4-ns';
var $author$project$Components$CommonElements$rRowExtraSpacing = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mt4_ns, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
			]),
		childs);
};
var $author$project$Utils$DateFormatter$shortDateFormatter = F2(
	function (sharedState, time) {
		var year = $elm$core$String$fromInt(
			A3(
				$author$project$Utils$Utils$flip,
				$elm$time$Time$toYear,
				time,
				A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_)));
		var monthType = A3(
			$author$project$Utils$Utils$flip,
			$elm$time$Time$toMonth,
			time,
			A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_));
		var month = A2($author$project$Utils$DateFormatter$monthFormatter, sharedState, monthType);
		var day = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A3(
					$author$project$Utils$Utils$flip,
					$elm$time$Time$toDay,
					time,
					A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_))));
		return day + ('/' + (month + ('/' + year)));
	});
var $author$project$Utils$DateFormatter$timeFormatter = F2(
	function (sharedState, time) {
		var second = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A3(
					$author$project$Utils$Utils$flip,
					$elm$time$Time$toSecond,
					time,
					A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_))));
		var minute = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A3(
					$author$project$Utils$Utils$flip,
					$elm$time$Time$toMinute,
					time,
					A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_))));
		var hour = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A3(
					$author$project$Utils$Utils$flip,
					$elm$time$Time$toHour,
					time,
					A2($elm$core$Maybe$withDefault, $elm$time$Time$utc, sharedState.o_))));
		return hour + (':' + (minute + (':' + second)));
	});
var $author$project$Pages$Dashboard$viewCourseWithTodos = F3(
	function (sharedState, model, fusedEnrollment) {
		var dateAndTimeShort = function (t) {
			return A2($author$project$Utils$DateFormatter$shortDateFormatter, sharedState, t) + (' - ' + A2($author$project$Utils$DateFormatter$timeFormatter, sharedState, t));
		};
		var allDoneHtml = _List_fromArray(
			[
				$author$project$Components$CommonElements$rRowExtraSpacing(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[$author$project$Utils$Styles$listHeadingStyle]),
						_List_fromArray(
							[
								$elm$html$Html$text('Nothing left to do in this course for you. Good job. Wait till the next exercise sheet is uploaded.')
							]))
					]))
			]);
		return $author$project$Components$CommonElements$rContainer(
			A2(
				$elm$core$List$cons,
				A3(
					$author$project$Components$CommonElements$rRowHeaderActionButtons,
					fusedEnrollment.E.kY,
					$author$project$Utils$Styles$headerStyle,
					_List_fromArray(
						[
							_Utils_Tuple3(
							'Show',
							$author$project$Pages$Dashboard$NavigateTo(
								$author$project$Routing$Helpers$CourseDetailRoute(fusedEnrollment.E.ki)),
							$author$project$Utils$Styles$buttonGreyStyle)
						])),
				function () {
					var _v0 = fusedEnrollment.f$;
					if (_v0.$ === 1) {
						return allDoneHtml;
					} else {
						if (!_v0.a.$) {
							if (!_v0.a.a.b) {
								return allDoneHtml;
							} else {
								var missingTasks = _v0.a.a;
								var missingTasksFiltered = function () {
									var _v5 = fusedEnrollment.lJ;
									if (!_v5) {
										return A2(
											$elm$core$List$filter,
											function (mt) {
												var _v6 = A2($elm$core$Dict$get, mt.lZ, model.bO);
												if (!_v6.$) {
													var sheet = _v6.a;
													return _Utils_cmp(
														$elm$time$Time$posixToMillis(
															A2(
																$elm$core$Maybe$withDefault,
																$elm$time$Time$millisToPosix(0),
																sharedState.jx)),
														$elm$time$Time$posixToMillis(sheet.jJ)) < 0;
												} else {
													return false;
												}
											},
											missingTasks);
									} else {
										return missingTasks;
									}
								}();
								var taskWithSheet = A2(
									$elm$core$List$filterMap,
									function (_v3) {
										var mt = _v3.a;
										var sheet = _v3.b;
										if (!sheet.$) {
											var s = sheet.a;
											return $elm$core$Maybe$Just(
												_Utils_Tuple2(mt, s));
										} else {
											return $elm$core$Maybe$Nothing;
										}
									},
									A2(
										$elm$core$List$map,
										function (mt) {
											return _Utils_Tuple2(
												mt,
												A2($elm$core$Dict$get, mt.lZ, model.bO));
										},
										missingTasksFiltered));
								var firstDueDate = $elm$core$List$head(
									A2(
										$elm$core$List$sortBy,
										function (t) {
											return $elm$time$Time$posixToMillis(t);
										},
										A2(
											$elm$core$List$map,
											function (sheet) {
												return sheet.jJ;
											},
											A2(
												$elm$core$List$filterMap,
												$elm$core$Basics$identity,
												A2(
													$elm$core$List$map,
													function (sid) {
														return A2($elm$core$Dict$get, sid, model.bO);
													},
													A2(
														$elm$core$List$map,
														function (mt) {
															return mt.lZ;
														},
														missingTasksFiltered))))));
								return A2(
									$elm$core$List$cons,
									$author$project$Components$CommonElements$rRowExtraSpacing(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[$author$project$Utils$Styles$labelStyle]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														'You have missing tasks to complete' + function () {
															if (!firstDueDate.$) {
																var date = firstDueDate.a;
																return '. The first is due on ' + (A2($author$project$Utils$DateFormatter$shortDateFormatter, sharedState, date) + (' at ' + (A2($author$project$Utils$DateFormatter$timeFormatter, sharedState, date) + ':')));
															} else {
																return ': ';
															}
														}())
													]))
											])),
									_List_fromArray(
										[
											$author$project$Components$CommonElements$oneButtonList(
											A2(
												$elm$core$List$map,
												function (_v2) {
													var mt = _v2.a;
													var sheet = _v2.b;
													return {
														jh: 'forward',
														ji: $author$project$Pages$Dashboard$NavigateTo(
															A2($author$project$Routing$Helpers$SheetDetailRoute, fusedEnrollment.E.ki, sheet.ki)),
														af: mt.mk.kY + ('  from ' + (sheet.kY + (' due on ' + dateAndTimeShort(sheet.jJ))))
													};
												},
												taskWithSheet))
										]));
							}
						} else {
							if (!_v0.a.a.b) {
								return allDoneHtml;
							} else {
								var missingGrades = _v0.a.a;
								var sheettaskWithGrades = A3(
									$elm$core$List$foldl,
									F2(
										function (mg, d) {
											return A3(
												$elm$core$Dict$update,
												mg.lZ,
												function (maybeEntry) {
													if (!maybeEntry.$) {
														var entry = maybeEntry.a;
														return $elm$core$Maybe$Just(
															A3(
																$elm$core$Dict$update,
																mg.ml,
																function (secondEntry) {
																	return $elm$core$Maybe$Just(
																		A2(
																			$elm$core$Maybe$withDefault,
																			_List_fromArray(
																				[mg]),
																			A2(
																				$elm$core$Maybe$map,
																				function (es) {
																					return _Utils_ap(
																						es,
																						_List_fromArray(
																							[mg]));
																				},
																				secondEntry)));
																},
																entry));
													} else {
														return $elm$core$Maybe$Just(
															$elm$core$Dict$fromList(
																_List_fromArray(
																	[
																		_Utils_Tuple2(
																		mg.ml,
																		_List_fromArray(
																			[mg]))
																	])));
													}
												},
												d);
										}),
									$elm$core$Dict$empty,
									missingGrades);
								return A2(
									$elm$core$List$cons,
									$author$project$Components$CommonElements$rRowExtraSpacing(
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[$author$project$Utils$Styles$listHeadingStyle]),
												_List_fromArray(
													[
														$elm$html$Html$text('You have missing tasks to grade:')
													]))
											])),
									$elm$core$List$concat(
										A2(
											$elm$core$List$map,
											function (_v7) {
												var sheetId = _v7.a;
												var taskDict = _v7.b;
												return A2(
													$elm$core$List$map,
													function (_v8) {
														var taskId = _v8.a;
														var mgs = _v8.b;
														return A3(
															$author$project$Components$CommonElements$rRowHeaderActionButtons,
															'On ' + (A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	function (s) {
																		return s.kY;
																	},
																	A2($elm$core$Dict$get, sheetId, model.bO))) + (' ' + (A2(
																$elm$core$Maybe$withDefault,
																'',
																A2(
																	$elm$core$Maybe$map,
																	function (t) {
																		return t.kY;
																	},
																	A2($elm$core$Dict$get, taskId, model.e$))) + (' - ' + ($elm$core$String$fromInt(
																$elm$core$List$length(mgs)) + ' Grades'))))),
															$author$project$Utils$Styles$listHeadingStyle,
															_List_fromArray(
																[
																	_Utils_Tuple3(
																	'Grade',
																	$author$project$Pages$Dashboard$NavigateTo(
																		A3(
																			$author$project$Routing$Helpers$SubmissionGradingRoute,
																			fusedEnrollment.E.ki,
																			taskId,
																			A2(
																				$elm$core$Maybe$withDefault,
																				0,
																				A2(
																					$elm$core$Maybe$map,
																					function (gs) {
																						return A2(
																							$elm$core$Maybe$withDefault,
																							0,
																							A2(
																								$elm$core$Maybe$map,
																								function (g) {
																									return g.ki;
																								},
																								$elm$core$List$head(gs)));
																					},
																					fusedEnrollment.fK)))),
																	$author$project$Utils$Styles$buttonGreenStyle)
																]));
													},
													$elm$core$Dict$toList(taskDict));
											},
											$elm$core$Dict$toList(sheettaskWithGrades))));
							}
						}
					}
				}()));
	});
var $author$project$Pages$Dashboard$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					_Utils_ap(
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rRowHeader('Dashboard')
							]),
						function () {
							var _v0 = _Utils_Tuple3(
								$elm$core$Dict$isEmpty(model.aN),
								model.cS,
								model.cU);
							_v0$2:
							while (true) {
								if (_v0.a) {
									if ((_v0.b.$ === 3) && (_v0.c.$ === 3)) {
										return _List_fromArray(
											[
												$author$project$Components$CommonElements$rRow(
												$author$project$Components$CommonElements$r1Column(
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[$author$project$Utils$Styles$textStyle]),
															_List_fromArray(
																[
																	$elm$html$Html$text('You are not enrolled in a course. Start by enrolling into a course:')
																]))
														]))),
												$author$project$Components$CommonElements$rRowButton(
												$author$project$Components$CommonElements$PbbButton(
													A2(
														$author$project$Components$CommonElements$PbbActive,
														'Start enrolling',
														$author$project$Pages$Dashboard$NavigateTo($author$project$Routing$Helpers$CoursesRoute))))
											]);
									} else {
										break _v0$2;
									}
								} else {
									if ((_v0.b.$ === 3) && (_v0.c.$ === 3)) {
										return A2(
											$elm$core$List$map,
											A2($author$project$Pages$Dashboard$viewCourseWithTodos, sharedState, model),
											$elm$core$Dict$values(model.aN));
									} else {
										break _v0$2;
									}
								}
							}
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						}()))
				]));
	});
var $author$project$Pages$GroupEditor$CreateOrEdit = {$: 6};
var $author$project$Pages$GroupEditor$Description = 0;
var $author$project$Components$CommonElements$PbbDisabled = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$GroupEditor$SearchByQuery = 2;
var $author$project$Pages$GroupEditor$SearchUsersByQuery = {$: 2};
var $author$project$Pages$GroupEditor$SetField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Pages$GroupEditor$SetUserAsTutor = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$GroupEditor$WriteEmailMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$GroupEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							$author$project$Components$CommonElements$rContainer(
							_List_fromArray(
								[
									$author$project$Components$CommonElements$rRowHeader(
									model.bY ? 'Gruppe erstellen' : 'Gruppe bearbeiten'),
									function () {
									var _v0 = model.cc;
									if (!_v0.$) {
										var tutor = _v0.a;
										return $author$project$Components$CommonElements$rRow(
											A2(
												$author$project$Components$CommonElements$r2Column,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h1,
														_List_fromArray(
															[$author$project$Utils$Styles$headerStyle]),
														_List_fromArray(
															[
																$elm$html$Html$text('Tutor')
															]))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$map,
														$author$project$Pages$GroupEditor$WriteEmailMsg,
														A3(
															$author$project$Components$UserAvatarEmailView$view,
															sharedState,
															$author$project$Components$UserAvatarEmailView$initFromUser(tutor).a,
															$elm$core$Maybe$Nothing))
													])));
									} else {
										return $elm$html$Html$text('');
									}
								}(),
									$author$project$Components$CommonElements$rRow(
									A2(
										$author$project$Components$CommonElements$r2Column,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h1,
												_List_fromArray(
													[$author$project$Utils$Styles$headerStyle]),
												_List_fromArray(
													[
														$elm$html$Html$text('Search For Tutor')
													]))
											]),
										A4(
											$author$project$Components$CommonElements$searchElement,
											{jY: 'text', eD: 'Find User', fa: model.eN},
											2,
											$author$project$Pages$GroupEditor$SetField,
											$author$project$Pages$GroupEditor$SearchUsersByQuery))),
									$author$project$Components$CommonElements$rRow(
									_List_fromArray(
										[
											function () {
											var _v1 = model.dp;
											if (_v1.$ === 3) {
												var userEnrollments = _v1.a;
												var _v2 = $elm$core$List$head(userEnrollments);
												if (!_v2.$) {
													var userEnrollment = _v2.a;
													var user = userEnrollment.mE;
													var avatar = function () {
														var _v3 = user.i3;
														if (!_v3.$) {
															var avatarUrl = _v3.a;
															return avatarUrl;
														} else {
															return 'images/defaultAvatar.png';
														}
													}();
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ph5_l]))
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$map,
																$author$project$Pages$GroupEditor$WriteEmailMsg,
																A3(
																	$author$project$Components$UserAvatarEmailView$view,
																	sharedState,
																	$author$project$Components$UserAvatarEmailView$initFromUser(user).a,
																	$elm$core$Maybe$Nothing)),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$ml4_l, $justgage$tachyons_elm$Tachyons$Classes$ml0, $justgage$tachyons_elm$Tachyons$Classes$mt0_l, $justgage$tachyons_elm$Tachyons$Classes$mt2, $justgage$tachyons_elm$Tachyons$Classes$flex]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$button,
																		_List_fromArray(
																			[
																				$author$project$Utils$Styles$buttonGreenStyle,
																				$elm$html$Html$Events$onClick(
																				$author$project$Pages$GroupEditor$SetUserAsTutor(user))
																			]),
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Set as tutor')
																			]))
																	]))
															]));
												} else {
													return A2(
														$elm$html$Html$h2,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph5_ns])),
																$author$project$Utils$Styles$listHeadingStyle
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Not found')
															]));
												}
											} else {
												return $elm$html$Html$text('');
											}
										}()
										])),
									$author$project$Components$CommonElements$rRow(
									$author$project$Components$CommonElements$r1Column(
										A4(
											$author$project$Components$CommonElements$textAreaElement,
											{af: 'Description', eD: 'Details about place and time of group meetings', ox: 1, fa: model.jC},
											0,
											model.hf,
											$author$project$Pages$GroupEditor$SetField))),
									$author$project$Components$CommonElements$rRowButton(
									$author$project$Components$CommonElements$PbbButton(
										function () {
											var _v4 = model.cc;
											if (!_v4.$) {
												return A2(
													$author$project$Components$CommonElements$PbbActive,
													model.bY ? 'Erstellen' : 'Bearbeiten',
													$author$project$Pages$GroupEditor$CreateOrEdit);
											} else {
												return $author$project$Components$CommonElements$PbbDisabled(
													model.bY ? 'Erstellen' : 'Bearbeiten');
											}
										}()))
								]))
						]))
				]));
	});
var $author$project$Pages$Login$Login = {$: 2};
var $author$project$Pages$Login$SetField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $justgage$tachyons_elm$Tachyons$Classes$dt = 'dt';
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $justgage$tachyons_elm$Tachyons$Classes$mb2 = 'mb2';
var $justgage$tachyons_elm$Tachyons$Classes$mv4 = 'mv4';
var $justgage$tachyons_elm$Tachyons$Classes$mw7 = 'mw7';
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $justgage$tachyons_elm$Tachyons$Classes$pl3 = 'pl3';
var $author$project$Components$CommonElements$PbbSpinner = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$Login$viewLoginButtonOrSpinner = F2(
	function (status, model) {
		return $author$project$Components$CommonElements$rRowButton(
			function () {
				if (status.$ === 1) {
					return $author$project$Components$CommonElements$PbbSpinner(model.eW);
				} else {
					return $author$project$Components$CommonElements$PbbButton(
						A2($author$project$Components$CommonElements$PbbActive, 'Anmelden', $author$project$Pages$Login$Login));
				}
			}());
	});
var $justgage$tachyons_elm$Tachyons$Classes$w3 = 'w3';
var $author$project$Pages$Login$view = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$center]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$w3, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$mv4, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/images/Logo.svg')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$pl3, $justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('C++ Blockkurs 2026 (Lehrstuhl Angewandte Bioinformatik)')
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40])),
									$elm$html$Html$Events$onSubmit($author$project$Pages$Login$Login)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$fieldset,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$legend,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$pa0, $justgage$tachyons_elm$Tachyons$Classes$mb2])),
													$author$project$Utils$Styles$headerStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('page-title-login'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4]))
												]),
											A4(
												$author$project$Components$CommonElements$inputElement,
												{
													jY: 'email',
													af: t('mail-address'),
													eD: 'Email',
													fa: model.jM
												},
												0,
												model.hf,
												$author$project$Pages$Login$SetField)),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt3]))
												]),
											A4(
												$author$project$Components$CommonElements$inputElement,
												{
													jY: 'password',
													af: t('password'),
													eD: t('password'),
													fa: model.le
												},
												1,
												model.hf,
												$author$project$Pages$Login$SetField)),
											A2($author$project$Pages$Login$viewLoginButtonOrSpinner, model.eu, model)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$mt3]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Login$NavigateTo($author$project$Routing$Helpers$RequestPasswordResetRoute)),
													$author$project$Utils$Styles$linkGreyStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('password-lost'))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Login$NavigateTo($author$project$Routing$Helpers$RegistrationRoute)),
													$author$project$Utils$Styles$linkGreyStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('action-register'))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$MailConfirmation$view = F2(
	function (sharedState, model) {
		var _v0 = model.fo;
		if (_v0.$ === 2) {
			var err = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l])),
						A2($elm$html$Html$Attributes$style, 'height', '80vh'),
						A2($elm$html$Html$Attributes$style, 'width', '100vw')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$f2_m, $justgage$tachyons_elm$Tachyons$Classes$f_subheadline_l, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$tc]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('There was a problem with the confirmation!')
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$MailEditor$Message = 1;
var $author$project$Pages$MailEditor$SendMessage = {$: 1};
var $author$project$Pages$MailEditor$SetField = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$MailEditor$Subject = 0;
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Pages$MailEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					function () {
						var _v0 = _Utils_Tuple3(
							A4(
								$author$project$Components$CommonElements$textAreaElement,
								{af: 'Subject', eD: '[Infomark] Subject of message', ox: 1, fa: model.mb},
								0,
								_List_Nil,
								$author$project$Pages$MailEditor$SetField),
							A4(
								$author$project$Components$CommonElements$textAreaElement,
								{af: 'Message', eD: 'Your Message', ox: 20, fa: model.kS},
								1,
								_List_Nil,
								$author$project$Pages$MailEditor$SetField),
							function () {
								var isButtonActive = !(($elm$core$String$isEmpty(model.kS) || $elm$core$String$isEmpty(model.mb)) && (!model.c0));
								var buttonMessage = isButtonActive ? 'Send' : (model.c0 ? 'Sending Please Wait!' : 'You need to write subject and message');
								return $author$project$Components$CommonElements$rRowButton(
									$author$project$Components$CommonElements$PbbButton(
										isButtonActive ? A2($author$project$Components$CommonElements$PbbActive, buttonMessage, $author$project$Pages$MailEditor$SendMessage) : $author$project$Components$CommonElements$PbbDisabled(buttonMessage)));
							}());
						var subjectView = _v0.a;
						var messageView = _v0.b;
						var sendButton = _v0.c;
						return _List_fromArray(
							[
								function () {
								var _v1 = model.db;
								switch (_v1.$) {
									case 0:
										var user = _v1.a;
										return $author$project$Components$CommonElements$rContainer(
											_List_fromArray(
												[
													$author$project$Components$CommonElements$rRowHeader('E-Mail for students not suppoted')
												]));
									case 1:
										var courseId = _v1.a;
										var groupId = _v1.b;
										var groupResponse = _v1.c;
										switch (groupResponse.$) {
											case 3:
												var group = groupResponse.a;
												var groupDetail = {jC: group.jC, mB: group.mB.j_ + (' ' + group.mB.kB)};
												return $author$project$Components$CommonElements$rContainer(
													_List_fromArray(
														[
															$author$project$Components$CommonElements$rRowHeader('Send Group E-Mail'),
															$author$project$Components$CommonElements$rRow(
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h5,
																			_List_fromArray(
																				[
																					$justgage$tachyons_elm$Tachyons$classes(
																					_List_fromArray(
																						[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mb1]))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('Diese Nachricht wird an alle Studenten in der Gruppe geschickt:')
																				])),
																			$author$project$Components$CommonElements$rRow(
																			A2(
																				$author$project$Components$CommonElements$r2Column,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$justgage$tachyons_elm$Tachyons$classes(
																								_List_fromArray(
																									[$justgage$tachyons_elm$Tachyons$Classes$b]))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Tutor: ')
																							])),
																						$elm$html$Html$text(groupDetail.mB)
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$justgage$tachyons_elm$Tachyons$classes(
																								_List_fromArray(
																									[$justgage$tachyons_elm$Tachyons$Classes$b]))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Details: ')
																							])),
																						$elm$html$Html$text(groupDetail.jC)
																					])))
																		]))
																])),
															$author$project$Components$CommonElements$rRow(subjectView),
															$author$project$Components$CommonElements$rRow(messageView),
															$author$project$Components$CommonElements$rRow(
															_List_fromArray(
																[sendButton]))
														]));
											case 2:
												return $elm$html$Html$text('');
											default:
												return $elm$html$Html$text('');
										}
									default:
										var courseId = _v1.a;
										var courseResponse = _v1.b;
										switch (courseResponse.$) {
											case 3:
												var course = courseResponse.a;
												return $author$project$Components$CommonElements$rContainer(
													_List_fromArray(
														[
															$author$project$Components$CommonElements$rRowHeader('Send Course E-Mail'),
															$author$project$Components$CommonElements$rRow(
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$elm$html$Html$h5,
																			_List_fromArray(
																				[
																					$justgage$tachyons_elm$Tachyons$classes(
																					_List_fromArray(
																						[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mb1]))
																				]),
																			_List_fromArray(
																				[
																					$elm$html$Html$text('This message will be sent to all members of the course:')
																				])),
																			$author$project$Components$CommonElements$rRow(
																			A2(
																				$author$project$Components$CommonElements$r2Column,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$justgage$tachyons_elm$Tachyons$classes(
																								_List_fromArray(
																									[$justgage$tachyons_elm$Tachyons$Classes$b]))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Course Name: ')
																							])),
																						$elm$html$Html$text(course.kY)
																					]),
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$justgage$tachyons_elm$Tachyons$classes(
																								_List_fromArray(
																									[$justgage$tachyons_elm$Tachyons$Classes$b]))
																							]),
																						_List_fromArray(
																							[
																								$elm$html$Html$text('Details: ')
																							])),
																						$elm$html$Html$text(course.jC)
																					])))
																		]))
																])),
															$author$project$Components$CommonElements$rRow(subjectView),
															$author$project$Components$CommonElements$rRow(messageView),
															$author$project$Components$CommonElements$rRow(
															_List_fromArray(
																[sendButton]))
														]));
											case 2:
												return $elm$html$Html$text('');
											default:
												return $elm$html$Html$text('');
										}
								}
							}()
							]);
					}())
				]));
	});
var $author$project$Pages$MaterialEditor$Delete = {$: 12};
var $author$project$Pages$MaterialEditor$DeleteMaterialDialogShown = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$MaterialEditor$NoOp = {$: 24};
var $author$project$Pages$MaterialEditor$deleteMaterialDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Pages$MaterialEditor$DeleteMaterialDialogShown, true, $author$project$Pages$MaterialEditor$NoOp);
var $author$project$Pages$MaterialEditor$viewDeleteMaterialDialog = F2(
	function (sharedState, model) {
		return A5(
			$author$project$Components$CommonElements$simpleDialog,
			'Delete the Material?',
			'Are you sure you want to delete the material? This cannot be undone. The material and everything associated with the material like files are gone.',
			_List_fromArray(
				[
					_Utils_Tuple3('Delete', $author$project$Utils$Styles$buttonRedStyle, $author$project$Pages$MaterialEditor$Delete),
					_Utils_Tuple3(
					'Cancel',
					$author$project$Utils$Styles$buttonGreenStyle,
					$author$project$Pages$MaterialEditor$DeleteMaterialDialogShown(false))
				]),
			model.d_,
			$author$project$Pages$MaterialEditor$deleteMaterialDialogConfig);
	});
var $author$project$Pages$MaterialEditor$Create = {$: 7};
var $author$project$Pages$MaterialEditor$DragEnter = {$: 19};
var $author$project$Pages$MaterialEditor$DragLeave = {$: 20};
var $author$project$Pages$MaterialEditor$LectureDatePickerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$MaterialEditor$LectureTimePickerMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$MaterialEditor$Pick = {$: 18};
var $author$project$Pages$MaterialEditor$PublishedDatePickerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$MaterialEditor$PublishedTimePickerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$MaterialEditor$RequestDelete = {$: 11};
var $author$project$Pages$MaterialEditor$SetField = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$MaterialEditor$SetMaterialType = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$MaterialEditor$SetRequiredRole = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$MaterialEditor$Update = {$: 9};
var $author$project$Pages$MaterialEditor$UtcOffset = 5;
var $justgage$tachyons_elm$Tachyons$Classes$b__dashed = 'b--dashed';
var $elm$file$File$decoder = _File_decoder;
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Components$CommonElements$dropDecoder = function (msg) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['dataTransfer', 'files']),
		A2($elm$json$Json$Decode$oneOrMore, msg, $elm$file$File$decoder));
};
var $justgage$tachyons_elm$Tachyons$Classes$flex_column = 'flex-column';
var $author$project$Components$CommonElements$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Components$CommonElements$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Components$CommonElements$hijack, decoder));
	});
var $author$project$Components$CommonElements$fileUploader = F6(
	function (hover, file, enterMsg, exitMsg, pickMsg, gotFileMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$Classes$pa4,
							$justgage$tachyons_elm$Tachyons$Classes$ba,
							$justgage$tachyons_elm$Tachyons$Classes$b__dashed,
							hover ? $justgage$tachyons_elm$Tachyons$Classes$b__dark_red : $justgage$tachyons_elm$Tachyons$Classes$b__black_40,
							$justgage$tachyons_elm$Tachyons$Classes$bw2,
							$justgage$tachyons_elm$Tachyons$Classes$br3,
							$justgage$tachyons_elm$Tachyons$Classes$w_100,
							$justgage$tachyons_elm$Tachyons$Classes$flex,
							$justgage$tachyons_elm$Tachyons$Classes$flex_column,
							$justgage$tachyons_elm$Tachyons$Classes$justify_center,
							$justgage$tachyons_elm$Tachyons$Classes$items_center,
							$justgage$tachyons_elm$Tachyons$Classes$fl
						])),
					A2(
					$author$project$Components$CommonElements$hijackOn,
					'dragenter',
					$elm$json$Json$Decode$succeed(enterMsg)),
					A2(
					$author$project$Components$CommonElements$hijackOn,
					'dragover',
					$elm$json$Json$Decode$succeed(enterMsg)),
					A2(
					$author$project$Components$CommonElements$hijackOn,
					'dragleave',
					$elm$json$Json$Decode$succeed(exitMsg)),
					A2(
					$author$project$Components$CommonElements$hijackOn,
					'drop',
					$author$project$Components$CommonElements$dropDecoder(gotFileMsg))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Utils$Styles$labelStyle]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2(
								$elm$core$Maybe$withDefault,
								'',
								A2($elm$core$Maybe$map, $elm$file$File$name, file)))
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$author$project$Utils$Styles$buttonGreyStyle,
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt4])),
							$elm$html$Html$Events$onClick(pickMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pick file')
						]))
				]));
	});
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Utils$DateAndTimeUtils$partsToLabel = function (parts) {
	var _v0 = _Utils_Tuple2(parts.ho, parts.hS);
	if ((!_v0.a) && (!_v0.b)) {
		return 'Z';
	} else {
		var sign = function () {
			var _v1 = _Utils_Tuple2(parts.hU, -parts.hU);
			if (_v1.a === 1) {
				return '+';
			} else {
				if (_v1.b === 1) {
					return '-';
				} else {
					return ' ';
				}
			}
		}();
		var minute = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(parts.hS));
		var hour = A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(parts.ho));
		return sign + (hour + (':' + minute));
	}
};
var $author$project$Utils$DateAndTimeUtils$utcOffsetLabelsList = A2($elm$core$List$map, $author$project$Utils$DateAndTimeUtils$partsToLabel, $author$project$Utils$DateAndTimeUtils$utcOffsetsPartsList);
var $author$project$Pages$MaterialEditor$viewForm = F2(
	function (sharedState, model) {
		var offsetLabelsArray = $elm$core$Array$fromList($author$project$Utils$DateAndTimeUtils$utcOffsetLabelsList);
		return $author$project$Components$CommonElements$rContainer(
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[$author$project$Utils$Styles$headerStyle]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.bZ ? 'Blatt erstellen' : 'Blatt bearbeiten')
							])),
						$author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								A6($author$project$Components$CommonElements$fileUploader, model.bB, model.d6, $author$project$Pages$MaterialEditor$DragEnter, $author$project$Pages$MaterialEditor$DragLeave, $author$project$Pages$MaterialEditor$Pick, $author$project$Pages$MaterialEditor$GotFiles)
							])),
						$author$project$Components$CommonElements$rRowExtraSpacing(
						$author$project$Components$CommonElements$r1Column(
							A4(
								$author$project$Components$CommonElements$inputElement,
								{jY: 'text', af: 'Material Name', eD: 'Name', fa: model.kY},
								0,
								model.hf,
								$author$project$Pages$MaterialEditor$SetField))),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							_List_fromArray(
								[
									$author$project$Components$CommonElements$inputLabel('Material Type'),
									$author$project$Components$CommonElements$multiButton(
									_List_fromArray(
										[
											_Utils_Tuple3(
											'Slide',
											model.bH === 1,
											$author$project$Pages$MaterialEditor$SetMaterialType(1)),
											_Utils_Tuple3(
											'Supplementary',
											!model.bH,
											$author$project$Pages$MaterialEditor$SetMaterialType(0))
										]))
								]),
							_List_fromArray(
								[
									$author$project$Components$CommonElements$inputLabel('Required Role'),
									$author$project$Components$CommonElements$multiButton(
									_List_fromArray(
										[
											_Utils_Tuple3(
											'Student',
											!model.bc,
											$author$project$Pages$MaterialEditor$SetRequiredRole(0)),
											_Utils_Tuple3(
											'Tutor',
											model.bc === 1,
											$author$project$Pages$MaterialEditor$SetRequiredRole(1)),
											_Utils_Tuple3(
											'Admin',
											model.bc === 2,
											$author$project$Pages$MaterialEditor$SetRequiredRole(2))
										]))
								]))),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$dateInputElement,
								{
									nb: model.eI,
									af: 'Published date',
									lY: $author$project$Pages$MaterialEditor$datePickerSettings(sharedState),
									fa: model.bb
								},
								2,
								model.hf,
								$author$project$Pages$MaterialEditor$PublishedDatePickerMsg),
							A4(
								$author$project$Components$CommonElements$timeInputElement,
								{af: 'Published time', eD: 'Select time...', lY: $author$project$Pages$MaterialEditor$timePickerSettings, oZ: model.dk},
								1,
								model.hf,
								$author$project$Pages$MaterialEditor$PublishedTimePickerMsg))),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$dateInputElement,
								{
									nb: model.eq,
									af: 'Lecture date',
									lY: $author$project$Pages$MaterialEditor$datePickerSettings(sharedState),
									fa: model.a4
								},
								4,
								model.hf,
								$author$project$Pages$MaterialEditor$LectureDatePickerMsg),
							A4(
								$author$project$Components$CommonElements$timeInputElement,
								{af: 'Lecture time', eD: 'Select time...', lY: $author$project$Pages$MaterialEditor$timePickerSettings, oZ: model.c1},
								3,
								model.hf,
								$author$project$Pages$MaterialEditor$LectureTimePickerMsg))),
						$author$project$Components$CommonElements$rRow(
						$author$project$Components$CommonElements$r1Column(
							A4(
								$author$project$Components$CommonElements$sliderInputElement,
								{
									af: 'UTC Offset',
									kK: $elm$core$Array$length(offsetLabelsArray) - 1,
									kT: 0,
									l6: 1,
									fa: model.aB,
									pi: A2(
										$elm$core$Maybe$withDefault,
										'Z',
										A2($elm$core$Array$get, model.aB, offsetLabelsArray))
								},
								5,
								model.hf,
								$author$project$Pages$MaterialEditor$SetField))),
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2(
								$author$project$Components$CommonElements$PbbActive,
								model.bZ ? 'Erstellen' : 'Bearbeiten',
								model.bZ ? $author$project$Pages$MaterialEditor$Create : $author$project$Pages$MaterialEditor$Update)))
					]),
				(!model.bZ) ? _List_fromArray(
					[
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2($author$project$Components$CommonElements$PbbActive, 'Löschen', $author$project$Pages$MaterialEditor$RequestDelete)))
					]) : _List_Nil));
	});
var $author$project$Pages$MaterialEditor$viewFormLoadingOrError = F2(
	function (sharedState, model) {
		var _v0 = model.c6;
		_v0$4:
		while (true) {
			switch (_v0.$) {
				case 1:
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				case 2:
					if (_v0.a.$ === 3) {
						switch (_v0.a.a) {
							case 400:
								return $elm$html$Html$text('Wrong Format');
							case 401:
								return $elm$html$Html$text('Not Logged In');
							case 403:
								return $elm$html$Html$text('Not permitted');
							default:
								break _v0$4;
						}
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return A2($author$project$Pages$MaterialEditor$viewForm, sharedState, model);
	});
var $author$project$Pages$MaterialEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$MaterialEditor$ToastyMsg, model.iC),
					A2($author$project$Pages$MaterialEditor$viewDeleteMaterialDialog, sharedState, model),
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							A2($author$project$Pages$MaterialEditor$viewFormLoadingOrError, sharedState, model)
						]))
				]));
	});
var $author$project$Pages$PasswordReset$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$PasswordReset$SetField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$PasswordReset$SetPassword = {$: 2};
var $author$project$Pages$PasswordReset$view = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$PasswordReset$ToastyMsg, model.iC),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w3, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$mv4]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/Logo.svg')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40])),
									$elm$html$Html$Events$onSubmit($author$project$Pages$PasswordReset$SetPassword)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$fieldset,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$legend,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$pa0, $justgage$tachyons_elm$Tachyons$Classes$mb2])),
													$author$project$Utils$Styles$headerStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('page-title-reset'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4]))
												]),
											A4(
												$author$project$Components$CommonElements$inputElement,
												{jY: 'password', af: 'Password', eD: 'Password', fa: model.lb},
												0,
												model.hf,
												$author$project$Pages$PasswordReset$SetField)),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4]))
												]),
											A4(
												$author$project$Components$CommonElements$inputElement,
												{jY: 'password', af: 'Password repeat', eD: 'Password', fa: model.dg},
												1,
												model.hf,
												$author$project$Pages$PasswordReset$SetField)),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Utils$Styles$buttonGreyStyle,
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$w_100])),
													$elm$html$Html$Events$onClick($author$project$Pages$PasswordReset$SetPassword)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Change Password')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$mt3]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Utils$Styles$linkGreyStyle,
													$elm$html$Html$Events$onClick(
													$author$project$Pages$PasswordReset$NavigateTo($author$project$Routing$Helpers$LoginRoute))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ich erinnere mich doch')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ProfileEditor$PasswordRepeat = 8;
var $author$project$Pages$ProfileEditor$RequestAccountDelete = {$: 8};
var $author$project$Pages$ProfileEditor$Save = {$: 7};
var $author$project$Pages$ProfileEditor$SetField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$ProfileEditor$DragEnter = {$: 5};
var $author$project$Pages$ProfileEditor$DragLeave = {$: 6};
var $author$project$Pages$ProfileEditor$Pick = {$: 4};
var $justgage$tachyons_elm$Tachyons$Classes$bg_center = 'bg-center';
var $justgage$tachyons_elm$Tachyons$Classes$contain = 'contain';
var $author$project$Pages$ProfileEditor$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$Pages$ProfileEditor$GotFiles, $elm$file$File$decoder));
var $justgage$tachyons_elm$Tachyons$Classes$h4 = 'h4';
var $author$project$Pages$ProfileEditor$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Pages$ProfileEditor$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Pages$ProfileEditor$hijack, decoder));
	});
var $justgage$tachyons_elm$Tachyons$Classes$w4 = 'w4';
var $author$project$Pages$ProfileEditor$avatarUploader = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$Classes$pa4,
						$justgage$tachyons_elm$Tachyons$Classes$ba,
						$justgage$tachyons_elm$Tachyons$Classes$b__dashed,
						model.bB ? $justgage$tachyons_elm$Tachyons$Classes$b__dark_red : $justgage$tachyons_elm$Tachyons$Classes$b__black_40,
						$justgage$tachyons_elm$Tachyons$Classes$bw2,
						$justgage$tachyons_elm$Tachyons$Classes$br3,
						$justgage$tachyons_elm$Tachyons$Classes$w_50_ns,
						$justgage$tachyons_elm$Tachyons$Classes$w_100,
						$justgage$tachyons_elm$Tachyons$Classes$flex,
						$justgage$tachyons_elm$Tachyons$Classes$flex_column,
						$justgage$tachyons_elm$Tachyons$Classes$justify_center,
						$justgage$tachyons_elm$Tachyons$Classes$items_center,
						$justgage$tachyons_elm$Tachyons$Classes$fl
					])),
				A2(
				$author$project$Pages$ProfileEditor$hijackOn,
				'dragenter',
				$elm$json$Json$Decode$succeed($author$project$Pages$ProfileEditor$DragEnter)),
				A2(
				$author$project$Pages$ProfileEditor$hijackOn,
				'dragover',
				$elm$json$Json$Decode$succeed($author$project$Pages$ProfileEditor$DragEnter)),
				A2(
				$author$project$Pages$ProfileEditor$hijackOn,
				'dragleave',
				$elm$json$Json$Decode$succeed($author$project$Pages$ProfileEditor$DragLeave)),
				A2($author$project$Pages$ProfileEditor$hijackOn, 'drop', $author$project$Pages$ProfileEditor$dropDecoder)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w4, $justgage$tachyons_elm$Tachyons$Classes$h4, $justgage$tachyons_elm$Tachyons$Classes$contain, $justgage$tachyons_elm$Tachyons$Classes$bg_center])),
						A2($elm$html$Html$Attributes$style, 'background-image', 'url(\'' + (model.dj + '\')'))
					]),
				_List_Nil),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$author$project$Utils$Styles$buttonGreyStyle,
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt4])),
						$elm$html$Html$Events$onClick($author$project$Pages$ProfileEditor$Pick)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Pick avatar')
					]))
			]));
};
var $justgage$tachyons_elm$Tachyons$Classes$bt = 'bt';
var $justgage$tachyons_elm$Tachyons$Classes$pl4_ns = 'pl4-ns';
var $justgage$tachyons_elm$Tachyons$Classes$pt4 = 'pt4';
var $justgage$tachyons_elm$Tachyons$Classes$f4 = 'f4';
var $justgage$tachyons_elm$Tachyons$Classes$fw2 = 'fw2';
var $author$project$Utils$Styles$sectionStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$f4, $justgage$tachyons_elm$Tachyons$Classes$fw2, $justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$b, $justgage$tachyons_elm$Tachyons$Classes$lh_title]));
var $author$project$Pages$ProfileEditor$viewForm = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[$author$project$Utils$Styles$headerStyle]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t('form-title-profile'))
						])),
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[
							$author$project$Pages$ProfileEditor$avatarUploader(model),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl4_ns, $justgage$tachyons_elm$Tachyons$Classes$mt3_ns, $justgage$tachyons_elm$Tachyons$Classes$mt4]))
								]),
							_Utils_ap(
								A4(
									$author$project$Components$CommonElements$inputElement,
									{
										jY: 'text',
										af: t('form-firstname'),
										eD: t('form-firstname'),
										fa: model.j_
									},
									0,
									model.bi,
									$author$project$Pages$ProfileEditor$SetField),
								A4(
									$author$project$Components$CommonElements$inputElement,
									{
										jY: 'text',
										af: t('form-lastname'),
										eD: t('form-lastname'),
										fa: model.kB
									},
									1,
									model.bi,
									$author$project$Pages$ProfileEditor$SetField)))
						])),
					$author$project$Components$CommonElements$rRowExtraSpacing(
					A2(
						$author$project$Components$CommonElements$r2Column,
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'text',
								af: t('form-course-of-studies'),
								eD: 'Informatik / Medieninformatik / Medizininformatik / ...',
								fa: model.mb
							},
							5,
							model.bi,
							$author$project$Pages$ProfileEditor$SetField),
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'number',
								af: t('form-semester'),
								eD: t('form-semester'),
								fa: model.lW
							},
							4,
							model.bi,
							$author$project$Pages$ProfileEditor$SetField))),
					$author$project$Components$CommonElements$rRow(
					$author$project$Components$CommonElements$r1Column(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'number',
								af: t('form-matriculation-number'),
								eD: '000000 (Uni Tübingen)',
								fa: model.oR
							},
							3,
							model.bi,
							$author$project$Pages$ProfileEditor$SetField))),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$Styles$sectionStyle,
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$mb3, $justgage$tachyons_elm$Tachyons$Classes$mt0]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account')
						])),
					$author$project$Components$CommonElements$rRow(
					$author$project$Components$CommonElements$r1Column(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'email',
								af: t('mail-address'),
								eD: t('mail-address'),
								fa: model.jM
							},
							2,
							model.bq,
							$author$project$Pages$ProfileEditor$SetField))),
					$author$project$Components$CommonElements$rRow(
					A2(
						$author$project$Components$CommonElements$r2Column,
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'password',
								af: t('form-new-password'),
								eD: 'Password',
								fa: model.lb
							},
							7,
							model.bq,
							$author$project$Pages$ProfileEditor$SetField),
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'password',
								af: t('form-repeat-password'),
								eD: 'Password',
								fa: model.dg
							},
							8,
							model.bq,
							$author$project$Pages$ProfileEditor$SetField))),
					$author$project$Components$CommonElements$rRow(
					$author$project$Components$CommonElements$r1Column(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{
								jY: 'password',
								af: t('form-old-password'),
								eD: 'Password',
								fa: model.k3
							},
							6,
							model.bq,
							$author$project$Pages$ProfileEditor$SetField))),
					$author$project$Components$CommonElements$rRowButton(
					$author$project$Components$CommonElements$PbbButton(
						($author$project$Pages$ProfileEditor$checkIfAccountChanged(model) || ($author$project$Pages$ProfileEditor$checkIfUserChanged(model) || model.cv)) ? A2(
							$author$project$Components$CommonElements$PbbActive,
							t('action-save'),
							$author$project$Pages$ProfileEditor$Save) : $author$project$Components$CommonElements$PbbDisabled(
							t('action-save')))),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$author$project$Utils$Styles$sectionStyle,
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$mt5, $justgage$tachyons_elm$Tachyons$Classes$bt, $justgage$tachyons_elm$Tachyons$Classes$b__dark_gray, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$pt4]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Account Actions')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$justify_center, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$flex_wrap]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns])),
									$author$project$Utils$Styles$textStyle
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									t('form-delete-account'))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$author$project$Utils$Styles$buttonRedStyle,
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$w_100])),
											$elm$html$Html$Events$onClick($author$project$Pages$ProfileEditor$RequestAccountDelete)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t('action-delete'))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$ProfileEditor$viewFormLoadingOrError = F2(
	function (sharedState, model) {
		var _v0 = model.mE;
		_v0$2:
		while (true) {
			switch (_v0.$) {
				case 1:
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				case 2:
					if ((_v0.a.$ === 3) && (_v0.a.a === 403)) {
						return $elm$html$Html$text('Not permitted');
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return A2($author$project$Pages$ProfileEditor$viewForm, sharedState, model);
	});
var $author$project$Pages$ProfileEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$ProfileEditor$ToastyMsg, model.iC),
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							A2($author$project$Pages$ProfileEditor$viewFormLoadingOrError, sharedState, model)
						]))
				]));
	});
var $author$project$Pages$Registration$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$Registration$Register = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$Registration$SetField = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Pages$Registration$TogglePlagiarismClauseAcceptance = {$: 6};
var $author$project$Components$CommonElements$checkBoxError = F3(
	function (config, field, errors) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$ma0, $justgage$tachyons_elm$Tachyons$Classes$pv2, $justgage$tachyons_elm$Tachyons$Classes$ph0, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$black_80]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Events$onClick(config.kS),
							$elm$html$Html$Attributes$checked(config.hA),
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$ma1]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$b]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(config.af)
						])),
					A2($author$project$Components$CommonElements$viewFormErrors, field, errors),
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[config.jC]))
				]));
	});
var $author$project$Pages$Registration$degrees = _List_fromArray(
	['Bachelor of Science', 'Master of Science', 'Bachelor of Education', 'Master of Education', 'Bachelor of Arts', 'Master of Arts', 'PhD', 'LA GymPO']);
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$Components$CommonElements$dropdownElement = F5(
	function (inputConfig, options, field, errors, msg) {
		return _List_fromArray(
			[
				$author$project$Components$CommonElements$inputLabel(inputConfig.af),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$author$project$Utils$Styles$lineInputStyle,
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3])),
						$elm$html$Html$Events$onInput(
						msg(field))
					]),
				options),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $author$project$Utils$Styles$linkGoldStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$linkStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$gold])));
var $author$project$Pages$Registration$majors = _List_fromArray(
	['Accounting and Finance', 'Bioinformatik', 'Biologie', 'Computational Neuroscience', 'Computerlinguistik', 'Economics and Business Administration', 'General Management', 'Geographie', 'Germanistik', 'Koreanistik', 'Philosophie', 'Physik', 'Psychologie', 'Informatik', 'Erweiterungsfach Informatik', 'International Business Administration', 'International Economics', 'Japanologie', 'Kognitionswissenschaft', 'Machine Learning', 'Mathematik', 'Medieninformatik', 'Medienwissenschaften', 'Medizininformatik (Uni Tübingen)', 'Medizintechnik (Uni Stuttgart)', 'Nanoscience', 'Sinologie']);
var $author$project$Pages$Registration$NoUniversityMailWarningVisible = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$Registration$NoOp = {$: 7};
var $author$project$Pages$Registration$noUniversityMailDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Pages$Registration$NoUniversityMailWarningVisible, true, $author$project$Pages$Registration$NoOp);
var $author$project$Pages$Registration$noUniEmailDialog = F2(
	function (sharedState, model) {
		return A5(
			$author$project$Components$Dialog$modalDialog,
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Utils$Styles$dialogOverlayStyle]),
			A3(
				$author$project$Components$Dialog$dialog,
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Utils$Styles$dialogContainerStyle]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph1, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$b__black]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Unzulässige E-Mail-Adresse')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt4]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[$author$project$Utils$Styles$textStyle]),
								_List_fromArray(
									[
										$elm$html$Html$text('Bitte verwende deine E-Mail-Adresse der Universität (...@student.uni-tuebingen.de).')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$fr, $justgage$tachyons_elm$Tachyons$Classes$mt3]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(_List_Nil),
												$author$project$Utils$Styles$buttonRedStyle,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Registration$Register(true))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Trotzdem Registrieren')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(
												_List_fromArray(
													[$justgage$tachyons_elm$Tachyons$Classes$ml3])),
												$author$project$Utils$Styles$buttonGreenStyle,
												$elm$html$Html$Events$onClick(
												$author$project$Pages$Registration$NoUniversityMailWarningVisible(false))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('E-Mail-Adresse ändern')
											]))
									]))
							]))
					])),
			model.ex,
			$author$project$Pages$Registration$noUniversityMailDialogConfig);
	});
var $justgage$tachyons_elm$Tachyons$Classes$pl3_ns = 'pl3-ns';
var $author$project$Pages$Registration$subjectOption = function (subject) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$selected((subject === 'Bachelor of Science') || (subject === 'Informatik')),
				$elm$html$Html$Attributes$value(subject)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(subject)
			]));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $justgage$tachyons_elm$Tachyons$Classes$w_20_ns = 'w-20-ns';
var $justgage$tachyons_elm$Tachyons$Classes$w_30_ns = 'w-30-ns';
var $author$project$Pages$Registration$view = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A2($author$project$Pages$Registration$noUniEmailDialog, sharedState, model),
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$Registration$ToastyMsg, model.iC),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$center]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$w3, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$mv4, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src('/images/Logo.svg')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$pl3, $justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('C++ Blockkurs 2026 (Lehrstuhl Angewandte Bioinformatik)')
										]))
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40])),
									$elm$html$Html$Events$onSubmit(
									$author$project$Pages$Registration$Register(false))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$fieldset,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$legend,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$pa0, $justgage$tachyons_elm$Tachyons$Classes$mb2])),
													$author$project$Utils$Styles$headerStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('page-title-registration'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_Utils_ap(
														_List_fromArray(
															[
																$elm$html$Html$text('Hinweis: Zur Registrierung '),
																A2(
																$elm$html$Html$b,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(_List_Nil)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('muss')
																	])),
																$elm$html$Html$text(' die universitäre E-Mail-Adresse (...@student.uni-tuebingen.de) verwendet werden. ')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Falls diese noch nicht vergeben wurde, bitte an '),
																A2(
																$elm$html$Html$a,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$link])),
																		$elm$html$Html$Attributes$href('mailto:timo.sachsenberg@uni-tuebingen.de?subject=[C++] Registrierung')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('timo.sachsenberg@uni-tuebingen.de')
																	])),
																$elm$html$Html$text(' wenden. '),
																$elm$html$Html$text('Geben Sie in diesem Fall in Ihrer E-Mail an uns die folgenden Daten an: '),
																$elm$html$Html$text('Vorname, Nachname, Studiengang, Semester, Matrikelnummer (falls vorhanden).')
															])))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$w_100]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'text',
																	af: t('form-firstname'),
																	eD: t('form-firstname'),
																	fa: model.hi
																},
																3,
																model.hf,
																$author$project$Pages$Registration$SetField)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'text',
																	af: t('form-lastname'),
																	eD: t('form-lastname'),
																	fa: model.hD
																},
																4,
																model.hf,
																$author$project$Pages$Registration$SetField))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_30_ns]))
																]),
															A5(
																$author$project$Components$CommonElements$dropdownElement,
																{jY: 'text', af: 'Abschluss', fa: model.cG},
																A2($elm$core$List$map, $author$project$Pages$Registration$subjectOption, $author$project$Pages$Registration$degrees),
																8,
																model.hf,
																$author$project$Pages$Registration$SetField)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl3_ns]))
																]),
															A5(
																$author$project$Components$CommonElements$dropdownElement,
																{
																	jY: 'text',
																	af: t('form-course-of-studies'),
																	fa: model.mb
																},
																A2($elm$core$List$map, $author$project$Pages$Registration$subjectOption, $author$project$Pages$Registration$majors),
																7,
																model.hf,
																$author$project$Pages$Registration$SetField)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_20_ns, $justgage$tachyons_elm$Tachyons$Classes$pl3_ns]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'number',
																	af: t('form-semester'),
																	eD: '1',
																	fa: model.lW
																},
																6,
																model.hf,
																$author$project$Pages$Registration$SetField))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'number',
																	af: t('form-matriculation-number'),
																	eD: '000000 (Uni Tübingen)',
																	fa: model.oR
																},
																5,
																model.hf,
																$author$project$Pages$Registration$SetField))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'email',
																	af: t('mail-address'),
																	eD: 'Email',
																	fa: model.jM
																},
																0,
																model.hf,
																$author$project$Pages$Registration$SetField))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'password',
																	af: t('password'),
																	eD: t('password'),
																	fa: model.lb
																},
																1,
																model.hf,
																$author$project$Pages$Registration$SetField)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$fl, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$w_50_ns, $justgage$tachyons_elm$Tachyons$Classes$pl2_ns]))
																]),
															A4(
																$author$project$Components$CommonElements$inputElement,
																{
																	jY: 'password',
																	af: t('form-repeat-password'),
																	eD: 'Password',
																	fa: model.dg
																},
																2,
																model.hf,
																$author$project$Pages$Registration$SetField))
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph2_ns]))
												]),
											_List_fromArray(
												[
													A3(
													$author$project$Components$CommonElements$checkBoxError,
													{
														jC: A2(
															$elm$html$Html$div,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	t('registration-plagiarism-description-first')),
																	A2(
																	$elm$html$Html$a,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$target('_blank'),
																			$elm$html$Html$Attributes$href('https://uni-tuebingen.de/fakultaeten/mathematisch-naturwissenschaftliche-fakultaet/fachbereiche/informatik/studium/downloads/informationen-und-formulare/'),
																			$author$project$Utils$Styles$linkGoldStyle
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(
																			t('registration-plagiarism-description-link'))
																		])),
																	$elm$html$Html$text(
																	t('registration-plagiarism-description-last'))
																])),
														hA: model.c$,
														af: t('registration-plagiarism-label'),
														kS: $author$project$Pages$Registration$TogglePlagiarismClauseAcceptance
													},
													9,
													model.hf)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('* Studiengang oder Abschluss nicht gefunden? '),
															$elm$html$Html$text('Bitte an '),
															A2(
															$elm$html$Html$a,
															_List_fromArray(
																[
																	$justgage$tachyons_elm$Tachyons$classes(
																	_List_fromArray(
																		[$justgage$tachyons_elm$Tachyons$Classes$link])),
																	$elm$html$Html$Attributes$href('mailto:timo.sachsenberg@uni-tuebingen.de?subject=[C++] Registrierung')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('timo.sachsenberg@uni-tuebingen.de')
																])),
															$elm$html$Html$text(' wenden. '),
															$elm$html$Html$text('Geben Sie in diesem Fall in Ihrer E-Mail an uns den fehlenden Studiengang oder Abschluss an.')
														]))
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Utils$Styles$buttonGreyStyle,
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('form-register'))
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$mt3]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$Pages$Registration$NavigateTo($author$project$Routing$Helpers$LoginRoute)),
													$author$project$Utils$Styles$linkGreyStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('form-login'))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$RequestPasswordReset$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$RequestPasswordReset$RequestReset = {$: 2};
var $author$project$Pages$RequestPasswordReset$SetField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Pages$RequestPasswordReset$view = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$RequestPasswordReset$ToastyMsg, model.iC),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w3, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$mv4]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/Logo.svg')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$mw7, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$black_40]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$fieldset,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$legend,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$pa0, $justgage$tachyons_elm$Tachyons$Classes$mb2])),
													$author$project$Utils$Styles$headerStyle
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													t('page-title-reset'))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4]))
												]),
											A4(
												$author$project$Components$CommonElements$inputElement,
												{jY: 'email', af: 'Email address', eD: 'Email', fa: model.jM},
												0,
												model.hf,
												$author$project$Pages$RequestPasswordReset$SetField)),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Utils$Styles$buttonGreyStyle,
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$w_100])),
													$elm$html$Html$Events$onClick($author$project$Pages$RequestPasswordReset$RequestReset)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Reset')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$mt3]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$author$project$Utils$Styles$linkGreyStyle,
													$elm$html$Html$Events$onClick(
													$author$project$Pages$RequestPasswordReset$NavigateTo($author$project$Routing$Helpers$LoginRoute))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ich erinnere mich doch')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Pages$SheetDetail$DownloadSheet = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Pages$SheetDetail$checkIfSheetStillActive = F2(
	function (sharedState, deadlineTime) {
		return _Utils_cmp(
			$elm$time$Time$posixToMillis(deadlineTime),
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2($elm$core$Maybe$map, $elm$time$Time$posixToMillis, sharedState.jx))) < 0;
	});
var $author$project$Utils$DateFormatter$dateAndTimeFormatter = F2(
	function (sharedState, time) {
		var timeFormat = A2($author$project$Utils$DateFormatter$timeFormatter, sharedState, time);
		var dateFormat = A2($author$project$Utils$DateFormatter$shortDateFormatter, sharedState, time);
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(dateFormat + (' - ' + timeFormat))
				]));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $justgage$tachyons_elm$Tachyons$Classes$b__white_60 = 'b--white-60';
var $justgage$tachyons_elm$Tachyons$Classes$ma2 = 'ma2';
var $author$project$Components$CommonElements$rRowWarning = F2(
	function (header, body) {
		return $author$project$Components$CommonElements$rRow(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$bg_red, $justgage$tachyons_elm$Tachyons$Classes$b__white_60, $justgage$tachyons_elm$Tachyons$Classes$bw1, $justgage$tachyons_elm$Tachyons$Classes$br3, $justgage$tachyons_elm$Tachyons$Classes$ma2, $justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$mw8, $justgage$tachyons_elm$Tachyons$Classes$shadow_5]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$author$project$Utils$Styles$listHeadingStyle,
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$mt0]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(header)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$author$project$Utils$Styles$textStyle,
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$white]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(body)
								]))
						]))
				]));
	});
var $author$project$Pages$SheetDetail$sumTasksPoints = function (model) {
	return A3(
		$elm$core$List$foldl,
		$elm$core$Basics$add,
		0,
		A2(
			$elm$core$List$map,
			function (taskModel) {
				switch (taskModel.$) {
					case 0:
						var admin = taskModel.a;
						return A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toInt(admin.kO));
					case 1:
						var student = taskModel.a;
						return student.mk.kO;
					default:
						var tutor = taskModel.a;
						return tutor.mk.kO;
				}
			},
			$elm$core$Dict$values(model.e$)));
};
var $author$project$Pages$SheetDetail$viewSheetDetail = F2(
	function (sharedState, model) {
		var maybePoints = function () {
			var _v2 = model.eE;
			if (_v2.$ === 3) {
				var points = _v2.a;
				return $elm$core$Maybe$Just(
					function (_v3) {
						var fst = _v3.a;
						var snd = _v3.b;
						var thrd = _v3.c;
						return {
							iW: thrd,
							iX: fst,
							g1: function () {
								var _v4 = model.gn;
								if (!_v4.$) {
									var percentage = _v4.a;
									var acquiredPerc = $elm$core$Basics$round((fst / snd) * 100);
									return (_Utils_cmp(acquiredPerc, percentage) < 0) ? $justgage$tachyons_elm$Tachyons$Classes$red : ((_Utils_cmp(acquiredPerc, percentage + 5) < 0) ? $justgage$tachyons_elm$Tachyons$Classes$gold : $justgage$tachyons_elm$Tachyons$Classes$dark_green);
								} else {
									return $justgage$tachyons_elm$Tachyons$Classes$dark_red;
								}
							}(),
							kO: snd
						};
					}(
						_Utils_Tuple3(
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.iX;
									},
									points)),
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.kO;
									},
									points)),
							$elm$core$List$sum(
								A2(
									$elm$core$List$map,
									function (p) {
										return p.iW;
									},
									points)))));
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var _v0 = model.eS;
		switch (_v0.$) {
			case 3:
				var detail = _v0.a;
				return $author$project$Components$CommonElements$rContainer(
					_List_fromArray(
						[
							A3(
							$author$project$Components$CommonElements$rRowHeaderActionButtons,
							detail.kY,
							$author$project$Utils$Styles$headerStyle,
							_Utils_ap(
								_List_fromArray(
									[
										_Utils_Tuple3(
										'Download',
										A2($author$project$Pages$SheetDetail$DownloadSheet, model.jv, model.ki),
										$author$project$Utils$Styles$buttonGreenStyle)
									]),
								_Utils_eq(
									model.lJ,
									$elm$core$Maybe$Just(2)) ? _List_fromArray(
									[
										_Utils_Tuple3(
										'Edit',
										$author$project$Pages$SheetDetail$NavigateTo(
											A2($author$project$Routing$Helpers$EditSheetRoute, model.jv, model.ki)),
										$author$project$Utils$Styles$buttonGreyStyle)
									]) : _List_Nil)),
							A2($author$project$Pages$SheetDetail$checkIfSheetStillActive, sharedState, detail.jJ) ? A2(
							$author$project$Components$CommonElements$rRowWarning,
							'Submission closed',
							'The sheet was due ' + (A2($author$project$Utils$DateFormatter$shortDateFormatter, sharedState, detail.jJ) + (' at ' + A2($author$project$Utils$DateFormatter$timeFormatter, sharedState, detail.jJ)))) : $elm$html$Html$text(''),
							$author$project$Components$CommonElements$rRow(
							A2(
								$author$project$Components$CommonElements$r2Column,
								_List_fromArray(
									[
										$author$project$Components$CommonElements$datesDisplayContainer(
										_Utils_ap(
											A2(
												$author$project$Components$CommonElements$dateElement,
												'Abgabezeit',
												A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, detail.jJ)),
											A2(
												$author$project$Components$CommonElements$dateElement,
												'Maximale Punkte',
												$elm$html$Html$text(
													$elm$core$String$fromInt(
														$author$project$Pages$SheetDetail$sumTasksPoints(model))))))
									]),
								_List_fromArray(
									[
										function () {
										if (!maybePoints.$) {
											var mp = maybePoints.a;
											return A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$h4,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ttu, $justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mb1]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Erreichte Punkte')
															])),
														A2(
														$elm$html$Html$h1,
														_List_fromArray(
															[
																$justgage$tachyons_elm$Tachyons$classes(
																_List_fromArray(
																	[mp.g1, $justgage$tachyons_elm$Tachyons$Classes$mt0, $justgage$tachyons_elm$Tachyons$Classes$f3])),
																$author$project$Utils$Styles$headerStyle
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																$elm$core$String$fromInt(mp.iX) + ('/' + ($elm$core$String$fromInt(mp.iW) + (' (maximal erreichbar: ' + ($elm$core$String$fromInt(mp.kO) + ')')))))
															]))
													]));
										} else {
											return $elm$html$Html$text('');
										}
									}()
									])))
						]));
			case 2:
				var err = _v0.a;
				return $elm$html$Html$text('Error loading');
			default:
				return $elm$html$Html$text('Loading');
		}
	});
var $author$project$Pages$SheetDetail$compareTaskModel = F2(
	function (modelA, modelB) {
		var _v0 = _Utils_Tuple2(modelA, modelB);
		_v0$3:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return A2($elm$core$Basics$compare, a.kY, b.kY);
					} else {
						break _v0$3;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return A2($elm$core$Basics$compare, a.mk.kY, b.mk.kY);
					} else {
						break _v0$3;
					}
				default:
					if (_v0.b.$ === 2) {
						var a = _v0.a.a;
						var b = _v0.b.a;
						return A2($elm$core$Basics$compare, a.mk.kY, b.mk.kY);
					} else {
						break _v0$3;
					}
			}
		}
		return 1;
	});
var $justgage$tachyons_elm$Tachyons$Classes$mh3 = 'mh3';
var $author$project$Components$Tasks$AdminView$DragEnter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Components$Tasks$AdminView$DragLeave = function (a) {
	return {$: 5, a: a};
};
var $author$project$Components$Tasks$AdminView$MaxPoints = 0;
var $author$project$Components$Tasks$AdminView$Name = 1;
var $author$project$Components$CommonElements$PbbFailure = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CommonElements$PbbProgressBar = function (a) {
	return {$: 1, a: a};
};
var $author$project$Components$CommonElements$PbbResult = function (a) {
	return {$: 2, a: a};
};
var $author$project$Components$CommonElements$PbbSuccess = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Tasks$AdminView$Pick = function (a) {
	return {$: 3, a: a};
};
var $author$project$Components$Tasks$AdminView$PrivateDockerImage = 3;
var $author$project$Components$Tasks$AdminView$PublicDockerImage = 2;
var $author$project$Components$Tasks$AdminView$SendTask = {$: 0};
var $author$project$Components$Tasks$AdminView$SetField = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Components$Tasks$AdminView$ToggleCollapse = {$: 11};
var $author$project$Components$Tasks$AdminView$chooseFile = function (fileType) {
	if (!fileType) {
		return function ($) {
			return $.eH;
		};
	} else {
		return function ($) {
			return $.eG;
		};
	}
};
var $author$project$Components$Tasks$AdminView$chooseHover = function (fileType) {
	if (!fileType) {
		return function ($) {
			return $.gj;
		};
	} else {
		return function ($) {
			return $.gh;
		};
	}
};
var $author$project$Utils$Styles$pillStyle = $justgage$tachyons_elm$Tachyons$classes(
	_List_fromArray(
		[$justgage$tachyons_elm$Tachyons$Classes$br4, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$pv3]));
var $author$project$Components$CommonElements$rCollapsable = F5(
	function (title, collapsed, collapseMsg, _v0, childs) {
		var show = _v0.a;
		var hide = _v0.b;
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$Classes$w_100,
								$justgage$tachyons_elm$Tachyons$Classes$flex,
								$justgage$tachyons_elm$Tachyons$Classes$flex_row,
								$justgage$tachyons_elm$Tachyons$Classes$justify_between,
								$justgage$tachyons_elm$Tachyons$Classes$items_center,
								collapsed ? $justgage$tachyons_elm$Tachyons$Classes$mb3 : $justgage$tachyons_elm$Tachyons$Classes$mb0
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[$author$project$Utils$Styles$listHeadingStyle]),
						_List_fromArray(
							[
								$elm$html$Html$text(title)
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$author$project$Utils$Styles$buttonGreyStyle,
								$author$project$Utils$Styles$pillStyle,
								$elm$html$Html$Events$onClick(collapseMsg)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								collapsed ? show : hide)
							]))
					])),
			collapsed ? _List_fromArray(
				[
					$elm$html$Html$text('')
				]) : childs);
	});
var $author$project$Components$Tasks$AdminView$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$rContainer(
			A5(
				$author$project$Components$CommonElements$rCollapsable,
				model.dW ? 'New task' : model.kY,
				model.dU,
				$author$project$Components$Tasks$AdminView$ToggleCollapse,
				_Utils_Tuple2('Show', 'Hide'),
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRow(
						A4(
							$author$project$Components$CommonElements$inputElement,
							{jY: 'text', af: 'Task name', eD: 'Task 1', fa: model.kY},
							1,
							model.hf,
							$author$project$Components$Tasks$AdminView$SetField)),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							_List_fromArray(
								[
									$author$project$Components$CommonElements$inputLabel('Public Tests'),
									A6(
									$author$project$Components$CommonElements$fileUploader,
									A2($author$project$Components$Tasks$AdminView$chooseHover, 0, model),
									A2($author$project$Components$Tasks$AdminView$chooseFile, 0, model),
									$author$project$Components$Tasks$AdminView$DragEnter(0),
									$author$project$Components$Tasks$AdminView$DragLeave(0),
									$author$project$Components$Tasks$AdminView$Pick(0),
									$author$project$Components$Tasks$AdminView$GotFiles(0))
								]),
							_List_fromArray(
								[
									$author$project$Components$CommonElements$inputLabel('Private Tests'),
									A6(
									$author$project$Components$CommonElements$fileUploader,
									A2($author$project$Components$Tasks$AdminView$chooseHover, 1, model),
									A2($author$project$Components$Tasks$AdminView$chooseFile, 1, model),
									$author$project$Components$Tasks$AdminView$DragEnter(1),
									$author$project$Components$Tasks$AdminView$DragLeave(1),
									$author$project$Components$Tasks$AdminView$Pick(1),
									$author$project$Components$Tasks$AdminView$GotFiles(1))
								]))),
						$author$project$Components$CommonElements$rRowExtraSpacing(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$inputElement,
								{jY: 'text', af: 'Public Tests Docker Image', eD: 'Image Name', fa: model.ls},
								2,
								model.hf,
								$author$project$Components$Tasks$AdminView$SetField),
							A4(
								$author$project$Components$CommonElements$inputElement,
								{jY: 'text', af: 'Private Tests Docker Image', eD: 'Image Name', fa: model.lj},
								3,
								model.hf,
								$author$project$Components$Tasks$AdminView$SetField))),
						$author$project$Components$CommonElements$rRow(
						$author$project$Components$CommonElements$r1Column(
							A4(
								$author$project$Components$CommonElements$inputElement,
								{jY: 'number', af: 'Max Points', eD: 'Points', fa: model.kO},
								0,
								model.hf,
								$author$project$Components$Tasks$AdminView$SetField))),
						function () {
						if ($author$project$Components$Tasks$AdminView$anythingUploading(model) && (!$elm$core$Dict$isEmpty(model.aV))) {
							return $author$project$Components$CommonElements$rRowButton(
								$author$project$Components$CommonElements$PbbProgressBar(model.dM));
						} else {
							var stateShownLongEnough = A3(
								$elm$core$Maybe$map2,
								F2(
									function (up, cur) {
										return ($elm$time$Time$posixToMillis(cur) - $elm$time$Time$posixToMillis(up)) > 1500;
									}),
								model.gK,
								sharedState.jx);
							return $author$project$Components$CommonElements$rRowButton(
								$author$project$Components$CommonElements$PbbButton(
									($author$project$Components$Tasks$AdminView$uploadSuccess(model) && _Utils_eq(
										stateShownLongEnough,
										$elm$core$Maybe$Just(false))) ? $author$project$Components$CommonElements$PbbResult(
										$author$project$Components$CommonElements$PbbSuccess('Success')) : (($author$project$Components$Tasks$AdminView$uploadFailure(model) && _Utils_eq(
										stateShownLongEnough,
										$elm$core$Maybe$Just(false))) ? $author$project$Components$CommonElements$PbbResult(
										$author$project$Components$CommonElements$PbbFailure('Failure')) : A2($author$project$Components$CommonElements$PbbActive, 'Bearbeiten', $author$project$Components$Tasks$AdminView$SendTask))));
						}
					}()
					])));
	});
var $author$project$Components$Tasks$StudentView$DownloadSubmission = function (a) {
	return {$: 16, a: a};
};
var $author$project$Components$Tasks$StudentView$DragEnter = {$: 12};
var $author$project$Components$Tasks$StudentView$DragLeave = {$: 13};
var $author$project$Components$Tasks$StudentView$Pick = {$: 11};
var $author$project$Components$Tasks$StudentView$RateTask = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Components$Tasks$StudentView$Rating = 0;
var $author$project$Components$Tasks$StudentView$ToggleCollapse = {$: 9};
var $author$project$Components$Tasks$StudentView$UploadSubmission = {$: 0};
var $justgage$tachyons_elm$Tachyons$Classes$normal = 'normal';
var $author$project$Components$CommonElements$rCollapsablePlain = F5(
	function (msgs, collapsed, collapseMsg, _v0, childs) {
		var show = _v0.a;
		var hide = _v0.b;
		return A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$Classes$w_100,
								$justgage$tachyons_elm$Tachyons$Classes$flex,
								$justgage$tachyons_elm$Tachyons$Classes$flex_row,
								$justgage$tachyons_elm$Tachyons$Classes$justify_between,
								$justgage$tachyons_elm$Tachyons$Classes$items_center,
								collapsed ? $justgage$tachyons_elm$Tachyons$Classes$mb3 : $justgage$tachyons_elm$Tachyons$Classes$mb0
							]))
					]),
				_Utils_ap(
					msgs,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$author$project$Utils$Styles$buttonGreyStyle,
									$author$project$Utils$Styles$pillStyle,
									$elm$html$Html$Events$onClick(collapseMsg)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									collapsed ? show : hide)
								]))
						]))),
			collapsed ? _List_fromArray(
				[
					$elm$html$Html$text('')
				]) : childs);
	});
var $justgage$tachyons_elm$Tachyons$Classes$bg_black_90 = 'bg-black-90';
var $justgage$tachyons_elm$Tachyons$Classes$near_white = 'near-white';
var $justgage$tachyons_elm$Tachyons$Classes$overflow_scroll = 'overflow-scroll';
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Components$CommonElements$renderInTerminalBox = function (content) {
	return A2(
		$elm$html$Html$pre,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$bg_black_90, $justgage$tachyons_elm$Tachyons$Classes$near_white, $justgage$tachyons_elm$Tachyons$Classes$shadow_5, $justgage$tachyons_elm$Tachyons$Classes$br3, $justgage$tachyons_elm$Tachyons$Classes$overflow_scroll, $justgage$tachyons_elm$Tachyons$Classes$f5]))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(content)
			]));
};
var $author$project$Components$CommonElements$renderInTextBox = F2(
	function (content, renderMarkdown) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$pv3, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ph2, $justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mb3, $justgage$tachyons_elm$Tachyons$Classes$bg_black_10, $justgage$tachyons_elm$Tachyons$Classes$br3, $justgage$tachyons_elm$Tachyons$Classes$overflow_scroll]))
				]),
			_List_fromArray(
				[
					renderMarkdown ? A2(
					$elm_explorations$markdown$Markdown$toHtml,
					_List_fromArray(
						[$author$project$Utils$Styles$textStyle]),
					content) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[$author$project$Utils$Styles$textStyle]),
					_List_fromArray(
						[
							$elm$html$Html$text(content)
						]))
				]));
	});
var $justgage$tachyons_elm$Tachyons$Classes$w_50 = 'w-50';
var $author$project$Components$Tasks$StudentView$view = F3(
	function (sharedState, model, deadlineReached) {
		var upl = function () {
			var _v7 = model.aq;
			if (_v7.$ === 3) {
				var grade = _v7.a;
				return A2($elm$core$String$contains, 'Fehlerhafte Abgabe!', grade.lu) ? A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$dark_red]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dd,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$ml0]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Fehlerhaft hochgeladen: '),
									A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD)
								]))
						])) : (A2($elm$core$String$contains, 'submission received and will be tested', grade.lu) ? A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$dark_red]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dd,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$ml0]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Validierung der Abgabe steht noch aus: '),
									A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD)
								]))
						])) : A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$dark_green]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$dd,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$ml0]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Erfolgreich hochgeladen: '),
									A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD)
								]))
						])));
			} else {
				return A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$dark_red]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Noch nichts hochgeladen.')
						]));
			}
		}();
		var showUpl = function () {
			var _v6 = model.e0;
			if (_v6.$ === 3) {
				var b = _v6.a;
				return b.jd;
			} else {
				return false;
			}
		}();
		return showUpl ? $author$project$Components$CommonElements$rContainer(
			A5(
				$author$project$Components$CommonElements$rCollapsablePlain,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[$author$project$Utils$Styles$listHeadingStyle]),
						_List_fromArray(
							[
								$elm$html$Html$text(model.mk.kY)
							])),
						upl
					]),
				model.dU,
				$author$project$Components$Tasks$StudentView$ToggleCollapse,
				_Utils_Tuple2('Show', 'Hide'),
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$Components$CommonElements$rRow(
							$author$project$Components$CommonElements$r1Column(
								_List_fromArray(
									[
										$author$project$Components$CommonElements$inputLabel('Submission'),
										A2(
										$elm$html$Html$h5,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(
												_List_fromArray(
													[$justgage$tachyons_elm$Tachyons$Classes$normal, $justgage$tachyons_elm$Tachyons$Classes$black_80, $justgage$tachyons_elm$Tachyons$Classes$mt0, $justgage$tachyons_elm$Tachyons$Classes$mb1]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('For '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$fw6]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('programming exercises:')
													])),
												$elm$html$Html$text(' Upload a '),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$fw6]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('zip-file')
													])),
												$elm$html$Html$text(' that contains the submission folder of your C++ project.')
											])),
										A6($author$project$Components$CommonElements$fileUploader, model.bB, model.bP, $author$project$Components$Tasks$StudentView$DragEnter, $author$project$Components$Tasks$StudentView$DragLeave, $author$project$Components$Tasks$StudentView$Pick, $author$project$Components$Tasks$StudentView$GotFiles)
									]))),
							function () {
							if (_Utils_eq(model.aV, $krisajenkins$remotedata$RemoteData$Loading)) {
								return $author$project$Components$CommonElements$rRowButton(
									$author$project$Components$CommonElements$PbbProgressBar(model.gL));
							} else {
								var success = $krisajenkins$remotedata$RemoteData$isSuccess(model.aV);
								var stateShownLongEnough = A3(
									$elm$core$Maybe$map2,
									F2(
										function (up, cur) {
											return ($elm$time$Time$posixToMillis(cur) - $elm$time$Time$posixToMillis(up)) > 1500;
										}),
									model.gK,
									sharedState.jx);
								var filesSelected = function () {
									var _v2 = model.bP;
									if (!_v2.$) {
										return true;
									} else {
										return false;
									}
								}();
								var failure = $krisajenkins$remotedata$RemoteData$isFailure(model.aV);
								return $author$project$Components$CommonElements$rRow(
									A2(
										$author$project$Components$CommonElements$r2Column,
										_List_fromArray(
											[
												$author$project$Components$CommonElements$rRowButton(
												$author$project$Components$CommonElements$PbbButton(
													(success && _Utils_eq(
														stateShownLongEnough,
														$elm$core$Maybe$Just(false))) ? $author$project$Components$CommonElements$PbbResult(
														$author$project$Components$CommonElements$PbbFailure('ZIP-Check läuft..')) : ((failure && _Utils_eq(
														stateShownLongEnough,
														$elm$core$Maybe$Just(false))) ? $author$project$Components$CommonElements$PbbResult(
														$author$project$Components$CommonElements$PbbFailure('Failure')) : (deadlineReached ? $author$project$Components$CommonElements$PbbDisabled('Submission closed') : ((!filesSelected) ? $author$project$Components$CommonElements$PbbDisabled('Upload') : A2($author$project$Components$CommonElements$PbbActive, 'Upload', $author$project$Components$Tasks$StudentView$UploadSubmission))))))
											]),
										function () {
											var _v0 = model.aq;
											if (_v0.$ === 3) {
												var grade = _v0.a;
												var _v1 = grade.jZ;
												if (!_v1.$) {
													var url = _v1.a;
													return $elm$core$String$isEmpty(url) ? _List_Nil : _List_fromArray(
														[
															$author$project$Components$CommonElements$rRowButton(
															$author$project$Components$CommonElements$PbbButton(
																A2(
																	$author$project$Components$CommonElements$PbbActive,
																	'Download Submission',
																	$author$project$Components$Tasks$StudentView$DownloadSubmission(url))))
														]);
												} else {
													return _List_Nil;
												}
											} else {
												return _List_Nil;
											}
										}()));
							}
						}(),
							$author$project$Components$CommonElements$rRow(
							$author$project$Components$CommonElements$r1Column(
								_List_fromArray(
									[
										$author$project$Components$CommonElements$inputLabel('Test Results'),
										$author$project$Components$CommonElements$renderInTerminalBox(
										function () {
											var _v3 = model.aq;
											switch (_v3.$) {
												case 3:
													var grade = _v3.a;
													return grade.lu;
												case 1:
													return 'Loading';
												default:
													return 'Undefined';
											}
										}())
									]))),
							$author$project$Components$CommonElements$rRow(
							$author$project$Components$CommonElements$r1Column(
								_List_fromArray(
									[
										function () {
										var _v4 = model.aq;
										if (_v4.$ === 3) {
											var grade = _v4.a;
											return A2($elm$core$String$contains, 'Fehlerhafte Abgabe!', grade.lu) ? $author$project$Components$CommonElements$datesDisplayContainer(
												A2(
													$author$project$Components$CommonElements$dateElement,
													'Die Abgabe wurde zuletzt fehlerhaft hochgeladen am: ',
													A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD))) : (A2($elm$core$String$contains, 'submission received and will be tested', grade.lu) ? $author$project$Components$CommonElements$datesDisplayContainer(
												A2(
													$author$project$Components$CommonElements$dateElement,
													'Validierung der Abgabe steht noch aus: ',
													A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD))) : $author$project$Components$CommonElements$datesDisplayContainer(
												A2(
													$author$project$Components$CommonElements$dateElement,
													'Die Abgabe wurde zuletzt erfolgreich hochgeladen am: ',
													A2($author$project$Utils$DateFormatter$dateAndTimeFormatter, sharedState, grade.mD))));
										} else {
											return $elm$html$Html$text('Bisher wurde noch keine Datei hochgeladen.');
										}
									}()
									])))
						]),
					_Utils_ap(
						function () {
							var _v5 = model.aq;
							if (_v5.$ === 3) {
								var grade = _v5.a;
								return $elm$core$String$isEmpty(grade.jX) ? _List_fromArray(
									[
										$elm$html$Html$text('')
									]) : (grade.ld ? _List_fromArray(
									[
										$author$project$Components$CommonElements$rRow(
										$author$project$Components$CommonElements$r1Column(
											_List_fromArray(
												[
													$author$project$Components$CommonElements$inputLabel('Feedback'),
													A2($author$project$Components$CommonElements$renderInTextBox, grade.jX, true)
												]))),
										A2(
										$elm$html$Html$h3,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(
												_List_fromArray(
													[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$dark_red]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Diese Abgabe wurde als Plagiat erkannt und wird daher mit 0 Punkten bewertet.')
											])),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(
												_List_fromArray(
													[$justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$bt, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$b__black]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												'(Bewertung: ' + ($elm$core$String$fromInt(grade.iX) + ('/' + ($elm$core$String$fromInt(model.mk.kO) + ' Punkte)'))))
											]))
									]) : _List_fromArray(
									[
										$author$project$Components$CommonElements$rRow(
										$author$project$Components$CommonElements$r1Column(
											_List_fromArray(
												[
													$author$project$Components$CommonElements$inputLabel('Feedback'),
													A2($author$project$Components$CommonElements$renderInTextBox, grade.jX, true)
												]))),
										A2(
										$elm$html$Html$h2,
										_List_fromArray(
											[
												$justgage$tachyons_elm$Tachyons$classes(
												_List_fromArray(
													[$justgage$tachyons_elm$Tachyons$Classes$pa4, $justgage$tachyons_elm$Tachyons$Classes$mt4, $justgage$tachyons_elm$Tachyons$Classes$bt, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$b__black]))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(grade.iX) + ('/' + ($elm$core$String$fromInt(model.mk.kO) + ' Punkte')))
											]))
									]));
							} else {
								return _List_fromArray(
									[
										$elm$html$Html$text('')
									]);
							}
						}(),
						_List_fromArray(
							[
								$author$project$Components$CommonElements$rRow(
								$author$project$Components$CommonElements$r1Column(
									A4(
										$author$project$Components$CommonElements$sliderInputElement,
										{
											af: 'Rating (1 horrible, 5 great)',
											kK: 5,
											kT: 0,
											l6: 1,
											fa: model.cg,
											pi: (!model.cg) ? 'Not rated' : $elm$core$String$fromInt(model.cg)
										},
										0,
										_List_Nil,
										$author$project$Components$Tasks$StudentView$RateTask)))
							]))))) : $author$project$Components$CommonElements$rContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w_50, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$flex_row, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[$author$project$Utils$Styles$listHeadingStyle]),
									_List_fromArray(
										[
											$elm$html$Html$text(model.mk.kY)
										])),
									upl
								]))
						])),
					$author$project$Components$CommonElements$rRow(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn, $justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$dark_red]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Übungsaufgaben können ausschließlich mit einem bestätigten Team abgegeben werden.')
								]))
						]))
				]));
	});
var $author$project$Components$Tasks$TutorView$DownloadAll = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Components$Tasks$TutorView$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Components$Tasks$TutorView$view = F2(
	function (sharedState, model) {
		return A3(
			$author$project$Components$CommonElements$rRowHeaderActionButtons,
			model.mk.kY,
			$author$project$Utils$Styles$listHeadingStyle,
			function () {
				var _v0 = model.h2;
				if (!_v0.b) {
					return _List_Nil;
				} else {
					if (!_v0.b.b) {
						var singleGroup = _v0.a;
						return _List_fromArray(
							[
								_Utils_Tuple3(
								'Download All',
								A3($author$project$Components$Tasks$TutorView$DownloadAll, model.ju, model.mk.ki, singleGroup.ki),
								$author$project$Utils$Styles$buttonGreyStyle),
								_Utils_Tuple3(
								'Benoten',
								$author$project$Components$Tasks$TutorView$NavigateTo(
									A3($author$project$Routing$Helpers$SubmissionGradingRoute, model.ju, model.mk.ki, singleGroup.ki)),
								$author$project$Utils$Styles$buttonGreyStyle)
							]);
					} else {
						var groups = _v0;
						return A2(
							$elm$core$List$map,
							function (g) {
								return _Utils_Tuple3(
									'Gruppe - ' + $elm$core$String$fromInt(g.ki),
									$author$project$Components$Tasks$TutorView$NavigateTo(
										A3($author$project$Routing$Helpers$SubmissionGradingRoute, model.ju, model.mk.ki, g.ki)),
									$author$project$Utils$Styles$buttonGreyStyle);
							},
							groups);
					}
				}
			}());
	});
var $author$project$Pages$SheetDetail$viewTasks = F2(
	function (sharedState, model) {
		var sorted_tasks = A2(
			$elm$core$List$sortWith,
			$author$project$Pages$SheetDetail$compareTaskModel,
			$elm$core$Dict$values(model.e$));
		var _v0 = model.eS;
		if (_v0.$ === 3) {
			var detail = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$mh3, $justgage$tachyons_elm$Tachyons$Classes$pa1]))
					]),
				A2(
					$elm$core$List$map,
					function (_v2) {
						var id = _v2.a;
						var taskModel = _v2.b;
						return A2(
							$elm$html$Html$map,
							$author$project$Pages$SheetDetail$TaskMsg(id),
							taskModel);
					},
					A2(
						$elm$core$List$map,
						function (taskModelType) {
							switch (taskModelType.$) {
								case 0:
									var taskModel = taskModelType.a;
									return _Utils_Tuple2(
										taskModel.ki,
										A2(
											$elm$html$Html$map,
											$author$project$Pages$SheetDetail$AdminTaskMsg,
											A2($author$project$Components$Tasks$AdminView$view, sharedState, taskModel)));
								case 1:
									var taskModel = taskModelType.a;
									return _Utils_Tuple2(
										taskModel.ki,
										A2(
											$elm$html$Html$map,
											$author$project$Pages$SheetDetail$StudentTaskMsg,
											A3(
												$author$project$Components$Tasks$StudentView$view,
												sharedState,
												taskModel,
												A2($author$project$Pages$SheetDetail$checkIfSheetStillActive, sharedState, detail.jJ))));
								default:
									var taskModel = taskModelType.a;
									return _Utils_Tuple2(
										taskModel.ki,
										A2(
											$elm$html$Html$map,
											$author$project$Pages$SheetDetail$TutorTaskMsg,
											A2($author$project$Components$Tasks$TutorView$view, sharedState, taskModel)));
							}
						},
						sorted_tasks)));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Pages$SheetDetail$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							A2($author$project$Pages$SheetDetail$viewSheetDetail, sharedState, model),
							$author$project$Components$CommonElements$rRowHeader('Tasks'),
							A2($author$project$Pages$SheetDetail$viewTasks, sharedState, model)
						]))
				]));
	});
var $author$project$Pages$SheetEditor$Delete = {$: 12};
var $author$project$Pages$SheetEditor$DeleteSheetDialogShown = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$SheetEditor$NoOp = {$: 22};
var $author$project$Pages$SheetEditor$deleteSheetDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Pages$SheetEditor$DeleteSheetDialogShown, true, $author$project$Pages$SheetEditor$NoOp);
var $author$project$Pages$SheetEditor$viewDeleteSheetDialog = F2(
	function (sharedState, model) {
		return A5(
			$author$project$Components$CommonElements$simpleDialog,
			'Delete the sheet?',
			'Are you sure you want to delete the sheet? This cannot be undone. The sheet and everything associated with the sheet like submissions and tests are gone.',
			_List_fromArray(
				[
					_Utils_Tuple3('Delete', $author$project$Utils$Styles$buttonRedStyle, $author$project$Pages$SheetEditor$Delete),
					_Utils_Tuple3(
					'Cancel',
					$author$project$Utils$Styles$buttonGreenStyle,
					$author$project$Pages$SheetEditor$DeleteSheetDialogShown(false))
				]),
			model.d$,
			$author$project$Pages$SheetEditor$deleteSheetDialogConfig);
	});
var $author$project$Pages$SheetEditor$Create = {$: 7};
var $author$project$Pages$SheetEditor$DeadlineTimePickerMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$SheetEditor$DragEnter = {$: 17};
var $author$project$Pages$SheetEditor$DragLeave = {$: 18};
var $author$project$Pages$SheetEditor$Pick = {$: 16};
var $author$project$Pages$SheetEditor$PublishedTimePickerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SheetEditor$RequestDelete = {$: 11};
var $author$project$Pages$SheetEditor$SetField = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Pages$SheetEditor$Update = {$: 9};
var $author$project$Pages$SheetEditor$UtcOffset = 5;
var $author$project$Pages$SheetEditor$viewForm = F2(
	function (sharedState, model) {
		var offsetLabelsArray = $elm$core$Array$fromList($author$project$Utils$DateAndTimeUtils$utcOffsetLabelsList);
		return $author$project$Components$CommonElements$rContainer(
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[$author$project$Utils$Styles$headerStyle]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								model.b_ ? 'Blatt erstellen' : 'Blatt bearbeiten')
							])),
						$author$project$Components$CommonElements$rRow(
						_List_fromArray(
							[
								A6($author$project$Components$CommonElements$fileUploader, model.bB, model.d6, $author$project$Pages$SheetEditor$DragEnter, $author$project$Pages$SheetEditor$DragLeave, $author$project$Pages$SheetEditor$Pick, $author$project$Pages$SheetEditor$GotFiles)
							])),
						$author$project$Components$CommonElements$rRowExtraSpacing(
						$author$project$Components$CommonElements$r1Column(
							A4(
								$author$project$Components$CommonElements$inputElement,
								{jY: 'text', af: 'Sheet Name', eD: 'Name', fa: model.kY},
								0,
								model.hf,
								$author$project$Pages$SheetEditor$SetField))),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$dateInputElement,
								{
									nb: model.eI,
									af: 'Published date',
									lY: $author$project$Pages$SheetEditor$datePickerSettings(sharedState),
									fa: model.bb
								},
								2,
								model.hf,
								$author$project$Pages$SheetEditor$PublishedDatePickerMsg),
							A4(
								$author$project$Components$CommonElements$timeInputElement,
								{af: 'Published time', eD: 'Select time...', lY: $author$project$Pages$SheetEditor$timePickerSettings, oZ: model.dk},
								1,
								model.hf,
								$author$project$Pages$SheetEditor$PublishedTimePickerMsg))),
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A4(
								$author$project$Components$CommonElements$dateInputElement,
								{
									nb: model.dX,
									af: 'Deadline date',
									lY: $author$project$Pages$SheetEditor$datePickerSettings(sharedState),
									fa: model.a_
								},
								4,
								model.hf,
								$author$project$Pages$SheetEditor$DeadlineDatePickerMsg),
							A4(
								$author$project$Components$CommonElements$timeInputElement,
								{af: 'Deadline time', eD: 'Select time...', lY: $author$project$Pages$SheetEditor$timePickerSettings, oZ: model.cF},
								3,
								model.hf,
								$author$project$Pages$SheetEditor$DeadlineTimePickerMsg))),
						$author$project$Components$CommonElements$rRow(
						$author$project$Components$CommonElements$r1Column(
							A4(
								$author$project$Components$CommonElements$sliderInputElement,
								{
									af: 'UTC Offset',
									kK: $elm$core$Array$length(offsetLabelsArray) - 1,
									kT: 0,
									l6: 1,
									fa: model.aB,
									pi: A2(
										$elm$core$Maybe$withDefault,
										'Z',
										A2($elm$core$Array$get, model.aB, offsetLabelsArray))
								},
								5,
								model.hf,
								$author$project$Pages$SheetEditor$SetField))),
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2(
								$author$project$Components$CommonElements$PbbActive,
								model.b_ ? 'Erstellen' : 'Bearbeiten',
								model.b_ ? $author$project$Pages$SheetEditor$Create : $author$project$Pages$SheetEditor$Update)))
					]),
				(!model.b_) ? _List_fromArray(
					[
						$author$project$Components$CommonElements$rRowButton(
						$author$project$Components$CommonElements$PbbButton(
							A2($author$project$Components$CommonElements$PbbActive, 'Löschen', $author$project$Pages$SheetEditor$RequestDelete)))
					]) : _List_Nil));
	});
var $author$project$Pages$SheetEditor$viewFormLoadingOrError = F2(
	function (sharedState, model) {
		var _v0 = model.dr;
		_v0$4:
		while (true) {
			switch (_v0.$) {
				case 1:
					return A2($elm$html$Html$div, _List_Nil, _List_Nil);
				case 2:
					if (_v0.a.$ === 3) {
						switch (_v0.a.a) {
							case 400:
								return $elm$html$Html$text('Wrong Format');
							case 401:
								return $elm$html$Html$text('Not Logged In');
							case 403:
								return $elm$html$Html$text('Not permitted');
							default:
								break _v0$4;
						}
					} else {
						break _v0$4;
					}
				default:
					break _v0$4;
			}
		}
		return A2($author$project$Pages$SheetEditor$viewForm, sharedState, model);
	});
var $author$project$Pages$SheetEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Pages$SheetEditor$ToastyMsg, model.iC),
					A2($author$project$Pages$SheetEditor$viewDeleteSheetDialog, sharedState, model),
					$author$project$Components$CommonElements$normalPage(
					_List_fromArray(
						[
							A2($author$project$Pages$SheetEditor$viewFormLoadingOrError, sharedState, model)
						]))
				]));
	});
var $author$project$Pages$SubmissionGradingEditor$NavigateTo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$ToggleGroupChanger = {$: 5};
var $author$project$Pages$SubmissionGradingEditor$compareGradeEntries = F2(
	function (fgA, fgB) {
		var joinedName = function (fg) {
			return A2(
				$elm$core$List$map,
				function (fga) {
					return fga.kB + (' ' + fga.j_);
				},
				fg.mH);
		};
		var _v0 = _Utils_Tuple2(
			$elm$core$String$isEmpty(fgA.jX),
			$elm$core$String$isEmpty(fgB.jX));
		_v0$2:
		while (true) {
			if (_v0.a) {
				if (!_v0.b) {
					return 0;
				} else {
					break _v0$2;
				}
			} else {
				if (_v0.b) {
					return 2;
				} else {
					break _v0$2;
				}
			}
		}
		return A2(
			$elm$core$Basics$compare,
			joinedName(fgA),
			joinedName(fgB));
	});
var $author$project$Pages$SubmissionGradingEditor$DownloadSubmission = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$Feedback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$Points = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$SendGrade = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$SubmissionGradingEditor$SetField = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $justgage$tachyons_elm$Tachyons$Classes$justify_end = 'justify-end';
var $justgage$tachyons_elm$Tachyons$Classes$mv3 = 'mv3';
var $justgage$tachyons_elm$Tachyons$Classes$pr4 = 'pr4';
var $author$project$Components$CommonElements$pointsInputElement = F4(
	function (inputConfig, field, errors, msg) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$mb1, $justgage$tachyons_elm$Tachyons$Classes$pr4])),
						$author$project$Utils$Styles$labelStyle
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(inputConfig.af)
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('number'),
						$author$project$Utils$Styles$lineInputStyle,
						$elm$html$Html$Attributes$min(
						$elm$core$String$fromInt(inputConfig.kT)),
						$elm$html$Html$Attributes$max(
						$elm$core$String$fromInt(inputConfig.kK)),
						$elm$html$Html$Attributes$value(
						$elm$core$String$fromInt(inputConfig.fa)),
						$elm$html$Html$Attributes$step(
						$elm$core$String$fromInt(inputConfig.l6)),
						$elm$html$Html$Events$onInput(
						msg(field)),
						$justgage$tachyons_elm$Tachyons$classes(
						_List_fromArray(
							[$justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$w_10, $justgage$tachyons_elm$Tachyons$Classes$bg_black_10, $justgage$tachyons_elm$Tachyons$Classes$ph2]))
					]),
				_List_Nil),
				A2($author$project$Components$CommonElements$viewFormErrors, field, errors)
			]);
	});
var $justgage$tachyons_elm$Tachyons$Classes$w_75 = 'w-75';
var $author$project$Components$CommonElements$rRowButton2 = function (buttonState) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$cf, $justgage$tachyons_elm$Tachyons$Classes$ph4_ns, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$w_75]))
			]),
		_List_fromArray(
			[
				$author$project$Components$CommonElements$progressBarButton(buttonState)
			]));
};
var $author$project$Pages$SubmissionGradingEditor$viewTask = F5(
	function (sharedState, model, task, grade, feedback) {
		var noSubmissionElement = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$author$project$Utils$Styles$headerStyle,
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$red]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No Submission')
				]));
		return $author$project$Components$CommonElements$rContainer(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Components$CommonElements$rRow(
						A2(
							$author$project$Components$CommonElements$r2Column,
							A2(
								$elm$core$List$map,
								function (user) {
									return A3(
										$author$project$Components$UserAvatarEmailView$view,
										sharedState,
										$author$project$Components$UserAvatarEmailView$initFromUser(user).a,
										$elm$core$Maybe$Nothing);
								},
								grade.mH),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$justgage$tachyons_elm$Tachyons$classes(
											_List_fromArray(
												[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$h3_ns, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$justify_end, $justgage$tachyons_elm$Tachyons$Classes$mv3]))
										]),
									_List_fromArray(
										[
											function () {
											var _v0 = grade.jZ;
											if (!_v0.$) {
												var url = _v0.a;
												return $elm$core$String$isEmpty(url) ? noSubmissionElement : A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$author$project$Utils$Styles$buttonGreyStyle,
															$author$project$Utils$Styles$pillStyle,
															$elm$html$Html$Events$onClick(
															$author$project$Pages$SubmissionGradingEditor$DownloadSubmission(url))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Download')
														]));
											} else {
												return noSubmissionElement;
											}
										}()
										]))
								])))
					]),
				_Utils_ap(
					function () {
						var _v1 = grade.jZ;
						if (!_v1.$) {
							var url = _v1.a;
							return $elm$core$String$isEmpty(url) ? _List_fromArray(
								[
									$elm$html$Html$text('')
								]) : _List_fromArray(
								[
									$author$project$Components$CommonElements$rRowExtraSpacing(
									$author$project$Components$CommonElements$r1Column(
										_List_fromArray(
											[
												$author$project$Components$CommonElements$inputLabel('Public Test Results'),
												$author$project$Components$CommonElements$renderInTerminalBox(
												function () {
													var _v2 = grade.lt;
													switch (_v2) {
														case 0:
															return 'Pending Test';
														case 1:
															return 'Running Test';
														default:
															return grade.lu;
													}
												}())
											]))),
									$author$project$Components$CommonElements$rRowExtraSpacing(
									$author$project$Components$CommonElements$r1Column(
										_List_fromArray(
											[
												$author$project$Components$CommonElements$inputLabel('Private Test Results'),
												$author$project$Components$CommonElements$renderInTerminalBox(
												function () {
													var _v3 = grade.lk;
													switch (_v3) {
														case 0:
															return 'Pending Test';
														case 1:
															return 'Running Test';
														default:
															return grade.ll;
													}
												}())
											])))
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						}
					}(),
					_List_fromArray(
						[
							$author$project$Components$CommonElements$rRowExtraSpacing(
							A2(
								$author$project$Components$CommonElements$r2Column,
								A4(
									$author$project$Components$CommonElements$textAreaElement,
									{af: 'Feedback', eD: 'Write some nice feedback for your student.', ox: 8, fa: feedback},
									$author$project$Pages$SubmissionGradingEditor$Feedback(grade.ki),
									_List_Nil,
									$author$project$Pages$SubmissionGradingEditor$SetField),
								_List_fromArray(
									[
										$author$project$Components$CommonElements$inputLabel('Feedback Preview'),
										A2(
										$author$project$Components$CommonElements$renderInTextBox,
										A2(
											$elm$core$Maybe$withDefault,
											'',
											A2($elm$core$Dict$get, grade.ki, model.bw)),
										true)
									]))),
							$author$project$Components$CommonElements$rRowExtraSpacing(
							A2(
								$author$project$Components$CommonElements$r2Column,
								A4(
									$author$project$Components$CommonElements$pointsInputElement,
									{
										af: 'Punkte (0 - ' + ($elm$core$String$fromInt(task.kO) + ')'),
										kK: task.kO,
										kT: 0,
										l6: 1,
										fa: grade.iX,
										pi: $elm$core$String$fromInt(grade.iX) + ' Punkte'
									},
									$author$project$Pages$SubmissionGradingEditor$Points(grade.ki),
									_List_Nil,
									$author$project$Pages$SubmissionGradingEditor$SetField),
								_List_fromArray(
									[
										$author$project$Components$CommonElements$rRowButton2(
										function () {
											var stateShownLongEnough = A3(
												$elm$core$Maybe$map2,
												F2(
													function (up, cur) {
														return ($elm$time$Time$posixToMillis(cur) - $elm$time$Time$posixToMillis(up)) > 1500;
													}),
												A2($elm$core$Dict$get, grade.ki, model.ed),
												sharedState.jx);
											var _v4 = _Utils_Tuple2(
												A2($elm$core$Dict$get, grade.ki, model.ec),
												stateShownLongEnough);
											_v4$3:
											while (true) {
												if (!_v4.a.$) {
													switch (_v4.a.a.$) {
														case 3:
															if ((!_v4.b.$) && (!_v4.b.a)) {
																return $author$project$Components$CommonElements$PbbButton(
																	$author$project$Components$CommonElements$PbbResult(
																		$author$project$Components$CommonElements$PbbSuccess('Erfolgreich benotet')));
															} else {
																break _v4$3;
															}
														case 2:
															if ((!_v4.b.$) && (!_v4.b.a)) {
																return $author$project$Components$CommonElements$PbbButton(
																	$author$project$Components$CommonElements$PbbResult(
																		$author$project$Components$CommonElements$PbbFailure('Fehler beim Benoten')));
															} else {
																break _v4$3;
															}
														case 1:
															var _v5 = _v4.a.a;
															return $author$project$Components$CommonElements$PbbSpinner(model.eW);
														default:
															break _v4$3;
													}
												} else {
													break _v4$3;
												}
											}
											var testFinished = (grade.lk === 2) && (grade.lt === 2);
											var submissionAvailable = (!_Utils_eq(
												grade.jZ,
												$elm$core$Maybe$Just(''))) && (!_Utils_eq(grade.jZ, $elm$core$Maybe$Nothing));
											var testDoneButtonState = $elm$core$String$isEmpty(feedback) ? $author$project$Components$CommonElements$PbbDisabled('You need to write Feedback') : (((!testFinished) && submissionAvailable) ? A2(
												$author$project$Components$CommonElements$PbbActive,
												'Benoten',
												$author$project$Pages$SubmissionGradingEditor$SendGrade(grade.ki)) : A2(
												$author$project$Components$CommonElements$PbbActive,
												'Benoten',
												$author$project$Pages$SubmissionGradingEditor$SendGrade(grade.ki)));
											return $author$project$Components$CommonElements$PbbButton(
												(!submissionAvailable) ? testDoneButtonState : testDoneButtonState);
										}())
									])))
						]))));
	});
var $justgage$tachyons_elm$Tachyons$Classes$mw9_ns = 'mw9-ns';
var $author$project$Components$CommonElements$widePage_mw9 = function (childs) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$justgage$tachyons_elm$Tachyons$classes(
				_List_fromArray(
					[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph4, $justgage$tachyons_elm$Tachyons$Classes$ph3_l, $justgage$tachyons_elm$Tachyons$Classes$center, $justgage$tachyons_elm$Tachyons$Classes$mw9_ns]))
			]),
		childs);
};
var $author$project$Pages$SubmissionGradingEditor$view = F2(
	function (sharedState, model) {
		return $author$project$Components$CommonElements$pageContainer(
			_List_fromArray(
				[
					$author$project$Components$CommonElements$widePage_mw9(
					function () {
						var _v0 = _Utils_Tuple2(model.fG, model.fH);
						if ((_v0.a.$ === 3) && (_v0.b.$ === 3)) {
							var groups = _v0.a.a;
							var task = _v0.b.a;
							var ownGroupData = A2(
								$elm$core$Maybe$withDefault,
								_Utils_Tuple2(-1, ''),
								$elm$core$List$head(
									A2(
										$elm$core$List$map,
										function (g) {
											return _Utils_Tuple2(g.ki, g.mB.j_ + (' ' + g.mB.kB));
										},
										A2(
											$elm$core$List$filter,
											function (g) {
												return _Utils_eq(g.ki, model.ke);
											},
											groups))));
							return _List_fromArray(
								[
									$author$project$Components$CommonElements$rContainer(
									_Utils_ap(
										_List_fromArray(
											[
												$author$project$Components$CommonElements$rRowHeader('Abgaben für ' + task.kY),
												$author$project$Components$CommonElements$rRow(
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$h4,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ttu, $justgage$tachyons_elm$Tachyons$Classes$lh_copy, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$mt3, $justgage$tachyons_elm$Tachyons$Classes$mb1]))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text('Maximale Punkte')
																	])),
																A2(
																$elm$html$Html$h1,
																_List_fromArray(
																	[
																		$justgage$tachyons_elm$Tachyons$classes(
																		_List_fromArray(
																			[$justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$mt0])),
																		$author$project$Utils$Styles$headerStyle
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$fromInt(task.kO))
																	]))
															]))
													])),
												$author$project$Components$CommonElements$rRowHeader('Abgaben')
											]),
										_Utils_ap(
											A5(
												$author$project$Components$CommonElements$rCollapsable,
												'Gruppe - ' + ownGroupData.b,
												model.ee,
												$author$project$Pages$SubmissionGradingEditor$ToggleGroupChanger,
												_Utils_Tuple2('Change Group', 'Hide'),
												_List_fromArray(
													[
														$author$project$Components$CommonElements$multiButton(
														A2(
															$elm$core$List$map,
															function (g) {
																return _Utils_Tuple3(
																	g.mB.j_ + (' ' + g.mB.kB),
																	_Utils_eq(g.ki, ownGroupData.a),
																	$author$project$Pages$SubmissionGradingEditor$NavigateTo(
																		A3($author$project$Routing$Helpers$SubmissionGradingRoute, model.ju, model.ix, g.ki)));
															},
															groups))
													])),
											A2(
												$elm$core$List$map,
												function (_v1) {
													var g = _v1.a;
													var f = _v1.b;
													return A5($author$project$Pages$SubmissionGradingEditor$viewTask, sharedState, model, task, g, f);
												},
												A2(
													$elm$core$List$map,
													function (g) {
														return _Utils_Tuple2(
															g,
															A2(
																$elm$core$Maybe$withDefault,
																'',
																A2($elm$core$Dict$get, g.ki, model.bw)));
													},
													A2(
														$elm$core$List$sortWith,
														$author$project$Pages$SubmissionGradingEditor$compareGradeEntries,
														$elm$core$Dict$values(model.b6)))))))
								]);
						} else {
							return _List_fromArray(
								[
									$elm$html$Html$text('')
								]);
						}
					}())
				]));
	});
var $author$project$Pages$Terms$view = F2(
	function (sharedState, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$db, $justgage$tachyons_elm$Tachyons$Classes$pv5_l, $justgage$tachyons_elm$Tachyons$Classes$pv3_m, $justgage$tachyons_elm$Tachyons$Classes$pv1, $justgage$tachyons_elm$Tachyons$Classes$dt, $justgage$tachyons_elm$Tachyons$Classes$w_100]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$w3, $justgage$tachyons_elm$Tachyons$Classes$dib, $justgage$tachyons_elm$Tachyons$Classes$mv4]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src('/images/Logo.svg')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$tl, $justgage$tachyons_elm$Tachyons$Classes$bn]))
								]),
							_List_fromArray(
								[
									$author$project$Components$CommonElements$rContainer(
									_List_fromArray(
										[
											$author$project$Components$CommonElements$rRow(
											_List_fromArray(
												[
													A2(
													$elm_explorations$markdown$Markdown$toHtml,
													_List_fromArray(
														[$author$project$Utils$Styles$textStyle]),
													model.oY)
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Routing$Router$pageView = F2(
	function (sharedState, model) {
		var _v0 = model.b0;
		switch (_v0.$) {
			case 0:
				var login = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$LoginMsg,
					A2($author$project$Pages$Login$view, sharedState, login));
			case 1:
				var registration = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$RegistrationMsg,
					A2($author$project$Pages$Registration$view, sharedState, registration));
			case 2:
				var dashboard = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$DashboardMsg,
					A2($author$project$Pages$Dashboard$view, sharedState, dashboard));
			case 5:
				var courses = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$CoursesMsg,
					A2($author$project$Pages$Courses$view, sharedState, courses));
			case 7:
				var courseEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$CourseEditorMsg,
					A2($author$project$Pages$CourseEditor$view, sharedState, courseEditor));
			case 6:
				var courseDetail = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$CourseDetailMsg,
					A2($author$project$Pages$CourseDetail$view, sharedState, courseDetail));
			case 10:
				var sheetEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$SheetEditorMsg,
					A2($author$project$Pages$SheetEditor$view, sharedState, sheetEditor));
			case 8:
				var materialEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$MaterialEditorMsg,
					A2($author$project$Pages$MaterialEditor$view, sharedState, materialEditor));
			case 9:
				var sheetDetail = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$SheetDetailMsg,
					A2($author$project$Pages$SheetDetail$view, sharedState, sheetDetail));
			case 11:
				var submissionEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$SubmissionGradingEditorMsg,
					A2($author$project$Pages$SubmissionGradingEditor$view, sharedState, submissionEditor));
			case 3:
				var admin = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$AdminMsg,
					A2($author$project$Pages$Admin$view, sharedState, admin));
			case 12:
				var profileEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$ProfileEditorMsg,
					A2($author$project$Pages$ProfileEditor$view, sharedState, profileEditor));
			case 13:
				var mailConfirmation = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$MailConfirmationMsg,
					A2($author$project$Pages$MailConfirmation$view, sharedState, mailConfirmation));
			case 14:
				var requestPasswordReset = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$RequestPasswordResetMsg,
					A2($author$project$Pages$RequestPasswordReset$view, sharedState, requestPasswordReset));
			case 15:
				var passwordReset = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$PasswordResetMsg,
					A2($author$project$Pages$PasswordReset$view, sharedState, passwordReset));
			case 16:
				var mailEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$MailEditorMsg,
					A2($author$project$Pages$MailEditor$view, sharedState, mailEditor));
			case 17:
				var groupEditor = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$GroupEditorMsg,
					A2($author$project$Pages$GroupEditor$view, sharedState, groupEditor));
			case 4:
				var termsView = _v0.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Routing$Router$TermsMsg,
					A2($author$project$Pages$Terms$view, sharedState, termsView));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$tc, $justgage$tachyons_elm$Tachyons$Classes$dark_red, $justgage$tachyons_elm$Tachyons$Classes$ph3, $justgage$tachyons_elm$Tachyons$Classes$ph4_l])),
							A2($elm$html$Html$Attributes$style, 'height', '80vh'),
							A2($elm$html$Html$Attributes$style, 'width', '100vw')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$f6, $justgage$tachyons_elm$Tachyons$Classes$f2_m, $justgage$tachyons_elm$Tachyons$Classes$f_subheadline_l, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$tc]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('404 :(')
								]))
						]));
		}
	});
var $author$project$Routing$Router$noTabPage = F2(
	function (sharedState, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$helvetica]))
				]),
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Routing$Router$ToastyMsg, model.iC),
					A2($author$project$Routing$Router$pageView, sharedState, model),
					A2($author$project$Routing$Router$footerView, sharedState, model)
				]));
	});
var $author$project$Routing$Router$Login = {$: 7};
var $author$project$Routing$Router$SetField = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Routing$Router$LoginDialogShown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Routing$Router$NoOp = {$: 32};
var $author$project$Routing$Router$loginDialogConfig = A5($author$project$Components$Dialog$Config, $author$project$Utils$Styles$dialogVisibleStyle, $author$project$Utils$Styles$dialogGoneStyle, $author$project$Routing$Router$LoginDialogShown, false, $author$project$Routing$Router$NoOp);
var $author$project$Routing$Router$loginDialog = F2(
	function (sharedState, model) {
		return A5(
			$author$project$Components$Dialog$modalDialog,
			$elm$html$Html$div,
			_List_fromArray(
				[$author$project$Utils$Styles$dialogOverlayStyle]),
			A3(
				$author$project$Components$Dialog$dialog,
				$elm$html$Html$div,
				_List_fromArray(
					[$author$project$Utils$Styles$dialogContainerStyle]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$ph1, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$bw2, $justgage$tachyons_elm$Tachyons$Classes$b__black]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Are you still there?')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$justgage$tachyons_elm$Tachyons$classes(
								_List_fromArray(
									[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$mt4]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$form,
								_List_Nil,
								_Utils_ap(
									A4(
										$author$project$Components$CommonElements$inputElement,
										{jY: 'password', af: 'Password', eD: 'Password', fa: model.le},
										0,
										model.hf,
										$author$project$Routing$Router$SetField),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$justgage$tachyons_elm$Tachyons$classes(
													_List_fromArray(
														[$justgage$tachyons_elm$Tachyons$Classes$fr, $justgage$tachyons_elm$Tachyons$Classes$mt3]))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(_List_Nil),
															$author$project$Utils$Styles$buttonRedStyle,
															$elm$html$Html$Events$onClick($author$project$Routing$Router$Logout)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Nah. I\'m away')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$justgage$tachyons_elm$Tachyons$classes(
															_List_fromArray(
																[$justgage$tachyons_elm$Tachyons$Classes$ml3])),
															$author$project$Utils$Styles$buttonGreenStyle,
															$elm$html$Html$Events$onClick($author$project$Routing$Router$Login)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Login Again')
														]))
												]))
										])))
							]))
					])),
			model.cb,
			$author$project$Routing$Router$loginDialogConfig);
	});
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $justgage$tachyons_elm$Tachyons$Classes$b__white_10 = 'b--white-10';
var $justgage$tachyons_elm$Tachyons$Classes$dib_l = 'dib-l';
var $justgage$tachyons_elm$Tachyons$Classes$fw5 = 'fw5';
var $author$project$Utils$Styles$linkWhiteStyle = $justgage$tachyons_elm$Tachyons$classes(
	_Utils_ap(
		$author$project$Utils$Styles$linkStyle,
		_List_fromArray(
			[$justgage$tachyons_elm$Tachyons$Classes$white])));
var $justgage$tachyons_elm$Tachyons$Classes$ml1 = 'ml1';
var $justgage$tachyons_elm$Tachyons$Classes$ml4_ns = 'ml4-ns';
var $justgage$tachyons_elm$Tachyons$Classes$mr1 = 'mr1';
var $justgage$tachyons_elm$Tachyons$Classes$mr2_l = 'mr2-l';
var $justgage$tachyons_elm$Tachyons$Classes$mr4_ns = 'mr4-ns';
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Routing$Router$navView = F2(
	function (sharedState, model) {
		var t = $author$project$I18n$get(sharedState.pa);
		var navItems = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple3(
					t('page-title-courses'),
					$elm$core$Maybe$Just('images/school-white.svg'),
					$author$project$Routing$Router$NavigateTo($author$project$Routing$Helpers$CoursesRoute))
				]),
			_Utils_ap(
				_Utils_eq(
					sharedState.lJ,
					$elm$core$Maybe$Just(
						{lK: true})) ? _List_fromArray(
					[
						_Utils_Tuple3(
						t('page-title-admin'),
						$elm$core$Maybe$Just('images/database-settings-white.svg'),
						$author$project$Routing$Router$NavigateTo($author$project$Routing$Helpers$AdminRoute))
					]) : _List_Nil,
				_List_fromArray(
					[
						_Utils_Tuple3(
						t('page-title-profile'),
						$elm$core$Maybe$Just('images/account-settings-white.svg'),
						$author$project$Routing$Router$NavigateTo($author$project$Routing$Helpers$ProfileEditorRoute)),
						_Utils_Tuple3(
						t('action-logout'),
						$elm$core$Maybe$Just('images/logout-variant-white.svg'),
						$author$project$Routing$Router$Logout)
					])));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$justify_between, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$bb, $justgage$tachyons_elm$Tachyons$Classes$b__white_10, $justgage$tachyons_elm$Tachyons$Classes$bg_dark_red]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$dt]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('image'),
									$elm$html$Html$Attributes$src('/images/Logo_white.svg'),
									$elm$html$Html$Events$onClick(
									$author$project$Routing$Router$NavigateTo($author$project$Routing$Helpers$DashboardRoute)),
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$link, $justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$no_underline, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$w2, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$dim, $justgage$tachyons_elm$Tachyons$Classes$ml1, $justgage$tachyons_elm$Tachyons$Classes$ml4_ns, $justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid]))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$justgage$tachyons_elm$Tachyons$classes(
									_List_fromArray(
										[$justgage$tachyons_elm$Tachyons$Classes$dtc, $justgage$tachyons_elm$Tachyons$Classes$v_mid, $justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$ph2, $justgage$tachyons_elm$Tachyons$Classes$pa3, $justgage$tachyons_elm$Tachyons$Classes$fw5]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('C++ Blockkurs 2026 (Lehrstuhl Angewandte Bioinformatik)')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$justgage$tachyons_elm$Tachyons$classes(
							_List_fromArray(
								[$justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$pa3]))
						]),
					A2(
						$elm$core$List$map,
						function (_v0) {
							var labelText = _v0.a;
							var maybeIcon = _v0.b;
							var msgAction = _v0.c;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$justgage$tachyons_elm$Tachyons$classes(
										_List_fromArray(
											[$justgage$tachyons_elm$Tachyons$Classes$dim, $justgage$tachyons_elm$Tachyons$Classes$pointer, $justgage$tachyons_elm$Tachyons$Classes$mr1, $justgage$tachyons_elm$Tachyons$Classes$mr4_ns, $justgage$tachyons_elm$Tachyons$Classes$flex, $justgage$tachyons_elm$Tachyons$Classes$items_center])),
										$elm$html$Html$Events$onClick(msgAction)
									]),
								function () {
									if (!maybeIcon.$) {
										var icon = maybeIcon.a;
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(icon),
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$w2, $justgage$tachyons_elm$Tachyons$Classes$h2, $justgage$tachyons_elm$Tachyons$Classes$mr3, $justgage$tachyons_elm$Tachyons$Classes$mr2_l]))
													]),
												_List_Nil),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$f5, $justgage$tachyons_elm$Tachyons$Classes$ph2, $justgage$tachyons_elm$Tachyons$Classes$white, $justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$ttu, $justgage$tachyons_elm$Tachyons$Classes$dn, $justgage$tachyons_elm$Tachyons$Classes$dib_l]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labelText)
													]))
											]);
									} else {
										return _List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														$author$project$Utils$Styles$linkWhiteStyle,
														$justgage$tachyons_elm$Tachyons$classes(
														_List_fromArray(
															[$justgage$tachyons_elm$Tachyons$Classes$fw6, $justgage$tachyons_elm$Tachyons$Classes$tracked, $justgage$tachyons_elm$Tachyons$Classes$ttu]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(labelText)
													]))
											]);
									}
								}());
						},
						navItems))
				]));
	});
var $author$project$Routing$Router$tabPage = F2(
	function (sharedState, model) {
		return A2(
			$elm$html$Html$main_,
			_List_fromArray(
				[
					$justgage$tachyons_elm$Tachyons$classes(
					_List_fromArray(
						[$justgage$tachyons_elm$Tachyons$Classes$w_100, $justgage$tachyons_elm$Tachyons$Classes$bg_white, $justgage$tachyons_elm$Tachyons$Classes$black, $justgage$tachyons_elm$Tachyons$Classes$helvetica]))
				]),
			_List_fromArray(
				[
					A4($pablen$toasty$Toasty$view, $author$project$Components$Toasty$config, $author$project$Components$Toasty$view, $author$project$Routing$Router$ToastyMsg, model.iC),
					A2($author$project$Routing$Router$loginDialog, sharedState, model),
					A2($author$project$Routing$Router$navView, sharedState, model),
					A2($author$project$Routing$Router$pageView, sharedState, model),
					A2($author$project$Routing$Router$footerView, sharedState, model)
				]));
	});
var $author$project$Routing$Router$view = F3(
	function (msgMapper, sharedState, model) {
		var title = function () {
			var _v1 = model.eM;
			switch (_v1.$) {
				case 9:
					return 'page-title-terms';
				case 0:
					return 'page-title-login';
				case 1:
					return 'page-title-registration';
				case 2:
					return 'page-title-dashboard';
				case 3:
					return 'page-title-courses';
				case 4:
					return 'page-title-create-course';
				case 5:
					return 'page-title-edit-course';
				case 6:
					return 'page-title-course';
				case 7:
					return 'page-title-create-sheet';
				case 8:
					return 'page-title-edit-sheet';
				case 10:
					return 'page-title-create-material';
				case 11:
					return 'page-title-edit-material';
				case 12:
					return 'page-title-sheet';
				case 13:
					return 'page-title-grade';
				case 14:
					return 'page-title-admin';
				case 15:
					return 'page-title-profile';
				case 16:
					return 'page-title-confirm';
				case 17:
					return 'page-title-reset';
				case 18:
					return 'page-title-reset';
				case 19:
					return 'page-title-group-create';
				case 20:
					return 'page-title-group-edit';
				case 21:
					return 'page-title-email';
				case 22:
					return 'page-title-email';
				case 23:
					return 'page-title-email';
				default:
					return 'page-title-404';
			}
		}();
		var t = $author$project$I18n$get(sharedState.pa);
		var body = function () {
			var _v0 = model.eM;
			switch (_v0.$) {
				case 0:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 1:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 24:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 16:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 17:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 18:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				case 9:
					return A2($author$project$Routing$Router$noTabPage, sharedState, model);
				default:
					return A2($author$project$Routing$Router$tabPage, sharedState, model);
			}
		}();
		return {
			al: _List_fromArray(
				[
					A2($elm$html$Html$map, msgMapper, body)
				]),
			mp: t('site-title') + (' - ' + t(title))
		};
	});
var $author$project$Main$view = function (model) {
	var _v0 = model.D;
	switch (_v0.$) {
		case 1:
			var sharedState = _v0.a;
			var routerModel = _v0.b;
			return A3($author$project$Routing$Router$view, $author$project$Main$RouterMsg, sharedState, routerModel);
		case 0:
			return {
				al: _List_fromArray(
					[
						$elm$html$Html$text('Loading')
					]),
				mp: 'Loading'
			};
		default:
			return {
				al: _List_fromArray(
					[
						$elm$html$Html$text('The application failed to initialize. ')
					]),
				mp: 'Failure'
			};
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{nM: $author$project$Main$init, of: $author$project$Main$UrlChange, og: $author$project$Main$LinkClicked, oT: $author$project$Main$subscriptions, pd: $author$project$Main$update, gP: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (storage) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (currentTime) {
					return $elm$json$Json$Decode$succeed(
						{jx: currentTime, iu: storage});
				},
				A2($elm$json$Json$Decode$field, 'currentTime', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'storage', $elm$json$Json$Decode$value)))(0)}});}(this));